//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const walkAndPunchApiEndpoint = new InjectionToken<string>('walkAndPunchApiEndpoint');

@Injectable()
export class WalkAndPunchApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(walkAndPunchApiEndpoint) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    v1UserGetAllByProjectTemplateGET(): Observable<UserViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/User/allUsersOnProjectTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetAllByProjectTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetAllByProjectTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel[] | null>;
        }));
    }

    protected processV1UserGetAllByProjectTemplateGET(response: HttpResponseBase): Observable<UserViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserGetAllSimpleByProjectTemplateGET(): Observable<UserInfoViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/User/allUsersSimpleOnProjectTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetAllSimpleByProjectTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetAllSimpleByProjectTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoViewModel[] | null>;
        }));
    }

    protected processV1UserGetAllSimpleByProjectTemplateGET(response: HttpResponseBase): Observable<UserInfoViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInfoViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    v1UserGetAllSubContratorGET(): Observable<UserViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/User/allUsersSubContrator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetAllSubContratorGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetAllSubContratorGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel[] | null>;
        }));
    }

    protected processV1UserGetAllSubContratorGET(response: HttpResponseBase): Observable<UserViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserGetByNameGET(userName: string | null | undefined): Observable<UserInfoViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/User/ByName?";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetByNameGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetByNameGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoViewModel[] | null>;
        }));
    }

    protected processV1UserGetByNameGET(response: HttpResponseBase): Observable<UserInfoViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInfoViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserGetByNameOnProjectTemplateGET(userName: string | null | undefined): Observable<UserInfoViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/User/ByNameOnProjectTemplate?";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetByNameOnProjectTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetByNameOnProjectTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoViewModel[] | null>;
        }));
    }

    protected processV1UserGetByNameOnProjectTemplateGET(response: HttpResponseBase): Observable<UserInfoViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInfoViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserGetByNameAndRolesOnProjectTemplatePOST(userName: string | null | undefined, roles: string[]): Observable<UserInfoViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/User/ByNameAndRolesOnProjectTemplate?";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetByNameAndRolesOnProjectTemplatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetByNameAndRolesOnProjectTemplatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoViewModel[] | null>;
        }));
    }

    protected processV1UserGetByNameAndRolesOnProjectTemplatePOST(response: HttpResponseBase): Observable<UserInfoViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInfoViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserGetSimpleByNameOnProjectTemplateGET(userName: string | null | undefined): Observable<UserInfoViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/User/SimpleByNameOnProjectTemplate?";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetSimpleByNameOnProjectTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetSimpleByNameOnProjectTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoViewModel[] | null>;
        }));
    }

    protected processV1UserGetSimpleByNameOnProjectTemplateGET(response: HttpResponseBase): Observable<UserInfoViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInfoViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserGetUserByIdGET(id: string): Observable<UserViewModel | null> {
        let url_ = this.baseUrl + "/v1/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetUserByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetUserByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel | null>;
        }));
    }

    protected processV1UserGetUserByIdGET(response: HttpResponseBase): Observable<UserViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserDeleteUserDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/v1/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserDeleteUserDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserDeleteUserDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1UserDeleteUserDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserGetUserLoginGET(): Observable<UserLoginViewModel | null> {
        let url_ = this.baseUrl + "/v1/User/Login";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetUserLoginGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetUserLoginGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLoginViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLoginViewModel | null>;
        }));
    }

    protected processV1UserGetUserLoginGET(response: HttpResponseBase): Observable<UserLoginViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserLoginViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserPutUserPUT(userToModify: UserInViewModel): Observable<UserViewModel | null> {
        let url_ = this.baseUrl + "/v1/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserPutUserPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserPutUserPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel | null>;
        }));
    }

    protected processV1UserPutUserPUT(response: HttpResponseBase): Observable<UserViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserPostUserPOST(userNew: UserInViewModel): Observable<UserViewModel | null> {
        let url_ = this.baseUrl + "/v1/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userNew);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserPostUserPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserPostUserPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel | null>;
        }));
    }

    protected processV1UserPostUserPOST(response: HttpResponseBase): Observable<UserViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserGetProjectsByUserGET(): Observable<ProjectViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/User/Projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetProjectsByUserGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetProjectsByUserGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel[] | null>;
        }));
    }

    protected processV1UserGetProjectsByUserGET(response: HttpResponseBase): Observable<ProjectViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserPostImportPreviewUsersPOST(importUsers: ImportViewModel): Observable<ImportViewModel | null> {
        let url_ = this.baseUrl + "/v1/User/ImportPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importUsers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserPostImportPreviewUsersPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserPostImportPreviewUsersPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportViewModel | null>;
        }));
    }

    protected processV1UserPostImportPreviewUsersPOST(response: HttpResponseBase): Observable<ImportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserPostImportUsersPOST(importUsers: ImportViewModel): Observable<ImportViewModel | null> {
        let url_ = this.baseUrl + "/v1/User/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importUsers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserPostImportUsersPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserPostImportUsersPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportViewModel | null>;
        }));
    }

    protected processV1UserPostImportUsersPOST(response: HttpResponseBase): Observable<ImportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserPostExportUsersPOST(exportUsers: ExportUserViewModel): Observable<ExportViewModel | null> {
        let url_ = this.baseUrl + "/v1/User/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportUsers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserPostExportUsersPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserPostExportUsersPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportViewModel | null>;
        }));
    }

    protected processV1UserPostExportUsersPOST(response: HttpResponseBase): Observable<ExportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserGetUsersPermissionsPOST(queryData: QueryData): Observable<UserPermissionsViewModelQueryResult | null> {
        let url_ = this.baseUrl + "/v1/User/UsersPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetUsersPermissionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetUsersPermissionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionsViewModelQueryResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionsViewModelQueryResult | null>;
        }));
    }

    protected processV1UserGetUsersPermissionsPOST(response: HttpResponseBase): Observable<UserPermissionsViewModelQueryResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserPermissionsViewModelQueryResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserGetUserPermissionsDetailsGET(userId: string | null | undefined): Observable<UserPermissionsDetailsViewModel | null> {
        let url_ = this.baseUrl + "/v1/User/UserPermissionsDetails?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetUserPermissionsDetailsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetUserPermissionsDetailsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionsDetailsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionsDetailsViewModel | null>;
        }));
    }

    protected processV1UserGetUserPermissionsDetailsGET(response: HttpResponseBase): Observable<UserPermissionsDetailsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserPermissionsDetailsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserUpsertPermissionPUT(permissionIn: PermissionInViewModel): Observable<void> {
        let url_ = this.baseUrl + "/v1/User/Permission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissionIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserUpsertPermissionPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserUpsertPermissionPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1UserUpsertPermissionPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserDeletePermissionDELETE(userProjectTemplateId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/User/Permission?";
        if (userProjectTemplateId === undefined || userProjectTemplateId === null)
            throw new globalThis.Error("The parameter 'userProjectTemplateId' must be defined and cannot be null.");
        else
            url_ += "userProjectTemplateId=" + encodeURIComponent("" + userProjectTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserDeletePermissionDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserDeletePermissionDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1UserDeletePermissionDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserUpsertGlobalPermissionPUT(permissionIn: PermissionGlobalInViewModel): Observable<void> {
        let url_ = this.baseUrl + "/v1/User/Global/Permission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissionIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserUpsertGlobalPermissionPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserUpsertGlobalPermissionPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1UserUpsertGlobalPermissionPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserDeleteGlobalPermissionDELETE(userId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/v1/User/Global/Permission?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserDeleteGlobalPermissionDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserDeleteGlobalPermissionDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1UserDeleteGlobalPermissionDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserGetPermissionDetailGET(userProjectTemplateId: number): Observable<PermissionDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/User/PermissionDetail?";
        if (userProjectTemplateId === undefined || userProjectTemplateId === null)
            throw new globalThis.Error("The parameter 'userProjectTemplateId' must be defined and cannot be null.");
        else
            url_ += "userProjectTemplateId=" + encodeURIComponent("" + userProjectTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserGetPermissionDetailGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserGetPermissionDetailGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDetailViewModel | null>;
        }));
    }

    protected processV1UserGetPermissionDetailGET(response: HttpResponseBase): Observable<PermissionDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PermissionDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CustomTemplateGetByProjectTemplateGET(): Observable<CustomTemplateViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/CustomTemplate/GetByProyectTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CustomTemplateGetByProjectTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CustomTemplateGetByProjectTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomTemplateViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomTemplateViewModel[] | null>;
        }));
    }

    protected processV1CustomTemplateGetByProjectTemplateGET(response: HttpResponseBase): Observable<CustomTemplateViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomTemplateViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CustomTemplateGetSourcesGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/CustomTemplate/Sources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CustomTemplateGetSourcesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CustomTemplateGetSourcesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1CustomTemplateGetSourcesGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CustomTemplateGetByProjectTemplateAndSourceGET(customTemplateSourceId: number): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/CustomTemplate/GetByProyectTemplateSource?";
        if (customTemplateSourceId === undefined || customTemplateSourceId === null)
            throw new globalThis.Error("The parameter 'customTemplateSourceId' must be defined and cannot be null.");
        else
            url_ += "customTemplateSourceId=" + encodeURIComponent("" + customTemplateSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CustomTemplateGetByProjectTemplateAndSourceGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CustomTemplateGetByProjectTemplateAndSourceGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1CustomTemplateGetByProjectTemplateAndSourceGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CustomTemplateDeleteDELETE(customTemplateId: number): Observable<CustomTemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/CustomTemplate?";
        if (customTemplateId === undefined || customTemplateId === null)
            throw new globalThis.Error("The parameter 'customTemplateId' must be defined and cannot be null.");
        else
            url_ += "customTemplateId=" + encodeURIComponent("" + customTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CustomTemplateDeleteDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CustomTemplateDeleteDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomTemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomTemplateViewModel | null>;
        }));
    }

    protected processV1CustomTemplateDeleteDELETE(response: HttpResponseBase): Observable<CustomTemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomTemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CustomTemplateCreatePOST(customTemplateVm: CustomTemplateInViewModel): Observable<CustomTemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/CustomTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customTemplateVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CustomTemplateCreatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CustomTemplateCreatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomTemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomTemplateViewModel | null>;
        }));
    }

    protected processV1CustomTemplateCreatePOST(response: HttpResponseBase): Observable<CustomTemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomTemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CustomTemplateUpdatePUT(customTemplateVm: CustomTemplateInViewModel): Observable<CustomTemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/CustomTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customTemplateVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CustomTemplateUpdatePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CustomTemplateUpdatePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomTemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomTemplateViewModel | null>;
        }));
    }

    protected processV1CustomTemplateUpdatePUT(response: HttpResponseBase): Observable<CustomTemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomTemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CustomTemplateGetAvailablePlaceholdersByTypeGET(customTemplateSourceId: number): Observable<ExportViewModel | null> {
        let url_ = this.baseUrl + "/v1/CustomTemplate/allAvailablePlaceholders?";
        if (customTemplateSourceId === undefined || customTemplateSourceId === null)
            throw new globalThis.Error("The parameter 'customTemplateSourceId' must be defined and cannot be null.");
        else
            url_ += "customTemplateSourceId=" + encodeURIComponent("" + customTemplateSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CustomTemplateGetAvailablePlaceholdersByTypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CustomTemplateGetAvailablePlaceholdersByTypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportViewModel | null>;
        }));
    }

    protected processV1CustomTemplateGetAvailablePlaceholdersByTypeGET(response: HttpResponseBase): Observable<ExportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CustomTemplateExportCustomTemplatePOST(customTemplateId: number, timezone: string | null | undefined, ids: number[]): Observable<number> {
        let url_ = this.baseUrl + "/v1/CustomTemplate/exportCustomTemplate?";
        if (customTemplateId === undefined || customTemplateId === null)
            throw new globalThis.Error("The parameter 'customTemplateId' must be defined and cannot be null.");
        else
            url_ += "customTemplateId=" + encodeURIComponent("" + customTemplateId) + "&";
        if (timezone !== undefined && timezone !== null)
            url_ += "timezone=" + encodeURIComponent("" + timezone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CustomTemplateExportCustomTemplatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CustomTemplateExportCustomTemplatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1CustomTemplateExportCustomTemplatePOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CustomTemplateDownloadCustomTemplatePOST(customTemplateId: number): Observable<ExportWithMimeTypeViewModel | null> {
        let url_ = this.baseUrl + "/v1/CustomTemplate/downloadCustomTemplate?";
        if (customTemplateId === undefined || customTemplateId === null)
            throw new globalThis.Error("The parameter 'customTemplateId' must be defined and cannot be null.");
        else
            url_ += "customTemplateId=" + encodeURIComponent("" + customTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CustomTemplateDownloadCustomTemplatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CustomTemplateDownloadCustomTemplatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportWithMimeTypeViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportWithMimeTypeViewModel | null>;
        }));
    }

    protected processV1CustomTemplateDownloadCustomTemplatePOST(response: HttpResponseBase): Observable<ExportWithMimeTypeViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExportWithMimeTypeViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ReportGetCustomReportsGET(): Observable<TemplateProjectCustomReportViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Report/CustomReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ReportGetCustomReportsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ReportGetCustomReportsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateProjectCustomReportViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateProjectCustomReportViewModel[] | null>;
        }));
    }

    protected processV1ReportGetCustomReportsGET(response: HttpResponseBase): Observable<TemplateProjectCustomReportViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateProjectCustomReportViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ReportGetCustomReportsByProjectTemplateGET(): Observable<TemplateProjectCustomReportViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Report/CustomReportsByProjectTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ReportGetCustomReportsByProjectTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ReportGetCustomReportsByProjectTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateProjectCustomReportViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateProjectCustomReportViewModel[] | null>;
        }));
    }

    protected processV1ReportGetCustomReportsByProjectTemplateGET(response: HttpResponseBase): Observable<TemplateProjectCustomReportViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateProjectCustomReportViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ReportGetCustomReportsForUserRoleGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Report/CustomReportsForUserRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ReportGetCustomReportsForUserRoleGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ReportGetCustomReportsForUserRoleGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1ReportGetCustomReportsForUserRoleGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ReportGetAvailableCustomReportSourcesPOST(templateIdProjectIdViewModels: TemplateIdProjectIdViewModel[]): Observable<TemplateProjectCustomReportSourceViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Report/GetCustomReportSources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templateIdProjectIdViewModels);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ReportGetAvailableCustomReportSourcesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ReportGetAvailableCustomReportSourcesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateProjectCustomReportSourceViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateProjectCustomReportSourceViewModel[] | null>;
        }));
    }

    protected processV1ReportGetAvailableCustomReportSourcesPOST(response: HttpResponseBase): Observable<TemplateProjectCustomReportSourceViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateProjectCustomReportSourceViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ReportGetAvailableColumnsBySourcePOST(sourceId: number, projectTemplates: string[]): Observable<AvailableColumnViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Report/customReportColumnsBySource?";
        if (sourceId === undefined || sourceId === null)
            throw new globalThis.Error("The parameter 'sourceId' must be defined and cannot be null.");
        else
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectTemplates);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ReportGetAvailableColumnsBySourcePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ReportGetAvailableColumnsBySourcePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableColumnViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableColumnViewModel[] | null>;
        }));
    }

    protected processV1ReportGetAvailableColumnsBySourcePOST(response: HttpResponseBase): Observable<AvailableColumnViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableColumnViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ReportSaveCustomReportPOST(saveCustomReportViewModel: SaveCustomReportViewModel): Observable<number> {
        let url_ = this.baseUrl + "/v1/Report/saveCustomReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveCustomReportViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ReportSaveCustomReportPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ReportSaveCustomReportPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1ReportSaveCustomReportPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ReportGetCustomReportForUpdateGET(templateProjectCustomReportId: number): Observable<SaveCustomReportViewModel | null> {
        let url_ = this.baseUrl + "/v1/Report/CustomReportForUpdate?";
        if (templateProjectCustomReportId === undefined || templateProjectCustomReportId === null)
            throw new globalThis.Error("The parameter 'templateProjectCustomReportId' must be defined and cannot be null.");
        else
            url_ += "templateProjectCustomReportId=" + encodeURIComponent("" + templateProjectCustomReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ReportGetCustomReportForUpdateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ReportGetCustomReportForUpdateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveCustomReportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveCustomReportViewModel | null>;
        }));
    }

    protected processV1ReportGetCustomReportForUpdateGET(response: HttpResponseBase): Observable<SaveCustomReportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaveCustomReportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ReportAddCustomReportQueuePOST(templateProjectCustomReportId: number, timezone: string | null | undefined, dataSourceRequest: PunchDataSourceViewModel): Observable<number> {
        let url_ = this.baseUrl + "/v1/Report/AddCustomReportQueue?";
        if (templateProjectCustomReportId === undefined || templateProjectCustomReportId === null)
            throw new globalThis.Error("The parameter 'templateProjectCustomReportId' must be defined and cannot be null.");
        else
            url_ += "templateProjectCustomReportId=" + encodeURIComponent("" + templateProjectCustomReportId) + "&";
        if (timezone !== undefined && timezone !== null)
            url_ += "timezone=" + encodeURIComponent("" + timezone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataSourceRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ReportAddCustomReportQueuePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ReportAddCustomReportQueuePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1ReportAddCustomReportQueuePOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ReportDeleteCustomReportDELETE(templateProjectCustomReportId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Report/CustomReport?";
        if (templateProjectCustomReportId === undefined || templateProjectCustomReportId === null)
            throw new globalThis.Error("The parameter 'templateProjectCustomReportId' must be defined and cannot be null.");
        else
            url_ += "templateProjectCustomReportId=" + encodeURIComponent("" + templateProjectCustomReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ReportDeleteCustomReportDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ReportDeleteCustomReportDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ReportDeleteCustomReportDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProjectGetAllProjectsGET(): Observable<ProjectViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Project/allProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectGetAllProjectsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectGetAllProjectsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel[] | null>;
        }));
    }

    protected processV1ProjectGetAllProjectsGET(response: HttpResponseBase): Observable<ProjectViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProjectGetAllProjectsRepositoryGET(): Observable<ProjectViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Project/allProjects/repository";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectGetAllProjectsRepositoryGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectGetAllProjectsRepositoryGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel[] | null>;
        }));
    }

    protected processV1ProjectGetAllProjectsRepositoryGET(response: HttpResponseBase): Observable<ProjectViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProjectGetProjectsWithAtLeastOneTemplateGET(): Observable<ProjectViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Project/allWithAtleastOneTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectGetProjectsWithAtLeastOneTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectGetProjectsWithAtLeastOneTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel[] | null>;
        }));
    }

    protected processV1ProjectGetProjectsWithAtLeastOneTemplateGET(response: HttpResponseBase): Observable<ProjectViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProjectDeleteProjectDELETE(projectId: number, deleteAll: boolean): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Project?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (deleteAll === undefined || deleteAll === null)
            throw new globalThis.Error("The parameter 'deleteAll' must be defined and cannot be null.");
        else
            url_ += "deleteAll=" + encodeURIComponent("" + deleteAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectDeleteProjectDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectDeleteProjectDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ProjectDeleteProjectDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProjectSyncProjectElementsProcessPOST(projectId: number, nodeLevel: number | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/v1/Project/syncProjectElements/Process?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (nodeLevel !== undefined && nodeLevel !== null)
            url_ += "nodeLevel=" + encodeURIComponent("" + nodeLevel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectSyncProjectElementsProcessPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectSyncProjectElementsProcessPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1ProjectSyncProjectElementsProcessPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProjectGetProjectDetailsGET(projectId: number): Observable<ProjectDetailsViewModel | null> {
        let url_ = this.baseUrl + "/v1/Project/details?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectGetProjectDetailsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectGetProjectDetailsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDetailsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDetailsViewModel | null>;
        }));
    }

    protected processV1ProjectGetProjectDetailsGET(response: HttpResponseBase): Observable<ProjectDetailsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProjectDetailsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProjectCleanBulkUpdateZipsOnStorageByProjectDELETE(projectId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/Project/CleanBulkUpdateZipsOnStorageByProject?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectCleanBulkUpdateZipsOnStorageByProjectDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectCleanBulkUpdateZipsOnStorageByProjectDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ProjectCleanBulkUpdateZipsOnStorageByProjectDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProjectCleanBulkUpdateZipsOnStorageByDateTimeDELETE(cutoffDate: Date): Observable<void> {
        let url_ = this.baseUrl + "/v1/Project/CleanBulkUpdateZipsOnStorageByDateTime?";
        if (cutoffDate === undefined || cutoffDate === null)
            throw new globalThis.Error("The parameter 'cutoffDate' must be defined and cannot be null.");
        else
            url_ += "cutoffDate=" + encodeURIComponent(cutoffDate ? "" + cutoffDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProjectCleanBulkUpdateZipsOnStorageByDateTimeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProjectCleanBulkUpdateZipsOnStorageByDateTimeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ProjectCleanBulkUpdateZipsOnStorageByDateTimeDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetAllTemplatesGET(): Observable<TemplateViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Template/allTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetAllTemplatesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetAllTemplatesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateViewModel[] | null>;
        }));
    }

    protected processV1TemplateGetAllTemplatesGET(response: HttpResponseBase): Observable<TemplateViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetTemplatesByProjectIdGET(projectId: number): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Template/templatesByProject/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetTemplatesByProjectIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetTemplatesByProjectIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1TemplateGetTemplatesByProjectIdGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetAllTemplatesByProjectGET(showTemplatesWithoutProject: boolean): Observable<TemplateViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Template/allTemplatesByProject?";
        if (showTemplatesWithoutProject === undefined || showTemplatesWithoutProject === null)
            throw new globalThis.Error("The parameter 'showTemplatesWithoutProject' must be defined and cannot be null.");
        else
            url_ += "showTemplatesWithoutProject=" + encodeURIComponent("" + showTemplatesWithoutProject) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetAllTemplatesByProjectGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetAllTemplatesByProjectGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateViewModel[] | null>;
        }));
    }

    protected processV1TemplateGetAllTemplatesByProjectGET(response: HttpResponseBase): Observable<TemplateViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetTemplateByIdGET(id: number): Observable<TemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetTemplateByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetTemplateByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateViewModel | null>;
        }));
    }

    protected processV1TemplateGetTemplateByIdGET(response: HttpResponseBase): Observable<TemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateDeleteTemplateDELETE(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Template/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateDeleteTemplateDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateDeleteTemplateDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1TemplateDeleteTemplateDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePutTemplatePUT(templateToModify: TemplateInViewModel): Observable<TemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templateToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePutTemplatePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePutTemplatePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateViewModel | null>;
        }));
    }

    protected processV1TemplatePutTemplatePUT(response: HttpResponseBase): Observable<TemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePostTemplatePOST(templateNew: TemplateInViewModel): Observable<TemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templateNew);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePostTemplatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePostTemplatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateViewModel | null>;
        }));
    }

    protected processV1TemplatePostTemplatePOST(response: HttpResponseBase): Observable<TemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePostTemplateAndAssignProjectPOST(templateNew: TemplateInViewModel): Observable<TemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/CreateTemplateAndAssignProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templateNew);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePostTemplateAndAssignProjectPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePostTemplateAndAssignProjectPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateViewModel | null>;
        }));
    }

    protected processV1TemplatePostTemplateAndAssignProjectPOST(response: HttpResponseBase): Observable<TemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetTopicsByTemplateIdGET(templateId: number): Observable<TopicViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Topics";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetTopicsByTemplateIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetTopicsByTemplateIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicViewModel[] | null>;
        }));
    }

    protected processV1TemplateGetTopicsByTemplateIdGET(response: HttpResponseBase): Observable<TopicViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopicViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetTopicsByIdGET(templateId: number, topicId: number): Observable<TopicViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Topic/{TopicId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{TopicId}", encodeURIComponent("" + topicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetTopicsByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetTopicsByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicViewModel | null>;
        }));
    }

    protected processV1TemplateGetTopicsByIdGET(response: HttpResponseBase): Observable<TopicViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TopicViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateDeleteTemplateTopicDELETE(templateId: number, topicId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Topic/{TopicId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{TopicId}", encodeURIComponent("" + topicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateDeleteTemplateTopicDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateDeleteTemplateTopicDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1TemplateDeleteTemplateTopicDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePostTemplateTopicPOST(templateId: number, topicCreate: TopicInViewModel): Observable<TopicViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Topic";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topicCreate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePostTemplateTopicPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePostTemplateTopicPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicViewModel | null>;
        }));
    }

    protected processV1TemplatePostTemplateTopicPOST(response: HttpResponseBase): Observable<TopicViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TopicViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePutTemplateTopicPUT(templateId: number, topicEdit: TopicInViewModel): Observable<TopicViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Topic";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topicEdit);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePutTemplateTopicPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePutTemplateTopicPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicViewModel | null>;
        }));
    }

    protected processV1TemplatePutTemplateTopicPUT(response: HttpResponseBase): Observable<TopicViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TopicViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetCategoriesByTemplateIdGET(templateId: number): Observable<CategoryViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Categories";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetCategoriesByTemplateIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetCategoriesByTemplateIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryViewModel[] | null>;
        }));
    }

    protected processV1TemplateGetCategoriesByTemplateIdGET(response: HttpResponseBase): Observable<CategoryViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetCategoryByIdGET(templateId: number, categoryId: number): Observable<CategoryViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Category/{categoryId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (categoryId === undefined || categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetCategoryByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetCategoryByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryViewModel | null>;
        }));
    }

    protected processV1TemplateGetCategoryByIdGET(response: HttpResponseBase): Observable<CategoryViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CategoryViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePostTemplateCategoryPOST(templateId: number, categoryToAdd: CategoryViewModel): Observable<CategoryViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Category";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(categoryToAdd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePostTemplateCategoryPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePostTemplateCategoryPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryViewModel | null>;
        }));
    }

    protected processV1TemplatePostTemplateCategoryPOST(response: HttpResponseBase): Observable<CategoryViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CategoryViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePutTemplateCategoryPUT(templateId: number, categoryToModify: CategoryViewModel): Observable<CategoryViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Category";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(categoryToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePutTemplateCategoryPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePutTemplateCategoryPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryViewModel | null>;
        }));
    }

    protected processV1TemplatePutTemplateCategoryPUT(response: HttpResponseBase): Observable<CategoryViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CategoryViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateDeleteTemplateCategoryDELETE(templateId: number, categoryId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Category/{CategoryId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (categoryId === undefined || categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{CategoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateDeleteTemplateCategoryDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateDeleteTemplateCategoryDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1TemplateDeleteTemplateCategoryDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetInspectionTypeByTemplateIdGET(templateId: number): Observable<InspectionTypeViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/InspectionTypes";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetInspectionTypeByTemplateIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetInspectionTypeByTemplateIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeViewModel[] | null>;
        }));
    }

    protected processV1TemplateGetInspectionTypeByTemplateIdGET(response: HttpResponseBase): Observable<InspectionTypeViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionTypeViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetTemplatePunchCustomFieldsByTemplateIdGET(templateId: number): Observable<TemplatePunchCustomFieldViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/TemplatePunchCustomFields";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetTemplatePunchCustomFieldsByTemplateIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetTemplatePunchCustomFieldsByTemplateIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplatePunchCustomFieldViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplatePunchCustomFieldViewModel[] | null>;
        }));
    }

    protected processV1TemplateGetTemplatePunchCustomFieldsByTemplateIdGET(response: HttpResponseBase): Observable<TemplatePunchCustomFieldViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplatePunchCustomFieldViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetTemplatePunchCustomFieldsByIdGET(templateId: number, templatePunchCustomFieldId: number): Observable<TemplatePunchCustomFieldViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/TemplatePunchCustomField/{TemplatePunchCustomFieldId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (templatePunchCustomFieldId === undefined || templatePunchCustomFieldId === null)
            throw new globalThis.Error("The parameter 'templatePunchCustomFieldId' must be defined.");
        url_ = url_.replace("{TemplatePunchCustomFieldId}", encodeURIComponent("" + templatePunchCustomFieldId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetTemplatePunchCustomFieldsByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetTemplatePunchCustomFieldsByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplatePunchCustomFieldViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplatePunchCustomFieldViewModel | null>;
        }));
    }

    protected processV1TemplateGetTemplatePunchCustomFieldsByIdGET(response: HttpResponseBase): Observable<TemplatePunchCustomFieldViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplatePunchCustomFieldViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateDeleteTemplateTemplatePunchCustomFieldDELETE(templateId: number, templatePunchCustomFieldId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/TemplatePunchCustomField/{TemplatePunchCustomFieldId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (templatePunchCustomFieldId === undefined || templatePunchCustomFieldId === null)
            throw new globalThis.Error("The parameter 'templatePunchCustomFieldId' must be defined.");
        url_ = url_.replace("{TemplatePunchCustomFieldId}", encodeURIComponent("" + templatePunchCustomFieldId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateDeleteTemplateTemplatePunchCustomFieldDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateDeleteTemplateTemplatePunchCustomFieldDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1TemplateDeleteTemplateTemplatePunchCustomFieldDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePostTemplatePunchCustomFieldPOST(templateId: number, templatePunchCustomFieldCreate: TemplatePunchCustomFieldViewModel): Observable<TemplatePunchCustomFieldViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/TemplatePunchCustomField";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templatePunchCustomFieldCreate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePostTemplatePunchCustomFieldPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePostTemplatePunchCustomFieldPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplatePunchCustomFieldViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplatePunchCustomFieldViewModel | null>;
        }));
    }

    protected processV1TemplatePostTemplatePunchCustomFieldPOST(response: HttpResponseBase): Observable<TemplatePunchCustomFieldViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplatePunchCustomFieldViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePutTemplateTemplatePunchCustomFieldPUT(templateId: number, templatePunchCustomFieldEdit: TemplatePunchCustomFieldViewModel): Observable<TemplatePunchCustomFieldViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/TemplatePunchCustomField";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templatePunchCustomFieldEdit);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePutTemplateTemplatePunchCustomFieldPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePutTemplateTemplatePunchCustomFieldPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplatePunchCustomFieldViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplatePunchCustomFieldViewModel | null>;
        }));
    }

    protected processV1TemplatePutTemplateTemplatePunchCustomFieldPUT(response: HttpResponseBase): Observable<TemplatePunchCustomFieldViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplatePunchCustomFieldViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetPunchCustomFieldsByTemplateIdGET(onlyCustosms: boolean): Observable<PunchCustomFieldViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Template/PunchCustomFields?";
        if (onlyCustosms === undefined || onlyCustosms === null)
            throw new globalThis.Error("The parameter 'onlyCustosms' must be defined and cannot be null.");
        else
            url_ += "onlyCustosms=" + encodeURIComponent("" + onlyCustosms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetPunchCustomFieldsByTemplateIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetPunchCustomFieldsByTemplateIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchCustomFieldViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchCustomFieldViewModel[] | null>;
        }));
    }

    protected processV1TemplateGetPunchCustomFieldsByTemplateIdGET(response: HttpResponseBase): Observable<PunchCustomFieldViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PunchCustomFieldViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePutPunchCustomFieldEditPUT(id: number, isEdit: boolean): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Template/PunchCustomField/{id}/Edit/{isEdit}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isEdit === undefined || isEdit === null)
            throw new globalThis.Error("The parameter 'isEdit' must be defined.");
        url_ = url_.replace("{isEdit}", encodeURIComponent("" + isEdit));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePutPunchCustomFieldEditPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePutPunchCustomFieldEditPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1TemplatePutPunchCustomFieldEditPUT(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePutPunchCustomFieldNotAllowedRolesPUT(id: number, notAllowedRoles: string[]): Observable<PunchCustomFieldViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/PunchCustomField/{id}/NotAllowedRoles";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notAllowedRoles);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePutPunchCustomFieldNotAllowedRolesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePutPunchCustomFieldNotAllowedRolesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchCustomFieldViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchCustomFieldViewModel | null>;
        }));
    }

    protected processV1TemplatePutPunchCustomFieldNotAllowedRolesPUT(response: HttpResponseBase): Observable<PunchCustomFieldViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchCustomFieldViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePostTemplateClonePOST(id: number): Observable<TemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{id}/Clone";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePostTemplateClonePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePostTemplateClonePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateViewModel | null>;
        }));
    }

    protected processV1TemplatePostTemplateClonePOST(response: HttpResponseBase): Observable<TemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePostCloneTemplateAndAssignProjectPOST(id: number): Observable<TemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{id}/CloneAndAssignProject";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePostCloneTemplateAndAssignProjectPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePostCloneTemplateAndAssignProjectPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateViewModel | null>;
        }));
    }

    protected processV1TemplatePostCloneTemplateAndAssignProjectPOST(response: HttpResponseBase): Observable<TemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePostTemplateAssignProjectPOST(templateId: number, projectId: number): Observable<TemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Assign/{projectId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePostTemplateAssignProjectPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePostTemplateAssignProjectPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateViewModel | null>;
        }));
    }

    protected processV1TemplatePostTemplateAssignProjectPOST(response: HttpResponseBase): Observable<TemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetProjectsByTemplateIdGET(templateId: number): Observable<ProjectViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Projects";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetProjectsByTemplateIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetProjectsByTemplateIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectViewModel[] | null>;
        }));
    }

    protected processV1TemplateGetProjectsByTemplateIdGET(response: HttpResponseBase): Observable<ProjectViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateDeleteProjectsByIdDELETE(templateId: number, projectId: number): Observable<boolean[] | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/Project/{projectId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateDeleteProjectsByIdDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateDeleteProjectsByIdDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean[] | null>;
        }));
    }

    protected processV1TemplateDeleteProjectsByIdDELETE(response: HttpResponseBase): Observable<boolean[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePutCloseProjectTemplatePUT(templateId: number, projectId: number, closeProjectTemplate: boolean): Observable<TemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/CloseProjectTemplate/{templateId}/{projectId}/{closeProjectTemplate}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (closeProjectTemplate === undefined || closeProjectTemplate === null)
            throw new globalThis.Error("The parameter 'closeProjectTemplate' must be defined.");
        url_ = url_.replace("{closeProjectTemplate}", encodeURIComponent("" + closeProjectTemplate));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePutCloseProjectTemplatePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePutCloseProjectTemplatePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateViewModel | null>;
        }));
    }

    protected processV1TemplatePutCloseProjectTemplatePUT(response: HttpResponseBase): Observable<TemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateUpdateReportTemplatePUT(templateId: number, reportTemplate: boolean): Observable<void> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/ProjectConfiguration/ReportTemplate?";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (reportTemplate === undefined || reportTemplate === null)
            throw new globalThis.Error("The parameter 'reportTemplate' must be defined and cannot be null.");
        else
            url_ += "reportTemplate=" + encodeURIComponent("" + reportTemplate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateUpdateReportTemplatePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateUpdateReportTemplatePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1TemplateUpdateReportTemplatePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetConfigurationsByTemplateIdGET(templateId: number): Observable<TemplateProjectConfigViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Template/{templateId}/ProjectConfigurations";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetConfigurationsByTemplateIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetConfigurationsByTemplateIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateProjectConfigViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateProjectConfigViewModel[] | null>;
        }));
    }

    protected processV1TemplateGetConfigurationsByTemplateIdGET(response: HttpResponseBase): Observable<TemplateProjectConfigViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateProjectConfigViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetConfigurationsByIdGET(projectConfigurationId: number): Observable<TemplateProjectConfigViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/ProjectConfiguration/{projectConfigurationId}";
        if (projectConfigurationId === undefined || projectConfigurationId === null)
            throw new globalThis.Error("The parameter 'projectConfigurationId' must be defined.");
        url_ = url_.replace("{projectConfigurationId}", encodeURIComponent("" + projectConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetConfigurationsByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetConfigurationsByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateProjectConfigViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateProjectConfigViewModel | null>;
        }));
    }

    protected processV1TemplateGetConfigurationsByIdGET(response: HttpResponseBase): Observable<TemplateProjectConfigViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateProjectConfigViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateDeleteTemplateConfigurationDELETE(projectConfigurationId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Template/ProjectConfiguration/{projectConfigurationId}";
        if (projectConfigurationId === undefined || projectConfigurationId === null)
            throw new globalThis.Error("The parameter 'projectConfigurationId' must be defined.");
        url_ = url_.replace("{projectConfigurationId}", encodeURIComponent("" + projectConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateDeleteTemplateConfigurationDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateDeleteTemplateConfigurationDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1TemplateDeleteTemplateConfigurationDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePostTemplateConfigurationPOST(configurationCreate: TemplateProjectConfigViewModel): Observable<TemplateProjectConfigViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/ProjectConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configurationCreate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePostTemplateConfigurationPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePostTemplateConfigurationPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateProjectConfigViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateProjectConfigViewModel | null>;
        }));
    }

    protected processV1TemplatePostTemplateConfigurationPOST(response: HttpResponseBase): Observable<TemplateProjectConfigViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateProjectConfigViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplatePutTemplateConfigurationPUT(configurationEdit: TemplateProjectConfigViewModel): Observable<TemplateProjectConfigViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/ProjectConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configurationEdit);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplatePutTemplateConfigurationPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplatePutTemplateConfigurationPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateProjectConfigViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateProjectConfigViewModel | null>;
        }));
    }

    protected processV1TemplatePutTemplateConfigurationPUT(response: HttpResponseBase): Observable<TemplateProjectConfigViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateProjectConfigViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateUpsertOverridenSignaturePOST(signatureFile: FileParameter | null | undefined): Observable<TemplateProjectConfigViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/OverridenSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (signatureFile !== null && signatureFile !== undefined)
            content_.append("signatureFile", signatureFile.data, signatureFile.fileName ? signatureFile.fileName : "signatureFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateUpsertOverridenSignaturePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateUpsertOverridenSignaturePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateProjectConfigViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateProjectConfigViewModel | null>;
        }));
    }

    protected processV1TemplateUpsertOverridenSignaturePOST(response: HttpResponseBase): Observable<TemplateProjectConfigViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateProjectConfigViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateUpsertDefaultDocumentSignaturePOST(signatureFile: FileParameter | null | undefined): Observable<TemplateProjectConfigViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/DefaultDocumentSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (signatureFile !== null && signatureFile !== undefined)
            content_.append("signatureFile", signatureFile.data, signatureFile.fileName ? signatureFile.fileName : "signatureFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateUpsertDefaultDocumentSignaturePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateUpsertDefaultDocumentSignaturePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateProjectConfigViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateProjectConfigViewModel | null>;
        }));
    }

    protected processV1TemplateUpsertDefaultDocumentSignaturePOST(response: HttpResponseBase): Observable<TemplateProjectConfigViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateProjectConfigViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateUpsertGridConfigPOST(configInViewModel: GridConfigInViewModel): Observable<GridConfigViewModel | null> {
        let url_ = this.baseUrl + "/v1/Template/GridConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configInViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateUpsertGridConfigPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateUpsertGridConfigPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridConfigViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridConfigViewModel | null>;
        }));
    }

    protected processV1TemplateUpsertGridConfigPOST(response: HttpResponseBase): Observable<GridConfigViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GridConfigViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateGetGridConfigsForUserGET(): Observable<GridConfigViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Template/GridConfigs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateGetGridConfigsForUserGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateGetGridConfigsForUserGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridConfigViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridConfigViewModel[] | null>;
        }));
    }

    protected processV1TemplateGetGridConfigsForUserGET(response: HttpResponseBase): Observable<GridConfigViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GridConfigViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateDeleteGridConfigDELETE(gridConfigId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/Template/GridConfigs?";
        if (gridConfigId === undefined || gridConfigId === null)
            throw new globalThis.Error("The parameter 'gridConfigId' must be defined and cannot be null.");
        else
            url_ += "gridConfigId=" + encodeURIComponent("" + gridConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateDeleteGridConfigDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateDeleteGridConfigDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1TemplateDeleteGridConfigDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateProjectSubcontractGetProjectTemplateSubcontractsGET(templateId: number): Observable<SubcontractorDto[] | null> {
        let url_ = this.baseUrl + "/v1/TemplateProjectSubcontract/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateProjectSubcontractGetProjectTemplateSubcontractsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateProjectSubcontractGetProjectTemplateSubcontractsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubcontractorDto[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubcontractorDto[] | null>;
        }));
    }

    protected processV1TemplateProjectSubcontractGetProjectTemplateSubcontractsGET(response: HttpResponseBase): Observable<SubcontractorDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubcontractorDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateProjectSubcontractCreatePOST(subcontractDto: TemplateProjectSubcontractDto): Observable<void> {
        let url_ = this.baseUrl + "/v1/TemplateProjectSubcontract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subcontractDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateProjectSubcontractCreatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateProjectSubcontractCreatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1TemplateProjectSubcontractCreatePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateProjectSubcontractDeleteDELETE(subcontractorId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/TemplateProjectSubcontract/{subcontractorId}";
        if (subcontractorId === undefined || subcontractorId === null)
            throw new globalThis.Error("The parameter 'subcontractorId' must be defined.");
        url_ = url_.replace("{subcontractorId}", encodeURIComponent("" + subcontractorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateProjectSubcontractDeleteDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateProjectSubcontractDeleteDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1TemplateProjectSubcontractDeleteDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TemplateTagsGetAllGET(): Observable<void> {
        let url_ = this.baseUrl + "/v1/TemplateTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TemplateTagsGetAllGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TemplateTagsGetAllGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1TemplateTagsGetAllGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchBagIsEnabledGET(): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/PunchBag/Enabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchBagIsEnabledGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchBagIsEnabledGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1PunchBagIsEnabledGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchBagCreatePOST(input: PunchBagCreateViewModel): Observable<number> {
        let url_ = this.baseUrl + "/v1/PunchBag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchBagCreatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchBagCreatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1PunchBagCreatePOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchBagDeleteDELETE(ids: number[]): Observable<void> {
        let url_ = this.baseUrl + "/v1/PunchBag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchBagDeleteDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchBagDeleteDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1PunchBagDeleteDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchBagGetAsMasterDataGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/PunchBag/MasterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchBagGetAsMasterDataGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchBagGetAsMasterDataGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1PunchBagGetAsMasterDataGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchBagGetPagedResultPOST(query: QueryData): Observable<PunchBagDtoQueryResult | null> {
        let url_ = this.baseUrl + "/v1/PunchBag/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchBagGetPagedResultPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchBagGetPagedResultPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchBagDtoQueryResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchBagDtoQueryResult | null>;
        }));
    }

    protected processV1PunchBagGetPagedResultPOST(response: HttpResponseBase): Observable<PunchBagDtoQueryResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchBagDtoQueryResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchBagGetByIdGET(id: number): Observable<PunchBagDetailsViewModel | null> {
        let url_ = this.baseUrl + "/v1/PunchBag/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchBagGetByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchBagGetByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchBagDetailsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchBagDetailsViewModel | null>;
        }));
    }

    protected processV1PunchBagGetByIdGET(response: HttpResponseBase): Observable<PunchBagDetailsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchBagDetailsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchBagAddPunchesPOST(id: number, punchIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/v1/PunchBag/{id}/Punches";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchBagAddPunchesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchBagAddPunchesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1PunchBagAddPunchesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchBagRemovePunchesDELETE(id: number, punchIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/v1/PunchBag/{id}/Punches";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchBagRemovePunchesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchBagRemovePunchesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1PunchBagRemovePunchesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchIsSignableGET(projectId: number | undefined, templateId: number | undefined, punchId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Punch/{punchId}/isSignable";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined.");
        url_ = url_.replace("{punchId}", encodeURIComponent("" + punchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "projectId": projectId !== undefined && projectId !== null ? "" + projectId : "",
                "templateId": templateId !== undefined && templateId !== null ? "" + templateId : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchIsSignableGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchIsSignableGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1PunchIsSignableGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetAllPagedStartingByElementPOST(elementId: number, punchDataSourceViewModel: PunchDataSourceViewModel | undefined): Observable<PunchViewModelDataSourceResult | null> {
        let url_ = this.baseUrl + "/v1/Punch/allPunchesStartingByElement/Paged/{elementId}";
        if (elementId === undefined || elementId === null)
            throw new globalThis.Error("The parameter 'elementId' must be defined.");
        url_ = url_.replace("{elementId}", encodeURIComponent("" + elementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchDataSourceViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetAllPagedStartingByElementPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetAllPagedStartingByElementPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchViewModelDataSourceResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchViewModelDataSourceResult | null>;
        }));
    }

    protected processV1PunchGetAllPagedStartingByElementPOST(response: HttpResponseBase): Observable<PunchViewModelDataSourceResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchViewModelDataSourceResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetAllPagedStartingByElementHCSPOST(elementId: number, punchDataSourceViewModel: PunchDataSourceViewModel | undefined): Observable<PunchViewModelDataSourceResult | null> {
        let url_ = this.baseUrl + "/v1/Punch/allPunchesStartingByElementHCS/Paged/{elementId}";
        if (elementId === undefined || elementId === null)
            throw new globalThis.Error("The parameter 'elementId' must be defined.");
        url_ = url_.replace("{elementId}", encodeURIComponent("" + elementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchDataSourceViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetAllPagedStartingByElementHCSPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetAllPagedStartingByElementHCSPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchViewModelDataSourceResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchViewModelDataSourceResult | null>;
        }));
    }

    protected processV1PunchGetAllPagedStartingByElementHCSPOST(response: HttpResponseBase): Observable<PunchViewModelDataSourceResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchViewModelDataSourceResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetAllPagedByIdPOST(punchDataSourceViewModel: PunchDataSourceViewModel | undefined): Observable<number[] | null> {
        let url_ = this.baseUrl + "/v1/Punch/allPunches/GetIdByCriteria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchDataSourceViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetAllPagedByIdPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetAllPagedByIdPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[] | null>;
        }));
    }

    protected processV1PunchGetAllPagedByIdPOST(response: HttpResponseBase): Observable<number[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetPunchByIdGET(punchId: number): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/{punchId}";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined.");
        url_ = url_.replace("{punchId}", encodeURIComponent("" + punchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetPunchByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetPunchByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1PunchGetPunchByIdGET(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetPunchDetailsByIdAndTabGET(punchId: number, punchTabId: PunchDetailsTab): Observable<PunchDetailByTabsViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/{punchId}/tab/{punchTabId}";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined.");
        url_ = url_.replace("{punchId}", encodeURIComponent("" + punchId));
        if (punchTabId === undefined || punchTabId === null)
            throw new globalThis.Error("The parameter 'punchTabId' must be defined.");
        url_ = url_.replace("{punchTabId}", encodeURIComponent("" + punchTabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetPunchDetailsByIdAndTabGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetPunchDetailsByIdAndTabGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailByTabsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailByTabsViewModel | null>;
        }));
    }

    protected processV1PunchGetPunchDetailsByIdAndTabGET(response: HttpResponseBase): Observable<PunchDetailByTabsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailByTabsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchPutPunchPUT(punchToModify: PunchDetailInViewModel): Observable<PunchDetailByTabsViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/UpdateOnDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchPutPunchPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchPutPunchPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailByTabsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailByTabsViewModel | null>;
        }));
    }

    protected processV1PunchPutPunchPUT(response: HttpResponseBase): Observable<PunchDetailByTabsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailByTabsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchIsPunchActiveGET(punchId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Punch/isActive/{punchId}";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined.");
        url_ = url_.replace("{punchId}", encodeURIComponent("" + punchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchIsPunchActiveGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchIsPunchActiveGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1PunchIsPunchActiveGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchPutpunchPUT(punchToModify: PunchDetailInViewModel): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchPutpunchPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchPutpunchPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1PunchPutpunchPUT(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchPostpunchPOST(punchNew: PunchDetailViewModel): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchNew);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchPostpunchPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchPostpunchPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1PunchPostpunchPOST(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchPutPunchAndReturnIdPUT(punchToModify: PunchDetailInViewModel): Observable<number> {
        let url_ = this.baseUrl + "/v1/Punch/PutPunchAndReturnId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchPutPunchAndReturnIdPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchPutPunchAndReturnIdPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1PunchPutPunchAndReturnIdPUT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetPunchesUpdateTemplatePOST(punchesIds: number[]): Observable<ExportViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/PunchesUpdateTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchesIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetPunchesUpdateTemplatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetPunchesUpdateTemplatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportViewModel | null>;
        }));
    }

    protected processV1PunchGetPunchesUpdateTemplatePOST(response: HttpResponseBase): Observable<ExportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetPunchesUpdateTemplatePreviewPOST(excelFile: FileParameter | null | undefined): Observable<PunchUpdatePreviewViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/PunchesUpdateTemplatePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetPunchesUpdateTemplatePreviewPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetPunchesUpdateTemplatePreviewPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchUpdatePreviewViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchUpdatePreviewViewModel | null>;
        }));
    }

    protected processV1PunchGetPunchesUpdateTemplatePreviewPOST(response: HttpResponseBase): Observable<PunchUpdatePreviewViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchUpdatePreviewViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchSavePunchesUpdateTemplatePreviewPUT(excelFile: FileParameter | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Punch/SavePunchesUpdateTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchSavePunchesUpdateTemplatePreviewPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchSavePunchesUpdateTemplatePreviewPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processV1PunchSavePunchesUpdateTemplatePreviewPUT(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchSavePunchesUpdateTemplatePreviewProcessPUT(zipFile: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/v1/Punch/SavePunchesUpdateTemplate/Process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (zipFile !== null && zipFile !== undefined)
            content_.append("zipFile", zipFile.data, zipFile.fileName ? zipFile.fileName : "zipFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchSavePunchesUpdateTemplatePreviewProcessPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchSavePunchesUpdateTemplatePreviewProcessPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1PunchSavePunchesUpdateTemplatePreviewProcessPUT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetPunchAttachmentsActionsTemplatePOST(punchesIds: number[]): Observable<ExportViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/PunchAttachmentsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchesIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetPunchAttachmentsActionsTemplatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetPunchAttachmentsActionsTemplatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportViewModel | null>;
        }));
    }

    protected processV1PunchGetPunchAttachmentsActionsTemplatePOST(response: HttpResponseBase): Observable<ExportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetPunchAttachmentsActionsTemplatePreviewPOST(zipFile: FileParameter | null | undefined): Observable<ResultDetailsTemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/PunchAttachmentsActionsTemplatePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (zipFile !== null && zipFile !== undefined)
            content_.append("zipFile", zipFile.data, zipFile.fileName ? zipFile.fileName : "zipFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetPunchAttachmentsActionsTemplatePreviewPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetPunchAttachmentsActionsTemplatePreviewPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDetailsTemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDetailsTemplateViewModel | null>;
        }));
    }

    protected processV1PunchGetPunchAttachmentsActionsTemplatePreviewPOST(response: HttpResponseBase): Observable<ResultDetailsTemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultDetailsTemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchSavePunchAttachmentsActionsTemplatePOST(zipFile: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/v1/Punch/SavePunchAttachmentsActionsTemplate/Process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (zipFile !== null && zipFile !== undefined)
            content_.append("zipFile", zipFile.data, zipFile.fileName ? zipFile.fileName : "zipFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchSavePunchAttachmentsActionsTemplatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchSavePunchAttachmentsActionsTemplatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1PunchSavePunchAttachmentsActionsTemplatePOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchDownloadPunchAttachmentsPOST(punchIds: number[]): Observable<number> {
        let url_ = this.baseUrl + "/v1/Punch/DownloadPunchAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchDownloadPunchAttachmentsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchDownloadPunchAttachmentsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1PunchDownloadPunchAttachmentsPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchPostPunchAndReturnIdPOST(punchNew: PunchDetailViewModel): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/PostPunchAndReturnId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchNew);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchPostPunchAndReturnIdPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchPostPunchAndReturnIdPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1PunchPostPunchAndReturnIdPOST(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchDeletepunchDELETE(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Punch/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchDeletepunchDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchDeletepunchDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1PunchDeletepunchDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchPostCreateMediaPOST(media: PunchMediaViewModel): Observable<PunchMediaViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/CreateMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(media);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchPostCreateMediaPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchPostCreateMediaPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchMediaViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchMediaViewModel | null>;
        }));
    }

    protected processV1PunchPostCreateMediaPOST(response: HttpResponseBase): Observable<PunchMediaViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchMediaViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchPostSetMediaCoverPUT(id: number): Observable<PunchMediaViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/Media/{Id}/Cover";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchPostSetMediaCoverPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchPostSetMediaCoverPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchMediaViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchMediaViewModel | null>;
        }));
    }

    protected processV1PunchPostSetMediaCoverPUT(response: HttpResponseBase): Observable<PunchMediaViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchMediaViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchAssignToPOST(punchId: number, userId: string | null): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/{punchId}/AssignTo/{userId}";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined.");
        url_ = url_.replace("{punchId}", encodeURIComponent("" + punchId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchAssignToPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchAssignToPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1PunchAssignToPOST(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchSignPunchByIdOnDetailsPOST(punchSign: PunchSignatureInDto): Observable<PunchDetailByTabsViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/SignOnDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchSign);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchSignPunchByIdOnDetailsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchSignPunchByIdOnDetailsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailByTabsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailByTabsViewModel | null>;
        }));
    }

    protected processV1PunchSignPunchByIdOnDetailsPOST(response: HttpResponseBase): Observable<PunchDetailByTabsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailByTabsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchSignPunchByIdPOST(punchSign: PunchSignatureInDto): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/Sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchSign);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchSignPunchByIdPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchSignPunchByIdPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1PunchSignPunchByIdPOST(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchRejectPunchByIdOnDetailsPOST(punchReject: PunchSignatureRejectViewModel): Observable<PunchDetailByTabsViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/RejectOnDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchReject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchRejectPunchByIdOnDetailsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchRejectPunchByIdOnDetailsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailByTabsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailByTabsViewModel | null>;
        }));
    }

    protected processV1PunchRejectPunchByIdOnDetailsPOST(response: HttpResponseBase): Observable<PunchDetailByTabsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailByTabsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchRejectPunchByIdPOST(punchReject: PunchSignatureRejectViewModel): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/Reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchReject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchRejectPunchByIdPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchRejectPunchByIdPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1PunchRejectPunchByIdPOST(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchRemarkPunchByIdOnDetailsPOST(punchRemark: PunchRemarkViewModel): Observable<PunchDetailByTabsViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/UpsertRemarkOnDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchRemark);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchRemarkPunchByIdOnDetailsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchRemarkPunchByIdOnDetailsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailByTabsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailByTabsViewModel | null>;
        }));
    }

    protected processV1PunchRemarkPunchByIdOnDetailsPOST(response: HttpResponseBase): Observable<PunchDetailByTabsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailByTabsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchRemarkPunchByIdPOST(punchRemark: PunchRemarkViewModel): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/Remark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchRemark);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchRemarkPunchByIdPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchRemarkPunchByIdPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1PunchRemarkPunchByIdPOST(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchEditRemarkPunchByIdPUT(punchRemark: PunchRemarkViewModel): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/Remark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchRemark);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchEditRemarkPunchByIdPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchEditRemarkPunchByIdPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1PunchEditRemarkPunchByIdPUT(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetAllSignableByIdExcelPOST(punchSign: PunchBulkSignatureViewModel): Observable<ImportViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/SignPunchesPreviewExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchSign);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetAllSignableByIdExcelPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetAllSignableByIdExcelPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportViewModel | null>;
        }));
    }

    protected processV1PunchGetAllSignableByIdExcelPOST(response: HttpResponseBase): Observable<ImportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetAllSignableByIdPOST(punchSign: PunchBulkSignatureViewModel): Observable<PunchViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Punch/SignPunchesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchSign);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetAllSignableByIdPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetAllSignableByIdPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchViewModel[] | null>;
        }));
    }

    protected processV1PunchGetAllSignableByIdPOST(response: HttpResponseBase): Observable<PunchViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PunchViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchSignPunchByIdsPOST(punchSign: PunchBulkSignatureDto): Observable<number[] | null> {
        let url_ = this.baseUrl + "/v1/Punch/SignByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchSign);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchSignPunchByIdsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchSignPunchByIdsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[] | null>;
        }));
    }

    protected processV1PunchSignPunchByIdsPOST(response: HttpResponseBase): Observable<number[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchRejectPunchByIdsPOST(punchesReject: PunchBulkSignatureViewModel): Observable<number[] | null> {
        let url_ = this.baseUrl + "/v1/Punch/RejectByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchesReject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchRejectPunchByIdsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchRejectPunchByIdsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[] | null>;
        }));
    }

    protected processV1PunchRejectPunchByIdsPOST(response: HttpResponseBase): Observable<number[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchOnDisputePOST(id: number, value: boolean): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/OnDispute/{id}/{value}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (value === undefined || value === null)
            throw new globalThis.Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchOnDisputePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchOnDisputePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1PunchOnDisputePOST(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchPostExportPunchesPOST(timezone: string | null | undefined, exportWithoutSigns: boolean, dataSourceRequest: PunchDataSourceViewModel): Observable<number> {
        let url_ = this.baseUrl + "/v1/Punch/ExportPunches?";
        if (timezone !== undefined && timezone !== null)
            url_ += "timezone=" + encodeURIComponent("" + timezone) + "&";
        if (exportWithoutSigns === undefined || exportWithoutSigns === null)
            throw new globalThis.Error("The parameter 'exportWithoutSigns' must be defined and cannot be null.");
        else
            url_ += "exportWithoutSigns=" + encodeURIComponent("" + exportWithoutSigns) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataSourceRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchPostExportPunchesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchPostExportPunchesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1PunchPostExportPunchesPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchPostTransferPunchPreviewPOST(punchTransfer: PunchTransferViewModel): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Punch/TransferPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchTransfer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchPostTransferPunchPreviewPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchPostTransferPunchPreviewPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1PunchPostTransferPunchPreviewPOST(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchPostTransferPunchPOST(saveConfig: boolean, punchTransfer: PunchTransferViewModel): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Punch/Transfer/{saveConfig}";
        if (saveConfig === undefined || saveConfig === null)
            throw new globalThis.Error("The parameter 'saveConfig' must be defined.");
        url_ = url_.replace("{saveConfig}", encodeURIComponent("" + saveConfig));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchTransfer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchPostTransferPunchPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchPostTransferPunchPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1PunchPostTransferPunchPOST(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchModifyBulkMediaPunchesPUT(punchesbulk: { [key: string]: any; }): Observable<void> {
        let url_ = this.baseUrl + "/v1/Punch/BulkMediaModify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchesbulk);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchModifyBulkMediaPunchesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchModifyBulkMediaPunchesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1PunchModifyBulkMediaPunchesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchModifyBulkInspectionPunchesPUT(punchesbulk: { [key: string]: any; }): Observable<PunchViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Punch/BulkModify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchesbulk);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchModifyBulkInspectionPunchesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchModifyBulkInspectionPunchesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchViewModel[] | null>;
        }));
    }

    protected processV1PunchModifyBulkInspectionPunchesPUT(response: HttpResponseBase): Observable<PunchViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PunchViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetColumnsForAdvancedFiltersByProjectTemplateGET(): Observable<PunchAvailableColumnViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Punch/ColumnsForAdvancedFiltersByProjectTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetColumnsForAdvancedFiltersByProjectTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetColumnsForAdvancedFiltersByProjectTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchAvailableColumnViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchAvailableColumnViewModel[] | null>;
        }));
    }

    protected processV1PunchGetColumnsForAdvancedFiltersByProjectTemplateGET(response: HttpResponseBase): Observable<PunchAvailableColumnViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PunchAvailableColumnViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchDeleteTemporalPunchDELETE(punchId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Punch/deleteTemporalPunch?";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined and cannot be null.");
        else
            url_ += "punchId=" + encodeURIComponent("" + punchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchDeleteTemporalPunchDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchDeleteTemporalPunchDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1PunchDeleteTemporalPunchDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchGetAllPunchesPagedPOST(sendCover: boolean, punchDataSourceViewModel: PunchDataSourceViewModel | undefined): Observable<PunchViewModelDataSourceResult | null> {
        let url_ = this.baseUrl + "/v1/Punch/allPunches/Paged?";
        if (sendCover === undefined || sendCover === null)
            throw new globalThis.Error("The parameter 'sendCover' must be defined and cannot be null.");
        else
            url_ += "sendCover=" + encodeURIComponent("" + sendCover) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchDataSourceViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchGetAllPunchesPagedPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchGetAllPunchesPagedPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchViewModelDataSourceResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchViewModelDataSourceResult | null>;
        }));
    }

    protected processV1PunchGetAllPunchesPagedPOST(response: HttpResponseBase): Observable<PunchViewModelDataSourceResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchViewModelDataSourceResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchExportAllAttachmentsPOST(exportPath: string | null | undefined, punchIds: number[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Punch/exportAllAttachments?";
        if (exportPath !== undefined && exportPath !== null)
            url_ += "exportPath=" + encodeURIComponent("" + exportPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchExportAllAttachmentsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchExportAllAttachmentsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1PunchExportAllAttachmentsPOST(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchExportTimelinePOST(punchId: number): Observable<ExportViewModel | null> {
        let url_ = this.baseUrl + "/v1/Punch/exportTimeline?";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined and cannot be null.");
        else
            url_ += "punchId=" + encodeURIComponent("" + punchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchExportTimelinePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchExportTimelinePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportViewModel | null>;
        }));
    }

    protected processV1PunchExportTimelinePOST(response: HttpResponseBase): Observable<ExportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchUnlockPunchesByProjectTemplatePOST(): Observable<number[] | null> {
        let url_ = this.baseUrl + "/v1/Punch/unlockByProjectTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchUnlockPunchesByProjectTemplatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchUnlockPunchesByProjectTemplatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[] | null>;
        }));
    }

    protected processV1PunchUnlockPunchesByProjectTemplatePOST(response: HttpResponseBase): Observable<number[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchSignFlowResetSignFlowDELETE(punchId: number): Observable<PunchDetailByTabsViewModel | null> {
        let url_ = this.baseUrl + "/v1/PunchSignFlow/Reset/{punchId}";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined.");
        url_ = url_.replace("{punchId}", encodeURIComponent("" + punchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchSignFlowResetSignFlowDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchSignFlowResetSignFlowDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailByTabsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailByTabsViewModel | null>;
        }));
    }

    protected processV1PunchSignFlowResetSignFlowDELETE(response: HttpResponseBase): Observable<PunchDetailByTabsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailByTabsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchSignFlowBulkResetSignFlowDELETE(userId: string | null | undefined, punchIds: number[]): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/PunchSignFlow/BulkReset?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchSignFlowBulkResetSignFlowDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchSignFlowBulkResetSignFlowDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1PunchSignFlowBulkResetSignFlowDELETE(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DocumentProcessorCreatePreviewPOST(documentProcessorTypeId: number, pdfFile: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/v1/DocumentProcessor/CreatePreview?";
        if (documentProcessorTypeId === undefined || documentProcessorTypeId === null)
            throw new globalThis.Error("The parameter 'documentProcessorTypeId' must be defined and cannot be null.");
        else
            url_ += "documentProcessorTypeId=" + encodeURIComponent("" + documentProcessorTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (pdfFile !== null && pdfFile !== undefined)
            content_.append("pdfFile", pdfFile.data, pdfFile.fileName ? pdfFile.fileName : "pdfFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DocumentProcessorCreatePreviewPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DocumentProcessorCreatePreviewPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1DocumentProcessorCreatePreviewPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DocumentProcessorPagePreviewPOST(mediaId: number, pages: number[]): Observable<string | null> {
        let url_ = this.baseUrl + "/v1/DocumentProcessor/PagePreview?";
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined and cannot be null.");
        else
            url_ += "mediaId=" + encodeURIComponent("" + mediaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pages);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DocumentProcessorPagePreviewPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DocumentProcessorPagePreviewPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processV1DocumentProcessorPagePreviewPOST(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DocumentProcessorGetAllDocumentsForListGET(documentProcessorTypeId: number, previews: boolean): Observable<DocumentForListViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/DocumentProcessor/AllDocumentsForList?";
        if (documentProcessorTypeId === undefined || documentProcessorTypeId === null)
            throw new globalThis.Error("The parameter 'documentProcessorTypeId' must be defined and cannot be null.");
        else
            url_ += "documentProcessorTypeId=" + encodeURIComponent("" + documentProcessorTypeId) + "&";
        if (previews === undefined || previews === null)
            throw new globalThis.Error("The parameter 'previews' must be defined and cannot be null.");
        else
            url_ += "previews=" + encodeURIComponent("" + previews) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DocumentProcessorGetAllDocumentsForListGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DocumentProcessorGetAllDocumentsForListGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentForListViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentForListViewModel[] | null>;
        }));
    }

    protected processV1DocumentProcessorGetAllDocumentsForListGET(response: HttpResponseBase): Observable<DocumentForListViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentForListViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DocumentProcessorDiscardPreviewsDELETE(processIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/v1/DocumentProcessor/DiscardPreviews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DocumentProcessorDiscardPreviewsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DocumentProcessorDiscardPreviewsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1DocumentProcessorDiscardPreviewsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DocumentProcessorExecuteProcessPOST(previousProcessId: number, signedPunchesExecute: SignedPunchesExecuteGenerationViewModel): Observable<number> {
        let url_ = this.baseUrl + "/v1/DocumentProcessor/SignedPunches/Execute?";
        if (previousProcessId === undefined || previousProcessId === null)
            throw new globalThis.Error("The parameter 'previousProcessId' must be defined and cannot be null.");
        else
            url_ += "previousProcessId=" + encodeURIComponent("" + previousProcessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signedPunchesExecute);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DocumentProcessorExecuteProcessPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DocumentProcessorExecuteProcessPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1DocumentProcessorExecuteProcessPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DocumentProcessorGetSignedPunchesDocumentPreviewGET(processId: number): Observable<SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel | null> {
        let url_ = this.baseUrl + "/v1/DocumentProcessor/SignedPunches/Preview?";
        if (processId === undefined || processId === null)
            throw new globalThis.Error("The parameter 'processId' must be defined and cannot be null.");
        else
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DocumentProcessorGetSignedPunchesDocumentPreviewGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DocumentProcessorGetSignedPunchesDocumentPreviewGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel | null>;
        }));
    }

    protected processV1DocumentProcessorGetSignedPunchesDocumentPreviewGET(response: HttpResponseBase): Observable<SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DocumentProcessorGetPunchesBySignRolesPOST(processId: number): Observable<GroupedPunchesByRolesViewModel | null> {
        let url_ = this.baseUrl + "/v1/DocumentProcessor/SignedPunches/PunchesBySignRoles?";
        if (processId === undefined || processId === null)
            throw new globalThis.Error("The parameter 'processId' must be defined and cannot be null.");
        else
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DocumentProcessorGetPunchesBySignRolesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DocumentProcessorGetPunchesBySignRolesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupedPunchesByRolesViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupedPunchesByRolesViewModel | null>;
        }));
    }

    protected processV1DocumentProcessorGetPunchesBySignRolesPOST(response: HttpResponseBase): Observable<GroupedPunchesByRolesViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GroupedPunchesByRolesViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DocumentProcessorSavePunchCodeOnSignedPunchesPreviewPUT(processId: number, punchIdModified: number, punchCode: string | null | undefined): Observable<MasterViewModel | null> {
        let url_ = this.baseUrl + "/v1/DocumentProcessor/SignedPunches/SavePunchCodeOnPreview?";
        if (processId === undefined || processId === null)
            throw new globalThis.Error("The parameter 'processId' must be defined and cannot be null.");
        else
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        if (punchIdModified === undefined || punchIdModified === null)
            throw new globalThis.Error("The parameter 'punchIdModified' must be defined and cannot be null.");
        else
            url_ += "punchIdModified=" + encodeURIComponent("" + punchIdModified) + "&";
        if (punchCode !== undefined && punchCode !== null)
            url_ += "punchCode=" + encodeURIComponent("" + punchCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DocumentProcessorSavePunchCodeOnSignedPunchesPreviewPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DocumentProcessorSavePunchCodeOnSignedPunchesPreviewPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel | null>;
        }));
    }

    protected processV1DocumentProcessorSavePunchCodeOnSignedPunchesPreviewPUT(response: HttpResponseBase): Observable<MasterViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MasterViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DocumentProcessorSavePunchesPreviewPOST(processId: number, punchPreviews: SignedPunchesDetailPreviewViewModel): Observable<number> {
        let url_ = this.baseUrl + "/v1/DocumentProcessor/SignedPunches/SavePunchesPreview?";
        if (processId === undefined || processId === null)
            throw new globalThis.Error("The parameter 'processId' must be defined and cannot be null.");
        else
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchPreviews);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DocumentProcessorSavePunchesPreviewPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DocumentProcessorSavePunchesPreviewPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1DocumentProcessorSavePunchesPreviewPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DocumentProcessorIsSignedPunchesVisibleGET(): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/DocumentProcessor/SignedPunches/Visible";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DocumentProcessorIsSignedPunchesVisibleGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DocumentProcessorIsSignedPunchesVisibleGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1DocumentProcessorIsSignedPunchesVisibleGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DownloadTotalChunkGET(templateProjectDownloadId: number): Observable<FileChunkViewModel | null> {
        let url_ = this.baseUrl + "/v1/Download/TotalChunk?";
        if (templateProjectDownloadId === undefined || templateProjectDownloadId === null)
            throw new globalThis.Error("The parameter 'templateProjectDownloadId' must be defined and cannot be null.");
        else
            url_ += "templateProjectDownloadId=" + encodeURIComponent("" + templateProjectDownloadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DownloadTotalChunkGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DownloadTotalChunkGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileChunkViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileChunkViewModel | null>;
        }));
    }

    protected processV1DownloadTotalChunkGET(response: HttpResponseBase): Observable<FileChunkViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileChunkViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DownloadDownloadChunkProcessGET(templateProjectDownloadId: number, chunkNumber: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Download/DownloadChunk?";
        if (templateProjectDownloadId === undefined || templateProjectDownloadId === null)
            throw new globalThis.Error("The parameter 'templateProjectDownloadId' must be defined and cannot be null.");
        else
            url_ += "templateProjectDownloadId=" + encodeURIComponent("" + templateProjectDownloadId) + "&";
        if (chunkNumber === undefined || chunkNumber === null)
            throw new globalThis.Error("The parameter 'chunkNumber' must be defined and cannot be null.");
        else
            url_ += "chunkNumber=" + encodeURIComponent("" + chunkNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DownloadDownloadChunkProcessGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DownloadDownloadChunkProcessGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processV1DownloadDownloadChunkProcessGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DownloadUserDownloadGET(templateProjectDownloadId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Download/userDownload/{templateProjectDownloadId}";
        if (templateProjectDownloadId === undefined || templateProjectDownloadId === null)
            throw new globalThis.Error("The parameter 'templateProjectDownloadId' must be defined.");
        url_ = url_.replace("{templateProjectDownloadId}", encodeURIComponent("" + templateProjectDownloadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DownloadUserDownloadGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DownloadUserDownloadGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processV1DownloadUserDownloadGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DownloadUserDownloadsGET(): Observable<TemplateProjectDownloadViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Download/userDownloads";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DownloadUserDownloadsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DownloadUserDownloadsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateProjectDownloadViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateProjectDownloadViewModel[] | null>;
        }));
    }

    protected processV1DownloadUserDownloadsGET(response: HttpResponseBase): Observable<TemplateProjectDownloadViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateProjectDownloadViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DownloadGetTemplateProjectDownloadByIdGET(templateProjectDownloadId: number): Observable<TemplateProjectDownloadViewModel | null> {
        let url_ = this.baseUrl + "/v1/Download/{templateProjectDownloadId}";
        if (templateProjectDownloadId === undefined || templateProjectDownloadId === null)
            throw new globalThis.Error("The parameter 'templateProjectDownloadId' must be defined.");
        url_ = url_.replace("{templateProjectDownloadId}", encodeURIComponent("" + templateProjectDownloadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DownloadGetTemplateProjectDownloadByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DownloadGetTemplateProjectDownloadByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateProjectDownloadViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateProjectDownloadViewModel | null>;
        }));
    }

    protected processV1DownloadGetTemplateProjectDownloadByIdGET(response: HttpResponseBase): Observable<TemplateProjectDownloadViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateProjectDownloadViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProcessGetAllProcessesGET(): Observable<ProcessViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Process/allProcesses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProcessGetAllProcessesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProcessGetAllProcessesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessViewModel[] | null>;
        }));
    }

    protected processV1ProcessGetAllProcessesGET(response: HttpResponseBase): Observable<ProcessViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProcessGetAllProcessesByProjectGET(): Observable<ProcessViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Process/allProcessesByProject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProcessGetAllProcessesByProjectGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProcessGetAllProcessesByProjectGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessViewModel[] | null>;
        }));
    }

    protected processV1ProcessGetAllProcessesByProjectGET(response: HttpResponseBase): Observable<ProcessViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProcessTotalChunkGET(id: number): Observable<FileChunkViewModel | null> {
        let url_ = this.baseUrl + "/v1/Process/TotalChunk?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProcessTotalChunkGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProcessTotalChunkGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileChunkViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileChunkViewModel | null>;
        }));
    }

    protected processV1ProcessTotalChunkGET(response: HttpResponseBase): Observable<FileChunkViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileChunkViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProcessDownloadChunkProcessGET(chunkNumber: number, id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Process/DownloadChunk?";
        if (chunkNumber === undefined || chunkNumber === null)
            throw new globalThis.Error("The parameter 'chunkNumber' must be defined and cannot be null.");
        else
            url_ += "chunkNumber=" + encodeURIComponent("" + chunkNumber) + "&";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProcessDownloadChunkProcessGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProcessDownloadChunkProcessGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processV1ProcessDownloadChunkProcessGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProcessDownloadMultipleProcessPOST(dataSourceRequest: DataSourceRequest | undefined): Observable<ExportWithMimeTypeViewModel | null> {
        let url_ = this.baseUrl + "/v1/Process/DownloadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataSourceRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProcessDownloadMultipleProcessPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProcessDownloadMultipleProcessPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportWithMimeTypeViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportWithMimeTypeViewModel | null>;
        }));
    }

    protected processV1ProcessDownloadMultipleProcessPOST(response: HttpResponseBase): Observable<ExportWithMimeTypeViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExportWithMimeTypeViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProcessDownloadProcessPOST(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Process/Download?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProcessDownloadProcessPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProcessDownloadProcessPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processV1ProcessDownloadProcessPOST(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProcessGetProcessGET(processId: number): Observable<ProcessDto | null> {
        let url_ = this.baseUrl + "/v1/Process/{processId}";
        if (processId === undefined || processId === null)
            throw new globalThis.Error("The parameter 'processId' must be defined.");
        url_ = url_.replace("{processId}", encodeURIComponent("" + processId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProcessGetProcessGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProcessGetProcessGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessDto | null>;
        }));
    }

    protected processV1ProcessGetProcessGET(response: HttpResponseBase): Observable<ProcessDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProcessDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProcessUpdateProcessPUT(process: ProcessViewModel): Observable<void> {
        let url_ = this.baseUrl + "/v1/Process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(process);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProcessUpdateProcessPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProcessUpdateProcessPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ProcessUpdateProcessPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProcessCancelProcessGenerationGET(processId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/Process/Cancel/{processId}";
        if (processId === undefined || processId === null)
            throw new globalThis.Error("The parameter 'processId' must be defined.");
        url_ = url_.replace("{processId}", encodeURIComponent("" + processId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProcessCancelProcessGenerationGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProcessCancelProcessGenerationGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ProcessCancelProcessGenerationGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProcessCancelHangfireProcessesPOST(processIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/v1/Process/CancelHangfireProcesses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProcessCancelHangfireProcessesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProcessCancelHangfireProcessesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ProcessCancelHangfireProcessesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ProcessRetryProcessGenerationGET(processId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/Process/Retry/{processId}";
        if (processId === undefined || processId === null)
            throw new globalThis.Error("The parameter 'processId' must be defined.");
        url_ = url_.replace("{processId}", encodeURIComponent("" + processId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ProcessRetryProcessGenerationGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ProcessRetryProcessGenerationGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ProcessRetryProcessGenerationGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ElementMobilityGetSubSystemsGET(): Observable<MasterViewModel | null> {
        let url_ = this.baseUrl + "/v1/ElementMobility/Subsystems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElementMobilityGetSubSystemsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElementMobilityGetSubSystemsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel | null>;
        }));
    }

    protected processV1ElementMobilityGetSubSystemsGET(response: HttpResponseBase): Observable<MasterViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MasterViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchMobilityGetPunchByIdGET(punchId: number): Observable<PunchDetailMobilityViewModel | null> {
        let url_ = this.baseUrl + "/v1/PunchMobility/{punchId}";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined.");
        url_ = url_.replace("{punchId}", encodeURIComponent("" + punchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchMobilityGetPunchByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchMobilityGetPunchByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailMobilityViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailMobilityViewModel | null>;
        }));
    }

    protected processV1PunchMobilityGetPunchByIdGET(response: HttpResponseBase): Observable<PunchDetailMobilityViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailMobilityViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchMobilityGetAllPunchesPagedPOST(sendCover: boolean, punchDataSourceViewModel: PunchDataSourceViewModel): Observable<PunchMobilityViewModelDataSourceResult | null> {
        let url_ = this.baseUrl + "/v1/PunchMobility/allPunches/Paged?";
        if (sendCover === undefined || sendCover === null)
            throw new globalThis.Error("The parameter 'sendCover' must be defined and cannot be null.");
        else
            url_ += "sendCover=" + encodeURIComponent("" + sendCover) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchDataSourceViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchMobilityGetAllPunchesPagedPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchMobilityGetAllPunchesPagedPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchMobilityViewModelDataSourceResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchMobilityViewModelDataSourceResult | null>;
        }));
    }

    protected processV1PunchMobilityGetAllPunchesPagedPOST(response: HttpResponseBase): Observable<PunchMobilityViewModelDataSourceResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchMobilityViewModelDataSourceResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchMobilityGetPunchBagsPagedPOST(query: QueryData): Observable<PunchBagMobilityViewModelQueryResult | null> {
        let url_ = this.baseUrl + "/v1/PunchMobility/punchBags/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchMobilityGetPunchBagsPagedPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchMobilityGetPunchBagsPagedPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchBagMobilityViewModelQueryResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchBagMobilityViewModelQueryResult | null>;
        }));
    }

    protected processV1PunchMobilityGetPunchBagsPagedPOST(response: HttpResponseBase): Observable<PunchBagMobilityViewModelQueryResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchBagMobilityViewModelQueryResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MediaGetmediaByIdGET(mediaId: number): Observable<PunchMediaViewModel | null> {
        let url_ = this.baseUrl + "/v1/Media/{mediaId}";
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MediaGetmediaByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MediaGetmediaByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchMediaViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchMediaViewModel | null>;
        }));
    }

    protected processV1MediaGetmediaByIdGET(response: HttpResponseBase): Observable<PunchMediaViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchMediaViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MediaDeleteMediaDELETE(mediaId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Media/{mediaId}";
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MediaDeleteMediaDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MediaDeleteMediaDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processV1MediaDeleteMediaDELETE(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MediaDownloadMediaByIdGET(mediaId: number): Observable<MediaFileViewModel | null> {
        let url_ = this.baseUrl + "/v1/Media/Download/{mediaId}";
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MediaDownloadMediaByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MediaDownloadMediaByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaFileViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaFileViewModel | null>;
        }));
    }

    protected processV1MediaDownloadMediaByIdGET(response: HttpResponseBase): Observable<MediaFileViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MediaFileViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MediaGetmediaFileByIdGET(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Media/InspectionFile/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MediaGetmediaFileByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MediaGetmediaFileByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processV1MediaGetmediaFileByIdGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MediaPutMediaPUT(mediaModify: PunchMediaViewModel): Observable<PunchMediaViewModel | null> {
        let url_ = this.baseUrl + "/v1/Media";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mediaModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MediaPutMediaPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MediaPutMediaPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchMediaViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchMediaViewModel | null>;
        }));
    }

    protected processV1MediaPutMediaPUT(response: HttpResponseBase): Observable<PunchMediaViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchMediaViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MediaGetmediaMapsFileByIdGET(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Media/MapFile/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MediaGetmediaMapsFileByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MediaGetmediaMapsFileByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processV1MediaGetmediaMapsFileByIdGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ApplicationMasterGetApplicationVersionCheckGET(applicationId: number, appVersion: string | null | undefined, platform: string | null | undefined): Observable<CheckVersionResultAppDto | null> {
        let url_ = this.baseUrl + "/v1/ApplicationMaster/versions/check?";
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined and cannot be null.");
        else
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        if (appVersion !== undefined && appVersion !== null)
            url_ += "appVersion=" + encodeURIComponent("" + appVersion) + "&";
        if (platform !== undefined && platform !== null)
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ApplicationMasterGetApplicationVersionCheckGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ApplicationMasterGetApplicationVersionCheckGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckVersionResultAppDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckVersionResultAppDto | null>;
        }));
    }

    protected processV1ApplicationMasterGetApplicationVersionCheckGET(response: HttpResponseBase): Observable<CheckVersionResultAppDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckVersionResultAppDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CategoryGetAllCategoryGET(): Observable<CategoryViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Category/allCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CategoryGetAllCategoryGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CategoryGetAllCategoryGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryViewModel[] | null>;
        }));
    }

    protected processV1CategoryGetAllCategoryGET(response: HttpResponseBase): Observable<CategoryViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CategoryGetAllCategoryWithTransferConfigGET(toTemplateId: number): Observable<CategoryViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Category/allCategory/{toTemplateId}";
        if (toTemplateId === undefined || toTemplateId === null)
            throw new globalThis.Error("The parameter 'toTemplateId' must be defined.");
        url_ = url_.replace("{toTemplateId}", encodeURIComponent("" + toTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CategoryGetAllCategoryWithTransferConfigGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CategoryGetAllCategoryWithTransferConfigGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryViewModel[] | null>;
        }));
    }

    protected processV1CategoryGetAllCategoryWithTransferConfigGET(response: HttpResponseBase): Observable<CategoryViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CategoryGetAllInspectionCategoryGET(inspectionId: number): Observable<CategoryViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Category/allInspectionCategory/{inspectionId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CategoryGetAllInspectionCategoryGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CategoryGetAllInspectionCategoryGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryViewModel[] | null>;
        }));
    }

    protected processV1CategoryGetAllInspectionCategoryGET(response: HttpResponseBase): Observable<CategoryViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1CategoryGetCategoriesByProjectIdGET(): Observable<CategoryProjectViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Category/categoriesByProjectId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1CategoryGetCategoriesByProjectIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1CategoryGetCategoriesByProjectIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryProjectViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryProjectViewModel[] | null>;
        }));
    }

    protected processV1CategoryGetCategoriesByProjectIdGET(response: HttpResponseBase): Observable<CategoryProjectViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryProjectViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DepartmentActionGetAllDepartmentActionGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/DepartmentAction/allDepartmentAction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DepartmentActionGetAllDepartmentActionGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DepartmentActionGetAllDepartmentActionGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1DepartmentActionGetAllDepartmentActionGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DisciplineGetAllDisciplinesGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Discipline/allDisciplines";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DisciplineGetAllDisciplinesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DisciplineGetAllDisciplinesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1DisciplineGetAllDisciplinesGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1DocumentTypeGetAllDocumentTypeGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/DocumentType/allDocumentType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1DocumentTypeGetAllDocumentTypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1DocumentTypeGetAllDocumentTypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1DocumentTypeGetAllDocumentTypeGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1EntryTypeGetAllEntryTypesGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/EntryType/allEntryTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1EntryTypeGetAllEntryTypesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1EntryTypeGetAllEntryTypesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1EntryTypeGetAllEntryTypesGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExperiedTimeGetAllExperiedTimeGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/ExperiedTime/allExperiedTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExperiedTimeGetAllExperiedTimeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExperiedTimeGetAllExperiedTimeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1ExperiedTimeGetAllExperiedTimeGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExperiedTypeGetAllExperiedTypesGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/ExperiedType/allExperiedTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExperiedTypeGetAllExperiedTypesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExperiedTypeGetAllExperiedTypesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1ExperiedTypeGetAllExperiedTypesGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1LocationProjectGetAllByProjectGET(): Observable<LocationProjectViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/LocationProject/ByProject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1LocationProjectGetAllByProjectGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1LocationProjectGetAllByProjectGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationProjectViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationProjectViewModel[] | null>;
        }));
    }

    protected processV1LocationProjectGetAllByProjectGET(response: HttpResponseBase): Observable<LocationProjectViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationProjectViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1LocationProjectUpsertPOST(locationProjectIn: LocationProjectViewModel): Observable<LocationProjectViewModel | null> {
        let url_ = this.baseUrl + "/v1/LocationProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationProjectIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1LocationProjectUpsertPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1LocationProjectUpsertPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationProjectViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationProjectViewModel | null>;
        }));
    }

    protected processV1LocationProjectUpsertPOST(response: HttpResponseBase): Observable<LocationProjectViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LocationProjectViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1LocationProjectRemoveDELETE(locationProjectId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/LocationProject?";
        if (locationProjectId === undefined || locationProjectId === null)
            throw new globalThis.Error("The parameter 'locationProjectId' must be defined and cannot be null.");
        else
            url_ += "locationProjectId=" + encodeURIComponent("" + locationProjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1LocationProjectRemoveDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1LocationProjectRemoveDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1LocationProjectRemoveDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MapsGetAllMapsGET(): Observable<MapResumeViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Maps/allMaps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MapsGetAllMapsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MapsGetAllMapsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapResumeViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapResumeViewModel[] | null>;
        }));
    }

    protected processV1MapsGetAllMapsGET(response: HttpResponseBase): Observable<MapResumeViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MapResumeViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MapsGetMapByIdGET(mapId: number): Observable<MapsViewModel | null> {
        let url_ = this.baseUrl + "/v1/Maps/{mapId}";
        if (mapId === undefined || mapId === null)
            throw new globalThis.Error("The parameter 'mapId' must be defined.");
        url_ = url_.replace("{mapId}", encodeURIComponent("" + mapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MapsGetMapByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MapsGetMapByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapsViewModel | null>;
        }));
    }

    protected processV1MapsGetMapByIdGET(response: HttpResponseBase): Observable<MapsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MapsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MapsUpdateMapPUT(mapToModify: MapsViewModel): Observable<MapsViewModel | null> {
        let url_ = this.baseUrl + "/v1/Maps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mapToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MapsUpdateMapPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MapsUpdateMapPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapsViewModel | null>;
        }));
    }

    protected processV1MapsUpdateMapPUT(response: HttpResponseBase): Observable<MapsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MapsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MapsCreateMapPOST(mapNew: MapInViewModel): Observable<MapsViewModel | null> {
        let url_ = this.baseUrl + "/v1/Maps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mapNew);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MapsCreateMapPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MapsCreateMapPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapsViewModel | null>;
        }));
    }

    protected processV1MapsCreateMapPOST(response: HttpResponseBase): Observable<MapsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MapsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MapsDeleteMapDELETE(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Maps/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MapsDeleteMapDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MapsDeleteMapDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1MapsDeleteMapDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MasterGetMasterTypesGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Master/MasterTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MasterGetMasterTypesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MasterGetMasterTypesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1MasterGetMasterTypesGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MasterGetAllMasterGET(masterTypeId: number, identifier: number | null | undefined): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Master?";
        if (masterTypeId === undefined || masterTypeId === null)
            throw new globalThis.Error("The parameter 'masterTypeId' must be defined and cannot be null.");
        else
            url_ += "masterTypeId=" + encodeURIComponent("" + masterTypeId) + "&";
        if (identifier !== undefined && identifier !== null)
            url_ += "identifier=" + encodeURIComponent("" + identifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MasterGetAllMasterGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MasterGetAllMasterGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1MasterGetAllMasterGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MasterPutMasterPUT(masterTypeId: number, masterToModify: MasterViewModel): Observable<MasterViewModel | null> {
        let url_ = this.baseUrl + "/v1/Master?";
        if (masterTypeId === undefined || masterTypeId === null)
            throw new globalThis.Error("The parameter 'masterTypeId' must be defined and cannot be null.");
        else
            url_ += "masterTypeId=" + encodeURIComponent("" + masterTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(masterToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MasterPutMasterPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MasterPutMasterPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel | null>;
        }));
    }

    protected processV1MasterPutMasterPUT(response: HttpResponseBase): Observable<MasterViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MasterViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MasterPostMasterPOST(masterTypeId: number, identifier: number | null | undefined, masterNew: MasterViewModel): Observable<MasterViewModel | null> {
        let url_ = this.baseUrl + "/v1/Master?";
        if (masterTypeId === undefined || masterTypeId === null)
            throw new globalThis.Error("The parameter 'masterTypeId' must be defined and cannot be null.");
        else
            url_ += "masterTypeId=" + encodeURIComponent("" + masterTypeId) + "&";
        if (identifier !== undefined && identifier !== null)
            url_ += "identifier=" + encodeURIComponent("" + identifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(masterNew);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MasterPostMasterPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MasterPostMasterPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel | null>;
        }));
    }

    protected processV1MasterPostMasterPOST(response: HttpResponseBase): Observable<MasterViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MasterViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MasterDeleteMasterDELETE(masterTypeId: number, id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Master?";
        if (masterTypeId === undefined || masterTypeId === null)
            throw new globalThis.Error("The parameter 'masterTypeId' must be defined and cannot be null.");
        else
            url_ += "masterTypeId=" + encodeURIComponent("" + masterTypeId) + "&";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MasterDeleteMasterDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MasterDeleteMasterDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1MasterDeleteMasterDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MasterGetCustomReportSourcesGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Master/CustomReportSources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MasterGetCustomReportSourcesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MasterGetCustomReportSourcesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1MasterGetCustomReportSourcesGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MemberStatusGetAllMemberStatusGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/MemberStatus/allMemberStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MemberStatusGetAllMemberStatusGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MemberStatusGetAllMemberStatusGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1MemberStatusGetAllMemberStatusGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1NotificationFieldGetAllNotificationFieldGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/NotificationField/allNotificationField";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1NotificationFieldGetAllNotificationFieldGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1NotificationFieldGetAllNotificationFieldGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1NotificationFieldGetAllNotificationFieldGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1OriginatorGetAllOriginatorGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Originator/allOriginator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1OriginatorGetAllOriginatorGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1OriginatorGetAllOriginatorGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1OriginatorGetAllOriginatorGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PriorityGetAllPriorityGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Priority/allPriority";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PriorityGetAllPriorityGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PriorityGetAllPriorityGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1PriorityGetAllPriorityGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1SignActionGetAllSignActionGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/SignAction/allSignAction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SignActionGetAllSignActionGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SignActionGetAllSignActionGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1SignActionGetAllSignActionGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1StatusGetAllStatusGET(onlyVisible: boolean): Observable<StatusViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Status/allStatus?";
        if (onlyVisible === undefined || onlyVisible === null)
            throw new globalThis.Error("The parameter 'onlyVisible' must be defined and cannot be null.");
        else
            url_ += "onlyVisible=" + encodeURIComponent("" + onlyVisible) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1StatusGetAllStatusGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1StatusGetAllStatusGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusViewModel[] | null>;
        }));
    }

    protected processV1StatusGetAllStatusGET(response: HttpResponseBase): Observable<StatusViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1SubcontractGetAllGET(): Observable<SubcontractorDto[] | null> {
        let url_ = this.baseUrl + "/v1/Subcontract/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SubcontractGetAllGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SubcontractGetAllGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubcontractorDto[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubcontractorDto[] | null>;
        }));
    }

    protected processV1SubcontractGetAllGET(response: HttpResponseBase): Observable<SubcontractorDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubcontractorDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1SubcontractGetByNameGET(name: string | null | undefined): Observable<SubcontractorDto[] | null> {
        let url_ = this.baseUrl + "/v1/Subcontract/ByName?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SubcontractGetByNameGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SubcontractGetByNameGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubcontractorDto[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubcontractorDto[] | null>;
        }));
    }

    protected processV1SubcontractGetByNameGET(response: HttpResponseBase): Observable<SubcontractorDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubcontractorDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1SubcontractGetSubcontractorsFromMasterByNameGET(name: string | null | undefined): Observable<SubcontractorDto[] | null> {
        let url_ = this.baseUrl + "/v1/Subcontract/MasterByName?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SubcontractGetSubcontractorsFromMasterByNameGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SubcontractGetSubcontractorsFromMasterByNameGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubcontractorDto[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubcontractorDto[] | null>;
        }));
    }

    protected processV1SubcontractGetSubcontractorsFromMasterByNameGET(response: HttpResponseBase): Observable<SubcontractorDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubcontractorDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1SubcontractGetByProjectTemplateGET(): Observable<SubcontractorDto[] | null> {
        let url_ = this.baseUrl + "/v1/Subcontract/ByProjectTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SubcontractGetByProjectTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SubcontractGetByProjectTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubcontractorDto[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubcontractorDto[] | null>;
        }));
    }

    protected processV1SubcontractGetByProjectTemplateGET(response: HttpResponseBase): Observable<SubcontractorDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubcontractorDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TagGetAllTagsGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Tag/allTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TagGetAllTagsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TagGetAllTagsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1TagGetAllTagsGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TopicGetAllTopicsGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Topic/allTopics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TopicGetAllTopicsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TopicGetAllTopicsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1TopicGetAllTopicsGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TopicPostImportPreviewTopicsPOST(importTopics: ImportViewModel): Observable<ImportViewModel | null> {
        let url_ = this.baseUrl + "/v1/Topic/ImportPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importTopics);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TopicPostImportPreviewTopicsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TopicPostImportPreviewTopicsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportViewModel | null>;
        }));
    }

    protected processV1TopicPostImportPreviewTopicsPOST(response: HttpResponseBase): Observable<ImportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TopicPostImportTopicsPOST(importTopics: ImportViewModel): Observable<ImportViewModel | null> {
        let url_ = this.baseUrl + "/v1/Topic/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importTopics);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TopicPostImportTopicsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TopicPostImportTopicsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportViewModel | null>;
        }));
    }

    protected processV1TopicPostImportTopicsPOST(response: HttpResponseBase): Observable<ImportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TopicPostExportTopicsPOST(exportTopics: ExportTopicViewModel): Observable<ExportViewModel | null> {
        let url_ = this.baseUrl + "/v1/Topic/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportTopics);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TopicPostExportTopicsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TopicPostExportTopicsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportViewModel | null>;
        }));
    }

    protected processV1TopicPostExportTopicsPOST(response: HttpResponseBase): Observable<ExportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TopicGetAllTopicWithTransferConfigGET(toTemplateId: number): Observable<TopicViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Topic/allTopics/{toTemplateId}";
        if (toTemplateId === undefined || toTemplateId === null)
            throw new globalThis.Error("The parameter 'toTemplateId' must be defined.");
        url_ = url_.replace("{toTemplateId}", encodeURIComponent("" + toTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TopicGetAllTopicWithTransferConfigGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TopicGetAllTopicWithTransferConfigGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicViewModel[] | null>;
        }));
    }

    protected processV1TopicGetAllTopicWithTransferConfigGET(response: HttpResponseBase): Observable<TopicViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopicViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TopicGetAllInspectionTopicsGET(inspectionId: number): Observable<TopicViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Topic/allInspectionTopics/{inspectionId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TopicGetAllInspectionTopicsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TopicGetAllInspectionTopicsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicViewModel[] | null>;
        }));
    }

    protected processV1TopicGetAllInspectionTopicsGET(response: HttpResponseBase): Observable<TopicViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopicViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TopicGetTopicsByProjectIdGET(): Observable<TopicProjectViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Topic/topicsByProjectId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TopicGetTopicsByProjectIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TopicGetTopicsByProjectIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicProjectViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicProjectViewModel[] | null>;
        }));
    }

    protected processV1TopicGetTopicsByProjectIdGET(response: HttpResponseBase): Observable<TopicProjectViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopicProjectViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MaintenanceModeGetGET(): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/MaintenanceMode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaintenanceModeGetGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaintenanceModeGetGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1MaintenanceModeGetGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MaintenanceModeCreatePOST(maintenanceMode: MaintenanceModeIn): Observable<MaintenanceModeViewModel | null> {
        let url_ = this.baseUrl + "/v1/MaintenanceMode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintenanceMode);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaintenanceModeCreatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaintenanceModeCreatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceModeViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceModeViewModel | null>;
        }));
    }

    protected processV1MaintenanceModeCreatePOST(response: HttpResponseBase): Observable<MaintenanceModeViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 ? MaintenanceModeViewModel.fromJS(resultData201) : null as any;
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MaintenanceModeUpdatePUT(maintenanceMode: MaintenanceModeIn): Observable<MaintenanceModeViewModel | null> {
        let url_ = this.baseUrl + "/v1/MaintenanceMode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maintenanceMode);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaintenanceModeUpdatePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaintenanceModeUpdatePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceModeViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceModeViewModel | null>;
        }));
    }

    protected processV1MaintenanceModeUpdatePUT(response: HttpResponseBase): Observable<MaintenanceModeViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaintenanceModeViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MaintenanceModeGetNotificationRequiredGET(): Observable<MaintenanceModeNotificationViewModel | null> {
        let url_ = this.baseUrl + "/v1/MaintenanceMode/NotificationRequired";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaintenanceModeGetNotificationRequiredGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaintenanceModeGetNotificationRequiredGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceModeNotificationViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceModeNotificationViewModel | null>;
        }));
    }

    protected processV1MaintenanceModeGetNotificationRequiredGET(response: HttpResponseBase): Observable<MaintenanceModeNotificationViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaintenanceModeNotificationViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MaintenanceModeGetAllGET(): Observable<MaintenanceModeViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/MaintenanceMode/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaintenanceModeGetAllGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaintenanceModeGetAllGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceModeViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceModeViewModel[] | null>;
        }));
    }

    protected processV1MaintenanceModeGetAllGET(response: HttpResponseBase): Observable<MaintenanceModeViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintenanceModeViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MaintenanceModeGetByIdGET(id: number): Observable<MaintenanceModeViewModel | null> {
        let url_ = this.baseUrl + "/v1/MaintenanceMode/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaintenanceModeGetByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaintenanceModeGetByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceModeViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceModeViewModel | null>;
        }));
    }

    protected processV1MaintenanceModeGetByIdGET(response: HttpResponseBase): Observable<MaintenanceModeViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaintenanceModeViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MaintenanceModeDisableAllPOST(): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/MaintenanceMode/Disable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MaintenanceModeDisableAllPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MaintenanceModeDisableAllPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1MaintenanceModeDisableAllPOST(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetAllInspectionsByDatesGET(start: Date, end: Date, allInfo: boolean): Observable<InspectionViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Inspection/allInspectionsByDates/{start}/{end}/{allInfo}";
        if (start === undefined || start === null)
            throw new globalThis.Error("The parameter 'start' must be defined.");
        url_ = url_.replace("{start}", encodeURIComponent(start ? "" + start.toISOString() : "null"));
        if (end === undefined || end === null)
            throw new globalThis.Error("The parameter 'end' must be defined.");
        url_ = url_.replace("{end}", encodeURIComponent(end ? "" + end.toISOString() : "null"));
        if (allInfo === undefined || allInfo === null)
            throw new globalThis.Error("The parameter 'allInfo' must be defined.");
        url_ = url_.replace("{allInfo}", encodeURIComponent("" + allInfo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetAllInspectionsByDatesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetAllInspectionsByDatesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionViewModel[] | null>;
        }));
    }

    protected processV1InspectionGetAllInspectionsByDatesGET(response: HttpResponseBase): Observable<InspectionViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetAllInspectionsPagedPOST(dataSourceViewModel: InspectionDataSourceViewModel): Observable<InspectionViewModelDataSourceResult | null> {
        let url_ = this.baseUrl + "/v1/Inspection/allInspections/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataSourceViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetAllInspectionsPagedPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetAllInspectionsPagedPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionViewModelDataSourceResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionViewModelDataSourceResult | null>;
        }));
    }

    protected processV1InspectionGetAllInspectionsPagedPOST(response: HttpResponseBase): Observable<InspectionViewModelDataSourceResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionViewModelDataSourceResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetIdsFilteredPOST(dataSourceViewModel: InspectionDataSourceViewModel): Observable<number[] | null> {
        let url_ = this.baseUrl + "/v1/Inspection/GetIds/Filtered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataSourceViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetIdsFilteredPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetIdsFilteredPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[] | null>;
        }));
    }

    protected processV1InspectionGetIdsFilteredPOST(response: HttpResponseBase): Observable<number[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionCheckInspectionNameAvailabilityGET(inspectionName: string): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Inspection/checkNameAvailability/{inspectionName}";
        if (inspectionName === undefined || inspectionName === null)
            throw new globalThis.Error("The parameter 'inspectionName' must be defined.");
        url_ = url_.replace("{inspectionName}", encodeURIComponent("" + inspectionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionCheckInspectionNameAvailabilityGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionCheckInspectionNameAvailabilityGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1InspectionCheckInspectionNameAvailabilityGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetAllInspectionWithTransferConfigGET(toTemplateId: number): Observable<InspectionViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Inspection/allInspections/{toTemplateId}";
        if (toTemplateId === undefined || toTemplateId === null)
            throw new globalThis.Error("The parameter 'toTemplateId' must be defined.");
        url_ = url_.replace("{toTemplateId}", encodeURIComponent("" + toTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetAllInspectionWithTransferConfigGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetAllInspectionWithTransferConfigGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionViewModel[] | null>;
        }));
    }

    protected processV1InspectionGetAllInspectionWithTransferConfigGET(response: HttpResponseBase): Observable<InspectionViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetInspectionByIdGET(inspectionId: number, allInfo: boolean): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/{allInfo}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (allInfo === undefined || allInfo === null)
            throw new globalThis.Error("The parameter 'allInfo' must be defined.");
        url_ = url_.replace("{allInfo}", encodeURIComponent("" + allInfo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetInspectionByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetInspectionByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionGetInspectionByIdGET(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostInspectionPOST(inspectionCreate: InspectionViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionCreate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPutInspectionPUT(inspectionModify: InspectionDetailViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPutInspectionPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPutInspectionPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPutInspectionPUT(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionDeleteInspectionDELETE(inspectionId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/Inspection?";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionDeleteInspectionDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionDeleteInspectionDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1InspectionDeleteInspectionDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPutInspectionMeetingPointPUT(inspectionModify: InspectionDetailViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/MeetingPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPutInspectionMeetingPointPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPutInspectionMeetingPointPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPutInspectionMeetingPointPUT(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostScheduleInspectionPOST(inspectionId: number): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/Schedule";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostScheduleInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostScheduleInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostScheduleInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostPreparationInspectionPOST(inspectionId: number): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/Preparation";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostPreparationInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostPreparationInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostPreparationInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostStartInspectionPOST(inspectionOptions: InspectionOptionsViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/Start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostStartInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostStartInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostStartInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostPauseInspectionPOST(inspectionOptions: InspectionOptionsViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/Pause";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostPauseInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostPauseInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostPauseInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostRescheduleInspectionPOST(inspectionOptions: InspectionOptionsViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/Reschedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostRescheduleInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostRescheduleInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostRescheduleInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostCancelInspectionPOST(inspectionOptions: InspectionOptionsViewModel): Observable<InspectionDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/Inspection/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostCancelInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostCancelInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailViewModel | null>;
        }));
    }

    protected processV1InspectionPostCancelInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostCompletedInspectionPOST(inspectionOptions: InspectionOptionsViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/Completed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostCompletedInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostCompletedInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostCompletedInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostConsolidatedInspectionPOST(inspectionId: number): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/Consolidated/{inspectionId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostConsolidatedInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostConsolidatedInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostConsolidatedInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostBackToCompletedStatusPOST(inspectionId: number): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/BackToCompletedStatus/{inspectionId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostBackToCompletedStatusPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostBackToCompletedStatusPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostBackToCompletedStatusPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetAttendeesByInspectionIdGET(inspectionId: number): Observable<UserInspectionViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/Attendees";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetAttendeesByInspectionIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetAttendeesByInspectionIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInspectionViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInspectionViewModel[] | null>;
        }));
    }

    protected processV1InspectionGetAttendeesByInspectionIdGET(response: HttpResponseBase): Observable<UserInspectionViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInspectionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostAttendeeInspectionPOST(attendee: AttendeeViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/Attendee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attendee);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostAttendeeInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostAttendeeInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostAttendeeInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostAttendeesInspectionPOST(attendees: AttendeeViewModel[]): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/Attendees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attendees);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostAttendeesInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostAttendeesInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostAttendeesInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostConfirmAttendeeInspectionPOST(attendee: AttendeeViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/ConfirmAttendee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attendee);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostConfirmAttendeeInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostConfirmAttendeeInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostConfirmAttendeeInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionDeleteAttendeeInspectionDELETE(inspectionId: number, userId: string): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/Attendee/{inspectionId}/{userId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionDeleteAttendeeInspectionDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionDeleteAttendeeInspectionDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionDeleteAttendeeInspectionDELETE(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostSendInvitationsPOST(inspectionId: number): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/SendInvitations";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostSendInvitationsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostSendInvitationsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostSendInvitationsPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostSendInvitationPOST(inspectionId: number, userId: string): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/SendInvitation/{userId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostSendInvitationPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostSendInvitationPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostSendInvitationPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionAcceptInvitationPOST(inspectionMemberId: string, accept: boolean): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/AcceptInvitation/{inspectionMemberId}/{accept}";
        if (inspectionMemberId === undefined || inspectionMemberId === null)
            throw new globalThis.Error("The parameter 'inspectionMemberId' must be defined.");
        url_ = url_.replace("{inspectionMemberId}", encodeURIComponent("" + inspectionMemberId));
        if (accept === undefined || accept === null)
            throw new globalThis.Error("The parameter 'accept' must be defined.");
        url_ = url_.replace("{accept}", encodeURIComponent("" + accept));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionAcceptInvitationPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionAcceptInvitationPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionAcceptInvitationPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPutOrganizerPUT(inspectionId: number, userId: string): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/Organizer/{userId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPutOrganizerPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPutOrganizerPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPutOrganizerPUT(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPutDiscardAttendeeInspectionPUT(attendee: AttendeeViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/DiscardAttendeeUnknown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attendee);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPutDiscardAttendeeInspectionPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPutDiscardAttendeeInspectionPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPutDiscardAttendeeInspectionPUT(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPutConsolidateAttendeeInspectionPUT(attendee: AttendeeViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/ConsolidateAttendeeUnknown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attendee);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPutConsolidateAttendeeInspectionPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPutConsolidateAttendeeInspectionPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPutConsolidateAttendeeInspectionPUT(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetInspectionMediasInspectionGET(inspectionId: number): Observable<InspectionMediaViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/Files";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetInspectionMediasInspectionGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetInspectionMediasInspectionGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionMediaViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionMediaViewModel[] | null>;
        }));
    }

    protected processV1InspectionGetInspectionMediasInspectionGET(response: HttpResponseBase): Observable<InspectionMediaViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionMediaViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetInspectionMediaInspectionGET(inspectionId: number, fileId: number): Observable<InspectionMediaViewModel | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/File/{fileId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetInspectionMediaInspectionGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetInspectionMediaInspectionGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionMediaViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionMediaViewModel | null>;
        }));
    }

    protected processV1InspectionGetInspectionMediaInspectionGET(response: HttpResponseBase): Observable<InspectionMediaViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionMediaViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostInspectionMediaInspectionPOST(inspectionId: number, inspectionMedia: InspectionMediaViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/File";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionMedia);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostInspectionMediaInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostInspectionMediaInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPostInspectionMediaInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPutInspectionMediaInspectionPUT(inspectionId: number, inspectionMedia: InspectionMediaViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/File";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionMedia);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPutInspectionMediaInspectionPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPutInspectionMediaInspectionPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionPutInspectionMediaInspectionPUT(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPutInspectionRootMediaPUT(inspectionId: number, inspectionFileId: number): Observable<InspectionMediaViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/File/{inspectionFileId}/Default";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (inspectionFileId === undefined || inspectionFileId === null)
            throw new globalThis.Error("The parameter 'inspectionFileId' must be defined.");
        url_ = url_.replace("{inspectionFileId}", encodeURIComponent("" + inspectionFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPutInspectionRootMediaPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPutInspectionRootMediaPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionMediaViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionMediaViewModel[] | null>;
        }));
    }

    protected processV1InspectionPutInspectionRootMediaPUT(response: HttpResponseBase): Observable<InspectionMediaViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionMediaViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPutInspectionDefaultDownloadMediaPUT(inspectionId: number, inspectionFileId: number): Observable<InspectionMediaViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/File/{inspectionFileId}/DefaultDownload";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (inspectionFileId === undefined || inspectionFileId === null)
            throw new globalThis.Error("The parameter 'inspectionFileId' must be defined.");
        url_ = url_.replace("{inspectionFileId}", encodeURIComponent("" + inspectionFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPutInspectionDefaultDownloadMediaPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPutInspectionDefaultDownloadMediaPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionMediaViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionMediaViewModel[] | null>;
        }));
    }

    protected processV1InspectionPutInspectionDefaultDownloadMediaPUT(response: HttpResponseBase): Observable<InspectionMediaViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionMediaViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionDeleteInspectionMediaInspectionDELETE(inspectionId: number, inspectionFileId: number): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/File/{inspectionFileId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (inspectionFileId === undefined || inspectionFileId === null)
            throw new globalThis.Error("The parameter 'inspectionFileId' must be defined.");
        url_ = url_.replace("{inspectionFileId}", encodeURIComponent("" + inspectionFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionDeleteInspectionMediaInspectionDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionDeleteInspectionMediaInspectionDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionDeleteInspectionMediaInspectionDELETE(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionApproveInspectionPunchesPUT(inspectionId: number, punchesbulk: PunchBulkModifyViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/ApprovePunches";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchesbulk);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionApproveInspectionPunchesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionApproveInspectionPunchesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionApproveInspectionPunchesPUT(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionDiscardInspectionPunchesPUT(inspectionId: number, punchesbulk: PunchBulkModifyViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/DiscardPunches";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchesbulk);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionDiscardInspectionPunchesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionDiscardInspectionPunchesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionDiscardInspectionPunchesPUT(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionModifyInspectionPunchesPUT(inspectionId: number, punchesbulk: PunchBulkModifyViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/ModifyPunches";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchesbulk);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionModifyInspectionPunchesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionModifyInspectionPunchesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionModifyInspectionPunchesPUT(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetInspectionSelectedItemsGET(inspectionId: number): Observable<ElementOutDto[] | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/Items";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetInspectionSelectedItemsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetInspectionSelectedItemsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementOutDto[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementOutDto[] | null>;
        }));
    }

    protected processV1InspectionGetInspectionSelectedItemsGET(response: HttpResponseBase): Observable<ElementOutDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementOutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionInspectionSelectedItemsPUT(inspectionId: number, addElemnts: boolean, inspectionSelectedItems: InspectionSelectedItemViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/Items/{addElemnts}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        if (addElemnts === undefined || addElemnts === null)
            throw new globalThis.Error("The parameter 'addElemnts' must be defined.");
        url_ = url_.replace("{addElemnts}", encodeURIComponent("" + addElemnts));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionSelectedItems);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionInspectionSelectedItemsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionInspectionSelectedItemsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1InspectionInspectionSelectedItemsPUT(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostImportInspectionPreviewPOST(projectId: number | null | undefined, templateId: number | null | undefined, inspectionId: number): Observable<ImportViewModel | null> {
        let url_ = this.baseUrl + "/v1/Inspection/ExportItems?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId !== undefined && templateId !== null)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostImportInspectionPreviewPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostImportInspectionPreviewPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportViewModel | null>;
        }));
    }

    protected processV1InspectionPostImportInspectionPreviewPOST(response: HttpResponseBase): Observable<ImportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostInspectionPunchImportPreviewPOST(punchImport: PunchImportViewModel): Observable<PunchImportPreviewViewModel | null> {
        let url_ = this.baseUrl + "/v1/Inspection/ImportPunchesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchImport);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostInspectionPunchImportPreviewPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostInspectionPunchImportPreviewPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchImportPreviewViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchImportPreviewViewModel | null>;
        }));
    }

    protected processV1InspectionPostInspectionPunchImportPreviewPOST(response: HttpResponseBase): Observable<PunchImportPreviewViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchImportPreviewViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetPunchTemplateGET(multipleInspections: boolean): Observable<ExportViewModel | null> {
        let url_ = this.baseUrl + "/v1/Inspection/PunchesTemplate?";
        if (multipleInspections === undefined || multipleInspections === null)
            throw new globalThis.Error("The parameter 'multipleInspections' must be defined and cannot be null.");
        else
            url_ += "multipleInspections=" + encodeURIComponent("" + multipleInspections) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetPunchTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetPunchTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportViewModel | null>;
        }));
    }

    protected processV1InspectionGetPunchTemplateGET(response: HttpResponseBase): Observable<ExportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostInspectionPunchImportPOST(punchImport: PunchImportViewModel): Observable<PunchImportPreviewViewModel | null> {
        let url_ = this.baseUrl + "/v1/Inspection/ImportPunches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchImport);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostInspectionPunchImportPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostInspectionPunchImportPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchImportPreviewViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchImportPreviewViewModel | null>;
        }));
    }

    protected processV1InspectionPostInspectionPunchImportPOST(response: HttpResponseBase): Observable<PunchImportPreviewViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchImportPreviewViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionPostMultipleInspectionPunchImportPOST(isPreview: boolean, punchImport: PunchImportMultipleInspectionsViewModel): Observable<PunchImportMultipleInspectionsPreviewViewModel | null> {
        let url_ = this.baseUrl + "/v1/Inspection/ImportPunchesMultipleInspection?";
        if (isPreview === undefined || isPreview === null)
            throw new globalThis.Error("The parameter 'isPreview' must be defined and cannot be null.");
        else
            url_ += "isPreview=" + encodeURIComponent("" + isPreview) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchImport);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionPostMultipleInspectionPunchImportPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionPostMultipleInspectionPunchImportPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchImportMultipleInspectionsPreviewViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchImportMultipleInspectionsPreviewViewModel | null>;
        }));
    }

    protected processV1InspectionPostMultipleInspectionPunchImportPOST(response: HttpResponseBase): Observable<PunchImportMultipleInspectionsPreviewViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchImportMultipleInspectionsPreviewViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionConsolidateMultipleInspectionsPOST(inspectionsIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/v1/Inspection/ConsolidateMultipleInspection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionsIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionConsolidateMultipleInspectionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionConsolidateMultipleInspectionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1InspectionConsolidateMultipleInspectionsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetConsolidateMultipleInspectionsPreviewPOST(inspectionsIds: number[]): Observable<TemplateSetUpDto | null> {
        let url_ = this.baseUrl + "/v1/Inspection/ConsolidateMultipleInspection/Preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionsIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetConsolidateMultipleInspectionsPreviewPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetConsolidateMultipleInspectionsPreviewPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateSetUpDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateSetUpDto | null>;
        }));
    }

    protected processV1InspectionGetConsolidateMultipleInspectionsPreviewPOST(response: HttpResponseBase): Observable<TemplateSetUpDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateSetUpDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetRemarksByInspectionIdGET(inspectionId: number): Observable<InspectionRemarkViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/Remarks";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetRemarksByInspectionIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetRemarksByInspectionIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionRemarkViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionRemarkViewModel[] | null>;
        }));
    }

    protected processV1InspectionGetRemarksByInspectionIdGET(response: HttpResponseBase): Observable<InspectionRemarkViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionRemarkViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetUserWalkByInspectionIdGET(inspectionId: number): Observable<UserWalkOutDto[] | null> {
        let url_ = this.baseUrl + "/v1/Inspection/{inspectionId}/UserWalks";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetUserWalkByInspectionIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetUserWalkByInspectionIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWalkOutDto[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWalkOutDto[] | null>;
        }));
    }

    protected processV1InspectionGetUserWalkByInspectionIdGET(response: HttpResponseBase): Observable<UserWalkOutDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWalkOutDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionDeleteMultipleInspectionsDELETE(inspectionsIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/v1/Inspection/multipleInspections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionsIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionDeleteMultipleInspectionsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionDeleteMultipleInspectionsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1InspectionDeleteMultipleInspectionsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionGetInspectionStatusesGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Inspection/InspectionStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionGetInspectionStatusesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionGetInspectionStatusesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1InspectionGetInspectionStatusesGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeGetInspectionTypeAllGET(): Observable<InspectionTypeViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/InspectionType/allInspectionsTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeGetInspectionTypeAllGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeGetInspectionTypeAllGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeViewModel[] | null>;
        }));
    }

    protected processV1InspectionTypeGetInspectionTypeAllGET(response: HttpResponseBase): Observable<InspectionTypeViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionTypeViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeGetInspectionTypeByIdGET(inspectionTypeId: number): Observable<InspectionTypeViewModel | null> {
        let url_ = this.baseUrl + "/v1/InspectionType/{inspectionTypeId}";
        if (inspectionTypeId === undefined || inspectionTypeId === null)
            throw new globalThis.Error("The parameter 'inspectionTypeId' must be defined.");
        url_ = url_.replace("{inspectionTypeId}", encodeURIComponent("" + inspectionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeGetInspectionTypeByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeGetInspectionTypeByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeViewModel | null>;
        }));
    }

    protected processV1InspectionTypeGetInspectionTypeByIdGET(response: HttpResponseBase): Observable<InspectionTypeViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionTypeViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeDeleteInspectionTypeInspectionTypeDELETE(inspectionTypeId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/InspectionType/{inspectionTypeId}";
        if (inspectionTypeId === undefined || inspectionTypeId === null)
            throw new globalThis.Error("The parameter 'inspectionTypeId' must be defined.");
        url_ = url_.replace("{inspectionTypeId}", encodeURIComponent("" + inspectionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeDeleteInspectionTypeInspectionTypeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeDeleteInspectionTypeInspectionTypeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1InspectionTypeDeleteInspectionTypeInspectionTypeDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypePostInspectionTypeInspectionTypePOST(inspectionTypeToAdd: InspectionTypeViewModel): Observable<InspectionTypeViewModel | null> {
        let url_ = this.baseUrl + "/v1/InspectionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionTypeToAdd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypePostInspectionTypeInspectionTypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypePostInspectionTypeInspectionTypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeViewModel | null>;
        }));
    }

    protected processV1InspectionTypePostInspectionTypeInspectionTypePOST(response: HttpResponseBase): Observable<InspectionTypeViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionTypeViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypePutInspectionTypeInspectionTypePUT(inspectionTypeToModify: InspectionTypeViewModel): Observable<InspectionTypeViewModel | null> {
        let url_ = this.baseUrl + "/v1/InspectionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionTypeToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypePutInspectionTypeInspectionTypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypePutInspectionTypeInspectionTypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeViewModel | null>;
        }));
    }

    protected processV1InspectionTypePutInspectionTypeInspectionTypePUT(response: HttpResponseBase): Observable<InspectionTypeViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionTypeViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeGetInspectionTypeCategoriesByIdGET(inspectionTypeId: number): Observable<CategoryViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/InspectionType/{inspectionTypeId}/Categories";
        if (inspectionTypeId === undefined || inspectionTypeId === null)
            throw new globalThis.Error("The parameter 'inspectionTypeId' must be defined.");
        url_ = url_.replace("{inspectionTypeId}", encodeURIComponent("" + inspectionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeGetInspectionTypeCategoriesByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeGetInspectionTypeCategoriesByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryViewModel[] | null>;
        }));
    }

    protected processV1InspectionTypeGetInspectionTypeCategoriesByIdGET(response: HttpResponseBase): Observable<CategoryViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeInspectionTypesSelectedCategoriesPUT(inpectionTypesSelectedCategories: InspectionTypeSelectedCategoriesViewModel): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/InspectionType/Categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inpectionTypesSelectedCategories);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeInspectionTypesSelectedCategoriesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeInspectionTypesSelectedCategoriesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1InspectionTypeInspectionTypesSelectedCategoriesPUT(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeGetInspectionTypeTopicsByIdGET(inspectionTypeId: number): Observable<TopicViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/InspectionType/{inspectionTypeId}/Topics";
        if (inspectionTypeId === undefined || inspectionTypeId === null)
            throw new globalThis.Error("The parameter 'inspectionTypeId' must be defined.");
        url_ = url_.replace("{inspectionTypeId}", encodeURIComponent("" + inspectionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeGetInspectionTypeTopicsByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeGetInspectionTypeTopicsByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicViewModel[] | null>;
        }));
    }

    protected processV1InspectionTypeGetInspectionTypeTopicsByIdGET(response: HttpResponseBase): Observable<TopicViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopicViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeInspectionTypesSelectedTopicsPUT(inpectionTypesSelectedTopics: InspectionTypeSelectedTopicsViewModel): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/InspectionType/Topics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inpectionTypesSelectedTopics);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeInspectionTypesSelectedTopicsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeInspectionTypesSelectedTopicsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1InspectionTypeInspectionTypesSelectedTopicsPUT(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeGetFlowSignsByInspectionTypeIdGET(inspectionTypeId: number): Observable<InspectionTypeFlowSignViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/InspectionType/{inspectionTypeId}/FlowSigns";
        if (inspectionTypeId === undefined || inspectionTypeId === null)
            throw new globalThis.Error("The parameter 'inspectionTypeId' must be defined.");
        url_ = url_.replace("{inspectionTypeId}", encodeURIComponent("" + inspectionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeGetFlowSignsByInspectionTypeIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeGetFlowSignsByInspectionTypeIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeFlowSignViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeFlowSignViewModel[] | null>;
        }));
    }

    protected processV1InspectionTypeGetFlowSignsByInspectionTypeIdGET(response: HttpResponseBase): Observable<InspectionTypeFlowSignViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionTypeFlowSignViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeCanEditSignsOrderGET(inspectionTypeId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/InspectionType/{inspectionTypeId}/FlowSigns/CanEditSignsOrder";
        if (inspectionTypeId === undefined || inspectionTypeId === null)
            throw new globalThis.Error("The parameter 'inspectionTypeId' must be defined.");
        url_ = url_.replace("{inspectionTypeId}", encodeURIComponent("" + inspectionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeCanEditSignsOrderGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeCanEditSignsOrderGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1InspectionTypeCanEditSignsOrderGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeGetInspectionTypeFlowSignByIdGET(signId: number): Observable<InspectionTypeFlowSignViewModel | null> {
        let url_ = this.baseUrl + "/v1/InspectionType/FlowSign/{signId}";
        if (signId === undefined || signId === null)
            throw new globalThis.Error("The parameter 'signId' must be defined.");
        url_ = url_.replace("{signId}", encodeURIComponent("" + signId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeGetInspectionTypeFlowSignByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeGetInspectionTypeFlowSignByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeFlowSignViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeFlowSignViewModel | null>;
        }));
    }

    protected processV1InspectionTypeGetInspectionTypeFlowSignByIdGET(response: HttpResponseBase): Observable<InspectionTypeFlowSignViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionTypeFlowSignViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypePostInspectionTypeFlowSignPOST(signToCreate: InspectionTypeFlowSignViewModel): Observable<InspectionTypeFlowSignViewModel | null> {
        let url_ = this.baseUrl + "/v1/InspectionType/FlowSign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signToCreate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypePostInspectionTypeFlowSignPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypePostInspectionTypeFlowSignPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeFlowSignViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeFlowSignViewModel | null>;
        }));
    }

    protected processV1InspectionTypePostInspectionTypeFlowSignPOST(response: HttpResponseBase): Observable<InspectionTypeFlowSignViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionTypeFlowSignViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypePutInspectionTypeFlowSignPUT(singToModify: InspectionTypeFlowSignViewModel): Observable<InspectionTypeFlowSignViewModel | null> {
        let url_ = this.baseUrl + "/v1/InspectionType/FlowSign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(singToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypePutInspectionTypeFlowSignPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypePutInspectionTypeFlowSignPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionTypeFlowSignViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionTypeFlowSignViewModel | null>;
        }));
    }

    protected processV1InspectionTypePutInspectionTypeFlowSignPUT(response: HttpResponseBase): Observable<InspectionTypeFlowSignViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionTypeFlowSignViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeDeleteInspectionTypeFlowSignDELETE(singId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/InspectionType/FlowSign/{singId}";
        if (singId === undefined || singId === null)
            throw new globalThis.Error("The parameter 'singId' must be defined.");
        url_ = url_.replace("{singId}", encodeURIComponent("" + singId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeDeleteInspectionTypeFlowSignDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeDeleteInspectionTypeFlowSignDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1InspectionTypeDeleteInspectionTypeFlowSignDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionTypeFlowTypeGetAllInspectionTypeFlowTypeGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/InspectionTypeFlowType/allInspectionTypeFlowType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionTypeFlowTypeGetAllInspectionTypeFlowTypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionTypeFlowTypeGetAllInspectionTypeFlowTypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1InspectionTypeFlowTypeGetAllInspectionTypeFlowTypeGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionWalkAnyAvailableGET(inspectionId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/InspectionWalk/AnyAvailable/{inspectionId}";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionWalkAnyAvailableGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionWalkAnyAvailableGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processV1InspectionWalkAnyAvailableGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetAllPunchesBookmarksPagedPOST(queryIn: PunchesQueryInDto): Observable<PunchBookmarksViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/External/punch/allPunchesBookmarks/paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetAllPunchesBookmarksPagedPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetAllPunchesBookmarksPagedPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchBookmarksViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchBookmarksViewModel[] | null>;
        }));
    }

    protected processV1ExternalGetAllPunchesBookmarksPagedPOST(response: HttpResponseBase): Observable<PunchBookmarksViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PunchBookmarksViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetPunchesBookmarksByInspectionIdsPagedPOST(applicationName: string | null | undefined, queryIn: PunchesWithInspectionQueryInDto): Observable<PunchBookmarksViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/External/punch/punchesBookmarksByInspectionIds/Paged?";
        if (applicationName !== undefined && applicationName !== null)
            url_ += "applicationName=" + encodeURIComponent("" + applicationName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetPunchesBookmarksByInspectionIdsPagedPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetPunchesBookmarksByInspectionIdsPagedPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchBookmarksViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchBookmarksViewModel[] | null>;
        }));
    }

    protected processV1ExternalGetPunchesBookmarksByInspectionIdsPagedPOST(response: HttpResponseBase): Observable<PunchBookmarksViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PunchBookmarksViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetPunchesIdsFilteredPOST(filterIn: PunchesFilterInDto): Observable<number[] | null> {
        let url_ = this.baseUrl + "/v1/External/punch/IdsFiltered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetPunchesIdsFilteredPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetPunchesIdsFilteredPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[] | null>;
        }));
    }

    protected processV1ExternalGetPunchesIdsFilteredPOST(response: HttpResponseBase): Observable<number[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetPunchesByIdsPOST(punchesIds: number[]): Observable<PunchMilestoneExportViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/External/punch/ByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchesIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetPunchesByIdsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetPunchesByIdsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchMilestoneExportViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchMilestoneExportViewModel[] | null>;
        }));
    }

    protected processV1ExternalGetPunchesByIdsPOST(response: HttpResponseBase): Observable<PunchMilestoneExportViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PunchMilestoneExportViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetTemplatesByProjectIdGET(projectId: number): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/External/template/templatesByProjectId?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetTemplatesByProjectIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetTemplatesByProjectIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1ExternalGetTemplatesByProjectIdGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalCheckSqmsTagByProjectIdGET(projectId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/External/template/checkSqmsTagByProjectId?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalCheckSqmsTagByProjectIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalCheckSqmsTagByProjectIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ExternalCheckSqmsTagByProjectIdGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetTemplateIdByProjectIdAndApplicationNameGET(projectId: number, applicationName: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/v1/External/template/templateIdByProjectIdAndApplicationName?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (applicationName !== undefined && applicationName !== null)
            url_ += "applicationName=" + encodeURIComponent("" + applicationName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetTemplateIdByProjectIdAndApplicationNameGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetTemplateIdByProjectIdAndApplicationNameGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1ExternalGetTemplateIdByProjectIdAndApplicationNameGET(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetPunchFiltersByProjectTemplateGET(projectId: number, templateId: number): Observable<PropertyFilterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/External/filtersByProjectTemplate?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetPunchFiltersByProjectTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetPunchFiltersByProjectTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyFilterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyFilterViewModel[] | null>;
        }));
    }

    protected processV1ExternalGetPunchFiltersByProjectTemplateGET(response: HttpResponseBase): Observable<PropertyFilterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyFilterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetPunchDynamicBookmarksByProjectTemplateGET(projectId: number, templateId: number): Observable<BookmarkDataWapPunchReflectionViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/External/dynamicBookmarksByProjectTemplate?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetPunchDynamicBookmarksByProjectTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetPunchDynamicBookmarksByProjectTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookmarkDataWapPunchReflectionViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookmarkDataWapPunchReflectionViewModel[] | null>;
        }));
    }

    protected processV1ExternalGetPunchDynamicBookmarksByProjectTemplateGET(response: HttpResponseBase): Observable<BookmarkDataWapPunchReflectionViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookmarkDataWapPunchReflectionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalCreateInspectionIfPreviousConsolidatedPOST(inspectionId: number): Observable<number> {
        let url_ = this.baseUrl + "/v1/External/CreateInspectionIfPreviousConsolidated?";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalCreateInspectionIfPreviousConsolidatedPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalCreateInspectionIfPreviousConsolidatedPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1ExternalCreateInspectionIfPreviousConsolidatedPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalHasInspectionDiscardPunchesGET(inspectionId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/External/HasInspectionDiscardPunches?";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalHasInspectionDiscardPunchesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalHasInspectionDiscardPunchesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ExternalHasInspectionDiscardPunchesGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalCreateAndStartInspectionPOST(planningDate: Date, inspectionName: string | null | undefined, elementIds: number[]): Observable<number> {
        let url_ = this.baseUrl + "/v1/External/createAndStartInspection?";
        if (planningDate === undefined || planningDate === null)
            throw new globalThis.Error("The parameter 'planningDate' must be defined and cannot be null.");
        else
            url_ += "planningDate=" + encodeURIComponent(planningDate ? "" + planningDate.toISOString() : "") + "&";
        if (inspectionName !== undefined && inspectionName !== null)
            url_ += "inspectionName=" + encodeURIComponent("" + inspectionName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(elementIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalCreateAndStartInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalCreateAndStartInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1ExternalCreateAndStartInspectionPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalDeleteInspectionDELETE(inspectionId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/External/inspection/deleteInspection?";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalDeleteInspectionDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalDeleteInspectionDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ExternalDeleteInspectionDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalUpdateInspectionNamePUT(inspectionId: number, inspectionName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/v1/External/inspection/updateInspectionName?";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (inspectionName !== undefined && inspectionName !== null)
            url_ += "inspectionName=" + encodeURIComponent("" + inspectionName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalUpdateInspectionNamePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalUpdateInspectionNamePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ExternalUpdateInspectionNamePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalPostCompletedInspectionPOST(inspectionOptions: InspectionOptionsViewModel): Observable<InspectionDetailDto | null> {
        let url_ = this.baseUrl + "/v1/External/inspection/completedInspection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalPostCompletedInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalPostCompletedInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionDetailDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionDetailDto | null>;
        }));
    }

    protected processV1ExternalPostCompletedInspectionPOST(response: HttpResponseBase): Observable<InspectionDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalStartInspectionIfCompletedPOST(inspectionId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/External/startInspectionIfCompleted?";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalStartInspectionIfCompletedPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalStartInspectionIfCompletedPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ExternalStartInspectionIfCompletedPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalHasInspectionPunchesGET(inspectionId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/External/inspection/hasInspectionPunches?";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalHasInspectionPunchesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalHasInspectionPunchesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ExternalHasInspectionPunchesGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetPunchesOnInspectionsPOST(queryIn: PunchesWithInspectionQueryInDto): Observable<PunchSimpleViewModelQueryResult | null> {
        let url_ = this.baseUrl + "/v1/External/punch/punchesOnInspections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetPunchesOnInspectionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetPunchesOnInspectionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchSimpleViewModelQueryResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchSimpleViewModelQueryResult | null>;
        }));
    }

    protected processV1ExternalGetPunchesOnInspectionsPOST(response: HttpResponseBase): Observable<PunchSimpleViewModelQueryResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchSimpleViewModelQueryResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetPunchDetailsByIdGET(punchId: number): Observable<PunchDetailSimpleViewModel | null> {
        let url_ = this.baseUrl + "/v1/External/punch/punchDetailsById?";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined and cannot be null.");
        else
            url_ += "punchId=" + encodeURIComponent("" + punchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetPunchDetailsByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetPunchDetailsByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailSimpleViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailSimpleViewModel | null>;
        }));
    }

    protected processV1ExternalGetPunchDetailsByIdGET(response: HttpResponseBase): Observable<PunchDetailSimpleViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailSimpleViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalCreateSimplePunchPOST(punchNew: PunchDetailSimpleInViewModel): Observable<number> {
        let url_ = this.baseUrl + "/v1/External/punch/createSimplePunch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchNew);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalCreateSimplePunchPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalCreateSimplePunchPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1ExternalCreateSimplePunchPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalUpdateSimplePunchPUT(punchToModify: PunchDetailSimpleInViewModel): Observable<number> {
        let url_ = this.baseUrl + "/v1/External/punch/updateSimplePunch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalUpdateSimplePunchPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalUpdateSimplePunchPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1ExternalUpdateSimplePunchPUT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalClonePunchPOST(punchId: number, inspectionId: number, copyAttachments: boolean): Observable<void> {
        let url_ = this.baseUrl + "/v1/External/punch/clonePunch?";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined and cannot be null.");
        else
            url_ += "punchId=" + encodeURIComponent("" + punchId) + "&";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        if (copyAttachments === undefined || copyAttachments === null)
            throw new globalThis.Error("The parameter 'copyAttachments' must be defined and cannot be null.");
        else
            url_ += "copyAttachments=" + encodeURIComponent("" + copyAttachments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalClonePunchPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalClonePunchPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ExternalClonePunchPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalSplitPunchPOST(punchId: number, copyAttachments: boolean): Observable<void> {
        let url_ = this.baseUrl + "/v1/External/punch/splitPunch?";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined and cannot be null.");
        else
            url_ += "punchId=" + encodeURIComponent("" + punchId) + "&";
        if (copyAttachments === undefined || copyAttachments === null)
            throw new globalThis.Error("The parameter 'copyAttachments' must be defined and cannot be null.");
        else
            url_ += "copyAttachments=" + encodeURIComponent("" + copyAttachments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalSplitPunchPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalSplitPunchPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ExternalSplitPunchPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalDeleteTemporalPunchDELETE(punchId: number, createUser: boolean): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/External/punch/deleteTemporalPunch?";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined and cannot be null.");
        else
            url_ += "punchId=" + encodeURIComponent("" + punchId) + "&";
        if (createUser === undefined || createUser === null)
            throw new globalThis.Error("The parameter 'createUser' must be defined and cannot be null.");
        else
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalDeleteTemporalPunchDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalDeleteTemporalPunchDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ExternalDeleteTemporalPunchDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalCreatePunchMediaPOST(media: PunchMediaViewModel): Observable<PunchMediaViewModel | null> {
        let url_ = this.baseUrl + "/v1/External/punchMedia/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(media);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalCreatePunchMediaPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalCreatePunchMediaPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchMediaViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchMediaViewModel | null>;
        }));
    }

    protected processV1ExternalCreatePunchMediaPOST(response: HttpResponseBase): Observable<PunchMediaViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchMediaViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalUpdatePunchMediaPUT(mediaModify: PunchMediaViewModel): Observable<PunchMediaViewModel | null> {
        let url_ = this.baseUrl + "/v1/External/punchMedia/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mediaModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalUpdatePunchMediaPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalUpdatePunchMediaPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchMediaViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchMediaViewModel | null>;
        }));
    }

    protected processV1ExternalUpdatePunchMediaPUT(response: HttpResponseBase): Observable<PunchMediaViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchMediaViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalDeletePunchMediaPOST(punchMediaId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/External/punchMedia/delete?";
        if (punchMediaId === undefined || punchMediaId === null)
            throw new globalThis.Error("The parameter 'punchMediaId' must be defined and cannot be null.");
        else
            url_ += "punchMediaId=" + encodeURIComponent("" + punchMediaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalDeletePunchMediaPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalDeletePunchMediaPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ExternalDeletePunchMediaPOST(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetPunchMediaByIdGET(punchMediaId: number): Observable<PunchMediaViewModel | null> {
        let url_ = this.baseUrl + "/v1/External/punchMedia/GetById?";
        if (punchMediaId === undefined || punchMediaId === null)
            throw new globalThis.Error("The parameter 'punchMediaId' must be defined and cannot be null.");
        else
            url_ += "punchMediaId=" + encodeURIComponent("" + punchMediaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetPunchMediaByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetPunchMediaByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchMediaViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchMediaViewModel | null>;
        }));
    }

    protected processV1ExternalGetPunchMediaByIdGET(response: HttpResponseBase): Observable<PunchMediaViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchMediaViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalSetPunchMediaCoverPUT(punchMediaId: number): Observable<PunchMediaViewModel | null> {
        let url_ = this.baseUrl + "/v1/External/punch/setPunchMediaCover?";
        if (punchMediaId === undefined || punchMediaId === null)
            throw new globalThis.Error("The parameter 'punchMediaId' must be defined and cannot be null.");
        else
            url_ += "punchMediaId=" + encodeURIComponent("" + punchMediaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalSetPunchMediaCoverPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalSetPunchMediaCoverPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchMediaViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchMediaViewModel | null>;
        }));
    }

    protected processV1ExternalSetPunchMediaCoverPUT(response: HttpResponseBase): Observable<PunchMediaViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchMediaViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetPunchMasterDataGET(): Observable<PunchMasterDataViewModel | null> {
        let url_ = this.baseUrl + "/v1/External/punchMasterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetPunchMasterDataGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetPunchMasterDataGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchMasterDataViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchMasterDataViewModel | null>;
        }));
    }

    protected processV1ExternalGetPunchMasterDataGET(response: HttpResponseBase): Observable<PunchMasterDataViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchMasterDataViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalSyncronizeProjectsDataPUT(userId: string | null | undefined, projectsSync: ProjectSyncViewModel[]): Observable<void> {
        let url_ = this.baseUrl + "/v1/External/project/syncronizeProjectsData?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectsSync);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalSyncronizeProjectsDataPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalSyncronizeProjectsDataPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ExternalSyncronizeProjectsDataPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalUpdateProjectDataPUT(project: ProjectSyncViewModel): Observable<void> {
        let url_ = this.baseUrl + "/v1/External/project/updateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(project);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalUpdateProjectDataPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalUpdateProjectDataPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ExternalUpdateProjectDataPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalCreateUserIfNotExistsPOST(): Observable<void> {
        let url_ = this.baseUrl + "/v1/External/user/createUserIfNotExists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalCreateUserIfNotExistsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalCreateUserIfNotExistsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ExternalCreateUserIfNotExistsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetUserByIdGET(): Observable<UserViewModel | null> {
        let url_ = this.baseUrl + "/v1/External/user/byId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetUserByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetUserByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel | null>;
        }));
    }

    protected processV1ExternalGetUserByIdGET(response: HttpResponseBase): Observable<UserViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalIsPunchActiveGET(punchId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/External/punch/isActive?";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined and cannot be null.");
        else
            url_ += "punchId=" + encodeURIComponent("" + punchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalIsPunchActiveGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalIsPunchActiveGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ExternalIsPunchActiveGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetPunchByIdGET(punchId: number, templateId: number): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/External/punch/byId?";
        if (punchId === undefined || punchId === null)
            throw new globalThis.Error("The parameter 'punchId' must be defined and cannot be null.");
        else
            url_ += "punchId=" + encodeURIComponent("" + punchId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetPunchByIdGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetPunchByIdGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1ExternalGetPunchByIdGET(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetAllPunchesPagedPOST(templateId: number, sendCover: boolean, punchDataSourceViewModel: PunchDataSourceViewModel): Observable<PunchViewModelDataSourceResult | null> {
        let url_ = this.baseUrl + "/v1/External/punch/allPunches/Paged?";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        if (sendCover === undefined || sendCover === null)
            throw new globalThis.Error("The parameter 'sendCover' must be defined and cannot be null.");
        else
            url_ += "sendCover=" + encodeURIComponent("" + sendCover) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchDataSourceViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetAllPunchesPagedPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetAllPunchesPagedPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchViewModelDataSourceResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchViewModelDataSourceResult | null>;
        }));
    }

    protected processV1ExternalGetAllPunchesPagedPOST(response: HttpResponseBase): Observable<PunchViewModelDataSourceResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchViewModelDataSourceResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetAllPagedStartingByElementHCSPOST(elementId: number, templateId: number, punchDataSourceViewModel: PunchDataSourceViewModel): Observable<PunchViewModelDataSourceResult | null> {
        let url_ = this.baseUrl + "/v1/External/punch/allPunchesStartingByElementHCS/Paged?";
        if (elementId === undefined || elementId === null)
            throw new globalThis.Error("The parameter 'elementId' must be defined and cannot be null.");
        else
            url_ += "elementId=" + encodeURIComponent("" + elementId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchDataSourceViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetAllPagedStartingByElementHCSPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetAllPagedStartingByElementHCSPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchViewModelDataSourceResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchViewModelDataSourceResult | null>;
        }));
    }

    protected processV1ExternalGetAllPagedStartingByElementHCSPOST(response: HttpResponseBase): Observable<PunchViewModelDataSourceResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchViewModelDataSourceResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalRemarkPunchByIdPOST(templateId: number, punchRemark: PunchRemarkViewModel): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/External/punch/remark?";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchRemark);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalRemarkPunchByIdPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalRemarkPunchByIdPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1ExternalRemarkPunchByIdPOST(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalSignPunchByIdPOST(templateId: number, punchSign: PunchSignatureSignViewModel): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/External/punch/sign?";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchSign);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalSignPunchByIdPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalSignPunchByIdPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1ExternalSignPunchByIdPOST(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalRejectPunchByIdPOST(templateId: number, punchReject: PunchSignatureRejectViewModel): Observable<PunchDetailViewModel | null> {
        let url_ = this.baseUrl + "/v1/External/punch/reject?";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchReject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalRejectPunchByIdPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalRejectPunchByIdPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchDetailViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchDetailViewModel | null>;
        }));
    }

    protected processV1ExternalRejectPunchByIdPOST(response: HttpResponseBase): Observable<PunchDetailViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchDetailViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalAnyAvailableGET(inspectionId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/External/inspectionWalk/anyAvailable?";
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined and cannot be null.");
        else
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalAnyAvailableGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalAnyAvailableGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ExternalAnyAvailableGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalStartInspectionPOST(templateId: number, inspectionOptions: InspectionOptionsViewModel): Observable<void> {
        let url_ = this.baseUrl + "/v1/External/inspection/start?";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalStartInspectionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalStartInspectionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1ExternalStartInspectionPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalCreatePunchPOST(templateId: number, punchNew: PunchDetailViewModel): Observable<number> {
        let url_ = this.baseUrl + "/v1/External/punch/createPunch?";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchNew);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalCreatePunchPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalCreatePunchPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1ExternalCreatePunchPOST(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalUpdatePunchPUT(templateId: number, punchToModify: PunchDetailInViewModel): Observable<number> {
        let url_ = this.baseUrl + "/v1/External/punch/updatePunch?";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(punchToModify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalUpdatePunchPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalUpdatePunchPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processV1ExternalUpdatePunchPUT(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalGetWbsElementsUsedOnPunchesPOST(wbsElementIds: number[]): Observable<number[] | null> {
        let url_ = this.baseUrl + "/v1/External/WbsElementsUsedOnPunches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wbsElementIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalGetWbsElementsUsedOnPunchesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalGetWbsElementsUsedOnPunchesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[] | null>;
        }));
    }

    protected processV1ExternalGetWbsElementsUsedOnPunchesPOST(response: HttpResponseBase): Observable<number[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalReportGetUserProjectReportsPOST(dataSourceRequest: DataSourceRequest): Observable<ConfiguredReportViewModelDataSourceResult | null> {
        let url_ = this.baseUrl + "/v1/ExternalReport/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataSourceRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalReportGetUserProjectReportsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalReportGetUserProjectReportsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfiguredReportViewModelDataSourceResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfiguredReportViewModelDataSourceResult | null>;
        }));
    }

    protected processV1ExternalReportGetUserProjectReportsPOST(response: HttpResponseBase): Observable<ConfiguredReportViewModelDataSourceResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConfiguredReportViewModelDataSourceResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ProblemDetails.fromJS(resultData400) : null as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ExternalReportGetProjectReportGET(reportId: number): Observable<ConfiguredReportViewModel | null> {
        let url_ = this.baseUrl + "/v1/ExternalReport/{reportId}/View";
        if (reportId === undefined || reportId === null)
            throw new globalThis.Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ExternalReportGetProjectReportGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ExternalReportGetProjectReportGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfiguredReportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfiguredReportViewModel | null>;
        }));
    }

    protected processV1ExternalReportGetProjectReportGET(response: HttpResponseBase): Observable<ConfiguredReportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConfiguredReportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? ProblemDetails.fromJS(resultData400) : null as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ElementsGetAllElementsGET(): Observable<ElementsViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Elements/allElements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElementsGetAllElementsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElementsGetAllElementsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementsViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementsViewModel[] | null>;
        }));
    }

    protected processV1ElementsGetAllElementsGET(response: HttpResponseBase): Observable<ElementsViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ElementsImportFromAPIGET(projectId: number, nodeLevel: number | null): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Elements/importFromAPI/{projectId}/{nodeLevel}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (nodeLevel === undefined || nodeLevel === null)
            throw new globalThis.Error("The parameter 'nodeLevel' must be defined.");
        url_ = url_.replace("{nodeLevel}", encodeURIComponent("" + nodeLevel));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElementsImportFromAPIGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElementsImportFromAPIGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ElementsImportFromAPIGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ElementsGetUnitsGET(): Observable<ElementsViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Elements/allUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElementsGetUnitsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElementsGetUnitsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementsViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementsViewModel[] | null>;
        }));
    }

    protected processV1ElementsGetUnitsGET(response: HttpResponseBase): Observable<ElementsViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ElementsGetUnitsByUnitsByProjectTemplateGET(projectId: number, templateId: number): Observable<ElementsViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Elements/allUnitsByProjectTemplate?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElementsGetUnitsByUnitsByProjectTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElementsGetUnitsByUnitsByProjectTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementsViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementsViewModel[] | null>;
        }));
    }

    protected processV1ElementsGetUnitsByUnitsByProjectTemplateGET(response: HttpResponseBase): Observable<ElementsViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ElementsGetSubSystemsGET(): Observable<ElementsViewModel | null> {
        let url_ = this.baseUrl + "/v1/Elements/allSubSystems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElementsGetSubSystemsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElementsGetSubSystemsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementsViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementsViewModel | null>;
        }));
    }

    protected processV1ElementsGetSubSystemsGET(response: HttpResponseBase): Observable<ElementsViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ElementsViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ElementsGetElementChildrenFlattenedGET(elementId: number | null | undefined, elementHierarchyTypeId: number | null | undefined): Observable<ElementsViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Elements/elementChildrenFlattened?";
        if (elementId !== undefined && elementId !== null)
            url_ += "elementId=" + encodeURIComponent("" + elementId) + "&";
        if (elementHierarchyTypeId !== undefined && elementHierarchyTypeId !== null)
            url_ += "elementHierarchyTypeId=" + encodeURIComponent("" + elementHierarchyTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElementsGetElementChildrenFlattenedGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElementsGetElementChildrenFlattenedGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementsViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementsViewModel[] | null>;
        }));
    }

    protected processV1ElementsGetElementChildrenFlattenedGET(response: HttpResponseBase): Observable<ElementsViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ElementsGetAllByIdsGET(projectId: number, templateId: number | null): Observable<ElementsViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Elements/allElements/{projectId}/{templateId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElementsGetAllByIdsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElementsGetAllByIdsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementsViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementsViewModel[] | null>;
        }));
    }

    protected processV1ElementsGetAllByIdsGET(response: HttpResponseBase): Observable<ElementsViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ElementsPostMatchWbsPOST(matchWbsViewModel: MatchWbsViewModel): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Elements/MatchWbs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchWbsViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElementsPostMatchWbsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElementsPostMatchWbsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1ElementsPostMatchWbsPOST(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ElementsGetAllElementsAndPunchesIdsGET(projectId: number | null | undefined): Observable<ElementsWithPunchesIdsViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Elements/ElementsAndPunches?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElementsGetAllElementsAndPunchesIdsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElementsGetAllElementsAndPunchesIdsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementsWithPunchesIdsViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementsWithPunchesIdsViewModel[] | null>;
        }));
    }

    protected processV1ElementsGetAllElementsAndPunchesIdsGET(response: HttpResponseBase): Observable<ElementsWithPunchesIdsViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementsWithPunchesIdsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1ElementsGetAllNodeLevelsGET(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Elements/allNodeLevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1ElementsGetAllNodeLevelsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1ElementsGetAllNodeLevelsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1ElementsGetAllNodeLevelsGET(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TreeGetElementChildrenGET(elementId: number | null | undefined, elementHierarchyTypeId: number | null | undefined): Observable<ElementTreeViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/Tree/elementChildren?";
        if (elementId !== undefined && elementId !== null)
            url_ += "elementId=" + encodeURIComponent("" + elementId) + "&";
        if (elementHierarchyTypeId !== undefined && elementHierarchyTypeId !== null)
            url_ += "elementHierarchyTypeId=" + encodeURIComponent("" + elementHierarchyTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TreeGetElementChildrenGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TreeGetElementChildrenGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementTreeViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementTreeViewModel[] | null>;
        }));
    }

    protected processV1TreeGetElementChildrenGET(response: HttpResponseBase): Observable<ElementTreeViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementTreeViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TreeGetWbsChildrenElementsPaginatedPOST(queryData: TreeElementQueryData): Observable<ElementTreeListViewModelQueryResult | null> {
        let url_ = this.baseUrl + "/v1/Tree/ChildrenPaginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TreeGetWbsChildrenElementsPaginatedPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TreeGetWbsChildrenElementsPaginatedPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementTreeListViewModelQueryResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementTreeListViewModelQueryResult | null>;
        }));
    }

    protected processV1TreeGetWbsChildrenElementsPaginatedPOST(response: HttpResponseBase): Observable<ElementTreeListViewModelQueryResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ElementTreeListViewModelQueryResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1WBSGetTemplateGET(): Observable<ImportViewModel | null> {
        let url_ = this.baseUrl + "/v1/WBS/Template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1WBSGetTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1WBSGetTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportViewModel | null>;
        }));
    }

    protected processV1WBSGetTemplateGET(response: HttpResponseBase): Observable<ImportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1WBSPostImportPreviewPOST(projectId: number | null | undefined, templateId: number | null | undefined, importModel: TemplateSetUpModelView): Observable<ImportViewModel | null> {
        let url_ = this.baseUrl + "/v1/WBS/ImportPreview?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId !== undefined && templateId !== null)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1WBSPostImportPreviewPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1WBSPostImportPreviewPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportViewModel | null>;
        }));
    }

    protected processV1WBSPostImportPreviewPOST(response: HttpResponseBase): Observable<ImportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1WBSPostImportPOST(projectId: number | null | undefined, templateId: number | null | undefined, importModel: TemplateSetUpModelView): Observable<ImportViewModel | null> {
        let url_ = this.baseUrl + "/v1/WBS/Import?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId !== undefined && templateId !== null)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1WBSPostImportPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1WBSPostImportPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportViewModel | null>;
        }));
    }

    protected processV1WBSPostImportPOST(response: HttpResponseBase): Observable<ImportViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImportViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1WBSPostExportPOST(projectId: number | null | undefined): Observable<TemplateSetUpInModelView | null> {
        let url_ = this.baseUrl + "/v1/WBS/ExportWBS?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1WBSPostExportPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1WBSPostExportPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateSetUpInModelView | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateSetUpInModelView | null>;
        }));
    }

    protected processV1WBSPostExportPOST(response: HttpResponseBase): Observable<TemplateSetUpInModelView | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateSetUpInModelView.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1WBSPostExportHPOST(projectId: number | null | undefined): Observable<TemplateSetUpInModelView | null> {
        let url_ = this.baseUrl + "/v1/WBS/ExportHierarchies?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1WBSPostExportHPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1WBSPostExportHPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateSetUpInModelView | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateSetUpInModelView | null>;
        }));
    }

    protected processV1WBSPostExportHPOST(response: HttpResponseBase): Observable<TemplateSetUpInModelView | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateSetUpInModelView.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1WBSTestPOST(): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/WBS/TestNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1WBSTestPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1WBSTestPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1WBSTestPOST(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1WBSPutUseProjectWbsPUT(templateId: number, projectId: number, useProjectWbs: boolean): Observable<TemplateViewModel | null> {
        let url_ = this.baseUrl + "/v1/WBS/UseProjectWbs/{templateId}/{projectId}/{useProjectWbs}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (useProjectWbs === undefined || useProjectWbs === null)
            throw new globalThis.Error("The parameter 'useProjectWbs' must be defined.");
        url_ = url_.replace("{useProjectWbs}", encodeURIComponent("" + useProjectWbs));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1WBSPutUseProjectWbsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1WBSPutUseProjectWbsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateViewModel | null>;
        }));
    }

    protected processV1WBSPutUseProjectWbsPUT(response: HttpResponseBase): Observable<TemplateViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TemplateViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AdHocFixesTermocandelariaPunchesResetPUT(excelPath: string | null | undefined, filesPath: string | null | undefined, projectId: number, templateId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/AdHocFixes/TermocandelariaPunchesReset?";
        if (excelPath !== undefined && excelPath !== null)
            url_ += "excelPath=" + encodeURIComponent("" + excelPath) + "&";
        if (filesPath !== undefined && filesPath !== null)
            url_ += "filesPath=" + encodeURIComponent("" + filesPath) + "&";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AdHocFixesTermocandelariaPunchesResetPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AdHocFixesTermocandelariaPunchesResetPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1AdHocFixesTermocandelariaPunchesResetPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AdHocFixesBulkUpdateReadingPunchCodeFromExcelPUT(excelPath: string | null | undefined, projectId: number, templateId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/AdHocFixes/BulkUpdateReadingPunchCodeFromExcel?";
        if (excelPath !== undefined && excelPath !== null)
            url_ += "excelPath=" + encodeURIComponent("" + excelPath) + "&";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AdHocFixesBulkUpdateReadingPunchCodeFromExcelPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AdHocFixesBulkUpdateReadingPunchCodeFromExcelPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1AdHocFixesBulkUpdateReadingPunchCodeFromExcelPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AdHocFixesBulkUpdateWithValuesReadingPunchCodeFromExcelPUT(excelPath: string | null | undefined, projectId: number, templateId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/AdHocFixes/BulkUpdateWithValuesReadingPunchCodeFromExcel?";
        if (excelPath !== undefined && excelPath !== null)
            url_ += "excelPath=" + encodeURIComponent("" + excelPath) + "&";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AdHocFixesBulkUpdateWithValuesReadingPunchCodeFromExcelPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AdHocFixesBulkUpdateWithValuesReadingPunchCodeFromExcelPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1AdHocFixesBulkUpdateWithValuesReadingPunchCodeFromExcelPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AdHocFixesBulkUpdateWithPunchItemReadingPunchCodeFromExcelPUT(excelPath: string | null | undefined, projectId: number, templateId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/AdHocFixes/BulkUpdateWithPunchItemReadingPunchCodeFromExcel?";
        if (excelPath !== undefined && excelPath !== null)
            url_ += "excelPath=" + encodeURIComponent("" + excelPath) + "&";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AdHocFixesBulkUpdateWithPunchItemReadingPunchCodeFromExcelPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AdHocFixesBulkUpdateWithPunchItemReadingPunchCodeFromExcelPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1AdHocFixesBulkUpdateWithPunchItemReadingPunchCodeFromExcelPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AdHocFixesBulkUpdateWithDifferentsValuesReadingPunchCodeFromExcelPUT(excelPath: string | null | undefined, projectId: number, templateId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/AdHocFixes/BulkUpdateWithDifferentsValuesReadingPunchCodeFromExcel?";
        if (excelPath !== undefined && excelPath !== null)
            url_ += "excelPath=" + encodeURIComponent("" + excelPath) + "&";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AdHocFixesBulkUpdateWithDifferentsValuesReadingPunchCodeFromExcelPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AdHocFixesBulkUpdateWithDifferentsValuesReadingPunchCodeFromExcelPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1AdHocFixesBulkUpdateWithDifferentsValuesReadingPunchCodeFromExcelPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AdHocFixesClearUserUnitAndUserDisciplinesPUT(projectId: number | null | undefined, templateId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/v1/AdHocFixes/clearUserUnitAndUserDisciplines?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId !== undefined && templateId !== null)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AdHocFixesClearUserUnitAndUserDisciplinesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AdHocFixesClearUserUnitAndUserDisciplinesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1AdHocFixesClearUserUnitAndUserDisciplinesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AdHocFixesChangeInspectionElementsPUT(excelPath: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/v1/AdHocFixes/changeInspectionElements?";
        if (excelPath !== undefined && excelPath !== null)
            url_ += "excelPath=" + encodeURIComponent("" + excelPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AdHocFixesChangeInspectionElementsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AdHocFixesChangeInspectionElementsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1AdHocFixesChangeInspectionElementsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AdHocFixesBulkConsolidatePUT(excelPath: string | null | undefined, projectId: number, templateId: number): Observable<void> {
        let url_ = this.baseUrl + "/v1/AdHocFixes/BulkCompleteAndConsolidateIfNoPunches?";
        if (excelPath !== undefined && excelPath !== null)
            url_ += "excelPath=" + encodeURIComponent("" + excelPath) + "&";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AdHocFixesBulkConsolidatePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AdHocFixesBulkConsolidatePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1AdHocFixesBulkConsolidatePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AdHocFixesCleanGCMemoryPOST(): Observable<void> {
        let url_ = this.baseUrl + "/v1/AdHocFixes/CleanGCMemory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AdHocFixesCleanGCMemoryPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AdHocFixesCleanGCMemoryPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processV1AdHocFixesCleanGCMemoryPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MigrationMigrateSignAttachmentsGET(): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Migration/SignAttachments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MigrationMigrateSignAttachmentsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MigrationMigrateSignAttachmentsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1MigrationMigrateSignAttachmentsGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MigrationScaleSignsGET(startId: number, endId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Migration/ScaleSigns/{startId}/{endId}";
        if (startId === undefined || startId === null)
            throw new globalThis.Error("The parameter 'startId' must be defined.");
        url_ = url_.replace("{startId}", encodeURIComponent("" + startId));
        if (endId === undefined || endId === null)
            throw new globalThis.Error("The parameter 'endId' must be defined.");
        url_ = url_.replace("{endId}", encodeURIComponent("" + endId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MigrationScaleSignsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MigrationScaleSignsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1MigrationScaleSignsGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1MigrationScaleSignGET(signatureId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Migration/ScaleSign/{signatureId}";
        if (signatureId === undefined || signatureId === null)
            throw new globalThis.Error("The parameter 'signatureId' must be defined.");
        url_ = url_.replace("{signatureId}", encodeURIComponent("" + signatureId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1MigrationScaleSignGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1MigrationScaleSignGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1MigrationScaleSignGET(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1SleepGetSleepGET(miliseconds: number): Observable<string | null> {
        let url_ = this.baseUrl + "/v1/Sleep/{miliseconds}";
        if (miliseconds === undefined || miliseconds === null)
            throw new globalThis.Error("The parameter 'miliseconds' must be defined.");
        url_ = url_.replace("{miliseconds}", encodeURIComponent("" + miliseconds));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1SleepGetSleepGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1SleepGetSleepGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processV1SleepGetSleepGET(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1VersionGetVersionGET(): Observable<string | null> {
        let url_ = this.baseUrl + "/v1/Version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1VersionGetVersionGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1VersionGetVersionGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processV1VersionGetVersionGET(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreGetRolesGET(mr: boolean): Observable<RoleViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/AuthCore/roles?";
        if (mr === undefined || mr === null)
            throw new globalThis.Error("The parameter 'mr' must be defined and cannot be null.");
        else
            url_ += "mr=" + encodeURIComponent("" + mr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreGetRolesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreGetRolesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel[] | null>;
        }));
    }

    protected processV1AuthCoreGetRolesGET(response: HttpResponseBase): Observable<RoleViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreGetPoliciesGET(): Observable<PolicyViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/AuthCore/policies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreGetPoliciesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreGetPoliciesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PolicyViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PolicyViewModel[] | null>;
        }));
    }

    protected processV1AuthCoreGetPoliciesGET(response: HttpResponseBase): Observable<PolicyViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreGetPoliciesWithDescriptionsGET(): Observable<PermissionRoleViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/AuthCore/policiesWithDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreGetPoliciesWithDescriptionsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreGetPoliciesWithDescriptionsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionRoleViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionRoleViewModel[] | null>;
        }));
    }

    protected processV1AuthCoreGetPoliciesWithDescriptionsGET(response: HttpResponseBase): Observable<PermissionRoleViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionRoleViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreGetUserAuthorizationsGET(userId: string | null | undefined): Observable<UserAuthorizationViewModel | null> {
        let url_ = this.baseUrl + "/v1/AuthCore/userAuthorizations?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreGetUserAuthorizationsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreGetUserAuthorizationsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAuthorizationViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAuthorizationViewModel | null>;
        }));
    }

    protected processV1AuthCoreGetUserAuthorizationsGET(response: HttpResponseBase): Observable<UserAuthorizationViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserAuthorizationViewModel.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreUnauthorizeUserDELETE(userId: string | null | undefined, projectId: number, templateId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/AuthCore/unathorizeUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreUnauthorizeUserDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreUnauthorizeUserDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1AuthCoreUnauthorizeUserDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreUnauthorizeUsersByAuthsIdsDELETE(authIds: number[]): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/AuthCore/unathorizeMultipleUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreUnauthorizeUsersByAuthsIdsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreUnauthorizeUsersByAuthsIdsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1AuthCoreUnauthorizeUsersByAuthsIdsDELETE(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreRegisterAndAuthorizeUserPOST(registerAndAuthorizeUserIn: RegisterAndAuthorizeUserInViewModel): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/AuthCore/registerAndAuthorizeUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerAndAuthorizeUserIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreRegisterAndAuthorizeUserPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreRegisterAndAuthorizeUserPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1AuthCoreRegisterAndAuthorizeUserPOST(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreAuthorizeUserPOST(authorizeUserIn: AuthorizeUserInViewModel): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/AuthCore/authorizeUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authorizeUserIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreAuthorizeUserPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreAuthorizeUserPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1AuthCoreAuthorizeUserPOST(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreEditUserAuthorizationPUT(editAuthorizationIn: EditAuthorizationInViewModel): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/AuthCore/editUserAuthorization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editAuthorizationIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreEditUserAuthorizationPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreEditUserAuthorizationPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1AuthCoreEditUserAuthorizationPUT(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreEditAuthPropertiesPUT(editAuthorizationIn: EditAuthPropertiesInViewModel): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/AuthCore/editAuthProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editAuthorizationIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreEditAuthPropertiesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreEditAuthPropertiesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processV1AuthCoreEditAuthPropertiesPUT(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreGetApplicationUsersGET(): Observable<UserApplicationViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/AuthCore/applicationUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreGetApplicationUsersGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreGetApplicationUsersGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserApplicationViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserApplicationViewModel[] | null>;
        }));
    }

    protected processV1AuthCoreGetApplicationUsersGET(response: HttpResponseBase): Observable<UserApplicationViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserApplicationViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1AuthCoreGetUserAuthlevelGlobalGET(): Observable<AuthLevelAppDto | null> {
        let url_ = this.baseUrl + "/v1/AuthCore/userAuthlevelGlobal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1AuthCoreGetUserAuthlevelGlobalGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1AuthCoreGetUserAuthlevelGlobalGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthLevelAppDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthLevelAppDto | null>;
        }));
    }

    protected processV1AuthCoreGetUserAuthlevelGlobalGET(response: HttpResponseBase): Observable<AuthLevelAppDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthLevelAppDto.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TrExternalApisGetTrUsersGET(userName: string | null | undefined): Observable<UserTridentityWithPhonesViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/TrExternalApis/Tr/Users?";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TrExternalApisGetTrUsersGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TrExternalApisGetTrUsersGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTridentityWithPhonesViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTridentityWithPhonesViewModel[] | null>;
        }));
    }

    protected processV1TrExternalApisGetTrUsersGET(response: HttpResponseBase): Observable<UserTridentityWithPhonesViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTridentityWithPhonesViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TrExternalApisGetExternalUsersGET(userName: string | null | undefined): Observable<UserTridentityWithPhonesViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/TrExternalApis/External/Users?";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TrExternalApisGetExternalUsersGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TrExternalApisGetExternalUsersGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTridentityWithPhonesViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTridentityWithPhonesViewModel[] | null>;
        }));
    }

    protected processV1TrExternalApisGetExternalUsersGET(response: HttpResponseBase): Observable<UserTridentityWithPhonesViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTridentityWithPhonesViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1TrExternalApisCreateNewExternalUserPOST(createTridentityUserIn: CreateTridentityUserInViewModel): Observable<string | null> {
        let url_ = this.baseUrl + "/v1/TrExternalApis/External/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createTridentityUserIn);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1TrExternalApisCreateNewExternalUserPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1TrExternalApisCreateNewExternalUserPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processV1TrExternalApisCreateNewExternalUserPOST(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionAuditGetPaginatedResultPOST(queryData: QueryData): Observable<InspectionAuditViewModelQueryResult | null> {
        let url_ = this.baseUrl + "/v1/InspectionAudit/paginated/result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionAuditGetPaginatedResultPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionAuditGetPaginatedResultPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionAuditViewModelQueryResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionAuditViewModelQueryResult | null>;
        }));
    }

    protected processV1InspectionAuditGetPaginatedResultPOST(response: HttpResponseBase): Observable<InspectionAuditViewModelQueryResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionAuditViewModelQueryResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1InspectionAuditGetActionsPOST(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/InspectionAudit/actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1InspectionAuditGetActionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1InspectionAuditGetActionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1InspectionAuditGetActionsPOST(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchAuditGetPaginatedResultPOST(queryData: QueryData): Observable<PunchAuditViewModelQueryResult | null> {
        let url_ = this.baseUrl + "/v1/PunchAudit/paginated/result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchAuditGetPaginatedResultPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchAuditGetPaginatedResultPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchAuditViewModelQueryResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchAuditViewModelQueryResult | null>;
        }));
    }

    protected processV1PunchAuditGetPaginatedResultPOST(response: HttpResponseBase): Observable<PunchAuditViewModelQueryResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PunchAuditViewModelQueryResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1PunchAuditGetActionsPOST(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/PunchAudit/actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1PunchAuditGetActionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1PunchAuditGetActionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1PunchAuditGetActionsPOST(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserAuditGetPaginatedResultPOST(queryData: QueryData): Observable<UserAuditViewModelQueryResult | null> {
        let url_ = this.baseUrl + "/v1/UserAudit/paginated/result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserAuditGetPaginatedResultPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserAuditGetPaginatedResultPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAuditViewModelQueryResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAuditViewModelQueryResult | null>;
        }));
    }

    protected processV1UserAuditGetPaginatedResultPOST(response: HttpResponseBase): Observable<UserAuditViewModelQueryResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserAuditViewModelQueryResult.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    v1UserAuditGetActionsPOST(): Observable<MasterViewModel[] | null> {
        let url_ = this.baseUrl + "/v1/UserAudit/actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processV1UserAuditGetActionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processV1UserAuditGetActionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterViewModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterViewModel[] | null>;
        }));
    }

    protected processV1UserAuditGetActionsPOST(response: HttpResponseBase): Observable<MasterViewModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UserViewModel implements IUserViewModel {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
    disciplines?: MasterViewModel[] | undefined;
    globalRole?: string | undefined;
    projectsTemplates?: ProjectTemplateViewModel[] | undefined;
    units?: MasterViewModel[] | undefined;
    isOrganizer?: boolean;

    constructor(data?: IUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.company = _data["company"];
            if (Array.isArray(_data["disciplines"])) {
                this.disciplines = [] as any;
                for (let item of _data["disciplines"])
                    this.disciplines!.push(MasterViewModel.fromJS(item));
            }
            this.globalRole = _data["globalRole"];
            if (Array.isArray(_data["projectsTemplates"])) {
                this.projectsTemplates = [] as any;
                for (let item of _data["projectsTemplates"])
                    this.projectsTemplates!.push(ProjectTemplateViewModel.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(MasterViewModel.fromJS(item));
            }
            this.isOrganizer = _data["isOrganizer"];
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["company"] = this.company;
        if (Array.isArray(this.disciplines)) {
            data["disciplines"] = [];
            for (let item of this.disciplines)
                data["disciplines"].push(item ? item.toJSON() : undefined as any);
        }
        data["globalRole"] = this.globalRole;
        if (Array.isArray(this.projectsTemplates)) {
            data["projectsTemplates"] = [];
            for (let item of this.projectsTemplates)
                data["projectsTemplates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        data["isOrganizer"] = this.isOrganizer;
        return data;
    }
}

export interface IUserViewModel {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
    disciplines?: MasterViewModel[] | undefined;
    globalRole?: string | undefined;
    projectsTemplates?: ProjectTemplateViewModel[] | undefined;
    units?: MasterViewModel[] | undefined;
    isOrganizer?: boolean;
}

export class MasterViewModel implements IMasterViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IMasterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MasterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MasterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IMasterViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export class ProjectTemplateViewModel implements IProjectTemplateViewModel {
    project?: MasterViewModel | undefined;
    template?: TemplateInViewModel | undefined;
    maps?: MapsViewModel[] | undefined;
    default?: boolean;
    useProjectWbs?: boolean;
    closed?: boolean;
    role?: string | undefined;
    visibleRole?: string | undefined;

    constructor(data?: IProjectTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? MasterViewModel.fromJS(_data["project"]) : undefined as any;
            this.template = _data["template"] ? TemplateInViewModel.fromJS(_data["template"]) : undefined as any;
            if (Array.isArray(_data["maps"])) {
                this.maps = [] as any;
                for (let item of _data["maps"])
                    this.maps!.push(MapsViewModel.fromJS(item));
            }
            this.default = _data["default"];
            this.useProjectWbs = _data["useProjectWbs"];
            this.closed = _data["closed"];
            this.role = _data["role"];
            this.visibleRole = _data["visibleRole"];
        }
    }

    static fromJS(data: any): ProjectTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        if (Array.isArray(this.maps)) {
            data["maps"] = [];
            for (let item of this.maps)
                data["maps"].push(item ? item.toJSON() : undefined as any);
        }
        data["default"] = this.default;
        data["useProjectWbs"] = this.useProjectWbs;
        data["closed"] = this.closed;
        data["role"] = this.role;
        data["visibleRole"] = this.visibleRole;
        return data;
    }
}

export interface IProjectTemplateViewModel {
    project?: MasterViewModel | undefined;
    template?: TemplateInViewModel | undefined;
    maps?: MapsViewModel[] | undefined;
    default?: boolean;
    useProjectWbs?: boolean;
    closed?: boolean;
    role?: string | undefined;
    visibleRole?: string | undefined;
}

export class TemplateInViewModel extends MasterViewModel implements ITemplateInViewModel {
    tags?: string[] | undefined;

    constructor(data?: ITemplateInViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static override fromJS(data: any): TemplateInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateInViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateInViewModel extends IMasterViewModel {
    tags?: string[] | undefined;
}

export class MapsViewModel implements IMapsViewModel {
    id?: string | undefined;
    description?: string | undefined;
    name?: string | undefined;
    version?: number;
    mimeType?: string | undefined;
    location?: string | undefined;
    zoomLevel?: number;
    default?: boolean;
    file?: string | undefined;

    constructor(data?: IMapsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.version = _data["version"];
            this.mimeType = _data["mimeType"];
            this.location = _data["location"];
            this.zoomLevel = _data["zoomLevel"];
            this.default = _data["default"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): MapsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MapsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["name"] = this.name;
        data["version"] = this.version;
        data["mimeType"] = this.mimeType;
        data["location"] = this.location;
        data["zoomLevel"] = this.zoomLevel;
        data["default"] = this.default;
        data["file"] = this.file;
        return data;
    }
}

export interface IMapsViewModel {
    id?: string | undefined;
    description?: string | undefined;
    name?: string | undefined;
    version?: number;
    mimeType?: string | undefined;
    location?: string | undefined;
    zoomLevel?: number;
    default?: boolean;
    file?: string | undefined;
}

export class UserInfoViewModel implements IUserInfoViewModel {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;

    constructor(data?: IUserInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.company = _data["company"];
        }
    }

    static fromJS(data: any): UserInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["company"] = this.company;
        return data;
    }
}

export interface IUserInfoViewModel {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
}

export class UserLoginViewModel implements IUserLoginViewModel {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
    globalRole?: string | undefined;
    projectsTemplates?: ProjectTemplateViewModel[] | undefined;
    isOrganizer?: boolean;

    constructor(data?: IUserLoginViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.company = _data["company"];
            this.globalRole = _data["globalRole"];
            if (Array.isArray(_data["projectsTemplates"])) {
                this.projectsTemplates = [] as any;
                for (let item of _data["projectsTemplates"])
                    this.projectsTemplates!.push(ProjectTemplateViewModel.fromJS(item));
            }
            this.isOrganizer = _data["isOrganizer"];
        }
    }

    static fromJS(data: any): UserLoginViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["company"] = this.company;
        data["globalRole"] = this.globalRole;
        if (Array.isArray(this.projectsTemplates)) {
            data["projectsTemplates"] = [];
            for (let item of this.projectsTemplates)
                data["projectsTemplates"].push(item ? item.toJSON() : undefined as any);
        }
        data["isOrganizer"] = this.isOrganizer;
        return data;
    }
}

export interface IUserLoginViewModel {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
    globalRole?: string | undefined;
    projectsTemplates?: ProjectTemplateViewModel[] | undefined;
    isOrganizer?: boolean;
}

export class UserInViewModel implements IUserInViewModel {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    company?: string | undefined;
    phone?: string | undefined;
    role?: string | undefined;
    disciplines?: MasterViewModel[] | undefined;
    units?: MasterViewModel[] | undefined;

    constructor(data?: IUserInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.company = _data["company"];
            this.phone = _data["phone"];
            this.role = _data["role"];
            if (Array.isArray(_data["disciplines"])) {
                this.disciplines = [] as any;
                for (let item of _data["disciplines"])
                    this.disciplines!.push(MasterViewModel.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(MasterViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["company"] = this.company;
        data["phone"] = this.phone;
        data["role"] = this.role;
        if (Array.isArray(this.disciplines)) {
            data["disciplines"] = [];
            for (let item of this.disciplines)
                data["disciplines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserInViewModel {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    company?: string | undefined;
    phone?: string | undefined;
    role?: string | undefined;
    disciplines?: MasterViewModel[] | undefined;
    units?: MasterViewModel[] | undefined;
}

export class ProjectViewModel extends MasterViewModel implements IProjectViewModel {
    name?: string | undefined;
    logo?: string | undefined;
    default?: boolean;
    wbsLastSync?: Date | undefined;
    lastWbsSyncStatus?: string | undefined;
    usingProjectWbs?: boolean;
    closed?: boolean;

    constructor(data?: IProjectViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.logo = _data["logo"];
            this.default = _data["default"];
            this.wbsLastSync = _data["wbsLastSync"] ? new Date(_data["wbsLastSync"].toString()) : undefined as any;
            this.lastWbsSyncStatus = _data["lastWbsSyncStatus"];
            this.usingProjectWbs = _data["usingProjectWbs"];
            this.closed = _data["closed"];
        }
    }

    static override fromJS(data: any): ProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["logo"] = this.logo;
        data["default"] = this.default;
        data["wbsLastSync"] = this.wbsLastSync ? this.wbsLastSync.toISOString() : undefined as any;
        data["lastWbsSyncStatus"] = this.lastWbsSyncStatus;
        data["usingProjectWbs"] = this.usingProjectWbs;
        data["closed"] = this.closed;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectViewModel extends IMasterViewModel {
    name?: string | undefined;
    logo?: string | undefined;
    default?: boolean;
    wbsLastSync?: Date | undefined;
    lastWbsSyncStatus?: string | undefined;
    usingProjectWbs?: boolean;
    closed?: boolean;
}

export class ImportViewModel implements IImportViewModel {
    templateId?: number;
    template?: string | undefined;
    templateName?: string | undefined;
    summary?: { [key: string]: any; } | undefined;
    error?: string | undefined;

    constructor(data?: IImportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.template = _data["template"];
            this.templateName = _data["templateName"];
            if (_data["summary"]) {
                this.summary = {} as any;
                for (let key in _data["summary"]) {
                    if (_data["summary"].hasOwnProperty(key))
                        (this.summary as any)![key] = _data["summary"][key];
                }
            }
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ImportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["template"] = this.template;
        data["templateName"] = this.templateName;
        if (this.summary) {
            data["summary"] = {};
            for (let key in this.summary) {
                if (this.summary.hasOwnProperty(key))
                    (data["summary"] as any)[key] = (this.summary as any)[key];
            }
        }
        data["error"] = this.error;
        return data;
    }
}

export interface IImportViewModel {
    templateId?: number;
    template?: string | undefined;
    templateName?: string | undefined;
    summary?: { [key: string]: any; } | undefined;
    error?: string | undefined;
}

export class ExportViewModel implements IExportViewModel {
    template?: string | undefined;
    templateName?: string | undefined;

    constructor(data?: IExportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"];
            this.templateName = _data["templateName"];
        }
    }

    static fromJS(data: any): ExportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template;
        data["templateName"] = this.templateName;
        return data;
    }
}

export interface IExportViewModel {
    template?: string | undefined;
    templateName?: string | undefined;
}

export class ExportUserViewModel implements IExportUserViewModel {
    templateId?: number;
    projectId?: number;

    constructor(data?: IExportUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ExportUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IExportUserViewModel {
    templateId?: number;
    projectId?: number;
}

export class UserPermissionsViewModelQueryResult implements IUserPermissionsViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: UserPermissionsViewModel[] | undefined;

    constructor(data?: IUserPermissionsViewModelQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.orderBy = _data["orderBy"];
            this.ascending = _data["ascending"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserPermissionsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPermissionsViewModelQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionsViewModelQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["orderBy"] = this.orderBy;
        data["ascending"] = this.ascending;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserPermissionsViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: UserPermissionsViewModel[] | undefined;
}

export class UserPermissionsViewModel implements IUserPermissionsViewModel {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    company?: string | undefined;
    templateCount?: number;
    projectCount?: number;
    globalRole?: string | undefined;
    projectTemplates?: string[] | undefined;

    constructor(data?: IUserPermissionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.company = _data["company"];
            this.templateCount = _data["templateCount"];
            this.projectCount = _data["projectCount"];
            this.globalRole = _data["globalRole"];
            if (Array.isArray(_data["projectTemplates"])) {
                this.projectTemplates = [] as any;
                for (let item of _data["projectTemplates"])
                    this.projectTemplates!.push(item);
            }
        }
    }

    static fromJS(data: any): UserPermissionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["company"] = this.company;
        data["templateCount"] = this.templateCount;
        data["projectCount"] = this.projectCount;
        data["globalRole"] = this.globalRole;
        if (Array.isArray(this.projectTemplates)) {
            data["projectTemplates"] = [];
            for (let item of this.projectTemplates)
                data["projectTemplates"].push(item);
        }
        return data;
    }
}

export interface IUserPermissionsViewModel {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    company?: string | undefined;
    templateCount?: number;
    projectCount?: number;
    globalRole?: string | undefined;
    projectTemplates?: string[] | undefined;
}

export class FilterData implements IFilterData {
    filterParameters?: string | undefined;
    orderField?: string | undefined;
    order?: string | undefined;
    isCustomOrder?: boolean;
    projectId?: number;
    templateId?: number | undefined;

    constructor(data?: IFilterData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterParameters = _data["filterParameters"];
            this.orderField = _data["orderField"];
            this.order = _data["order"];
            this.isCustomOrder = _data["isCustomOrder"];
            this.projectId = _data["projectId"];
            this.templateId = _data["templateId"];
        }
    }

    static fromJS(data: any): FilterData {
        data = typeof data === 'object' ? data : {};
        let result = new FilterData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterParameters"] = this.filterParameters;
        data["orderField"] = this.orderField;
        data["order"] = this.order;
        data["isCustomOrder"] = this.isCustomOrder;
        data["projectId"] = this.projectId;
        data["templateId"] = this.templateId;
        return data;
    }
}

export interface IFilterData {
    filterParameters?: string | undefined;
    orderField?: string | undefined;
    order?: string | undefined;
    isCustomOrder?: boolean;
    projectId?: number;
    templateId?: number | undefined;
}

export class QueryData extends FilterData implements IQueryData {
    pageSize?: number;
    pageIndex?: number;
    allowSeeInactive?: boolean;

    constructor(data?: IQueryData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.allowSeeInactive = _data["allowSeeInactive"];
        }
    }

    static override fromJS(data: any): QueryData {
        data = typeof data === 'object' ? data : {};
        let result = new QueryData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["allowSeeInactive"] = this.allowSeeInactive;
        super.toJSON(data);
        return data;
    }
}

export interface IQueryData extends IFilterData {
    pageSize?: number;
    pageIndex?: number;
    allowSeeInactive?: boolean;
}

export class UserPermissionsDetailsViewModel implements IUserPermissionsDetailsViewModel {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    globalRole?: string | undefined;
    userProjectTemplates?: ProjectTemplatesPermissionViewModel[] | undefined;

    constructor(data?: IUserPermissionsDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.globalRole = _data["globalRole"];
            if (Array.isArray(_data["userProjectTemplates"])) {
                this.userProjectTemplates = [] as any;
                for (let item of _data["userProjectTemplates"])
                    this.userProjectTemplates!.push(ProjectTemplatesPermissionViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPermissionsDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionsDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["globalRole"] = this.globalRole;
        if (Array.isArray(this.userProjectTemplates)) {
            data["userProjectTemplates"] = [];
            for (let item of this.userProjectTemplates)
                data["userProjectTemplates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserPermissionsDetailsViewModel {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    globalRole?: string | undefined;
    userProjectTemplates?: ProjectTemplatesPermissionViewModel[] | undefined;
}

export class ProjectTemplatesPermissionViewModel implements IProjectTemplatesPermissionViewModel {
    projectId?: number;
    code?: string | undefined;
    templatePermissions?: TemplatePermissionViewModel[] | undefined;

    constructor(data?: IProjectTemplatesPermissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.code = _data["code"];
            if (Array.isArray(_data["templatePermissions"])) {
                this.templatePermissions = [] as any;
                for (let item of _data["templatePermissions"])
                    this.templatePermissions!.push(TemplatePermissionViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectTemplatesPermissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTemplatesPermissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["code"] = this.code;
        if (Array.isArray(this.templatePermissions)) {
            data["templatePermissions"] = [];
            for (let item of this.templatePermissions)
                data["templatePermissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTemplatesPermissionViewModel {
    projectId?: number;
    code?: string | undefined;
    templatePermissions?: TemplatePermissionViewModel[] | undefined;
}

export class TemplatePermissionViewModel implements ITemplatePermissionViewModel {
    userProjectTemplateId?: number;
    templateId?: number;
    description?: string | undefined;
    role?: string | undefined;

    constructor(data?: ITemplatePermissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userProjectTemplateId = _data["userProjectTemplateId"];
            this.templateId = _data["templateId"];
            this.description = _data["description"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): TemplatePermissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplatePermissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProjectTemplateId"] = this.userProjectTemplateId;
        data["templateId"] = this.templateId;
        data["description"] = this.description;
        data["role"] = this.role;
        return data;
    }
}

export interface ITemplatePermissionViewModel {
    userProjectTemplateId?: number;
    templateId?: number;
    description?: string | undefined;
    role?: string | undefined;
}

export class PermissionInViewModel implements IPermissionInViewModel {
    userProjectTemplateId?: number | undefined;
    userId?: string | undefined;
    projectId?: number;
    templateId?: number;
    role?: string | undefined;
    userDisciplinesIds?: number[] | undefined;
    userUnitsIds?: number[] | undefined;

    constructor(data?: IPermissionInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userProjectTemplateId = _data["userProjectTemplateId"];
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.templateId = _data["templateId"];
            this.role = _data["role"];
            if (Array.isArray(_data["userDisciplinesIds"])) {
                this.userDisciplinesIds = [] as any;
                for (let item of _data["userDisciplinesIds"])
                    this.userDisciplinesIds!.push(item);
            }
            if (Array.isArray(_data["userUnitsIds"])) {
                this.userUnitsIds = [] as any;
                for (let item of _data["userUnitsIds"])
                    this.userUnitsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PermissionInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProjectTemplateId"] = this.userProjectTemplateId;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["templateId"] = this.templateId;
        data["role"] = this.role;
        if (Array.isArray(this.userDisciplinesIds)) {
            data["userDisciplinesIds"] = [];
            for (let item of this.userDisciplinesIds)
                data["userDisciplinesIds"].push(item);
        }
        if (Array.isArray(this.userUnitsIds)) {
            data["userUnitsIds"] = [];
            for (let item of this.userUnitsIds)
                data["userUnitsIds"].push(item);
        }
        return data;
    }
}

export interface IPermissionInViewModel {
    userProjectTemplateId?: number | undefined;
    userId?: string | undefined;
    projectId?: number;
    templateId?: number;
    role?: string | undefined;
    userDisciplinesIds?: number[] | undefined;
    userUnitsIds?: number[] | undefined;
}

export class PermissionGlobalInViewModel implements IPermissionGlobalInViewModel {
    userId?: string | undefined;
    role?: string | undefined;

    constructor(data?: IPermissionGlobalInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): PermissionGlobalInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionGlobalInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["role"] = this.role;
        return data;
    }
}

export interface IPermissionGlobalInViewModel {
    userId?: string | undefined;
    role?: string | undefined;
}

export class PermissionDetailViewModel implements IPermissionDetailViewModel {
    userProjectTemplateId?: number;
    userId?: string | undefined;
    projectId?: number;
    templateId?: number;
    role?: string | undefined;
    userDisciplinesIds?: number[] | undefined;
    userUnitsIds?: number[] | undefined;

    constructor(data?: IPermissionDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userProjectTemplateId = _data["userProjectTemplateId"];
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.templateId = _data["templateId"];
            this.role = _data["role"];
            if (Array.isArray(_data["userDisciplinesIds"])) {
                this.userDisciplinesIds = [] as any;
                for (let item of _data["userDisciplinesIds"])
                    this.userDisciplinesIds!.push(item);
            }
            if (Array.isArray(_data["userUnitsIds"])) {
                this.userUnitsIds = [] as any;
                for (let item of _data["userUnitsIds"])
                    this.userUnitsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PermissionDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProjectTemplateId"] = this.userProjectTemplateId;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["templateId"] = this.templateId;
        data["role"] = this.role;
        if (Array.isArray(this.userDisciplinesIds)) {
            data["userDisciplinesIds"] = [];
            for (let item of this.userDisciplinesIds)
                data["userDisciplinesIds"].push(item);
        }
        if (Array.isArray(this.userUnitsIds)) {
            data["userUnitsIds"] = [];
            for (let item of this.userUnitsIds)
                data["userUnitsIds"].push(item);
        }
        return data;
    }
}

export interface IPermissionDetailViewModel {
    userProjectTemplateId?: number;
    userId?: string | undefined;
    projectId?: number;
    templateId?: number;
    role?: string | undefined;
    userDisciplinesIds?: number[] | undefined;
    userUnitsIds?: number[] | undefined;
}

export class CustomTemplateViewModel implements ICustomTemplateViewModel {
    id?: number | undefined;
    name?: string | undefined;
    fileName?: string | undefined;
    file?: string | undefined;
    mimeType?: string | undefined;
    source?: MasterViewModel | undefined;
    isListTemplate?: boolean;
    numberOfRows?: number | undefined;

    constructor(data?: ICustomTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileName = _data["fileName"];
            this.file = _data["file"];
            this.mimeType = _data["mimeType"];
            this.source = _data["source"] ? MasterViewModel.fromJS(_data["source"]) : undefined as any;
            this.isListTemplate = _data["isListTemplate"];
            this.numberOfRows = _data["numberOfRows"];
        }
    }

    static fromJS(data: any): CustomTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        data["file"] = this.file;
        data["mimeType"] = this.mimeType;
        data["source"] = this.source ? this.source.toJSON() : undefined as any;
        data["isListTemplate"] = this.isListTemplate;
        data["numberOfRows"] = this.numberOfRows;
        return data;
    }
}

export interface ICustomTemplateViewModel {
    id?: number | undefined;
    name?: string | undefined;
    fileName?: string | undefined;
    file?: string | undefined;
    mimeType?: string | undefined;
    source?: MasterViewModel | undefined;
    isListTemplate?: boolean;
    numberOfRows?: number | undefined;
}

export class CustomTemplateInViewModel implements ICustomTemplateInViewModel {
    id?: number | undefined;
    name?: string | undefined;
    fileName?: string | undefined;
    file?: string | undefined;
    mimeType?: string | undefined;
    sourceId?: number;
    isListTemplate?: boolean;
    numberOfRows?: number | undefined;

    constructor(data?: ICustomTemplateInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileName = _data["fileName"];
            this.file = _data["file"];
            this.mimeType = _data["mimeType"];
            this.sourceId = _data["sourceId"];
            this.isListTemplate = _data["isListTemplate"];
            this.numberOfRows = _data["numberOfRows"];
        }
    }

    static fromJS(data: any): CustomTemplateInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomTemplateInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        data["file"] = this.file;
        data["mimeType"] = this.mimeType;
        data["sourceId"] = this.sourceId;
        data["isListTemplate"] = this.isListTemplate;
        data["numberOfRows"] = this.numberOfRows;
        return data;
    }
}

export interface ICustomTemplateInViewModel {
    id?: number | undefined;
    name?: string | undefined;
    fileName?: string | undefined;
    file?: string | undefined;
    mimeType?: string | undefined;
    sourceId?: number;
    isListTemplate?: boolean;
    numberOfRows?: number | undefined;
}

export class ExportWithMimeTypeViewModel extends ExportViewModel implements IExportWithMimeTypeViewModel {
    mimeType?: string | undefined;

    constructor(data?: IExportWithMimeTypeViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mimeType = _data["mimeType"];
        }
    }

    static override fromJS(data: any): ExportWithMimeTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportWithMimeTypeViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mimeType"] = this.mimeType;
        super.toJSON(data);
        return data;
    }
}

export interface IExportWithMimeTypeViewModel extends IExportViewModel {
    mimeType?: string | undefined;
}

export class TemplateProjectCustomReportViewModel implements ITemplateProjectCustomReportViewModel {
    id?: number;
    createdBy?: string | undefined;
    projectId?: number | undefined;
    templateId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    allowedRoles?: string[] | undefined;
    query?: string | undefined;
    previousQuery?: string | undefined;
    templateProjectCustomReportSourceId?: number;

    constructor(data?: ITemplateProjectCustomReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.projectId = _data["projectId"];
            this.templateId = _data["templateId"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["allowedRoles"])) {
                this.allowedRoles = [] as any;
                for (let item of _data["allowedRoles"])
                    this.allowedRoles!.push(item);
            }
            this.query = _data["query"];
            this.previousQuery = _data["previousQuery"];
            this.templateProjectCustomReportSourceId = _data["templateProjectCustomReportSourceId"];
        }
    }

    static fromJS(data: any): TemplateProjectCustomReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateProjectCustomReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["projectId"] = this.projectId;
        data["templateId"] = this.templateId;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.allowedRoles)) {
            data["allowedRoles"] = [];
            for (let item of this.allowedRoles)
                data["allowedRoles"].push(item);
        }
        data["query"] = this.query;
        data["previousQuery"] = this.previousQuery;
        data["templateProjectCustomReportSourceId"] = this.templateProjectCustomReportSourceId;
        return data;
    }
}

export interface ITemplateProjectCustomReportViewModel {
    id?: number;
    createdBy?: string | undefined;
    projectId?: number | undefined;
    templateId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    allowedRoles?: string[] | undefined;
    query?: string | undefined;
    previousQuery?: string | undefined;
    templateProjectCustomReportSourceId?: number;
}

export class TemplateProjectCustomReportSourceViewModel implements ITemplateProjectCustomReportSourceViewModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITemplateProjectCustomReportSourceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TemplateProjectCustomReportSourceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateProjectCustomReportSourceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITemplateProjectCustomReportSourceViewModel {
    id?: number;
    name?: string | undefined;
}

export class TemplateIdProjectIdViewModel implements ITemplateIdProjectIdViewModel {
    templateId?: number;
    projectId?: number;

    constructor(data?: ITemplateIdProjectIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): TemplateIdProjectIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateIdProjectIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ITemplateIdProjectIdViewModel {
    templateId?: number;
    projectId?: number;
}

export class AvailableColumnViewModel implements IAvailableColumnViewModel {
    columnName?: string | undefined;
    dataType?: AvailableTypesEnum;

    constructor(data?: IAvailableColumnViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): AvailableColumnViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableColumnViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface IAvailableColumnViewModel {
    columnName?: string | undefined;
    dataType?: AvailableTypesEnum;
}

export enum AvailableTypesEnum {
    String = 1,
    Bool = 2,
    DateTime = 3,
    Double = 4,
    Long = 5,
    Short = 6,
    MultiSelect = 7,
}

export class SaveCustomReportViewModel implements ISaveCustomReportViewModel {
    templateProjectCustomReportId?: number | undefined;
    allowedProjectTemplates?: string[] | undefined;
    sourceId?: number;
    name?: string | undefined;
    description?: string | undefined;
    allowedRoles?: string[] | undefined;
    columns?: string[] | undefined;
    filters?: FilterViewModel[] | undefined;

    constructor(data?: ISaveCustomReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateProjectCustomReportId = _data["templateProjectCustomReportId"];
            if (Array.isArray(_data["allowedProjectTemplates"])) {
                this.allowedProjectTemplates = [] as any;
                for (let item of _data["allowedProjectTemplates"])
                    this.allowedProjectTemplates!.push(item);
            }
            this.sourceId = _data["sourceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["allowedRoles"])) {
                this.allowedRoles = [] as any;
                for (let item of _data["allowedRoles"])
                    this.allowedRoles!.push(item);
            }
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveCustomReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCustomReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateProjectCustomReportId"] = this.templateProjectCustomReportId;
        if (Array.isArray(this.allowedProjectTemplates)) {
            data["allowedProjectTemplates"] = [];
            for (let item of this.allowedProjectTemplates)
                data["allowedProjectTemplates"].push(item);
        }
        data["sourceId"] = this.sourceId;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.allowedRoles)) {
            data["allowedRoles"] = [];
            for (let item of this.allowedRoles)
                data["allowedRoles"].push(item);
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveCustomReportViewModel {
    templateProjectCustomReportId?: number | undefined;
    allowedProjectTemplates?: string[] | undefined;
    sourceId?: number;
    name?: string | undefined;
    description?: string | undefined;
    allowedRoles?: string[] | undefined;
    columns?: string[] | undefined;
    filters?: FilterViewModel[] | undefined;
}

export class FilterViewModel implements IFilterViewModel {
    columnName?: string | undefined;
    dataType?: AvailableTypesEnum;
    value?: any | undefined;
    filterType?: FilterTypes;

    constructor(data?: IFilterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.dataType = _data["dataType"];
            this.value = _data["value"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): FilterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["dataType"] = this.dataType;
        data["value"] = this.value;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IFilterViewModel {
    columnName?: string | undefined;
    dataType?: AvailableTypesEnum;
    value?: any | undefined;
    filterType?: FilterTypes;
}

export enum FilterTypes {
    In = 0,
    NotIn = 1,
    Contains = 2,
    StartWith = 3,
    EndsWith = 4,
    Equals = 5,
    NotEquals = 6,
    Greater = 7,
    GreaterOrEquals = 8,
    Less = 9,
    LessOrEquals = 10,
    IsNotNull = 11,
    IsNull = 12,
    Between = 13,
    NotBetween = 14,
}

export class DataSourceViewModel implements IDataSourceViewModel {
    page?: number;
    pageSize?: number;

    constructor(data?: IDataSourceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): DataSourceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataSourceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IDataSourceViewModel {
    page?: number;
    pageSize?: number;
}

export class PunchFilterViewModelDataSourceViewModel extends DataSourceViewModel implements IPunchFilterViewModelDataSourceViewModel {
    filters?: PunchFilterViewModel[] | undefined;

    constructor(data?: IPunchFilterViewModelDataSourceViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(PunchFilterViewModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PunchFilterViewModelDataSourceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchFilterViewModelDataSourceViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPunchFilterViewModelDataSourceViewModel extends IDataSourceViewModel {
    filters?: PunchFilterViewModel[] | undefined;
}

export class PunchDataSourceViewModel extends PunchFilterViewModelDataSourceViewModel implements IPunchDataSourceViewModel {
    applyOrderAndDefaultFiltersForExternalApps?: boolean;

    constructor(data?: IPunchDataSourceViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applyOrderAndDefaultFiltersForExternalApps = _data["applyOrderAndDefaultFiltersForExternalApps"];
        }
    }

    static override fromJS(data: any): PunchDataSourceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchDataSourceViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applyOrderAndDefaultFiltersForExternalApps"] = this.applyOrderAndDefaultFiltersForExternalApps;
        super.toJSON(data);
        return data;
    }
}

export interface IPunchDataSourceViewModel extends IPunchFilterViewModelDataSourceViewModel {
    applyOrderAndDefaultFiltersForExternalApps?: boolean;
}

export class PunchFilterViewModel extends FilterViewModel implements IPunchFilterViewModel {
    isCustomField?: boolean;
    propertyName?: string | undefined;

    constructor(data?: IPunchFilterViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isCustomField = _data["isCustomField"];
            this.propertyName = _data["propertyName"];
        }
    }

    static override fromJS(data: any): PunchFilterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchFilterViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCustomField"] = this.isCustomField;
        data["propertyName"] = this.propertyName;
        super.toJSON(data);
        return data;
    }
}

export interface IPunchFilterViewModel extends IFilterViewModel {
    isCustomField?: boolean;
    propertyName?: string | undefined;
}

export class ProjectDetailsViewModel implements IProjectDetailsViewModel {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    name?: string | undefined;
    client?: string | undefined;
    location?: string | undefined;
    wbsLastSync?: Date | undefined;
    lastWbsSyncStatus?: string | undefined;
    templatesCount?: number;
    projectTemplatesInfo?: ProjectTemplateInfoDto[] | undefined;

    constructor(data?: IProjectDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.client = _data["client"];
            this.location = _data["location"];
            this.wbsLastSync = _data["wbsLastSync"] ? new Date(_data["wbsLastSync"].toString()) : undefined as any;
            this.lastWbsSyncStatus = _data["lastWbsSyncStatus"];
            this.templatesCount = _data["templatesCount"];
            if (Array.isArray(_data["projectTemplatesInfo"])) {
                this.projectTemplatesInfo = [] as any;
                for (let item of _data["projectTemplatesInfo"])
                    this.projectTemplatesInfo!.push(ProjectTemplateInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["name"] = this.name;
        data["client"] = this.client;
        data["location"] = this.location;
        data["wbsLastSync"] = this.wbsLastSync ? this.wbsLastSync.toISOString() : undefined as any;
        data["lastWbsSyncStatus"] = this.lastWbsSyncStatus;
        data["templatesCount"] = this.templatesCount;
        if (Array.isArray(this.projectTemplatesInfo)) {
            data["projectTemplatesInfo"] = [];
            for (let item of this.projectTemplatesInfo)
                data["projectTemplatesInfo"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDetailsViewModel {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    name?: string | undefined;
    client?: string | undefined;
    location?: string | undefined;
    wbsLastSync?: Date | undefined;
    lastWbsSyncStatus?: string | undefined;
    templatesCount?: number;
    projectTemplatesInfo?: ProjectTemplateInfoDto[] | undefined;
}

export class ProjectTemplateInfoDto implements IProjectTemplateInfoDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    usersCount?: number;
    punchesCount?: number;

    constructor(data?: IProjectTemplateInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.usersCount = _data["usersCount"];
            this.punchesCount = _data["punchesCount"];
        }
    }

    static fromJS(data: any): ProjectTemplateInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTemplateInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["usersCount"] = this.usersCount;
        data["punchesCount"] = this.punchesCount;
        return data;
    }
}

export interface IProjectTemplateInfoDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    usersCount?: number;
    punchesCount?: number;
}

export class TemplateViewModel extends MasterViewModel implements ITemplateViewModel {
    hcsLinked?: boolean;
    reportTemplate?: boolean;
    topicsCount?: number;
    tags?: string[] | undefined;
    projects?: ProjectViewModel[] | undefined;
    configuration?: TemplateProjectConfigViewModel[] | undefined;
    templatePunchCustomField?: TemplatePunchCustomFieldViewModel[] | undefined;
    inspectionType?: InspectionTypeViewModel[] | undefined;
    category?: CategoryViewModel[] | undefined;
    topic?: TopicViewModel[] | undefined;

    constructor(data?: ITemplateViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hcsLinked = _data["hcsLinked"];
            this.reportTemplate = _data["reportTemplate"];
            this.topicsCount = _data["topicsCount"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectViewModel.fromJS(item));
            }
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(TemplateProjectConfigViewModel.fromJS(item));
            }
            if (Array.isArray(_data["templatePunchCustomField"])) {
                this.templatePunchCustomField = [] as any;
                for (let item of _data["templatePunchCustomField"])
                    this.templatePunchCustomField!.push(TemplatePunchCustomFieldViewModel.fromJS(item));
            }
            if (Array.isArray(_data["inspectionType"])) {
                this.inspectionType = [] as any;
                for (let item of _data["inspectionType"])
                    this.inspectionType!.push(InspectionTypeViewModel.fromJS(item));
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(CategoryViewModel.fromJS(item));
            }
            if (Array.isArray(_data["topic"])) {
                this.topic = [] as any;
                for (let item of _data["topic"])
                    this.topic!.push(TopicViewModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hcsLinked"] = this.hcsLinked;
        data["reportTemplate"] = this.reportTemplate;
        data["topicsCount"] = this.topicsCount;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.templatePunchCustomField)) {
            data["templatePunchCustomField"] = [];
            for (let item of this.templatePunchCustomField)
                data["templatePunchCustomField"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionType)) {
            data["inspectionType"] = [];
            for (let item of this.inspectionType)
                data["inspectionType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.topic)) {
            data["topic"] = [];
            for (let item of this.topic)
                data["topic"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateViewModel extends IMasterViewModel {
    hcsLinked?: boolean;
    reportTemplate?: boolean;
    topicsCount?: number;
    tags?: string[] | undefined;
    projects?: ProjectViewModel[] | undefined;
    configuration?: TemplateProjectConfigViewModel[] | undefined;
    templatePunchCustomField?: TemplatePunchCustomFieldViewModel[] | undefined;
    inspectionType?: InspectionTypeViewModel[] | undefined;
    category?: CategoryViewModel[] | undefined;
    topic?: TopicViewModel[] | undefined;
}

export class TemplateProjectConfigViewModel extends MasterViewModel implements ITemplateProjectConfigViewModel {
    key?: string | undefined;
    value?: string | undefined;
    templateId?: number;

    constructor(data?: ITemplateProjectConfigViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.templateId = _data["templateId"];
        }
    }

    static override fromJS(data: any): TemplateProjectConfigViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateProjectConfigViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["templateId"] = this.templateId;
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateProjectConfigViewModel extends IMasterViewModel {
    key?: string | undefined;
    value?: string | undefined;
    templateId?: number;
}

export class TemplatePunchCustomFieldViewModel extends MasterViewModel implements ITemplatePunchCustomFieldViewModel {
    order?: number | undefined;
    name?: string | undefined;
    front?: string | undefined;
    visual?: string | undefined;
    type?: string | undefined;
    options?: string | undefined;
    templateId?: number | undefined;
    notAllowedRoles?: string[] | undefined;
    edit?: boolean;

    constructor(data?: ITemplatePunchCustomFieldViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            this.front = _data["front"];
            this.visual = _data["visual"];
            this.type = _data["type"];
            this.options = _data["options"];
            this.templateId = _data["templateId"];
            if (Array.isArray(_data["notAllowedRoles"])) {
                this.notAllowedRoles = [] as any;
                for (let item of _data["notAllowedRoles"])
                    this.notAllowedRoles!.push(item);
            }
            this.edit = _data["edit"];
        }
    }

    static override fromJS(data: any): TemplatePunchCustomFieldViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplatePunchCustomFieldViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        data["front"] = this.front;
        data["visual"] = this.visual;
        data["type"] = this.type;
        data["options"] = this.options;
        data["templateId"] = this.templateId;
        if (Array.isArray(this.notAllowedRoles)) {
            data["notAllowedRoles"] = [];
            for (let item of this.notAllowedRoles)
                data["notAllowedRoles"].push(item);
        }
        data["edit"] = this.edit;
        super.toJSON(data);
        return data;
    }
}

export interface ITemplatePunchCustomFieldViewModel extends IMasterViewModel {
    order?: number | undefined;
    name?: string | undefined;
    front?: string | undefined;
    visual?: string | undefined;
    type?: string | undefined;
    options?: string | undefined;
    templateId?: number | undefined;
    notAllowedRoles?: string[] | undefined;
    edit?: boolean;
}

export class InspectionTypeViewModel extends MasterViewModel implements IInspectionTypeViewModel {
    name?: string | undefined;
    connector?: string | undefined;
    templateId?: number;
    tags?: string[] | undefined;
    category?: CategoryViewModel[] | undefined;
    topic?: TopicViewModel[] | undefined;
    inspectionTypeFlowSign?: InspectionTypeFlowSignViewModel[] | undefined;

    constructor(data?: IInspectionTypeViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.connector = _data["connector"];
            this.templateId = _data["templateId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(CategoryViewModel.fromJS(item));
            }
            if (Array.isArray(_data["topic"])) {
                this.topic = [] as any;
                for (let item of _data["topic"])
                    this.topic!.push(TopicViewModel.fromJS(item));
            }
            if (Array.isArray(_data["inspectionTypeFlowSign"])) {
                this.inspectionTypeFlowSign = [] as any;
                for (let item of _data["inspectionTypeFlowSign"])
                    this.inspectionTypeFlowSign!.push(InspectionTypeFlowSignViewModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): InspectionTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["connector"] = this.connector;
        data["templateId"] = this.templateId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.topic)) {
            data["topic"] = [];
            for (let item of this.topic)
                data["topic"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionTypeFlowSign)) {
            data["inspectionTypeFlowSign"] = [];
            for (let item of this.inspectionTypeFlowSign)
                data["inspectionTypeFlowSign"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionTypeViewModel extends IMasterViewModel {
    name?: string | undefined;
    connector?: string | undefined;
    templateId?: number;
    tags?: string[] | undefined;
    category?: CategoryViewModel[] | undefined;
    topic?: TopicViewModel[] | undefined;
    inspectionTypeFlowSign?: InspectionTypeFlowSignViewModel[] | undefined;
}

export class CategoryViewModel extends MasterViewModel implements ICategoryViewModel {
    contractualInterpretation?: string | undefined;
    colorType?: number | undefined;
    categoryMatchId?: number | undefined;
    order?: number | undefined;

    constructor(data?: ICategoryViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contractualInterpretation = _data["contractualInterpretation"];
            this.colorType = _data["colorType"];
            this.categoryMatchId = _data["categoryMatchId"];
            this.order = _data["order"];
        }
    }

    static override fromJS(data: any): CategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractualInterpretation"] = this.contractualInterpretation;
        data["colorType"] = this.colorType;
        data["categoryMatchId"] = this.categoryMatchId;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }
}

export interface ICategoryViewModel extends IMasterViewModel {
    contractualInterpretation?: string | undefined;
    colorType?: number | undefined;
    categoryMatchId?: number | undefined;
    order?: number | undefined;
}

export class TopicViewModel extends MasterViewModel implements ITopicViewModel {
    topicImpactLevel?: number | undefined;
    topicMatchId?: number | undefined;
    discipline?: MasterViewModel | undefined;

    constructor(data?: ITopicViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.topicImpactLevel = _data["topicImpactLevel"];
            this.topicMatchId = _data["topicMatchId"];
            this.discipline = _data["discipline"] ? MasterViewModel.fromJS(_data["discipline"]) : undefined as any;
        }
    }

    static override fromJS(data: any): TopicViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TopicViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicImpactLevel"] = this.topicImpactLevel;
        data["topicMatchId"] = this.topicMatchId;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITopicViewModel extends IMasterViewModel {
    topicImpactLevel?: number | undefined;
    topicMatchId?: number | undefined;
    discipline?: MasterViewModel | undefined;
}

export class InspectionTypeFlowSignViewModel implements IInspectionTypeFlowSignViewModel {
    id?: number | undefined;
    inspectionTypeId?: number | undefined;
    override?: boolean;
    sequence?: number | undefined;
    user?: UserViewModel | undefined;
    role?: string | undefined;
    expiredType?: MasterViewModel | undefined;
    expiredTime?: MasterViewModel | undefined;
    inspectionTypeFlowType?: InspectionTypeFlowTypeViewModel[] | undefined;
    expiredValue?: number | undefined;

    constructor(data?: IInspectionTypeFlowSignViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inspectionTypeId = _data["inspectionTypeId"];
            this.override = _data["override"];
            this.sequence = _data["sequence"];
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : undefined as any;
            this.role = _data["role"];
            this.expiredType = _data["expiredType"] ? MasterViewModel.fromJS(_data["expiredType"]) : undefined as any;
            this.expiredTime = _data["expiredTime"] ? MasterViewModel.fromJS(_data["expiredTime"]) : undefined as any;
            if (Array.isArray(_data["inspectionTypeFlowType"])) {
                this.inspectionTypeFlowType = [] as any;
                for (let item of _data["inspectionTypeFlowType"])
                    this.inspectionTypeFlowType!.push(InspectionTypeFlowTypeViewModel.fromJS(item));
            }
            this.expiredValue = _data["expiredValue"];
        }
    }

    static fromJS(data: any): InspectionTypeFlowSignViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeFlowSignViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionTypeId"] = this.inspectionTypeId;
        data["override"] = this.override;
        data["sequence"] = this.sequence;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["role"] = this.role;
        data["expiredType"] = this.expiredType ? this.expiredType.toJSON() : undefined as any;
        data["expiredTime"] = this.expiredTime ? this.expiredTime.toJSON() : undefined as any;
        if (Array.isArray(this.inspectionTypeFlowType)) {
            data["inspectionTypeFlowType"] = [];
            for (let item of this.inspectionTypeFlowType)
                data["inspectionTypeFlowType"].push(item ? item.toJSON() : undefined as any);
        }
        data["expiredValue"] = this.expiredValue;
        return data;
    }
}

export interface IInspectionTypeFlowSignViewModel {
    id?: number | undefined;
    inspectionTypeId?: number | undefined;
    override?: boolean;
    sequence?: number | undefined;
    user?: UserViewModel | undefined;
    role?: string | undefined;
    expiredType?: MasterViewModel | undefined;
    expiredTime?: MasterViewModel | undefined;
    inspectionTypeFlowType?: InspectionTypeFlowTypeViewModel[] | undefined;
    expiredValue?: number | undefined;
}

export class InspectionTypeFlowTypeViewModel extends MasterViewModel implements IInspectionTypeFlowTypeViewModel {
    signAction?: InspectionTypeSignActionViewModel[] | undefined;

    constructor(data?: IInspectionTypeFlowTypeViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["signAction"])) {
                this.signAction = [] as any;
                for (let item of _data["signAction"])
                    this.signAction!.push(InspectionTypeSignActionViewModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): InspectionTypeFlowTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeFlowTypeViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.signAction)) {
            data["signAction"] = [];
            for (let item of this.signAction)
                data["signAction"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionTypeFlowTypeViewModel extends IMasterViewModel {
    signAction?: InspectionTypeSignActionViewModel[] | undefined;
}

export class InspectionTypeSignActionViewModel implements IInspectionTypeSignActionViewModel {
    id?: number | undefined;
    action?: MasterViewModel | undefined;
    status?: StatusViewModel | undefined;

    constructor(data?: IInspectionTypeSignActionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.action = _data["action"] ? MasterViewModel.fromJS(_data["action"]) : undefined as any;
            this.status = _data["status"] ? StatusViewModel.fromJS(_data["status"]) : undefined as any;
        }
    }

    static fromJS(data: any): InspectionTypeSignActionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeSignActionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["action"] = this.action ? this.action.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        return data;
    }
}

export interface IInspectionTypeSignActionViewModel {
    id?: number | undefined;
    action?: MasterViewModel | undefined;
    status?: StatusViewModel | undefined;
}

export class StatusViewModel extends MasterViewModel implements IStatusViewModel {
    color?: string | undefined;
    isVisible?: boolean;

    constructor(data?: IStatusViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.color = _data["color"];
            this.isVisible = _data["isVisible"];
        }
    }

    static override fromJS(data: any): StatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatusViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["isVisible"] = this.isVisible;
        super.toJSON(data);
        return data;
    }
}

export interface IStatusViewModel extends IMasterViewModel {
    color?: string | undefined;
    isVisible?: boolean;
}

export class TopicInViewModel extends MasterViewModel implements ITopicInViewModel {
    topicImpactLevel?: number | undefined;
    topicMatchId?: number | undefined;
    disciplineId?: number | undefined;

    constructor(data?: ITopicInViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.topicImpactLevel = _data["topicImpactLevel"];
            this.topicMatchId = _data["topicMatchId"];
            this.disciplineId = _data["disciplineId"];
        }
    }

    static override fromJS(data: any): TopicInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TopicInViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicImpactLevel"] = this.topicImpactLevel;
        data["topicMatchId"] = this.topicMatchId;
        data["disciplineId"] = this.disciplineId;
        super.toJSON(data);
        return data;
    }
}

export interface ITopicInViewModel extends IMasterViewModel {
    topicImpactLevel?: number | undefined;
    topicMatchId?: number | undefined;
    disciplineId?: number | undefined;
}

export class PunchCustomFieldViewModel implements IPunchCustomFieldViewModel {
    id?: number | undefined;
    value?: string | undefined;
    visible?: boolean | undefined;
    templatePunchCustomField?: TemplatePunchCustomFieldViewModel | undefined;

    constructor(data?: IPunchCustomFieldViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.visible = _data["visible"];
            this.templatePunchCustomField = _data["templatePunchCustomField"] ? TemplatePunchCustomFieldViewModel.fromJS(_data["templatePunchCustomField"]) : undefined as any;
        }
    }

    static fromJS(data: any): PunchCustomFieldViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchCustomFieldViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["visible"] = this.visible;
        data["templatePunchCustomField"] = this.templatePunchCustomField ? this.templatePunchCustomField.toJSON() : undefined as any;
        return data;
    }
}

export interface IPunchCustomFieldViewModel {
    id?: number | undefined;
    value?: string | undefined;
    visible?: boolean | undefined;
    templatePunchCustomField?: TemplatePunchCustomFieldViewModel | undefined;
}

export class GridConfigViewModel implements IGridConfigViewModel {
    id?: number | undefined;
    userId?: string | undefined;
    templateId?: number;
    projectId?: number;
    configType?: number;
    configJson?: string | undefined;

    constructor(data?: IGridConfigViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.templateId = _data["templateId"];
            this.projectId = _data["projectId"];
            this.configType = _data["configType"];
            this.configJson = _data["configJson"];
        }
    }

    static fromJS(data: any): GridConfigViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GridConfigViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["templateId"] = this.templateId;
        data["projectId"] = this.projectId;
        data["configType"] = this.configType;
        data["configJson"] = this.configJson;
        return data;
    }
}

export interface IGridConfigViewModel {
    id?: number | undefined;
    userId?: string | undefined;
    templateId?: number;
    projectId?: number;
    configType?: number;
    configJson?: string | undefined;
}

export class GridConfigInViewModel implements IGridConfigInViewModel {
    id?: number | undefined;
    configType?: number;
    configJson?: string | undefined;

    constructor(data?: IGridConfigInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.configType = _data["configType"];
            this.configJson = _data["configJson"];
        }
    }

    static fromJS(data: any): GridConfigInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GridConfigInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["configType"] = this.configType;
        data["configJson"] = this.configJson;
        return data;
    }
}

export interface IGridConfigInViewModel {
    id?: number | undefined;
    configType?: number;
    configJson?: string | undefined;
}

export class SubcontractorDto implements ISubcontractorDto {
    id?: number | undefined;
    code?: string | undefined;
    shortDescription?: string | undefined;
    name?: string | undefined;

    constructor(data?: ISubcontractorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.shortDescription = _data["shortDescription"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SubcontractorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["shortDescription"] = this.shortDescription;
        data["name"] = this.name;
        return data;
    }
}

export interface ISubcontractorDto {
    id?: number | undefined;
    code?: string | undefined;
    shortDescription?: string | undefined;
    name?: string | undefined;
}

export class MasterDto implements IMasterDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IMasterDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export class TemplateProjectSubcontractDto extends MasterDto implements ITemplateProjectSubcontractDto {
    subcontractorId?: number;

    constructor(data?: ITemplateProjectSubcontractDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static override fromJS(data: any): TemplateProjectSubcontractDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateProjectSubcontractDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subcontractorId"] = this.subcontractorId;
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateProjectSubcontractDto extends IMasterDto {
    subcontractorId?: number;
}

export class PunchBagCreateViewModel implements IPunchBagCreateViewModel {
    name?: string | undefined;
    assignedUserId?: string | undefined;
    maxSignatureRole?: string | undefined;
    punchIds?: number[] | undefined;

    constructor(data?: IPunchBagCreateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.assignedUserId = _data["assignedUserId"];
            this.maxSignatureRole = _data["maxSignatureRole"];
            if (Array.isArray(_data["punchIds"])) {
                this.punchIds = [] as any;
                for (let item of _data["punchIds"])
                    this.punchIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PunchBagCreateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBagCreateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["assignedUserId"] = this.assignedUserId;
        data["maxSignatureRole"] = this.maxSignatureRole;
        if (Array.isArray(this.punchIds)) {
            data["punchIds"] = [];
            for (let item of this.punchIds)
                data["punchIds"].push(item);
        }
        return data;
    }
}

export interface IPunchBagCreateViewModel {
    name?: string | undefined;
    assignedUserId?: string | undefined;
    maxSignatureRole?: string | undefined;
    punchIds?: number[] | undefined;
}

export class PunchBagDtoQueryResult implements IPunchBagDtoQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: PunchBagDto[] | undefined;

    constructor(data?: IPunchBagDtoQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.orderBy = _data["orderBy"];
            this.ascending = _data["ascending"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PunchBagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchBagDtoQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBagDtoQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["orderBy"] = this.orderBy;
        data["ascending"] = this.ascending;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchBagDtoQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: PunchBagDto[] | undefined;
}

export class PunchBagDto implements IPunchBagDto {
    id?: number;
    name?: string | undefined;
    templateId?: number;
    projectId?: number;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    assignedUserId?: string | undefined;
    assignedUserName?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
    expiresAt?: Date;
    maxSignatureRole?: string | undefined;
    punchCount?: number;

    constructor(data?: IPunchBagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.templateId = _data["templateId"];
            this.projectId = _data["projectId"];
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.assignedUserId = _data["assignedUserId"];
            this.assignedUserName = _data["assignedUserName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.maxSignatureRole = _data["maxSignatureRole"];
            this.punchCount = _data["punchCount"];
        }
    }

    static fromJS(data: any): PunchBagDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["templateId"] = this.templateId;
        data["projectId"] = this.projectId;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["assignedUserId"] = this.assignedUserId;
        data["assignedUserName"] = this.assignedUserName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["maxSignatureRole"] = this.maxSignatureRole;
        data["punchCount"] = this.punchCount;
        return data;
    }
}

export interface IPunchBagDto {
    id?: number;
    name?: string | undefined;
    templateId?: number;
    projectId?: number;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    assignedUserId?: string | undefined;
    assignedUserName?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
    expiresAt?: Date;
    maxSignatureRole?: string | undefined;
    punchCount?: number;
}

export class PunchBagViewModel implements IPunchBagViewModel {
    id?: number;
    name?: string | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    assignedUserId?: string | undefined;
    assignedUserName?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
    expiresAt?: Date;
    maxSignatureRole?: string | undefined;
    punchCount?: number;

    constructor(data?: IPunchBagViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.assignedUserId = _data["assignedUserId"];
            this.assignedUserName = _data["assignedUserName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.maxSignatureRole = _data["maxSignatureRole"];
            this.punchCount = _data["punchCount"];
        }
    }

    static fromJS(data: any): PunchBagViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBagViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["assignedUserId"] = this.assignedUserId;
        data["assignedUserName"] = this.assignedUserName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["maxSignatureRole"] = this.maxSignatureRole;
        data["punchCount"] = this.punchCount;
        return data;
    }
}

export interface IPunchBagViewModel {
    id?: number;
    name?: string | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    assignedUserId?: string | undefined;
    assignedUserName?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
    expiresAt?: Date;
    maxSignatureRole?: string | undefined;
    punchCount?: number;
}

export class PunchBagDetailsViewModel extends PunchBagViewModel implements IPunchBagDetailsViewModel {
    punches?: PunchBagPunchViewModel[] | undefined;

    constructor(data?: IPunchBagDetailsViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["punches"])) {
                this.punches = [] as any;
                for (let item of _data["punches"])
                    this.punches!.push(PunchBagPunchViewModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PunchBagDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBagDetailsViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.punches)) {
            data["punches"] = [];
            for (let item of this.punches)
                data["punches"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPunchBagDetailsViewModel extends IPunchBagViewModel {
    punches?: PunchBagPunchViewModel[] | undefined;
}

export class PunchBagPunchViewModel implements IPunchBagPunchViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    topic?: TopicViewModel | undefined;
    discipline?: DisciplineViewModel | undefined;
    status?: StatusViewModel | undefined;
    category?: CategoryViewModel | undefined;
    originator?: MasterViewModel | undefined;
    userOriginator?: UserInfoViewModel | undefined;
    inspectionId?: number;
    closed?: boolean;
    createdBy?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date;
    notes?: string | undefined;
    elements?: MasterViewModel[] | undefined;

    constructor(data?: IPunchBagPunchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.topic = _data["topic"] ? TopicViewModel.fromJS(_data["topic"]) : undefined as any;
            this.discipline = _data["discipline"] ? DisciplineViewModel.fromJS(_data["discipline"]) : undefined as any;
            this.status = _data["status"] ? StatusViewModel.fromJS(_data["status"]) : undefined as any;
            this.category = _data["category"] ? CategoryViewModel.fromJS(_data["category"]) : undefined as any;
            this.originator = _data["originator"] ? MasterViewModel.fromJS(_data["originator"]) : undefined as any;
            this.userOriginator = _data["userOriginator"] ? UserInfoViewModel.fromJS(_data["userOriginator"]) : undefined as any;
            this.inspectionId = _data["inspectionId"];
            this.closed = _data["closed"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.notes = _data["notes"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(MasterViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchBagPunchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBagPunchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["topic"] = this.topic ? this.topic.toJSON() : undefined as any;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["originator"] = this.originator ? this.originator.toJSON() : undefined as any;
        data["userOriginator"] = this.userOriginator ? this.userOriginator.toJSON() : undefined as any;
        data["inspectionId"] = this.inspectionId;
        data["closed"] = this.closed;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["notes"] = this.notes;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchBagPunchViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    topic?: TopicViewModel | undefined;
    discipline?: DisciplineViewModel | undefined;
    status?: StatusViewModel | undefined;
    category?: CategoryViewModel | undefined;
    originator?: MasterViewModel | undefined;
    userOriginator?: UserInfoViewModel | undefined;
    inspectionId?: number;
    closed?: boolean;
    createdBy?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date;
    notes?: string | undefined;
    elements?: MasterViewModel[] | undefined;
}

export class DisciplineViewModel extends MasterViewModel implements IDisciplineViewModel {
    sequence?: number;

    constructor(data?: IDisciplineViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sequence = _data["sequence"];
        }
    }

    static override fromJS(data: any): DisciplineViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DisciplineViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence;
        super.toJSON(data);
        return data;
    }
}

export interface IDisciplineViewModel extends IMasterViewModel {
    sequence?: number;
}

export class PunchViewModelDataSourceResult implements IPunchViewModelDataSourceResult {
    data?: PunchViewModel[] | undefined;
    total?: number;
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;

    constructor(data?: IPunchViewModelDataSourceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PunchViewModel.fromJS(item));
            }
            this.total = _data["total"];
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PunchViewModelDataSourceResult {
        data = typeof data === 'object' ? data : {};
        let result = new PunchViewModelDataSourceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPunchViewModelDataSourceResult {
    data?: PunchViewModel[] | undefined;
    total?: number;
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
}

export class PunchViewModel implements IPunchViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    altitude?: number | undefined;
    location?: string | undefined;
    pdfPositionX?: number | undefined;
    pdfPositionY?: number | undefined;
    pdfPage?: number | undefined;
    pdfFile?: number | undefined;
    punchCoordinator?: string | undefined;
    rejectCount?: number | undefined;
    dateEntry?: Date;
    createdAt?: Date;
    lastModifiedAt?: Date;
    expectedClosingDate?: Date | undefined;
    discipline?: MasterViewModel | undefined;
    category?: CategoryViewModel | undefined;
    departmentAction?: MasterViewModel | undefined;
    itemsAffected?: ElementsViewModel[] | undefined;
    attachments?: PunchMediaViewModel[] | undefined;
    punchCustomFields?: PunchCustomFieldViewModel[] | undefined;
    priority?: MasterViewModel | undefined;
    status?: StatusViewModel | undefined;
    topic?: MasterViewModel | undefined;
    entryType?: MasterViewModel | undefined;
    originator?: OriginatorDto | undefined;
    userOriginator?: UserInfoViewModel | undefined;
    subContractor?: SubcontractorDto | undefined;
    cover?: PunchMediaViewModel | undefined;
    userValid?: boolean;
    commentary?: string | undefined;
    user?: UserInfoViewModel | undefined;
    tags?: TagsViewModel[] | undefined;
    inspection?: InspectionViewModel | undefined;
    inspectionCode?: string | undefined;
    inspectionType?: InspectionTypeViewModel | undefined;
    unit?: MasterViewModel | undefined;
    subSystem?: MasterViewModel | undefined;
    isMyPunch?: boolean;
    isRejected?: boolean;
    isSignable?: boolean;
    isRejectable?: boolean;
    reasonNotSignable?: string | undefined;
    onDispute?: boolean | undefined;
    closed?: boolean | undefined;
    isLocked?: boolean;
    createdBy?: string | undefined;
    notes?: string | undefined;
    tag?: string | undefined;
    contractorResponsibleName?: string | undefined;
    locationProject?: LocationProjectViewModel | undefined;

    constructor(data?: IPunchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.altitude = _data["altitude"];
            this.location = _data["location"];
            this.pdfPositionX = _data["pdfPositionX"];
            this.pdfPositionY = _data["pdfPositionY"];
            this.pdfPage = _data["pdfPage"];
            this.pdfFile = _data["pdfFile"];
            this.punchCoordinator = _data["punchCoordinator"];
            this.rejectCount = _data["rejectCount"];
            this.dateEntry = _data["dateEntry"] ? new Date(_data["dateEntry"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.expectedClosingDate = _data["expectedClosingDate"] ? new Date(_data["expectedClosingDate"].toString()) : undefined as any;
            this.discipline = _data["discipline"] ? MasterViewModel.fromJS(_data["discipline"]) : undefined as any;
            this.category = _data["category"] ? CategoryViewModel.fromJS(_data["category"]) : undefined as any;
            this.departmentAction = _data["departmentAction"] ? MasterViewModel.fromJS(_data["departmentAction"]) : undefined as any;
            if (Array.isArray(_data["itemsAffected"])) {
                this.itemsAffected = [] as any;
                for (let item of _data["itemsAffected"])
                    this.itemsAffected!.push(ElementsViewModel.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(PunchMediaViewModel.fromJS(item));
            }
            if (Array.isArray(_data["punchCustomFields"])) {
                this.punchCustomFields = [] as any;
                for (let item of _data["punchCustomFields"])
                    this.punchCustomFields!.push(PunchCustomFieldViewModel.fromJS(item));
            }
            this.priority = _data["priority"] ? MasterViewModel.fromJS(_data["priority"]) : undefined as any;
            this.status = _data["status"] ? StatusViewModel.fromJS(_data["status"]) : undefined as any;
            this.topic = _data["topic"] ? MasterViewModel.fromJS(_data["topic"]) : undefined as any;
            this.entryType = _data["entryType"] ? MasterViewModel.fromJS(_data["entryType"]) : undefined as any;
            this.originator = _data["originator"] ? OriginatorDto.fromJS(_data["originator"]) : undefined as any;
            this.userOriginator = _data["userOriginator"] ? UserInfoViewModel.fromJS(_data["userOriginator"]) : undefined as any;
            this.subContractor = _data["subContractor"] ? SubcontractorDto.fromJS(_data["subContractor"]) : undefined as any;
            this.cover = _data["cover"] ? PunchMediaViewModel.fromJS(_data["cover"]) : undefined as any;
            this.userValid = _data["userValid"];
            this.commentary = _data["commentary"];
            this.user = _data["user"] ? UserInfoViewModel.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagsViewModel.fromJS(item));
            }
            this.inspection = _data["inspection"] ? InspectionViewModel.fromJS(_data["inspection"]) : undefined as any;
            this.inspectionCode = _data["inspectionCode"];
            this.inspectionType = _data["inspectionType"] ? InspectionTypeViewModel.fromJS(_data["inspectionType"]) : undefined as any;
            this.unit = _data["unit"] ? MasterViewModel.fromJS(_data["unit"]) : undefined as any;
            this.subSystem = _data["subSystem"] ? MasterViewModel.fromJS(_data["subSystem"]) : undefined as any;
            this.isMyPunch = _data["isMyPunch"];
            this.isRejected = _data["isRejected"];
            this.isSignable = _data["isSignable"];
            this.isRejectable = _data["isRejectable"];
            this.reasonNotSignable = _data["reasonNotSignable"];
            this.onDispute = _data["onDispute"];
            this.closed = _data["closed"];
            this.isLocked = _data["isLocked"];
            this.createdBy = _data["createdBy"];
            this.notes = _data["notes"];
            this.tag = _data["tag"];
            this.contractorResponsibleName = _data["contractorResponsibleName"];
            this.locationProject = _data["locationProject"] ? LocationProjectViewModel.fromJS(_data["locationProject"]) : undefined as any;
        }
    }

    static fromJS(data: any): PunchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["altitude"] = this.altitude;
        data["location"] = this.location;
        data["pdfPositionX"] = this.pdfPositionX;
        data["pdfPositionY"] = this.pdfPositionY;
        data["pdfPage"] = this.pdfPage;
        data["pdfFile"] = this.pdfFile;
        data["punchCoordinator"] = this.punchCoordinator;
        data["rejectCount"] = this.rejectCount;
        data["dateEntry"] = this.dateEntry ? this.dateEntry.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["expectedClosingDate"] = this.expectedClosingDate ? this.expectedClosingDate.toISOString() : undefined as any;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["departmentAction"] = this.departmentAction ? this.departmentAction.toJSON() : undefined as any;
        if (Array.isArray(this.itemsAffected)) {
            data["itemsAffected"] = [];
            for (let item of this.itemsAffected)
                data["itemsAffected"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchCustomFields)) {
            data["punchCustomFields"] = [];
            for (let item of this.punchCustomFields)
                data["punchCustomFields"].push(item ? item.toJSON() : undefined as any);
        }
        data["priority"] = this.priority ? this.priority.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["topic"] = this.topic ? this.topic.toJSON() : undefined as any;
        data["entryType"] = this.entryType ? this.entryType.toJSON() : undefined as any;
        data["originator"] = this.originator ? this.originator.toJSON() : undefined as any;
        data["userOriginator"] = this.userOriginator ? this.userOriginator.toJSON() : undefined as any;
        data["subContractor"] = this.subContractor ? this.subContractor.toJSON() : undefined as any;
        data["cover"] = this.cover ? this.cover.toJSON() : undefined as any;
        data["userValid"] = this.userValid;
        data["commentary"] = this.commentary;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["inspection"] = this.inspection ? this.inspection.toJSON() : undefined as any;
        data["inspectionCode"] = this.inspectionCode;
        data["inspectionType"] = this.inspectionType ? this.inspectionType.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["subSystem"] = this.subSystem ? this.subSystem.toJSON() : undefined as any;
        data["isMyPunch"] = this.isMyPunch;
        data["isRejected"] = this.isRejected;
        data["isSignable"] = this.isSignable;
        data["isRejectable"] = this.isRejectable;
        data["reasonNotSignable"] = this.reasonNotSignable;
        data["onDispute"] = this.onDispute;
        data["closed"] = this.closed;
        data["isLocked"] = this.isLocked;
        data["createdBy"] = this.createdBy;
        data["notes"] = this.notes;
        data["tag"] = this.tag;
        data["contractorResponsibleName"] = this.contractorResponsibleName;
        data["locationProject"] = this.locationProject ? this.locationProject.toJSON() : undefined as any;
        return data;
    }
}

export interface IPunchViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    altitude?: number | undefined;
    location?: string | undefined;
    pdfPositionX?: number | undefined;
    pdfPositionY?: number | undefined;
    pdfPage?: number | undefined;
    pdfFile?: number | undefined;
    punchCoordinator?: string | undefined;
    rejectCount?: number | undefined;
    dateEntry?: Date;
    createdAt?: Date;
    lastModifiedAt?: Date;
    expectedClosingDate?: Date | undefined;
    discipline?: MasterViewModel | undefined;
    category?: CategoryViewModel | undefined;
    departmentAction?: MasterViewModel | undefined;
    itemsAffected?: ElementsViewModel[] | undefined;
    attachments?: PunchMediaViewModel[] | undefined;
    punchCustomFields?: PunchCustomFieldViewModel[] | undefined;
    priority?: MasterViewModel | undefined;
    status?: StatusViewModel | undefined;
    topic?: MasterViewModel | undefined;
    entryType?: MasterViewModel | undefined;
    originator?: OriginatorDto | undefined;
    userOriginator?: UserInfoViewModel | undefined;
    subContractor?: SubcontractorDto | undefined;
    cover?: PunchMediaViewModel | undefined;
    userValid?: boolean;
    commentary?: string | undefined;
    user?: UserInfoViewModel | undefined;
    tags?: TagsViewModel[] | undefined;
    inspection?: InspectionViewModel | undefined;
    inspectionCode?: string | undefined;
    inspectionType?: InspectionTypeViewModel | undefined;
    unit?: MasterViewModel | undefined;
    subSystem?: MasterViewModel | undefined;
    isMyPunch?: boolean;
    isRejected?: boolean;
    isSignable?: boolean;
    isRejectable?: boolean;
    reasonNotSignable?: string | undefined;
    onDispute?: boolean | undefined;
    closed?: boolean | undefined;
    isLocked?: boolean;
    createdBy?: string | undefined;
    notes?: string | undefined;
    tag?: string | undefined;
    contractorResponsibleName?: string | undefined;
    locationProject?: LocationProjectViewModel | undefined;
}

export class ElementsViewModel implements IElementsViewModel {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    nodeLevel?: MasterViewModel | undefined;
    subElement?: ElementsViewModel[] | undefined;
    elementType?: MasterViewModel | undefined;
    discipline?: MasterViewModel | undefined;
    selected?: boolean;
    elementMatchId?: number | undefined;
    areWapId?: boolean | undefined;

    constructor(data?: IElementsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.nodeLevel = _data["nodeLevel"] ? MasterViewModel.fromJS(_data["nodeLevel"]) : undefined as any;
            if (Array.isArray(_data["subElement"])) {
                this.subElement = [] as any;
                for (let item of _data["subElement"])
                    this.subElement!.push(ElementsViewModel.fromJS(item));
            }
            this.elementType = _data["elementType"] ? MasterViewModel.fromJS(_data["elementType"]) : undefined as any;
            this.discipline = _data["discipline"] ? MasterViewModel.fromJS(_data["discipline"]) : undefined as any;
            this.selected = _data["selected"];
            this.elementMatchId = _data["elementMatchId"];
            this.areWapId = _data["areWapId"];
        }
    }

    static fromJS(data: any): ElementsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ElementsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["nodeLevel"] = this.nodeLevel ? this.nodeLevel.toJSON() : undefined as any;
        if (Array.isArray(this.subElement)) {
            data["subElement"] = [];
            for (let item of this.subElement)
                data["subElement"].push(item ? item.toJSON() : undefined as any);
        }
        data["elementType"] = this.elementType ? this.elementType.toJSON() : undefined as any;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        data["selected"] = this.selected;
        data["elementMatchId"] = this.elementMatchId;
        data["areWapId"] = this.areWapId;
        return data;
    }
}

export interface IElementsViewModel {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    nodeLevel?: MasterViewModel | undefined;
    subElement?: ElementsViewModel[] | undefined;
    elementType?: MasterViewModel | undefined;
    discipline?: MasterViewModel | undefined;
    selected?: boolean;
    elementMatchId?: number | undefined;
    areWapId?: boolean | undefined;
}

export class PunchMediaViewModel implements IPunchMediaViewModel {
    id?: number | undefined;
    punchId?: number | undefined;
    mimeType?: string | undefined;
    mediaTypeId?: number | undefined;
    file?: string | undefined;
    cover?: boolean;
    realNameFile?: string | undefined;
    lastModifiedAt?: Date;

    constructor(data?: IPunchMediaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.punchId = _data["punchId"];
            this.mimeType = _data["mimeType"];
            this.mediaTypeId = _data["mediaTypeId"];
            this.file = _data["file"];
            this.cover = _data["cover"];
            this.realNameFile = _data["realNameFile"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PunchMediaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchMediaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["punchId"] = this.punchId;
        data["mimeType"] = this.mimeType;
        data["mediaTypeId"] = this.mediaTypeId;
        data["file"] = this.file;
        data["cover"] = this.cover;
        data["realNameFile"] = this.realNameFile;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IPunchMediaViewModel {
    id?: number | undefined;
    punchId?: number | undefined;
    mimeType?: string | undefined;
    mediaTypeId?: number | undefined;
    file?: string | undefined;
    cover?: boolean;
    realNameFile?: string | undefined;
    lastModifiedAt?: Date;
}

export class OriginatorDto extends MasterDto implements IOriginatorDto {

    constructor(data?: IOriginatorDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OriginatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new OriginatorDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOriginatorDto extends IMasterDto {
}

export class TagsViewModel extends MasterViewModel implements ITagsViewModel {

    constructor(data?: ITagsViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TagsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagsViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITagsViewModel extends IMasterViewModel {
}

export class InspectionViewModel extends MasterViewModel implements IInspectionViewModel {
    name?: string | undefined;
    information?: string | undefined;
    location?: string | undefined;
    tracked?: boolean;
    date?: Date | undefined;
    lastModifiedAt?: Date | undefined;
    inspectionType?: MasterViewModel | undefined;
    inspectionState?: InspectionStatusViewModel | undefined;
    wbs?: WbsViewModel | undefined;
    attendes?: UserInspectionViewModel[] | undefined;
    items?: ElementsViewModel[] | undefined;
    userWalks?: UserWalkInfoViewModel[] | undefined;
    attendesCount?: number | undefined;
    files?: InspectionMediaViewModel[] | undefined;
    organizer?: UserInfoViewModel | undefined;
    walks?: number;
    walksStarted?: number;
    walksCompleted?: number;
    walksScheduled?: number;
    walksPaused?: number;
    walksCanceled?: number;

    constructor(data?: IInspectionViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.information = _data["information"];
            this.location = _data["location"];
            this.tracked = _data["tracked"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.inspectionType = _data["inspectionType"] ? MasterViewModel.fromJS(_data["inspectionType"]) : undefined as any;
            this.inspectionState = _data["inspectionState"] ? InspectionStatusViewModel.fromJS(_data["inspectionState"]) : undefined as any;
            this.wbs = _data["wbs"] ? WbsViewModel.fromJS(_data["wbs"]) : undefined as any;
            if (Array.isArray(_data["attendes"])) {
                this.attendes = [] as any;
                for (let item of _data["attendes"])
                    this.attendes!.push(UserInspectionViewModel.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ElementsViewModel.fromJS(item));
            }
            if (Array.isArray(_data["userWalks"])) {
                this.userWalks = [] as any;
                for (let item of _data["userWalks"])
                    this.userWalks!.push(UserWalkInfoViewModel.fromJS(item));
            }
            this.attendesCount = _data["attendesCount"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(InspectionMediaViewModel.fromJS(item));
            }
            this.organizer = _data["organizer"] ? UserInfoViewModel.fromJS(_data["organizer"]) : undefined as any;
            this.walks = _data["walks"];
            this.walksStarted = _data["walksStarted"];
            this.walksCompleted = _data["walksCompleted"];
            this.walksScheduled = _data["walksScheduled"];
            this.walksPaused = _data["walksPaused"];
            this.walksCanceled = _data["walksCanceled"];
        }
    }

    static override fromJS(data: any): InspectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["information"] = this.information;
        data["location"] = this.location;
        data["tracked"] = this.tracked;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["inspectionType"] = this.inspectionType ? this.inspectionType.toJSON() : undefined as any;
        data["inspectionState"] = this.inspectionState ? this.inspectionState.toJSON() : undefined as any;
        data["wbs"] = this.wbs ? this.wbs.toJSON() : undefined as any;
        if (Array.isArray(this.attendes)) {
            data["attendes"] = [];
            for (let item of this.attendes)
                data["attendes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userWalks)) {
            data["userWalks"] = [];
            for (let item of this.userWalks)
                data["userWalks"].push(item ? item.toJSON() : undefined as any);
        }
        data["attendesCount"] = this.attendesCount;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        data["organizer"] = this.organizer ? this.organizer.toJSON() : undefined as any;
        data["walks"] = this.walks;
        data["walksStarted"] = this.walksStarted;
        data["walksCompleted"] = this.walksCompleted;
        data["walksScheduled"] = this.walksScheduled;
        data["walksPaused"] = this.walksPaused;
        data["walksCanceled"] = this.walksCanceled;
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionViewModel extends IMasterViewModel {
    name?: string | undefined;
    information?: string | undefined;
    location?: string | undefined;
    tracked?: boolean;
    date?: Date | undefined;
    lastModifiedAt?: Date | undefined;
    inspectionType?: MasterViewModel | undefined;
    inspectionState?: InspectionStatusViewModel | undefined;
    wbs?: WbsViewModel | undefined;
    attendes?: UserInspectionViewModel[] | undefined;
    items?: ElementsViewModel[] | undefined;
    userWalks?: UserWalkInfoViewModel[] | undefined;
    attendesCount?: number | undefined;
    files?: InspectionMediaViewModel[] | undefined;
    organizer?: UserInfoViewModel | undefined;
    walks?: number;
    walksStarted?: number;
    walksCompleted?: number;
    walksScheduled?: number;
    walksPaused?: number;
    walksCanceled?: number;
}

export class InspectionStatusViewModel extends MasterViewModel implements IInspectionStatusViewModel {
    color?: string | undefined;
    createdAt?: Date;
    inspectionStatusAvailable?: InspectionStatusViewModel[] | undefined;

    constructor(data?: IInspectionStatusViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.color = _data["color"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            if (Array.isArray(_data["inspectionStatusAvailable"])) {
                this.inspectionStatusAvailable = [] as any;
                for (let item of _data["inspectionStatusAvailable"])
                    this.inspectionStatusAvailable!.push(InspectionStatusViewModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): InspectionStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionStatusViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        if (Array.isArray(this.inspectionStatusAvailable)) {
            data["inspectionStatusAvailable"] = [];
            for (let item of this.inspectionStatusAvailable)
                data["inspectionStatusAvailable"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionStatusViewModel extends IMasterViewModel {
    color?: string | undefined;
    createdAt?: Date;
    inspectionStatusAvailable?: InspectionStatusViewModel[] | undefined;
}

export class WbsViewModel extends MasterViewModel implements IWbsViewModel {
    areWapId?: boolean | undefined;
    node?: string | undefined;

    constructor(data?: IWbsViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.areWapId = _data["areWapId"];
            this.node = _data["node"];
        }
    }

    static override fromJS(data: any): WbsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WbsViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areWapId"] = this.areWapId;
        data["node"] = this.node;
        super.toJSON(data);
        return data;
    }
}

export interface IWbsViewModel extends IMasterViewModel {
    areWapId?: boolean | undefined;
    node?: string | undefined;
}

export class UserInspectionViewModel implements IUserInspectionViewModel {
    invitationStatus?: InvitationStatusViewModel | undefined;
    memberStatus?: MasterViewModel | undefined;
    user?: UserViewModel | undefined;
    confirmed?: boolean;

    constructor(data?: IUserInspectionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationStatus = _data["invitationStatus"] ? InvitationStatusViewModel.fromJS(_data["invitationStatus"]) : undefined as any;
            this.memberStatus = _data["memberStatus"] ? MasterViewModel.fromJS(_data["memberStatus"]) : undefined as any;
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : undefined as any;
            this.confirmed = _data["confirmed"];
        }
    }

    static fromJS(data: any): UserInspectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInspectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationStatus"] = this.invitationStatus ? this.invitationStatus.toJSON() : undefined as any;
        data["memberStatus"] = this.memberStatus ? this.memberStatus.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["confirmed"] = this.confirmed;
        return data;
    }
}

export interface IUserInspectionViewModel {
    invitationStatus?: InvitationStatusViewModel | undefined;
    memberStatus?: MasterViewModel | undefined;
    user?: UserViewModel | undefined;
    confirmed?: boolean;
}

export class InvitationStatusViewModel extends MasterViewModel implements IInvitationStatusViewModel {
    color?: string | undefined;

    constructor(data?: IInvitationStatusViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.color = _data["color"];
        }
    }

    static override fromJS(data: any): InvitationStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvitationStatusViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        super.toJSON(data);
        return data;
    }
}

export interface IInvitationStatusViewModel extends IMasterViewModel {
    color?: string | undefined;
}

export class UserWalkInfoViewModel implements IUserWalkInfoViewModel {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
    walks?: InspectionWalkViewModel[] | undefined;

    constructor(data?: IUserWalkInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.company = _data["company"];
            if (Array.isArray(_data["walks"])) {
                this.walks = [] as any;
                for (let item of _data["walks"])
                    this.walks!.push(InspectionWalkViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserWalkInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserWalkInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["company"] = this.company;
        if (Array.isArray(this.walks)) {
            data["walks"] = [];
            for (let item of this.walks)
                data["walks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserWalkInfoViewModel {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
    walks?: InspectionWalkViewModel[] | undefined;
}

export class InspectionWalkViewModel extends MasterViewModel implements IInspectionWalkViewModel {
    track?: string | undefined;
    startDate?: Date;
    closeDate?: Date | undefined;
    punch?: PunchViewModel[] | undefined;
    inspectionStatus?: InspectionStatusViewModel | undefined;
    fromImport?: boolean;

    constructor(data?: IInspectionWalkViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.track = _data["track"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : undefined as any;
            if (Array.isArray(_data["punch"])) {
                this.punch = [] as any;
                for (let item of _data["punch"])
                    this.punch!.push(PunchViewModel.fromJS(item));
            }
            this.inspectionStatus = _data["inspectionStatus"] ? InspectionStatusViewModel.fromJS(_data["inspectionStatus"]) : undefined as any;
            this.fromImport = _data["fromImport"];
        }
    }

    static override fromJS(data: any): InspectionWalkViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionWalkViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["track"] = this.track;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : undefined as any;
        if (Array.isArray(this.punch)) {
            data["punch"] = [];
            for (let item of this.punch)
                data["punch"].push(item ? item.toJSON() : undefined as any);
        }
        data["inspectionStatus"] = this.inspectionStatus ? this.inspectionStatus.toJSON() : undefined as any;
        data["fromImport"] = this.fromImport;
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionWalkViewModel extends IMasterViewModel {
    track?: string | undefined;
    startDate?: Date;
    closeDate?: Date | undefined;
    punch?: PunchViewModel[] | undefined;
    inspectionStatus?: InspectionStatusViewModel | undefined;
    fromImport?: boolean;
}

export class MediaViewModel implements IMediaViewModel {
    id?: number | undefined;
    mimeType?: string | undefined;
    mediaTypeId?: number | undefined;
    file?: string | undefined;
    default?: boolean;

    constructor(data?: IMediaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mimeType = _data["mimeType"];
            this.mediaTypeId = _data["mediaTypeId"];
            this.file = _data["file"];
            this.default = _data["default"];
        }
    }

    static fromJS(data: any): MediaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MediaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mimeType"] = this.mimeType;
        data["mediaTypeId"] = this.mediaTypeId;
        data["file"] = this.file;
        data["default"] = this.default;
        return data;
    }
}

export interface IMediaViewModel {
    id?: number | undefined;
    mimeType?: string | undefined;
    mediaTypeId?: number | undefined;
    file?: string | undefined;
    default?: boolean;
}

export class InspectionMediaViewModel extends MediaViewModel implements IInspectionMediaViewModel {
    name?: string | undefined;
    description?: string | undefined;
    lastModifiedAt?: Date | undefined;
    documentType?: MasterViewModel | undefined;
    defaultDownload?: boolean;
    size?: number;

    constructor(data?: IInspectionMediaViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.documentType = _data["documentType"] ? MasterViewModel.fromJS(_data["documentType"]) : undefined as any;
            this.defaultDownload = _data["defaultDownload"];
            this.size = _data["size"];
        }
    }

    static override fromJS(data: any): InspectionMediaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionMediaViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : undefined as any;
        data["defaultDownload"] = this.defaultDownload;
        data["size"] = this.size;
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionMediaViewModel extends IMediaViewModel {
    name?: string | undefined;
    description?: string | undefined;
    lastModifiedAt?: Date | undefined;
    documentType?: MasterViewModel | undefined;
    defaultDownload?: boolean;
    size?: number;
}

export class LocationProjectViewModel implements ILocationProjectViewModel {
    id?: number | undefined;
    name?: string | undefined;
    locationTypeId?: number;
    locationTypeName?: string | undefined;
    projectId?: number;

    constructor(data?: ILocationProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locationTypeId = _data["locationTypeId"];
            this.locationTypeName = _data["locationTypeName"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): LocationProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationTypeId"] = this.locationTypeId;
        data["locationTypeName"] = this.locationTypeName;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ILocationProjectViewModel {
    id?: number | undefined;
    name?: string | undefined;
    locationTypeId?: number;
    locationTypeName?: string | undefined;
    projectId?: number;
}

export class PunchDetailViewModel extends PunchViewModel implements IPunchDetailViewModel {
    signature?: PunchStageViewModel[] | undefined;
    logs?: PunchLogViewModel[] | undefined;
    remark?: PunchRemarkViewModel[] | undefined;
    inspection?: InspectionViewModel | undefined;
    inspectionWalk?: InspectionWalkInfoViewModel | undefined;
    customsFields?: PunchCustomFieldViewModel[] | undefined;
    fields?: PunchCustomFieldViewModel[] | undefined;

    constructor(data?: IPunchDetailViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["signature"])) {
                this.signature = [] as any;
                for (let item of _data["signature"])
                    this.signature!.push(PunchStageViewModel.fromJS(item));
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(PunchLogViewModel.fromJS(item));
            }
            if (Array.isArray(_data["remark"])) {
                this.remark = [] as any;
                for (let item of _data["remark"])
                    this.remark!.push(PunchRemarkViewModel.fromJS(item));
            }
            this.inspection = _data["inspection"] ? InspectionViewModel.fromJS(_data["inspection"]) : undefined as any;
            this.inspectionWalk = _data["inspectionWalk"] ? InspectionWalkInfoViewModel.fromJS(_data["inspectionWalk"]) : undefined as any;
            if (Array.isArray(_data["customsFields"])) {
                this.customsFields = [] as any;
                for (let item of _data["customsFields"])
                    this.customsFields!.push(PunchCustomFieldViewModel.fromJS(item));
            }
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(PunchCustomFieldViewModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PunchDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchDetailViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.signature)) {
            data["signature"] = [];
            for (let item of this.signature)
                data["signature"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.remark)) {
            data["remark"] = [];
            for (let item of this.remark)
                data["remark"].push(item ? item.toJSON() : undefined as any);
        }
        data["inspection"] = this.inspection ? this.inspection.toJSON() : undefined as any;
        data["inspectionWalk"] = this.inspectionWalk ? this.inspectionWalk.toJSON() : undefined as any;
        if (Array.isArray(this.customsFields)) {
            data["customsFields"] = [];
            for (let item of this.customsFields)
                data["customsFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPunchDetailViewModel extends IPunchViewModel {
    signature?: PunchStageViewModel[] | undefined;
    logs?: PunchLogViewModel[] | undefined;
    remark?: PunchRemarkViewModel[] | undefined;
    inspection?: InspectionViewModel | undefined;
    inspectionWalk?: InspectionWalkInfoViewModel | undefined;
    customsFields?: PunchCustomFieldViewModel[] | undefined;
    fields?: PunchCustomFieldViewModel[] | undefined;
}

export class PunchStageViewModel implements IPunchStageViewModel {
    id?: number | undefined;
    done?: boolean | undefined;
    reject?: boolean | undefined;
    rejectCount?: number;
    overridden?: boolean | undefined;
    createdAt?: Date;
    user?: UserViewModel | undefined;
    assignedTo?: UserViewModel | undefined;
    lastModifiedAt?: Date;
    doneByUser?: UserViewModel | undefined;
    doneAt?: Date | undefined;
    isSignable?: boolean;
    isRejectable?: boolean;
    isDisputable?: boolean;
    isOverridable?: boolean;
    statusStage?: PunchStageStatusViewModel | undefined;
    remark?: RemarkViewModel | undefined;
    sign?: PunchSignatureRejectViewModel | undefined;
    comment?: string | undefined;
    signConfigId?: number | undefined;

    constructor(data?: IPunchStageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.done = _data["done"];
            this.reject = _data["reject"];
            this.rejectCount = _data["rejectCount"];
            this.overridden = _data["overridden"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : undefined as any;
            this.assignedTo = _data["assignedTo"] ? UserViewModel.fromJS(_data["assignedTo"]) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.doneByUser = _data["doneByUser"] ? UserViewModel.fromJS(_data["doneByUser"]) : undefined as any;
            this.doneAt = _data["doneAt"] ? new Date(_data["doneAt"].toString()) : undefined as any;
            this.isSignable = _data["isSignable"];
            this.isRejectable = _data["isRejectable"];
            this.isDisputable = _data["isDisputable"];
            this.isOverridable = _data["isOverridable"];
            this.statusStage = _data["statusStage"] ? PunchStageStatusViewModel.fromJS(_data["statusStage"]) : undefined as any;
            this.remark = _data["remark"] ? RemarkViewModel.fromJS(_data["remark"]) : undefined as any;
            this.sign = _data["sign"] ? PunchSignatureRejectViewModel.fromJS(_data["sign"]) : undefined as any;
            this.comment = _data["comment"];
            this.signConfigId = _data["signConfigId"];
        }
    }

    static fromJS(data: any): PunchStageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchStageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["done"] = this.done;
        data["reject"] = this.reject;
        data["rejectCount"] = this.rejectCount;
        data["overridden"] = this.overridden;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["assignedTo"] = this.assignedTo ? this.assignedTo.toJSON() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["doneByUser"] = this.doneByUser ? this.doneByUser.toJSON() : undefined as any;
        data["doneAt"] = this.doneAt ? this.doneAt.toISOString() : undefined as any;
        data["isSignable"] = this.isSignable;
        data["isRejectable"] = this.isRejectable;
        data["isDisputable"] = this.isDisputable;
        data["isOverridable"] = this.isOverridable;
        data["statusStage"] = this.statusStage ? this.statusStage.toJSON() : undefined as any;
        data["remark"] = this.remark ? this.remark.toJSON() : undefined as any;
        data["sign"] = this.sign ? this.sign.toJSON() : undefined as any;
        data["comment"] = this.comment;
        data["signConfigId"] = this.signConfigId;
        return data;
    }
}

export interface IPunchStageViewModel {
    id?: number | undefined;
    done?: boolean | undefined;
    reject?: boolean | undefined;
    rejectCount?: number;
    overridden?: boolean | undefined;
    createdAt?: Date;
    user?: UserViewModel | undefined;
    assignedTo?: UserViewModel | undefined;
    lastModifiedAt?: Date;
    doneByUser?: UserViewModel | undefined;
    doneAt?: Date | undefined;
    isSignable?: boolean;
    isRejectable?: boolean;
    isDisputable?: boolean;
    isOverridable?: boolean;
    statusStage?: PunchStageStatusViewModel | undefined;
    remark?: RemarkViewModel | undefined;
    sign?: PunchSignatureRejectViewModel | undefined;
    comment?: string | undefined;
    signConfigId?: number | undefined;
}

export class PunchStageStatusViewModel implements IPunchStageStatusViewModel {
    code?: string | undefined;
    color?: string | undefined;

    constructor(data?: IPunchStageStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): PunchStageStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchStageStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["color"] = this.color;
        return data;
    }
}

export interface IPunchStageStatusViewModel {
    code?: string | undefined;
    color?: string | undefined;
}

export class RemarkViewModel implements IRemarkViewModel {
    id?: number | undefined;
    remarkTypeId?: number | undefined;
    userName?: string | undefined;
    remark?: string | undefined;
    lastModifiedAt?: Date | undefined;

    constructor(data?: IRemarkViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.remarkTypeId = _data["remarkTypeId"];
            this.userName = _data["userName"];
            this.remark = _data["remark"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RemarkViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemarkViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["remarkTypeId"] = this.remarkTypeId;
        data["userName"] = this.userName;
        data["remark"] = this.remark;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IRemarkViewModel {
    id?: number | undefined;
    remarkTypeId?: number | undefined;
    userName?: string | undefined;
    remark?: string | undefined;
    lastModifiedAt?: Date | undefined;
}

export class PunchSignatureRejectViewModel implements IPunchSignatureRejectViewModel {
    punchId?: number;
    sign?: string | undefined;
    date?: Date;
    remark?: PunchRemarkViewModel | undefined;

    constructor(data?: IPunchSignatureRejectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchId = _data["punchId"];
            this.sign = _data["sign"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.remark = _data["remark"] ? PunchRemarkViewModel.fromJS(_data["remark"]) : undefined as any;
        }
    }

    static fromJS(data: any): PunchSignatureRejectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchSignatureRejectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchId"] = this.punchId;
        data["sign"] = this.sign;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["remark"] = this.remark ? this.remark.toJSON() : undefined as any;
        return data;
    }
}

export interface IPunchSignatureRejectViewModel {
    punchId?: number;
    sign?: string | undefined;
    date?: Date;
    remark?: PunchRemarkViewModel | undefined;
}

export class PunchRemarkViewModel implements IPunchRemarkViewModel {
    remarkId?: number | undefined;
    punchId?: number | undefined;
    remark?: string | undefined;
    remarkType?: MasterViewModel | undefined;
    punchMedia?: PunchMediaViewModel[] | undefined;
    user?: UserInfoViewModel | undefined;
    createdAt?: Date;
    isEdited?: boolean;

    constructor(data?: IPunchRemarkViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remarkId = _data["remarkId"];
            this.punchId = _data["punchId"];
            this.remark = _data["remark"];
            this.remarkType = _data["remarkType"] ? MasterViewModel.fromJS(_data["remarkType"]) : undefined as any;
            if (Array.isArray(_data["punchMedia"])) {
                this.punchMedia = [] as any;
                for (let item of _data["punchMedia"])
                    this.punchMedia!.push(PunchMediaViewModel.fromJS(item));
            }
            this.user = _data["user"] ? UserInfoViewModel.fromJS(_data["user"]) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.isEdited = _data["isEdited"];
        }
    }

    static fromJS(data: any): PunchRemarkViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchRemarkViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remarkId"] = this.remarkId;
        data["punchId"] = this.punchId;
        data["remark"] = this.remark;
        data["remarkType"] = this.remarkType ? this.remarkType.toJSON() : undefined as any;
        if (Array.isArray(this.punchMedia)) {
            data["punchMedia"] = [];
            for (let item of this.punchMedia)
                data["punchMedia"].push(item ? item.toJSON() : undefined as any);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["isEdited"] = this.isEdited;
        return data;
    }
}

export interface IPunchRemarkViewModel {
    remarkId?: number | undefined;
    punchId?: number | undefined;
    remark?: string | undefined;
    remarkType?: MasterViewModel | undefined;
    punchMedia?: PunchMediaViewModel[] | undefined;
    user?: UserInfoViewModel | undefined;
    createdAt?: Date;
    isEdited?: boolean;
}

export class PunchLogViewModel implements IPunchLogViewModel {
    id?: number;
    entryType?: EntryTypeViewModel | undefined;
    category?: MasterViewModel | undefined;
    deparmentAction?: MasterViewModel | undefined;
    priority?: MasterViewModel | undefined;
    status?: MasterViewModel | undefined;
    entryDate?: Date | undefined;
    originator?: UserInfoViewModel | undefined;
    user?: UserInfoViewModel | undefined;
    actionUser?: UserInfoViewModel | undefined;
    remark?: PunchRemarkViewModel | undefined;
    subContractor?: UserInfoViewModel | undefined;
    userGuest?: string | undefined;
    commentary?: string | undefined;
    changes?: PunchLogChangeViewModel[] | undefined;

    constructor(data?: IPunchLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entryType = _data["entryType"] ? EntryTypeViewModel.fromJS(_data["entryType"]) : undefined as any;
            this.category = _data["category"] ? MasterViewModel.fromJS(_data["category"]) : undefined as any;
            this.deparmentAction = _data["deparmentAction"] ? MasterViewModel.fromJS(_data["deparmentAction"]) : undefined as any;
            this.priority = _data["priority"] ? MasterViewModel.fromJS(_data["priority"]) : undefined as any;
            this.status = _data["status"] ? MasterViewModel.fromJS(_data["status"]) : undefined as any;
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : undefined as any;
            this.originator = _data["originator"] ? UserInfoViewModel.fromJS(_data["originator"]) : undefined as any;
            this.user = _data["user"] ? UserInfoViewModel.fromJS(_data["user"]) : undefined as any;
            this.actionUser = _data["actionUser"] ? UserInfoViewModel.fromJS(_data["actionUser"]) : undefined as any;
            this.remark = _data["remark"] ? PunchRemarkViewModel.fromJS(_data["remark"]) : undefined as any;
            this.subContractor = _data["subContractor"] ? UserInfoViewModel.fromJS(_data["subContractor"]) : undefined as any;
            this.userGuest = _data["userGuest"];
            this.commentary = _data["commentary"];
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(PunchLogChangeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entryType"] = this.entryType ? this.entryType.toJSON() : undefined as any;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["deparmentAction"] = this.deparmentAction ? this.deparmentAction.toJSON() : undefined as any;
        data["priority"] = this.priority ? this.priority.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["originator"] = this.originator ? this.originator.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["actionUser"] = this.actionUser ? this.actionUser.toJSON() : undefined as any;
        data["remark"] = this.remark ? this.remark.toJSON() : undefined as any;
        data["subContractor"] = this.subContractor ? this.subContractor.toJSON() : undefined as any;
        data["userGuest"] = this.userGuest;
        data["commentary"] = this.commentary;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchLogViewModel {
    id?: number;
    entryType?: EntryTypeViewModel | undefined;
    category?: MasterViewModel | undefined;
    deparmentAction?: MasterViewModel | undefined;
    priority?: MasterViewModel | undefined;
    status?: MasterViewModel | undefined;
    entryDate?: Date | undefined;
    originator?: UserInfoViewModel | undefined;
    user?: UserInfoViewModel | undefined;
    actionUser?: UserInfoViewModel | undefined;
    remark?: PunchRemarkViewModel | undefined;
    subContractor?: UserInfoViewModel | undefined;
    userGuest?: string | undefined;
    commentary?: string | undefined;
    changes?: PunchLogChangeViewModel[] | undefined;
}

export class EntryTypeViewModel extends MasterViewModel implements IEntryTypeViewModel {
    color?: string | undefined;

    constructor(data?: IEntryTypeViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.color = _data["color"];
        }
    }

    static override fromJS(data: any): EntryTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EntryTypeViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        super.toJSON(data);
        return data;
    }
}

export interface IEntryTypeViewModel extends IMasterViewModel {
    color?: string | undefined;
}

export class PunchLogChangeViewModel implements IPunchLogChangeViewModel {
    property?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IPunchLogChangeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): PunchLogChangeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchLogChangeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IPunchLogChangeViewModel {
    property?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class InspectionWalkInfoViewModel extends MasterViewModel implements IInspectionWalkInfoViewModel {
    track?: string | undefined;
    closeDate?: Date;

    constructor(data?: IInspectionWalkInfoViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.track = _data["track"];
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): InspectionWalkInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionWalkInfoViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["track"] = this.track;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionWalkInfoViewModel extends IMasterViewModel {
    track?: string | undefined;
    closeDate?: Date;
}

export class PunchDetailByTabsViewModel implements IPunchDetailByTabsViewModel {
    mainAndSignatures?: PunchDetailMainViewModel | undefined;
    attachments?: PunchMediaViewModel[] | undefined;
    remarks?: PunchRemarkViewModel[] | undefined;
    timeline?: PunchLogViewModel[] | undefined;

    constructor(data?: IPunchDetailByTabsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainAndSignatures = _data["mainAndSignatures"] ? PunchDetailMainViewModel.fromJS(_data["mainAndSignatures"]) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(PunchMediaViewModel.fromJS(item));
            }
            if (Array.isArray(_data["remarks"])) {
                this.remarks = [] as any;
                for (let item of _data["remarks"])
                    this.remarks!.push(PunchRemarkViewModel.fromJS(item));
            }
            if (Array.isArray(_data["timeline"])) {
                this.timeline = [] as any;
                for (let item of _data["timeline"])
                    this.timeline!.push(PunchLogViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchDetailByTabsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchDetailByTabsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainAndSignatures"] = this.mainAndSignatures ? this.mainAndSignatures.toJSON() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.remarks)) {
            data["remarks"] = [];
            for (let item of this.remarks)
                data["remarks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.timeline)) {
            data["timeline"] = [];
            for (let item of this.timeline)
                data["timeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchDetailByTabsViewModel {
    mainAndSignatures?: PunchDetailMainViewModel | undefined;
    attachments?: PunchMediaViewModel[] | undefined;
    remarks?: PunchRemarkViewModel[] | undefined;
    timeline?: PunchLogViewModel[] | undefined;
}

export class PunchDetailMainViewModel implements IPunchDetailMainViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    pdfPositionX?: number | undefined;
    pdfPositionY?: number | undefined;
    location?: string | undefined;
    status?: StatusViewModel | undefined;
    discipline?: MasterViewModel | undefined;
    punchTags?: TagsViewModel[] | undefined;
    category?: CategoryViewModel | undefined;
    priority?: MasterViewModel | undefined;
    departmentAction?: MasterViewModel | undefined;
    topic?: MasterViewModel | undefined;
    originator?: MasterViewModel | undefined;
    subContractor?: SubcontractorViewModel | undefined;
    userOriginator?: UserInfoViewModel | undefined;
    userValid?: boolean;
    commentary?: string | undefined;
    contractorResponsibleName?: string | undefined;
    createdAt?: Date;
    punchFields?: PunchCustomFieldViewModel[] | undefined;
    punchCustomFields?: PunchCustomFieldViewModel[] | undefined;
    punchItems?: ElementsViewModel[] | undefined;
    punchStage?: PunchStageViewModel[] | undefined;
    inspection?: InspectionViewModel | undefined;
    entryType?: MasterViewModel | undefined;
    coverAndAudioMedia?: PunchMediaViewModel[] | undefined;
    isRejectable?: boolean;
    isSignable?: boolean;
    onDispute?: boolean | undefined;
    closed?: boolean | undefined;
    locationProject?: LocationProjectViewModel | undefined;
    expectedClosingDate?: Date | undefined;

    constructor(data?: IPunchDetailMainViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.pdfPositionX = _data["pdfPositionX"];
            this.pdfPositionY = _data["pdfPositionY"];
            this.location = _data["location"];
            this.status = _data["status"] ? StatusViewModel.fromJS(_data["status"]) : undefined as any;
            this.discipline = _data["discipline"] ? MasterViewModel.fromJS(_data["discipline"]) : undefined as any;
            if (Array.isArray(_data["punchTags"])) {
                this.punchTags = [] as any;
                for (let item of _data["punchTags"])
                    this.punchTags!.push(TagsViewModel.fromJS(item));
            }
            this.category = _data["category"] ? CategoryViewModel.fromJS(_data["category"]) : undefined as any;
            this.priority = _data["priority"] ? MasterViewModel.fromJS(_data["priority"]) : undefined as any;
            this.departmentAction = _data["departmentAction"] ? MasterViewModel.fromJS(_data["departmentAction"]) : undefined as any;
            this.topic = _data["topic"] ? MasterViewModel.fromJS(_data["topic"]) : undefined as any;
            this.originator = _data["originator"] ? MasterViewModel.fromJS(_data["originator"]) : undefined as any;
            this.subContractor = _data["subContractor"] ? SubcontractorViewModel.fromJS(_data["subContractor"]) : undefined as any;
            this.userOriginator = _data["userOriginator"] ? UserInfoViewModel.fromJS(_data["userOriginator"]) : undefined as any;
            this.userValid = _data["userValid"];
            this.commentary = _data["commentary"];
            this.contractorResponsibleName = _data["contractorResponsibleName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            if (Array.isArray(_data["punchFields"])) {
                this.punchFields = [] as any;
                for (let item of _data["punchFields"])
                    this.punchFields!.push(PunchCustomFieldViewModel.fromJS(item));
            }
            if (Array.isArray(_data["punchCustomFields"])) {
                this.punchCustomFields = [] as any;
                for (let item of _data["punchCustomFields"])
                    this.punchCustomFields!.push(PunchCustomFieldViewModel.fromJS(item));
            }
            if (Array.isArray(_data["punchItems"])) {
                this.punchItems = [] as any;
                for (let item of _data["punchItems"])
                    this.punchItems!.push(ElementsViewModel.fromJS(item));
            }
            if (Array.isArray(_data["punchStage"])) {
                this.punchStage = [] as any;
                for (let item of _data["punchStage"])
                    this.punchStage!.push(PunchStageViewModel.fromJS(item));
            }
            this.inspection = _data["inspection"] ? InspectionViewModel.fromJS(_data["inspection"]) : undefined as any;
            this.entryType = _data["entryType"] ? MasterViewModel.fromJS(_data["entryType"]) : undefined as any;
            if (Array.isArray(_data["coverAndAudioMedia"])) {
                this.coverAndAudioMedia = [] as any;
                for (let item of _data["coverAndAudioMedia"])
                    this.coverAndAudioMedia!.push(PunchMediaViewModel.fromJS(item));
            }
            this.isRejectable = _data["isRejectable"];
            this.isSignable = _data["isSignable"];
            this.onDispute = _data["onDispute"];
            this.closed = _data["closed"];
            this.locationProject = _data["locationProject"] ? LocationProjectViewModel.fromJS(_data["locationProject"]) : undefined as any;
            this.expectedClosingDate = _data["expectedClosingDate"] ? new Date(_data["expectedClosingDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PunchDetailMainViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchDetailMainViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["pdfPositionX"] = this.pdfPositionX;
        data["pdfPositionY"] = this.pdfPositionY;
        data["location"] = this.location;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        if (Array.isArray(this.punchTags)) {
            data["punchTags"] = [];
            for (let item of this.punchTags)
                data["punchTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["priority"] = this.priority ? this.priority.toJSON() : undefined as any;
        data["departmentAction"] = this.departmentAction ? this.departmentAction.toJSON() : undefined as any;
        data["topic"] = this.topic ? this.topic.toJSON() : undefined as any;
        data["originator"] = this.originator ? this.originator.toJSON() : undefined as any;
        data["subContractor"] = this.subContractor ? this.subContractor.toJSON() : undefined as any;
        data["userOriginator"] = this.userOriginator ? this.userOriginator.toJSON() : undefined as any;
        data["userValid"] = this.userValid;
        data["commentary"] = this.commentary;
        data["contractorResponsibleName"] = this.contractorResponsibleName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        if (Array.isArray(this.punchFields)) {
            data["punchFields"] = [];
            for (let item of this.punchFields)
                data["punchFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchCustomFields)) {
            data["punchCustomFields"] = [];
            for (let item of this.punchCustomFields)
                data["punchCustomFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchItems)) {
            data["punchItems"] = [];
            for (let item of this.punchItems)
                data["punchItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchStage)) {
            data["punchStage"] = [];
            for (let item of this.punchStage)
                data["punchStage"].push(item ? item.toJSON() : undefined as any);
        }
        data["inspection"] = this.inspection ? this.inspection.toJSON() : undefined as any;
        data["entryType"] = this.entryType ? this.entryType.toJSON() : undefined as any;
        if (Array.isArray(this.coverAndAudioMedia)) {
            data["coverAndAudioMedia"] = [];
            for (let item of this.coverAndAudioMedia)
                data["coverAndAudioMedia"].push(item ? item.toJSON() : undefined as any);
        }
        data["isRejectable"] = this.isRejectable;
        data["isSignable"] = this.isSignable;
        data["onDispute"] = this.onDispute;
        data["closed"] = this.closed;
        data["locationProject"] = this.locationProject ? this.locationProject.toJSON() : undefined as any;
        data["expectedClosingDate"] = this.expectedClosingDate ? this.expectedClosingDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPunchDetailMainViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    pdfPositionX?: number | undefined;
    pdfPositionY?: number | undefined;
    location?: string | undefined;
    status?: StatusViewModel | undefined;
    discipline?: MasterViewModel | undefined;
    punchTags?: TagsViewModel[] | undefined;
    category?: CategoryViewModel | undefined;
    priority?: MasterViewModel | undefined;
    departmentAction?: MasterViewModel | undefined;
    topic?: MasterViewModel | undefined;
    originator?: MasterViewModel | undefined;
    subContractor?: SubcontractorViewModel | undefined;
    userOriginator?: UserInfoViewModel | undefined;
    userValid?: boolean;
    commentary?: string | undefined;
    contractorResponsibleName?: string | undefined;
    createdAt?: Date;
    punchFields?: PunchCustomFieldViewModel[] | undefined;
    punchCustomFields?: PunchCustomFieldViewModel[] | undefined;
    punchItems?: ElementsViewModel[] | undefined;
    punchStage?: PunchStageViewModel[] | undefined;
    inspection?: InspectionViewModel | undefined;
    entryType?: MasterViewModel | undefined;
    coverAndAudioMedia?: PunchMediaViewModel[] | undefined;
    isRejectable?: boolean;
    isSignable?: boolean;
    onDispute?: boolean | undefined;
    closed?: boolean | undefined;
    locationProject?: LocationProjectViewModel | undefined;
    expectedClosingDate?: Date | undefined;
}

export class SubcontractorViewModel implements ISubcontractorViewModel {
    id?: number | undefined;
    code?: string | undefined;
    shortDescription?: string | undefined;
    name?: string | undefined;

    constructor(data?: ISubcontractorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.shortDescription = _data["shortDescription"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SubcontractorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["shortDescription"] = this.shortDescription;
        data["name"] = this.name;
        return data;
    }
}

export interface ISubcontractorViewModel {
    id?: number | undefined;
    code?: string | undefined;
    shortDescription?: string | undefined;
    name?: string | undefined;
}

export enum PunchDetailsTab {
    MainAndSignatures = 1,
    Attachments = 2,
    Remarks = 3,
    Timeline = 4,
}

export class PunchDetailInViewModel implements IPunchDetailInViewModel {
    id?: number | undefined;
    disciplineId?: number | undefined;
    categoryId?: number | undefined;
    topicId?: number | undefined;
    priorityId?: number | undefined;
    location?: string | undefined;
    description?: string | undefined;
    user?: UserViewModel | undefined;
    originatorId?: number;
    userOriginatorId?: string | undefined;
    subContractorId?: number | undefined;
    departmentActionId?: number | undefined;
    commentary?: string | undefined;
    contractorResponsibleName?: string | undefined;
    notes?: string | undefined;
    locationProjectId?: number | undefined;
    itemsAffected?: ElementsViewModel[] | undefined;
    customsFields?: PunchCustomFieldViewModel[] | undefined;
    tags?: TagsViewModel[] | undefined;
    expectedClosingDate?: Date | undefined;

    constructor(data?: IPunchDetailInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disciplineId = _data["disciplineId"];
            this.categoryId = _data["categoryId"];
            this.topicId = _data["topicId"];
            this.priorityId = _data["priorityId"];
            this.location = _data["location"];
            this.description = _data["description"];
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : undefined as any;
            this.originatorId = _data["originatorId"];
            this.userOriginatorId = _data["userOriginatorId"];
            this.subContractorId = _data["subContractorId"];
            this.departmentActionId = _data["departmentActionId"];
            this.commentary = _data["commentary"];
            this.contractorResponsibleName = _data["contractorResponsibleName"];
            this.notes = _data["notes"];
            this.locationProjectId = _data["locationProjectId"];
            if (Array.isArray(_data["itemsAffected"])) {
                this.itemsAffected = [] as any;
                for (let item of _data["itemsAffected"])
                    this.itemsAffected!.push(ElementsViewModel.fromJS(item));
            }
            if (Array.isArray(_data["customsFields"])) {
                this.customsFields = [] as any;
                for (let item of _data["customsFields"])
                    this.customsFields!.push(PunchCustomFieldViewModel.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagsViewModel.fromJS(item));
            }
            this.expectedClosingDate = _data["expectedClosingDate"] ? new Date(_data["expectedClosingDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PunchDetailInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchDetailInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disciplineId"] = this.disciplineId;
        data["categoryId"] = this.categoryId;
        data["topicId"] = this.topicId;
        data["priorityId"] = this.priorityId;
        data["location"] = this.location;
        data["description"] = this.description;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["originatorId"] = this.originatorId;
        data["userOriginatorId"] = this.userOriginatorId;
        data["subContractorId"] = this.subContractorId;
        data["departmentActionId"] = this.departmentActionId;
        data["commentary"] = this.commentary;
        data["contractorResponsibleName"] = this.contractorResponsibleName;
        data["notes"] = this.notes;
        data["locationProjectId"] = this.locationProjectId;
        if (Array.isArray(this.itemsAffected)) {
            data["itemsAffected"] = [];
            for (let item of this.itemsAffected)
                data["itemsAffected"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customsFields)) {
            data["customsFields"] = [];
            for (let item of this.customsFields)
                data["customsFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["expectedClosingDate"] = this.expectedClosingDate ? this.expectedClosingDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPunchDetailInViewModel {
    id?: number | undefined;
    disciplineId?: number | undefined;
    categoryId?: number | undefined;
    topicId?: number | undefined;
    priorityId?: number | undefined;
    location?: string | undefined;
    description?: string | undefined;
    user?: UserViewModel | undefined;
    originatorId?: number;
    userOriginatorId?: string | undefined;
    subContractorId?: number | undefined;
    departmentActionId?: number | undefined;
    commentary?: string | undefined;
    contractorResponsibleName?: string | undefined;
    notes?: string | undefined;
    locationProjectId?: number | undefined;
    itemsAffected?: ElementsViewModel[] | undefined;
    customsFields?: PunchCustomFieldViewModel[] | undefined;
    tags?: TagsViewModel[] | undefined;
    expectedClosingDate?: Date | undefined;
}

export class PunchUpdatePreviewViewModel implements IPunchUpdatePreviewViewModel {
    template?: string | undefined;
    templateNamePreview?: string | undefined;
    changes?: PunchChangesPreviewViewModel[] | undefined;
    errors?: string | undefined;
    isCorrect?: boolean;
    punchesCount?: number;
    punchChangesExcel?: string | undefined;

    constructor(data?: IPunchUpdatePreviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"];
            this.templateNamePreview = _data["templateNamePreview"];
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(PunchChangesPreviewViewModel.fromJS(item));
            }
            this.errors = _data["errors"];
            this.isCorrect = _data["isCorrect"];
            this.punchesCount = _data["punchesCount"];
            this.punchChangesExcel = _data["punchChangesExcel"];
        }
    }

    static fromJS(data: any): PunchUpdatePreviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchUpdatePreviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template;
        data["templateNamePreview"] = this.templateNamePreview;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item ? item.toJSON() : undefined as any);
        }
        data["errors"] = this.errors;
        data["isCorrect"] = this.isCorrect;
        data["punchesCount"] = this.punchesCount;
        data["punchChangesExcel"] = this.punchChangesExcel;
        return data;
    }
}

export interface IPunchUpdatePreviewViewModel {
    template?: string | undefined;
    templateNamePreview?: string | undefined;
    changes?: PunchChangesPreviewViewModel[] | undefined;
    errors?: string | undefined;
    isCorrect?: boolean;
    punchesCount?: number;
    punchChangesExcel?: string | undefined;
}

export class PunchChangesPreviewViewModel implements IPunchChangesPreviewViewModel {
    punchId?: number;
    punchCode?: string | undefined;
    propertiesChanges?: PropertyChangeViewModel[] | undefined;

    constructor(data?: IPunchChangesPreviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchId = _data["punchId"];
            this.punchCode = _data["punchCode"];
            if (Array.isArray(_data["propertiesChanges"])) {
                this.propertiesChanges = [] as any;
                for (let item of _data["propertiesChanges"])
                    this.propertiesChanges!.push(PropertyChangeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchChangesPreviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchChangesPreviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchId"] = this.punchId;
        data["punchCode"] = this.punchCode;
        if (Array.isArray(this.propertiesChanges)) {
            data["propertiesChanges"] = [];
            for (let item of this.propertiesChanges)
                data["propertiesChanges"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchChangesPreviewViewModel {
    punchId?: number;
    punchCode?: string | undefined;
    propertiesChanges?: PropertyChangeViewModel[] | undefined;
}

export class PropertyChangeViewModel implements IPropertyChangeViewModel {
    property?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IPropertyChangeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): PropertyChangeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyChangeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IPropertyChangeViewModel {
    property?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class ResultDetailsTemplateViewModel implements IResultDetailsTemplateViewModel {
    template?: string | undefined;
    templateNamePreview?: string | undefined;
    changes?: ChangesPreviewDto[] | undefined;
    errors?: string | undefined;
    isCorrect?: boolean;
    count?: number;
    changesExcel?: string | undefined;

    constructor(data?: IResultDetailsTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"];
            this.templateNamePreview = _data["templateNamePreview"];
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(ChangesPreviewDto.fromJS(item));
            }
            this.errors = _data["errors"];
            this.isCorrect = _data["isCorrect"];
            this.count = _data["count"];
            this.changesExcel = _data["changesExcel"];
        }
    }

    static fromJS(data: any): ResultDetailsTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResultDetailsTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template;
        data["templateNamePreview"] = this.templateNamePreview;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item ? item.toJSON() : undefined as any);
        }
        data["errors"] = this.errors;
        data["isCorrect"] = this.isCorrect;
        data["count"] = this.count;
        data["changesExcel"] = this.changesExcel;
        return data;
    }
}

export interface IResultDetailsTemplateViewModel {
    template?: string | undefined;
    templateNamePreview?: string | undefined;
    changes?: ChangesPreviewDto[] | undefined;
    errors?: string | undefined;
    isCorrect?: boolean;
    count?: number;
    changesExcel?: string | undefined;
}

export class ChangesPreviewDto implements IChangesPreviewDto {
    identifier?: string | undefined;
    propertiesChanges?: PropertyChangeDto[] | undefined;

    constructor(data?: IChangesPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["propertiesChanges"])) {
                this.propertiesChanges = [] as any;
                for (let item of _data["propertiesChanges"])
                    this.propertiesChanges!.push(PropertyChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChangesPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangesPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        if (Array.isArray(this.propertiesChanges)) {
            data["propertiesChanges"] = [];
            for (let item of this.propertiesChanges)
                data["propertiesChanges"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IChangesPreviewDto {
    identifier?: string | undefined;
    propertiesChanges?: PropertyChangeDto[] | undefined;
}

export class PropertyChangeDto implements IPropertyChangeDto {
    property?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): PropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IPropertyChangeDto {
    property?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class PunchSignatureInDto implements IPunchSignatureInDto {
    punchId?: number | undefined;
    sign?: string | undefined;
    date?: Date | undefined;
    remark?: PunchRemarkDto | undefined;
    templateId?: number;
    projectId?: number;
    signConfigId?: number | undefined;
    requiredRole?: string | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IPunchSignatureInDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchId = _data["punchId"];
            this.sign = _data["sign"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.remark = _data["remark"] ? PunchRemarkDto.fromJS(_data["remark"]) : undefined as any;
            this.templateId = _data["templateId"];
            this.projectId = _data["projectId"];
            this.signConfigId = _data["signConfigId"];
            this.requiredRole = _data["requiredRole"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchSignatureInDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchSignatureInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchId"] = this.punchId;
        data["sign"] = this.sign;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["remark"] = this.remark ? this.remark.toJSON() : undefined as any;
        data["templateId"] = this.templateId;
        data["projectId"] = this.projectId;
        data["signConfigId"] = this.signConfigId;
        data["requiredRole"] = this.requiredRole;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchSignatureInDto {
    punchId?: number | undefined;
    sign?: string | undefined;
    date?: Date | undefined;
    remark?: PunchRemarkDto | undefined;
    templateId?: number;
    projectId?: number;
    signConfigId?: number | undefined;
    requiredRole?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export class PunchRemarkDto implements IPunchRemarkDto {
    id?: number | undefined;
    punchId?: number | undefined;
    punch?: PunchDto | undefined;
    remark?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    user?: UserDetailDto | undefined;
    remarkTypeId?: number | undefined;
    remarkType?: RemarkTypesDto | undefined;
    punchMedia?: PunchMediaDto[] | undefined;
    isEdited?: boolean;
    metadata?: string | undefined;

    constructor(data?: IPunchRemarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.punchId = _data["punchId"];
            this.punch = _data["punch"] ? PunchDto.fromJS(_data["punch"]) : undefined as any;
            this.remark = _data["remark"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.user = _data["user"] ? UserDetailDto.fromJS(_data["user"]) : undefined as any;
            this.remarkTypeId = _data["remarkTypeId"];
            this.remarkType = _data["remarkType"] ? RemarkTypesDto.fromJS(_data["remarkType"]) : undefined as any;
            if (Array.isArray(_data["punchMedia"])) {
                this.punchMedia = [] as any;
                for (let item of _data["punchMedia"])
                    this.punchMedia!.push(PunchMediaDto.fromJS(item));
            }
            this.isEdited = _data["isEdited"];
            this.metadata = _data["metadata"];
        }
    }

    static fromJS(data: any): PunchRemarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchRemarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["punchId"] = this.punchId;
        data["punch"] = this.punch ? this.punch.toJSON() : undefined as any;
        data["remark"] = this.remark;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["remarkTypeId"] = this.remarkTypeId;
        data["remarkType"] = this.remarkType ? this.remarkType.toJSON() : undefined as any;
        if (Array.isArray(this.punchMedia)) {
            data["punchMedia"] = [];
            for (let item of this.punchMedia)
                data["punchMedia"].push(item ? item.toJSON() : undefined as any);
        }
        data["isEdited"] = this.isEdited;
        data["metadata"] = this.metadata;
        return data;
    }
}

export interface IPunchRemarkDto {
    id?: number | undefined;
    punchId?: number | undefined;
    punch?: PunchDto | undefined;
    remark?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    user?: UserDetailDto | undefined;
    remarkTypeId?: number | undefined;
    remarkType?: RemarkTypesDto | undefined;
    punchMedia?: PunchMediaDto[] | undefined;
    isEdited?: boolean;
    metadata?: string | undefined;
}

export class PunchDto implements IPunchDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    altitude?: number | undefined;
    location?: string | undefined;
    pdfPositionX?: number | undefined;
    pdfPositionY?: number | undefined;
    pdfPage?: number | undefined;
    punchCoordinator?: string | undefined;
    rejectCount?: number | undefined;
    inspectionWalk?: InspectionWalkDto | undefined;
    originator?: OriginatorDto | undefined;
    userOriginator?: UserDetailDto | undefined;
    topic?: TopicDto | undefined;
    discipline?: DisciplineDto | undefined;
    status?: StatusDto | undefined;
    punchMedia?: PunchMediaDto[] | undefined;
    punchItem?: PunchItemDto[] | undefined;
    punchLogs?: PunchLogDto[] | undefined;
    punchTags?: PunchTagsDto[] | undefined;
    punchRemark?: PunchRemarkDto[] | undefined;
    punchFields?: PunchCustomFieldDto[] | undefined;
    punchCustomFields?: PunchCustomFieldDto[] | undefined;
    inspection?: InspectionDto | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date;
    user?: UserDetailDto | undefined;
    unit?: MasterDto | undefined;
    subSystem?: MasterDto | undefined;
    createdBy?: string | undefined;
    punchStage?: PunchStageDto[] | undefined;
    isMyPunch?: boolean;
    assignedToId?: string | undefined;
    isRejected?: boolean;
    isSignable?: boolean;
    pendingFlowSignStepId?: number | undefined;
    isRejectable?: boolean;
    reasonNotSignable?: string | undefined;
    onDispute?: boolean | undefined;
    subContractorId?: number | undefined;
    subContractor?: SubcontractorDto | undefined;
    departmentActionId?: number | undefined;
    departmentActionCode?: string | undefined;
    departmentAction?: string | undefined;
    signFlowRole?: string | undefined;
    closed?: boolean | undefined;
    isLocked?: boolean;
    commentary?: string | undefined;
    notes?: string | undefined;
    contractorResponsibleName?: string | undefined;
    locationProject?: LocationProjectDto | undefined;

    constructor(data?: IPunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.altitude = _data["altitude"];
            this.location = _data["location"];
            this.pdfPositionX = _data["pdfPositionX"];
            this.pdfPositionY = _data["pdfPositionY"];
            this.pdfPage = _data["pdfPage"];
            this.punchCoordinator = _data["punchCoordinator"];
            this.rejectCount = _data["rejectCount"];
            this.inspectionWalk = _data["inspectionWalk"] ? InspectionWalkDto.fromJS(_data["inspectionWalk"]) : undefined as any;
            this.originator = _data["originator"] ? OriginatorDto.fromJS(_data["originator"]) : undefined as any;
            this.userOriginator = _data["userOriginator"] ? UserDetailDto.fromJS(_data["userOriginator"]) : undefined as any;
            this.topic = _data["topic"] ? TopicDto.fromJS(_data["topic"]) : undefined as any;
            this.discipline = _data["discipline"] ? DisciplineDto.fromJS(_data["discipline"]) : undefined as any;
            this.status = _data["status"] ? StatusDto.fromJS(_data["status"]) : undefined as any;
            if (Array.isArray(_data["punchMedia"])) {
                this.punchMedia = [] as any;
                for (let item of _data["punchMedia"])
                    this.punchMedia!.push(PunchMediaDto.fromJS(item));
            }
            if (Array.isArray(_data["punchItem"])) {
                this.punchItem = [] as any;
                for (let item of _data["punchItem"])
                    this.punchItem!.push(PunchItemDto.fromJS(item));
            }
            if (Array.isArray(_data["punchLogs"])) {
                this.punchLogs = [] as any;
                for (let item of _data["punchLogs"])
                    this.punchLogs!.push(PunchLogDto.fromJS(item));
            }
            if (Array.isArray(_data["punchTags"])) {
                this.punchTags = [] as any;
                for (let item of _data["punchTags"])
                    this.punchTags!.push(PunchTagsDto.fromJS(item));
            }
            if (Array.isArray(_data["punchRemark"])) {
                this.punchRemark = [] as any;
                for (let item of _data["punchRemark"])
                    this.punchRemark!.push(PunchRemarkDto.fromJS(item));
            }
            if (Array.isArray(_data["punchFields"])) {
                this.punchFields = [] as any;
                for (let item of _data["punchFields"])
                    this.punchFields!.push(PunchCustomFieldDto.fromJS(item));
            }
            if (Array.isArray(_data["punchCustomFields"])) {
                this.punchCustomFields = [] as any;
                for (let item of _data["punchCustomFields"])
                    this.punchCustomFields!.push(PunchCustomFieldDto.fromJS(item));
            }
            this.inspection = _data["inspection"] ? InspectionDto.fromJS(_data["inspection"]) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.user = _data["user"] ? UserDetailDto.fromJS(_data["user"]) : undefined as any;
            this.unit = _data["unit"] ? MasterDto.fromJS(_data["unit"]) : undefined as any;
            this.subSystem = _data["subSystem"] ? MasterDto.fromJS(_data["subSystem"]) : undefined as any;
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["punchStage"])) {
                this.punchStage = [] as any;
                for (let item of _data["punchStage"])
                    this.punchStage!.push(PunchStageDto.fromJS(item));
            }
            this.isMyPunch = _data["isMyPunch"];
            this.assignedToId = _data["assignedToId"];
            this.isRejected = _data["isRejected"];
            this.isSignable = _data["isSignable"];
            this.pendingFlowSignStepId = _data["pendingFlowSignStepId"];
            this.isRejectable = _data["isRejectable"];
            this.reasonNotSignable = _data["reasonNotSignable"];
            this.onDispute = _data["onDispute"];
            this.subContractorId = _data["subContractorId"];
            this.subContractor = _data["subContractor"] ? SubcontractorDto.fromJS(_data["subContractor"]) : undefined as any;
            this.departmentActionId = _data["departmentActionId"];
            this.departmentActionCode = _data["departmentActionCode"];
            this.departmentAction = _data["departmentAction"];
            this.signFlowRole = _data["signFlowRole"];
            this.closed = _data["closed"];
            this.isLocked = _data["isLocked"];
            this.commentary = _data["commentary"];
            this.notes = _data["notes"];
            this.contractorResponsibleName = _data["contractorResponsibleName"];
            this.locationProject = _data["locationProject"] ? LocationProjectDto.fromJS(_data["locationProject"]) : undefined as any;
        }
    }

    static fromJS(data: any): PunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["altitude"] = this.altitude;
        data["location"] = this.location;
        data["pdfPositionX"] = this.pdfPositionX;
        data["pdfPositionY"] = this.pdfPositionY;
        data["pdfPage"] = this.pdfPage;
        data["punchCoordinator"] = this.punchCoordinator;
        data["rejectCount"] = this.rejectCount;
        data["inspectionWalk"] = this.inspectionWalk ? this.inspectionWalk.toJSON() : undefined as any;
        data["originator"] = this.originator ? this.originator.toJSON() : undefined as any;
        data["userOriginator"] = this.userOriginator ? this.userOriginator.toJSON() : undefined as any;
        data["topic"] = this.topic ? this.topic.toJSON() : undefined as any;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        if (Array.isArray(this.punchMedia)) {
            data["punchMedia"] = [];
            for (let item of this.punchMedia)
                data["punchMedia"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchItem)) {
            data["punchItem"] = [];
            for (let item of this.punchItem)
                data["punchItem"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchLogs)) {
            data["punchLogs"] = [];
            for (let item of this.punchLogs)
                data["punchLogs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchTags)) {
            data["punchTags"] = [];
            for (let item of this.punchTags)
                data["punchTags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchRemark)) {
            data["punchRemark"] = [];
            for (let item of this.punchRemark)
                data["punchRemark"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchFields)) {
            data["punchFields"] = [];
            for (let item of this.punchFields)
                data["punchFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchCustomFields)) {
            data["punchCustomFields"] = [];
            for (let item of this.punchCustomFields)
                data["punchCustomFields"].push(item ? item.toJSON() : undefined as any);
        }
        data["inspection"] = this.inspection ? this.inspection.toJSON() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["subSystem"] = this.subSystem ? this.subSystem.toJSON() : undefined as any;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.punchStage)) {
            data["punchStage"] = [];
            for (let item of this.punchStage)
                data["punchStage"].push(item ? item.toJSON() : undefined as any);
        }
        data["isMyPunch"] = this.isMyPunch;
        data["assignedToId"] = this.assignedToId;
        data["isRejected"] = this.isRejected;
        data["isSignable"] = this.isSignable;
        data["pendingFlowSignStepId"] = this.pendingFlowSignStepId;
        data["isRejectable"] = this.isRejectable;
        data["reasonNotSignable"] = this.reasonNotSignable;
        data["onDispute"] = this.onDispute;
        data["subContractorId"] = this.subContractorId;
        data["subContractor"] = this.subContractor ? this.subContractor.toJSON() : undefined as any;
        data["departmentActionId"] = this.departmentActionId;
        data["departmentActionCode"] = this.departmentActionCode;
        data["departmentAction"] = this.departmentAction;
        data["signFlowRole"] = this.signFlowRole;
        data["closed"] = this.closed;
        data["isLocked"] = this.isLocked;
        data["commentary"] = this.commentary;
        data["notes"] = this.notes;
        data["contractorResponsibleName"] = this.contractorResponsibleName;
        data["locationProject"] = this.locationProject ? this.locationProject.toJSON() : undefined as any;
        return data;
    }
}

export interface IPunchDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    altitude?: number | undefined;
    location?: string | undefined;
    pdfPositionX?: number | undefined;
    pdfPositionY?: number | undefined;
    pdfPage?: number | undefined;
    punchCoordinator?: string | undefined;
    rejectCount?: number | undefined;
    inspectionWalk?: InspectionWalkDto | undefined;
    originator?: OriginatorDto | undefined;
    userOriginator?: UserDetailDto | undefined;
    topic?: TopicDto | undefined;
    discipline?: DisciplineDto | undefined;
    status?: StatusDto | undefined;
    punchMedia?: PunchMediaDto[] | undefined;
    punchItem?: PunchItemDto[] | undefined;
    punchLogs?: PunchLogDto[] | undefined;
    punchTags?: PunchTagsDto[] | undefined;
    punchRemark?: PunchRemarkDto[] | undefined;
    punchFields?: PunchCustomFieldDto[] | undefined;
    punchCustomFields?: PunchCustomFieldDto[] | undefined;
    inspection?: InspectionDto | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date;
    user?: UserDetailDto | undefined;
    unit?: MasterDto | undefined;
    subSystem?: MasterDto | undefined;
    createdBy?: string | undefined;
    punchStage?: PunchStageDto[] | undefined;
    isMyPunch?: boolean;
    assignedToId?: string | undefined;
    isRejected?: boolean;
    isSignable?: boolean;
    pendingFlowSignStepId?: number | undefined;
    isRejectable?: boolean;
    reasonNotSignable?: string | undefined;
    onDispute?: boolean | undefined;
    subContractorId?: number | undefined;
    subContractor?: SubcontractorDto | undefined;
    departmentActionId?: number | undefined;
    departmentActionCode?: string | undefined;
    departmentAction?: string | undefined;
    signFlowRole?: string | undefined;
    closed?: boolean | undefined;
    isLocked?: boolean;
    commentary?: string | undefined;
    notes?: string | undefined;
    contractorResponsibleName?: string | undefined;
    locationProject?: LocationProjectDto | undefined;
}

export class InspectionWalkDto implements IInspectionWalkDto {
    id?: number;
    track?: string | undefined;
    createdAt?: Date | undefined;
    lastModifiedAt?: Date | undefined;
    closeDate?: Date | undefined;
    punch?: PunchDto[] | undefined;
    inspectionStatus?: InspectionStatusDto | undefined;
    createdBy?: string | undefined;
    userWalks?: UserDetailDto | undefined;
    fromImport?: boolean;
    date?: Date | undefined;

    constructor(data?: IInspectionWalkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.track = _data["track"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : undefined as any;
            if (Array.isArray(_data["punch"])) {
                this.punch = [] as any;
                for (let item of _data["punch"])
                    this.punch!.push(PunchDto.fromJS(item));
            }
            this.inspectionStatus = _data["inspectionStatus"] ? InspectionStatusDto.fromJS(_data["inspectionStatus"]) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.userWalks = _data["userWalks"] ? UserDetailDto.fromJS(_data["userWalks"]) : undefined as any;
            this.fromImport = _data["fromImport"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InspectionWalkDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionWalkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["track"] = this.track;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : undefined as any;
        if (Array.isArray(this.punch)) {
            data["punch"] = [];
            for (let item of this.punch)
                data["punch"].push(item ? item.toJSON() : undefined as any);
        }
        data["inspectionStatus"] = this.inspectionStatus ? this.inspectionStatus.toJSON() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["userWalks"] = this.userWalks ? this.userWalks.toJSON() : undefined as any;
        data["fromImport"] = this.fromImport;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }
}

export interface IInspectionWalkDto {
    id?: number;
    track?: string | undefined;
    createdAt?: Date | undefined;
    lastModifiedAt?: Date | undefined;
    closeDate?: Date | undefined;
    punch?: PunchDto[] | undefined;
    inspectionStatus?: InspectionStatusDto | undefined;
    createdBy?: string | undefined;
    userWalks?: UserDetailDto | undefined;
    fromImport?: boolean;
    date?: Date | undefined;
}

export class InspectionStatusDto extends MasterDto implements IInspectionStatusDto {
    color?: string | undefined;
    createdAt?: Date;
    inspectionStatusAvailable?: InspectionStatusDto[] | undefined;
    otherInspectionsAvailable?: boolean[] | undefined;

    constructor(data?: IInspectionStatusDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.color = _data["color"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            if (Array.isArray(_data["inspectionStatusAvailable"])) {
                this.inspectionStatusAvailable = [] as any;
                for (let item of _data["inspectionStatusAvailable"])
                    this.inspectionStatusAvailable!.push(InspectionStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["otherInspectionsAvailable"])) {
                this.otherInspectionsAvailable = [] as any;
                for (let item of _data["otherInspectionsAvailable"])
                    this.otherInspectionsAvailable!.push(item);
            }
        }
    }

    static override fromJS(data: any): InspectionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionStatusDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        if (Array.isArray(this.inspectionStatusAvailable)) {
            data["inspectionStatusAvailable"] = [];
            for (let item of this.inspectionStatusAvailable)
                data["inspectionStatusAvailable"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.otherInspectionsAvailable)) {
            data["otherInspectionsAvailable"] = [];
            for (let item of this.otherInspectionsAvailable)
                data["otherInspectionsAvailable"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionStatusDto extends IMasterDto {
    color?: string | undefined;
    createdAt?: Date;
    inspectionStatusAvailable?: InspectionStatusDto[] | undefined;
    otherInspectionsAvailable?: boolean[] | undefined;
}

export class UserDto implements IUserDto {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.company = _data["company"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["company"] = this.company;
        return data;
    }
}

export interface IUserDto {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
}

export class UserDetailProjectTemplateDto extends UserDto implements IUserDetailProjectTemplateDto {
    userProjectTemplate?: TemplateProjectDto[] | undefined;
    globalRole?: string | undefined;

    constructor(data?: IUserDetailProjectTemplateDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["userProjectTemplate"])) {
                this.userProjectTemplate = [] as any;
                for (let item of _data["userProjectTemplate"])
                    this.userProjectTemplate!.push(TemplateProjectDto.fromJS(item));
            }
            this.globalRole = _data["globalRole"];
        }
    }

    static override fromJS(data: any): UserDetailProjectTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailProjectTemplateDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userProjectTemplate)) {
            data["userProjectTemplate"] = [];
            for (let item of this.userProjectTemplate)
                data["userProjectTemplate"].push(item ? item.toJSON() : undefined as any);
        }
        data["globalRole"] = this.globalRole;
        super.toJSON(data);
        return data;
    }
}

export interface IUserDetailProjectTemplateDto extends IUserDto {
    userProjectTemplate?: TemplateProjectDto[] | undefined;
    globalRole?: string | undefined;
}

export class UserDetailDto extends UserDetailProjectTemplateDto implements IUserDetailDto {
    departmentId?: number | undefined;
    userDiscipline?: DisciplineDto[] | undefined;
    hasAllDisciplines?: boolean;
    userUnit?: ElementsDto[] | undefined;
    hasAllUnits?: boolean;
    walks?: InspectionWalkDto[] | undefined;
    isOrganizer?: boolean;

    constructor(data?: IUserDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.departmentId = _data["departmentId"];
            if (Array.isArray(_data["userDiscipline"])) {
                this.userDiscipline = [] as any;
                for (let item of _data["userDiscipline"])
                    this.userDiscipline!.push(DisciplineDto.fromJS(item));
            }
            this.hasAllDisciplines = _data["hasAllDisciplines"];
            if (Array.isArray(_data["userUnit"])) {
                this.userUnit = [] as any;
                for (let item of _data["userUnit"])
                    this.userUnit!.push(ElementsDto.fromJS(item));
            }
            this.hasAllUnits = _data["hasAllUnits"];
            if (Array.isArray(_data["walks"])) {
                this.walks = [] as any;
                for (let item of _data["walks"])
                    this.walks!.push(InspectionWalkDto.fromJS(item));
            }
            this.isOrganizer = _data["isOrganizer"];
        }
    }

    static override fromJS(data: any): UserDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId;
        if (Array.isArray(this.userDiscipline)) {
            data["userDiscipline"] = [];
            for (let item of this.userDiscipline)
                data["userDiscipline"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasAllDisciplines"] = this.hasAllDisciplines;
        if (Array.isArray(this.userUnit)) {
            data["userUnit"] = [];
            for (let item of this.userUnit)
                data["userUnit"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasAllUnits"] = this.hasAllUnits;
        if (Array.isArray(this.walks)) {
            data["walks"] = [];
            for (let item of this.walks)
                data["walks"].push(item ? item.toJSON() : undefined as any);
        }
        data["isOrganizer"] = this.isOrganizer;
        super.toJSON(data);
        return data;
    }
}

export interface IUserDetailDto extends IUserDetailProjectTemplateDto {
    departmentId?: number | undefined;
    userDiscipline?: DisciplineDto[] | undefined;
    hasAllDisciplines?: boolean;
    userUnit?: ElementsDto[] | undefined;
    hasAllUnits?: boolean;
    walks?: InspectionWalkDto[] | undefined;
    isOrganizer?: boolean;
}

export class DisciplineDto extends MasterDto implements IDisciplineDto {

    constructor(data?: IDisciplineDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DisciplineDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisciplineDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDisciplineDto extends IMasterDto {
}

export class ElementsDto extends MasterDto implements IElementsDto {
    nodeLevelId?: number;
    nodeLevel?: NodeLevelsDto | undefined;
    elementTypeId?: number | undefined;
    elementType?: ElementTypesDto | undefined;
    active?: boolean;
    priority?: number;
    remarks?: string | undefined;
    discipline?: DisciplineDto | undefined;
    project?: ProjectDto | undefined;
    template?: TemplateDto | undefined;
    childs?: ElementsDto[] | undefined;
    selected?: boolean;
    elementMatchId?: number | undefined;

    constructor(data?: IElementsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nodeLevelId = _data["nodeLevelId"];
            this.nodeLevel = _data["nodeLevel"] ? NodeLevelsDto.fromJS(_data["nodeLevel"]) : undefined as any;
            this.elementTypeId = _data["elementTypeId"];
            this.elementType = _data["elementType"] ? ElementTypesDto.fromJS(_data["elementType"]) : undefined as any;
            this.active = _data["active"];
            this.priority = _data["priority"];
            this.remarks = _data["remarks"];
            this.discipline = _data["discipline"] ? DisciplineDto.fromJS(_data["discipline"]) : undefined as any;
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : undefined as any;
            this.template = _data["template"] ? TemplateDto.fromJS(_data["template"]) : undefined as any;
            if (Array.isArray(_data["childs"])) {
                this.childs = [] as any;
                for (let item of _data["childs"])
                    this.childs!.push(ElementsDto.fromJS(item));
            }
            this.selected = _data["selected"];
            this.elementMatchId = _data["elementMatchId"];
        }
    }

    static override fromJS(data: any): ElementsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeLevelId"] = this.nodeLevelId;
        data["nodeLevel"] = this.nodeLevel ? this.nodeLevel.toJSON() : undefined as any;
        data["elementTypeId"] = this.elementTypeId;
        data["elementType"] = this.elementType ? this.elementType.toJSON() : undefined as any;
        data["active"] = this.active;
        data["priority"] = this.priority;
        data["remarks"] = this.remarks;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        if (Array.isArray(this.childs)) {
            data["childs"] = [];
            for (let item of this.childs)
                data["childs"].push(item ? item.toJSON() : undefined as any);
        }
        data["selected"] = this.selected;
        data["elementMatchId"] = this.elementMatchId;
        super.toJSON(data);
        return data;
    }
}

export interface IElementsDto extends IMasterDto {
    nodeLevelId?: number;
    nodeLevel?: NodeLevelsDto | undefined;
    elementTypeId?: number | undefined;
    elementType?: ElementTypesDto | undefined;
    active?: boolean;
    priority?: number;
    remarks?: string | undefined;
    discipline?: DisciplineDto | undefined;
    project?: ProjectDto | undefined;
    template?: TemplateDto | undefined;
    childs?: ElementsDto[] | undefined;
    selected?: boolean;
    elementMatchId?: number | undefined;
}

export class NodeLevelsDto extends MasterDto implements INodeLevelsDto {

    constructor(data?: INodeLevelsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): NodeLevelsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NodeLevelsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface INodeLevelsDto extends IMasterDto {
}

export class ElementTypesDto extends MasterDto implements IElementTypesDto {

    constructor(data?: IElementTypesDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ElementTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementTypesDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IElementTypesDto extends IMasterDto {
}

export class ProjectDto extends MasterDto implements IProjectDto {
    wbsLastSync?: Date | undefined;
    wbsId?: number | undefined;
    name?: string | undefined;
    type?: string | undefined;
    client?: string | undefined;
    location?: string | undefined;
    logo?: string | undefined;
    default?: boolean | undefined;
    usingProjectWbs?: boolean | undefined;
    closed?: boolean | undefined;
    isSynchronizationActive?: boolean;
    lastSynchronizationInfo?: string | undefined;
    lastWbsSyncStatus?: WbsSyncStatusEnum | undefined;
    synchronizationType?: string | undefined;

    constructor(data?: IProjectDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.wbsLastSync = _data["wbsLastSync"] ? new Date(_data["wbsLastSync"].toString()) : undefined as any;
            this.wbsId = _data["wbsId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.client = _data["client"];
            this.location = _data["location"];
            this.logo = _data["logo"];
            this.default = _data["default"];
            this.usingProjectWbs = _data["usingProjectWbs"];
            this.closed = _data["closed"];
            this.isSynchronizationActive = _data["isSynchronizationActive"];
            this.lastSynchronizationInfo = _data["lastSynchronizationInfo"];
            this.lastWbsSyncStatus = _data["lastWbsSyncStatus"];
            this.synchronizationType = _data["synchronizationType"];
        }
    }

    static override fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wbsLastSync"] = this.wbsLastSync ? this.wbsLastSync.toISOString() : undefined as any;
        data["wbsId"] = this.wbsId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["client"] = this.client;
        data["location"] = this.location;
        data["logo"] = this.logo;
        data["default"] = this.default;
        data["usingProjectWbs"] = this.usingProjectWbs;
        data["closed"] = this.closed;
        data["isSynchronizationActive"] = this.isSynchronizationActive;
        data["lastSynchronizationInfo"] = this.lastSynchronizationInfo;
        data["lastWbsSyncStatus"] = this.lastWbsSyncStatus;
        data["synchronizationType"] = this.synchronizationType;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectDto extends IMasterDto {
    wbsLastSync?: Date | undefined;
    wbsId?: number | undefined;
    name?: string | undefined;
    type?: string | undefined;
    client?: string | undefined;
    location?: string | undefined;
    logo?: string | undefined;
    default?: boolean | undefined;
    usingProjectWbs?: boolean | undefined;
    closed?: boolean | undefined;
    isSynchronizationActive?: boolean;
    lastSynchronizationInfo?: string | undefined;
    lastWbsSyncStatus?: WbsSyncStatusEnum | undefined;
    synchronizationType?: string | undefined;
}

export enum WbsSyncStatusEnum {
    Success = 1,
    Error = 2,
}

export class TemplateDto extends MasterDto implements ITemplateDto {
    reportTemplate?: boolean;
    topicsCount?: number;
    tags?: string[] | undefined;
    templateProject?: TemplateProjectDto[] | undefined;
    templateProjectConfig?: TemplateProjectConfigDto[] | undefined;
    templatePunchCustomField?: TemplatePunchCustomFieldDto[] | undefined;
    inspectionType?: InspectionTypeDto[] | undefined;
    category?: CategoryDto[] | undefined;
    topic?: TopicDto[] | undefined;

    constructor(data?: ITemplateDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reportTemplate = _data["reportTemplate"];
            this.topicsCount = _data["topicsCount"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["templateProject"])) {
                this.templateProject = [] as any;
                for (let item of _data["templateProject"])
                    this.templateProject!.push(TemplateProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["templateProjectConfig"])) {
                this.templateProjectConfig = [] as any;
                for (let item of _data["templateProjectConfig"])
                    this.templateProjectConfig!.push(TemplateProjectConfigDto.fromJS(item));
            }
            if (Array.isArray(_data["templatePunchCustomField"])) {
                this.templatePunchCustomField = [] as any;
                for (let item of _data["templatePunchCustomField"])
                    this.templatePunchCustomField!.push(TemplatePunchCustomFieldDto.fromJS(item));
            }
            if (Array.isArray(_data["inspectionType"])) {
                this.inspectionType = [] as any;
                for (let item of _data["inspectionType"])
                    this.inspectionType!.push(InspectionTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(CategoryDto.fromJS(item));
            }
            if (Array.isArray(_data["topic"])) {
                this.topic = [] as any;
                for (let item of _data["topic"])
                    this.topic!.push(TopicDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportTemplate"] = this.reportTemplate;
        data["topicsCount"] = this.topicsCount;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.templateProject)) {
            data["templateProject"] = [];
            for (let item of this.templateProject)
                data["templateProject"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.templateProjectConfig)) {
            data["templateProjectConfig"] = [];
            for (let item of this.templateProjectConfig)
                data["templateProjectConfig"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.templatePunchCustomField)) {
            data["templatePunchCustomField"] = [];
            for (let item of this.templatePunchCustomField)
                data["templatePunchCustomField"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionType)) {
            data["inspectionType"] = [];
            for (let item of this.inspectionType)
                data["inspectionType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.topic)) {
            data["topic"] = [];
            for (let item of this.topic)
                data["topic"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateDto extends IMasterDto {
    reportTemplate?: boolean;
    topicsCount?: number;
    tags?: string[] | undefined;
    templateProject?: TemplateProjectDto[] | undefined;
    templateProjectConfig?: TemplateProjectConfigDto[] | undefined;
    templatePunchCustomField?: TemplatePunchCustomFieldDto[] | undefined;
    inspectionType?: InspectionTypeDto[] | undefined;
    category?: CategoryDto[] | undefined;
    topic?: TopicDto[] | undefined;
}

export class TemplateProjectDto extends MasterDto implements ITemplateProjectDto {
    project?: ProjectDto | undefined;
    template?: TemplateDto | undefined;
    default?: boolean;
    useProjectWbs?: boolean;
    closed?: boolean;
    role?: string | undefined;
    visibleRole?: string | undefined;
    maps?: MapsDto[] | undefined;

    constructor(data?: ITemplateProjectDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : undefined as any;
            this.template = _data["template"] ? TemplateDto.fromJS(_data["template"]) : undefined as any;
            this.default = _data["default"];
            this.useProjectWbs = _data["useProjectWbs"];
            this.closed = _data["closed"];
            this.role = _data["role"];
            this.visibleRole = _data["visibleRole"];
            if (Array.isArray(_data["maps"])) {
                this.maps = [] as any;
                for (let item of _data["maps"])
                    this.maps!.push(MapsDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TemplateProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateProjectDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        data["default"] = this.default;
        data["useProjectWbs"] = this.useProjectWbs;
        data["closed"] = this.closed;
        data["role"] = this.role;
        data["visibleRole"] = this.visibleRole;
        if (Array.isArray(this.maps)) {
            data["maps"] = [];
            for (let item of this.maps)
                data["maps"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateProjectDto extends IMasterDto {
    project?: ProjectDto | undefined;
    template?: TemplateDto | undefined;
    default?: boolean;
    useProjectWbs?: boolean;
    closed?: boolean;
    role?: string | undefined;
    visibleRole?: string | undefined;
    maps?: MapsDto[] | undefined;
}

export class MapsDto extends MasterDto implements IMapsDto {
    name?: string | undefined;
    version?: number;
    projectId?: number;
    templateId?: number;
    mimeType?: string | undefined;
    imageFileServer?: string | undefined;
    location?: string | undefined;
    zoomLevel?: number;
    file?: string | undefined;
    default?: boolean;
    createdAt?: Date;
    lastModifiedAt?: Date;

    constructor(data?: IMapsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.version = _data["version"];
            this.projectId = _data["projectId"];
            this.templateId = _data["templateId"];
            this.mimeType = _data["mimeType"];
            this.imageFileServer = _data["imageFileServer"];
            this.location = _data["location"];
            this.zoomLevel = _data["zoomLevel"];
            this.file = _data["file"];
            this.default = _data["default"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): MapsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["version"] = this.version;
        data["projectId"] = this.projectId;
        data["templateId"] = this.templateId;
        data["mimeType"] = this.mimeType;
        data["imageFileServer"] = this.imageFileServer;
        data["location"] = this.location;
        data["zoomLevel"] = this.zoomLevel;
        data["file"] = this.file;
        data["default"] = this.default;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMapsDto extends IMasterDto {
    name?: string | undefined;
    version?: number;
    projectId?: number;
    templateId?: number;
    mimeType?: string | undefined;
    imageFileServer?: string | undefined;
    location?: string | undefined;
    zoomLevel?: number;
    file?: string | undefined;
    default?: boolean;
    createdAt?: Date;
    lastModifiedAt?: Date;
}

export class TemplateProjectConfigDto extends MasterDto implements ITemplateProjectConfigDto {
    key?: string | undefined;
    value?: string | undefined;
    templateId?: number;

    constructor(data?: ITemplateProjectConfigDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.templateId = _data["templateId"];
        }
    }

    static override fromJS(data: any): TemplateProjectConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateProjectConfigDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["templateId"] = this.templateId;
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateProjectConfigDto extends IMasterDto {
    key?: string | undefined;
    value?: string | undefined;
    templateId?: number;
}

export class TemplatePunchCustomFieldDto extends MasterDto implements ITemplatePunchCustomFieldDto {
    order?: number | undefined;
    name?: string | undefined;
    front?: string | undefined;
    visual?: string | undefined;
    type?: string | undefined;
    options?: string | undefined;
    main?: string | undefined;
    templateId?: number | undefined;
    template?: TemplateDto | undefined;
    notAllowedRoles?: string[] | undefined;
    edit?: boolean;

    constructor(data?: ITemplatePunchCustomFieldDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            this.front = _data["front"];
            this.visual = _data["visual"];
            this.type = _data["type"];
            this.options = _data["options"];
            this.main = _data["main"];
            this.templateId = _data["templateId"];
            this.template = _data["template"] ? TemplateDto.fromJS(_data["template"]) : undefined as any;
            if (Array.isArray(_data["notAllowedRoles"])) {
                this.notAllowedRoles = [] as any;
                for (let item of _data["notAllowedRoles"])
                    this.notAllowedRoles!.push(item);
            }
            this.edit = _data["edit"];
        }
    }

    static override fromJS(data: any): TemplatePunchCustomFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplatePunchCustomFieldDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        data["front"] = this.front;
        data["visual"] = this.visual;
        data["type"] = this.type;
        data["options"] = this.options;
        data["main"] = this.main;
        data["templateId"] = this.templateId;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        if (Array.isArray(this.notAllowedRoles)) {
            data["notAllowedRoles"] = [];
            for (let item of this.notAllowedRoles)
                data["notAllowedRoles"].push(item);
        }
        data["edit"] = this.edit;
        super.toJSON(data);
        return data;
    }
}

export interface ITemplatePunchCustomFieldDto extends IMasterDto {
    order?: number | undefined;
    name?: string | undefined;
    front?: string | undefined;
    visual?: string | undefined;
    type?: string | undefined;
    options?: string | undefined;
    main?: string | undefined;
    templateId?: number | undefined;
    template?: TemplateDto | undefined;
    notAllowedRoles?: string[] | undefined;
    edit?: boolean;
}

export class InspectionTypeDto extends MasterDto implements IInspectionTypeDto {
    tags?: string[] | undefined;
    name?: string | undefined;
    connector?: string | undefined;
    templateId?: number;
    inspectionTypeCategory?: InspectionTypeCategoryDto[] | undefined;
    inspectionTypeTopic?: InspectionTypeTopicDto[] | undefined;
    inspectionTypeFlowSign?: InspectionTypeFlowSignDto[] | undefined;
    departmentActionInspectionType?: DepartmentActionInspectionTypeDto[] | undefined;

    constructor(data?: IInspectionTypeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.name = _data["name"];
            this.connector = _data["connector"];
            this.templateId = _data["templateId"];
            if (Array.isArray(_data["inspectionTypeCategory"])) {
                this.inspectionTypeCategory = [] as any;
                for (let item of _data["inspectionTypeCategory"])
                    this.inspectionTypeCategory!.push(InspectionTypeCategoryDto.fromJS(item));
            }
            if (Array.isArray(_data["inspectionTypeTopic"])) {
                this.inspectionTypeTopic = [] as any;
                for (let item of _data["inspectionTypeTopic"])
                    this.inspectionTypeTopic!.push(InspectionTypeTopicDto.fromJS(item));
            }
            if (Array.isArray(_data["inspectionTypeFlowSign"])) {
                this.inspectionTypeFlowSign = [] as any;
                for (let item of _data["inspectionTypeFlowSign"])
                    this.inspectionTypeFlowSign!.push(InspectionTypeFlowSignDto.fromJS(item));
            }
            if (Array.isArray(_data["departmentActionInspectionType"])) {
                this.departmentActionInspectionType = [] as any;
                for (let item of _data["departmentActionInspectionType"])
                    this.departmentActionInspectionType!.push(DepartmentActionInspectionTypeDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): InspectionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["name"] = this.name;
        data["connector"] = this.connector;
        data["templateId"] = this.templateId;
        if (Array.isArray(this.inspectionTypeCategory)) {
            data["inspectionTypeCategory"] = [];
            for (let item of this.inspectionTypeCategory)
                data["inspectionTypeCategory"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionTypeTopic)) {
            data["inspectionTypeTopic"] = [];
            for (let item of this.inspectionTypeTopic)
                data["inspectionTypeTopic"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionTypeFlowSign)) {
            data["inspectionTypeFlowSign"] = [];
            for (let item of this.inspectionTypeFlowSign)
                data["inspectionTypeFlowSign"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.departmentActionInspectionType)) {
            data["departmentActionInspectionType"] = [];
            for (let item of this.departmentActionInspectionType)
                data["departmentActionInspectionType"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionTypeDto extends IMasterDto {
    tags?: string[] | undefined;
    name?: string | undefined;
    connector?: string | undefined;
    templateId?: number;
    inspectionTypeCategory?: InspectionTypeCategoryDto[] | undefined;
    inspectionTypeTopic?: InspectionTypeTopicDto[] | undefined;
    inspectionTypeFlowSign?: InspectionTypeFlowSignDto[] | undefined;
    departmentActionInspectionType?: DepartmentActionInspectionTypeDto[] | undefined;
}

export class InspectionTypeCategoryDto extends MasterDto implements IInspectionTypeCategoryDto {
    inspectionType?: InspectionTypeDto | undefined;
    category?: CategoryDto | undefined;

    constructor(data?: IInspectionTypeCategoryDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.inspectionType = _data["inspectionType"] ? InspectionTypeDto.fromJS(_data["inspectionType"]) : undefined as any;
            this.category = _data["category"] ? CategoryDto.fromJS(_data["category"]) : undefined as any;
        }
    }

    static override fromJS(data: any): InspectionTypeCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeCategoryDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionType"] = this.inspectionType ? this.inspectionType.toJSON() : undefined as any;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionTypeCategoryDto extends IMasterDto {
    inspectionType?: InspectionTypeDto | undefined;
    category?: CategoryDto | undefined;
}

export class CategoryDto extends MasterDto implements ICategoryDto {
    contractualInterpretation?: string | undefined;
    colorType?: number | undefined;
    categoryMatchId?: number | undefined;
    order?: number | undefined;

    constructor(data?: ICategoryDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contractualInterpretation = _data["contractualInterpretation"];
            this.colorType = _data["colorType"];
            this.categoryMatchId = _data["categoryMatchId"];
            this.order = _data["order"];
        }
    }

    static override fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractualInterpretation"] = this.contractualInterpretation;
        data["colorType"] = this.colorType;
        data["categoryMatchId"] = this.categoryMatchId;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }
}

export interface ICategoryDto extends IMasterDto {
    contractualInterpretation?: string | undefined;
    colorType?: number | undefined;
    categoryMatchId?: number | undefined;
    order?: number | undefined;
}

export class InspectionTypeTopicDto extends MasterDto implements IInspectionTypeTopicDto {
    inspectionType?: InspectionTypeDto | undefined;
    topic?: TopicDto | undefined;

    constructor(data?: IInspectionTypeTopicDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.inspectionType = _data["inspectionType"] ? InspectionTypeDto.fromJS(_data["inspectionType"]) : undefined as any;
            this.topic = _data["topic"] ? TopicDto.fromJS(_data["topic"]) : undefined as any;
        }
    }

    static override fromJS(data: any): InspectionTypeTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeTopicDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionType"] = this.inspectionType ? this.inspectionType.toJSON() : undefined as any;
        data["topic"] = this.topic ? this.topic.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionTypeTopicDto extends IMasterDto {
    inspectionType?: InspectionTypeDto | undefined;
    topic?: TopicDto | undefined;
}

export class TopicDto extends MasterDto implements ITopicDto {
    topicImpactLevel?: number | undefined;
    topicMatchId?: number | undefined;
    discipline?: DisciplineDto | undefined;

    constructor(data?: ITopicDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.topicImpactLevel = _data["topicImpactLevel"];
            this.topicMatchId = _data["topicMatchId"];
            this.discipline = _data["discipline"] ? DisciplineDto.fromJS(_data["discipline"]) : undefined as any;
        }
    }

    static override fromJS(data: any): TopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicImpactLevel"] = this.topicImpactLevel;
        data["topicMatchId"] = this.topicMatchId;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ITopicDto extends IMasterDto {
    topicImpactLevel?: number | undefined;
    topicMatchId?: number | undefined;
    discipline?: DisciplineDto | undefined;
}

export class InspectionTypeFlowSignDto implements IInspectionTypeFlowSignDto {
    id?: number;
    inspectionTypeId?: number;
    inspectionTypeFlowSignAction?: InspectionTypeFlowSignActionDto[] | undefined;
    user?: UserDetailDto | undefined;
    role?: string | undefined;
    expiredType?: ExpiredTypeDto | undefined;
    expiredTime?: ExpiredTimeDto | undefined;
    expiredValue?: number | undefined;
    sequence?: number | undefined;
    override?: boolean | undefined;

    constructor(data?: IInspectionTypeFlowSignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inspectionTypeId = _data["inspectionTypeId"];
            if (Array.isArray(_data["inspectionTypeFlowSignAction"])) {
                this.inspectionTypeFlowSignAction = [] as any;
                for (let item of _data["inspectionTypeFlowSignAction"])
                    this.inspectionTypeFlowSignAction!.push(InspectionTypeFlowSignActionDto.fromJS(item));
            }
            this.user = _data["user"] ? UserDetailDto.fromJS(_data["user"]) : undefined as any;
            this.role = _data["role"];
            this.expiredType = _data["expiredType"] ? ExpiredTypeDto.fromJS(_data["expiredType"]) : undefined as any;
            this.expiredTime = _data["expiredTime"] ? ExpiredTimeDto.fromJS(_data["expiredTime"]) : undefined as any;
            this.expiredValue = _data["expiredValue"];
            this.sequence = _data["sequence"];
            this.override = _data["override"];
        }
    }

    static fromJS(data: any): InspectionTypeFlowSignDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeFlowSignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionTypeId"] = this.inspectionTypeId;
        if (Array.isArray(this.inspectionTypeFlowSignAction)) {
            data["inspectionTypeFlowSignAction"] = [];
            for (let item of this.inspectionTypeFlowSignAction)
                data["inspectionTypeFlowSignAction"].push(item ? item.toJSON() : undefined as any);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["role"] = this.role;
        data["expiredType"] = this.expiredType ? this.expiredType.toJSON() : undefined as any;
        data["expiredTime"] = this.expiredTime ? this.expiredTime.toJSON() : undefined as any;
        data["expiredValue"] = this.expiredValue;
        data["sequence"] = this.sequence;
        data["override"] = this.override;
        return data;
    }
}

export interface IInspectionTypeFlowSignDto {
    id?: number;
    inspectionTypeId?: number;
    inspectionTypeFlowSignAction?: InspectionTypeFlowSignActionDto[] | undefined;
    user?: UserDetailDto | undefined;
    role?: string | undefined;
    expiredType?: ExpiredTypeDto | undefined;
    expiredTime?: ExpiredTimeDto | undefined;
    expiredValue?: number | undefined;
    sequence?: number | undefined;
    override?: boolean | undefined;
}

export class InspectionTypeFlowSignActionDto extends MasterDto implements IInspectionTypeFlowSignActionDto {
    signAction?: SignActionDto | undefined;
    inspectionTypeFlowType?: InspectionTypeFlowTypeDto | undefined;
    status?: StatusDto | undefined;

    constructor(data?: IInspectionTypeFlowSignActionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.signAction = _data["signAction"] ? SignActionDto.fromJS(_data["signAction"]) : undefined as any;
            this.inspectionTypeFlowType = _data["inspectionTypeFlowType"] ? InspectionTypeFlowTypeDto.fromJS(_data["inspectionTypeFlowType"]) : undefined as any;
            this.status = _data["status"] ? StatusDto.fromJS(_data["status"]) : undefined as any;
        }
    }

    static override fromJS(data: any): InspectionTypeFlowSignActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeFlowSignActionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signAction"] = this.signAction ? this.signAction.toJSON() : undefined as any;
        data["inspectionTypeFlowType"] = this.inspectionTypeFlowType ? this.inspectionTypeFlowType.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionTypeFlowSignActionDto extends IMasterDto {
    signAction?: SignActionDto | undefined;
    inspectionTypeFlowType?: InspectionTypeFlowTypeDto | undefined;
    status?: StatusDto | undefined;
}

export class SignActionDto extends MasterDto implements ISignActionDto {

    constructor(data?: ISignActionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SignActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignActionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISignActionDto extends IMasterDto {
}

export class InspectionTypeFlowTypeDto extends MasterDto implements IInspectionTypeFlowTypeDto {

    constructor(data?: IInspectionTypeFlowTypeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): InspectionTypeFlowTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeFlowTypeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionTypeFlowTypeDto extends IMasterDto {
}

export class StatusDto extends MasterDto implements IStatusDto {
    color?: string | undefined;
    isVisible?: boolean;

    constructor(data?: IStatusDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.color = _data["color"];
            this.isVisible = _data["isVisible"];
        }
    }

    static override fromJS(data: any): StatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["isVisible"] = this.isVisible;
        super.toJSON(data);
        return data;
    }
}

export interface IStatusDto extends IMasterDto {
    color?: string | undefined;
    isVisible?: boolean;
}

export class ExpiredTypeDto extends MasterDto implements IExpiredTypeDto {

    constructor(data?: IExpiredTypeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ExpiredTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiredTypeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IExpiredTypeDto extends IMasterDto {
}

export class ExpiredTimeDto extends MasterDto implements IExpiredTimeDto {

    constructor(data?: IExpiredTimeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ExpiredTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiredTimeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IExpiredTimeDto extends IMasterDto {
}

export class DepartmentActionInspectionTypeDto implements IDepartmentActionInspectionTypeDto {
    departmentAction?: DepartmentActionDto | undefined;
    inspectionType?: InspectionTypeDto | undefined;

    constructor(data?: IDepartmentActionInspectionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentAction = _data["departmentAction"] ? DepartmentActionDto.fromJS(_data["departmentAction"]) : undefined as any;
            this.inspectionType = _data["inspectionType"] ? InspectionTypeDto.fromJS(_data["inspectionType"]) : undefined as any;
        }
    }

    static fromJS(data: any): DepartmentActionInspectionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentActionInspectionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentAction"] = this.departmentAction ? this.departmentAction.toJSON() : undefined as any;
        data["inspectionType"] = this.inspectionType ? this.inspectionType.toJSON() : undefined as any;
        return data;
    }
}

export interface IDepartmentActionInspectionTypeDto {
    departmentAction?: DepartmentActionDto | undefined;
    inspectionType?: InspectionTypeDto | undefined;
}

export class DepartmentActionDto extends MasterDto implements IDepartmentActionDto {
    departmentActionInspectionType?: DepartmentActionInspectionTypeDto[] | undefined;

    constructor(data?: IDepartmentActionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["departmentActionInspectionType"])) {
                this.departmentActionInspectionType = [] as any;
                for (let item of _data["departmentActionInspectionType"])
                    this.departmentActionInspectionType!.push(DepartmentActionInspectionTypeDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DepartmentActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentActionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.departmentActionInspectionType)) {
            data["departmentActionInspectionType"] = [];
            for (let item of this.departmentActionInspectionType)
                data["departmentActionInspectionType"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDepartmentActionDto extends IMasterDto {
    departmentActionInspectionType?: DepartmentActionInspectionTypeDto[] | undefined;
}

export class PunchMediaDto implements IPunchMediaDto {
    id?: number | undefined;
    punchId?: number | undefined;
    punchRemarkId?: number | undefined;
    mimeType?: string | undefined;
    name?: string | undefined;
    thumbnail?: string | undefined;
    imageFileServer?: string | undefined;
    mediaTypeId?: number | undefined;
    cover?: boolean;
    realNameFile?: string | undefined;
    mediaType?: MediaTypeDto | undefined;
    punchRemark?: PunchRemarkDto | undefined;
    lastModifiedAt?: Date | undefined;

    constructor(data?: IPunchMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.punchId = _data["punchId"];
            this.punchRemarkId = _data["punchRemarkId"];
            this.mimeType = _data["mimeType"];
            this.name = _data["name"];
            this.thumbnail = _data["thumbnail"];
            this.imageFileServer = _data["imageFileServer"];
            this.mediaTypeId = _data["mediaTypeId"];
            this.cover = _data["cover"];
            this.realNameFile = _data["realNameFile"];
            this.mediaType = _data["mediaType"] ? MediaTypeDto.fromJS(_data["mediaType"]) : undefined as any;
            this.punchRemark = _data["punchRemark"] ? PunchRemarkDto.fromJS(_data["punchRemark"]) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PunchMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["punchId"] = this.punchId;
        data["punchRemarkId"] = this.punchRemarkId;
        data["mimeType"] = this.mimeType;
        data["name"] = this.name;
        data["thumbnail"] = this.thumbnail;
        data["imageFileServer"] = this.imageFileServer;
        data["mediaTypeId"] = this.mediaTypeId;
        data["cover"] = this.cover;
        data["realNameFile"] = this.realNameFile;
        data["mediaType"] = this.mediaType ? this.mediaType.toJSON() : undefined as any;
        data["punchRemark"] = this.punchRemark ? this.punchRemark.toJSON() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IPunchMediaDto {
    id?: number | undefined;
    punchId?: number | undefined;
    punchRemarkId?: number | undefined;
    mimeType?: string | undefined;
    name?: string | undefined;
    thumbnail?: string | undefined;
    imageFileServer?: string | undefined;
    mediaTypeId?: number | undefined;
    cover?: boolean;
    realNameFile?: string | undefined;
    mediaType?: MediaTypeDto | undefined;
    punchRemark?: PunchRemarkDto | undefined;
    lastModifiedAt?: Date | undefined;
}

export class MediaTypeDto implements IMediaTypeDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    punchMedia?: PunchMediaDto[] | undefined;

    constructor(data?: IMediaTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            if (Array.isArray(_data["punchMedia"])) {
                this.punchMedia = [] as any;
                for (let item of _data["punchMedia"])
                    this.punchMedia!.push(PunchMediaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MediaTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        if (Array.isArray(this.punchMedia)) {
            data["punchMedia"] = [];
            for (let item of this.punchMedia)
                data["punchMedia"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMediaTypeDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    punchMedia?: PunchMediaDto[] | undefined;
}

export class PunchItemDto implements IPunchItemDto {
    element?: ElementsDto | undefined;

    constructor(data?: IPunchItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.element = _data["element"] ? ElementsDto.fromJS(_data["element"]) : undefined as any;
        }
    }

    static fromJS(data: any): PunchItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["element"] = this.element ? this.element.toJSON() : undefined as any;
        return data;
    }
}

export interface IPunchItemDto {
    element?: ElementsDto | undefined;
}

export class PunchLogDto implements IPunchLogDto {
    id?: number | undefined;
    createdBy?: UserDetailDto | undefined;
    punchId?: number | undefined;
    entryDate?: Date | undefined;
    expectedClosingDate?: Date | undefined;
    isException?: boolean | undefined;
    closingResponsibleEntity?: string | undefined;
    commentary?: string | undefined;
    category?: CategoryDto | undefined;
    deparmentAction?: DepartmentActionDto | undefined;
    entryType?: EntryTypeDto | undefined;
    entryUser?: UserDetailDto | undefined;
    forecastClosingType?: ForecastClosingTypeDto | undefined;
    priority?: PriorityDto | undefined;
    remarkType?: RemarkTypesDto | undefined;
    punchRemark?: PunchRemarkDto | undefined;
    userGuest?: string | undefined;
    changes?: PunchLogChangeDto[] | undefined;
    subContractor?: SubcontractorDto | undefined;

    constructor(data?: IPunchLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"] ? UserDetailDto.fromJS(_data["createdBy"]) : undefined as any;
            this.punchId = _data["punchId"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : undefined as any;
            this.expectedClosingDate = _data["expectedClosingDate"] ? new Date(_data["expectedClosingDate"].toString()) : undefined as any;
            this.isException = _data["isException"];
            this.closingResponsibleEntity = _data["closingResponsibleEntity"];
            this.commentary = _data["commentary"];
            this.category = _data["category"] ? CategoryDto.fromJS(_data["category"]) : undefined as any;
            this.deparmentAction = _data["deparmentAction"] ? DepartmentActionDto.fromJS(_data["deparmentAction"]) : undefined as any;
            this.entryType = _data["entryType"] ? EntryTypeDto.fromJS(_data["entryType"]) : undefined as any;
            this.entryUser = _data["entryUser"] ? UserDetailDto.fromJS(_data["entryUser"]) : undefined as any;
            this.forecastClosingType = _data["forecastClosingType"] ? ForecastClosingTypeDto.fromJS(_data["forecastClosingType"]) : undefined as any;
            this.priority = _data["priority"] ? PriorityDto.fromJS(_data["priority"]) : undefined as any;
            this.remarkType = _data["remarkType"] ? RemarkTypesDto.fromJS(_data["remarkType"]) : undefined as any;
            this.punchRemark = _data["punchRemark"] ? PunchRemarkDto.fromJS(_data["punchRemark"]) : undefined as any;
            this.userGuest = _data["userGuest"];
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(PunchLogChangeDto.fromJS(item));
            }
            this.subContractor = _data["subContractor"] ? SubcontractorDto.fromJS(_data["subContractor"]) : undefined as any;
        }
    }

    static fromJS(data: any): PunchLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["punchId"] = this.punchId;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["expectedClosingDate"] = this.expectedClosingDate ? this.expectedClosingDate.toISOString() : undefined as any;
        data["isException"] = this.isException;
        data["closingResponsibleEntity"] = this.closingResponsibleEntity;
        data["commentary"] = this.commentary;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["deparmentAction"] = this.deparmentAction ? this.deparmentAction.toJSON() : undefined as any;
        data["entryType"] = this.entryType ? this.entryType.toJSON() : undefined as any;
        data["entryUser"] = this.entryUser ? this.entryUser.toJSON() : undefined as any;
        data["forecastClosingType"] = this.forecastClosingType ? this.forecastClosingType.toJSON() : undefined as any;
        data["priority"] = this.priority ? this.priority.toJSON() : undefined as any;
        data["remarkType"] = this.remarkType ? this.remarkType.toJSON() : undefined as any;
        data["punchRemark"] = this.punchRemark ? this.punchRemark.toJSON() : undefined as any;
        data["userGuest"] = this.userGuest;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item ? item.toJSON() : undefined as any);
        }
        data["subContractor"] = this.subContractor ? this.subContractor.toJSON() : undefined as any;
        return data;
    }
}

export interface IPunchLogDto {
    id?: number | undefined;
    createdBy?: UserDetailDto | undefined;
    punchId?: number | undefined;
    entryDate?: Date | undefined;
    expectedClosingDate?: Date | undefined;
    isException?: boolean | undefined;
    closingResponsibleEntity?: string | undefined;
    commentary?: string | undefined;
    category?: CategoryDto | undefined;
    deparmentAction?: DepartmentActionDto | undefined;
    entryType?: EntryTypeDto | undefined;
    entryUser?: UserDetailDto | undefined;
    forecastClosingType?: ForecastClosingTypeDto | undefined;
    priority?: PriorityDto | undefined;
    remarkType?: RemarkTypesDto | undefined;
    punchRemark?: PunchRemarkDto | undefined;
    userGuest?: string | undefined;
    changes?: PunchLogChangeDto[] | undefined;
    subContractor?: SubcontractorDto | undefined;
}

export class EntryTypeDto extends MasterDto implements IEntryTypeDto {
    color?: string | undefined;

    constructor(data?: IEntryTypeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.color = _data["color"];
        }
    }

    static override fromJS(data: any): EntryTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntryTypeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        super.toJSON(data);
        return data;
    }
}

export interface IEntryTypeDto extends IMasterDto {
    color?: string | undefined;
}

export class ForecastClosingTypeDto extends MasterDto implements IForecastClosingTypeDto {

    constructor(data?: IForecastClosingTypeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ForecastClosingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastClosingTypeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IForecastClosingTypeDto extends IMasterDto {
}

export class PriorityDto extends MasterDto implements IPriorityDto {

    constructor(data?: IPriorityDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PriorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPriorityDto extends IMasterDto {
}

export class RemarkTypesDto extends MasterDto implements IRemarkTypesDto {

    constructor(data?: IRemarkTypesDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RemarkTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemarkTypesDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRemarkTypesDto extends IMasterDto {
}

export class PunchLogChangeDto implements IPunchLogChangeDto {
    property?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IPunchLogChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): PunchLogChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchLogChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IPunchLogChangeDto {
    property?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class PunchTagsDto extends MasterDto implements IPunchTagsDto {
    tagsId?: number;
    punchId?: number;
    tags?: TagsDto | undefined;

    constructor(data?: IPunchTagsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tagsId = _data["tagsId"];
            this.punchId = _data["punchId"];
            this.tags = _data["tags"] ? TagsDto.fromJS(_data["tags"]) : undefined as any;
        }
    }

    static override fromJS(data: any): PunchTagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchTagsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagsId"] = this.tagsId;
        data["punchId"] = this.punchId;
        data["tags"] = this.tags ? this.tags.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPunchTagsDto extends IMasterDto {
    tagsId?: number;
    punchId?: number;
    tags?: TagsDto | undefined;
}

export class TagsDto extends MasterDto implements ITagsDto {

    constructor(data?: ITagsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITagsDto extends IMasterDto {
}

export class PunchCustomFieldDto extends MasterDto implements IPunchCustomFieldDto {
    punchId?: number | undefined;
    projectId?: number | undefined;
    value?: string | undefined;
    templatePunchCustomField?: TemplatePunchCustomFieldDto | undefined;
    main?: boolean;
    visible?: boolean | undefined;

    constructor(data?: IPunchCustomFieldDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.punchId = _data["punchId"];
            this.projectId = _data["projectId"];
            this.value = _data["value"];
            this.templatePunchCustomField = _data["templatePunchCustomField"] ? TemplatePunchCustomFieldDto.fromJS(_data["templatePunchCustomField"]) : undefined as any;
            this.main = _data["main"];
            this.visible = _data["visible"];
        }
    }

    static override fromJS(data: any): PunchCustomFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchCustomFieldDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchId"] = this.punchId;
        data["projectId"] = this.projectId;
        data["value"] = this.value;
        data["templatePunchCustomField"] = this.templatePunchCustomField ? this.templatePunchCustomField.toJSON() : undefined as any;
        data["main"] = this.main;
        data["visible"] = this.visible;
        super.toJSON(data);
        return data;
    }
}

export interface IPunchCustomFieldDto extends IMasterDto {
    punchId?: number | undefined;
    projectId?: number | undefined;
    value?: string | undefined;
    templatePunchCustomField?: TemplatePunchCustomFieldDto | undefined;
    main?: boolean;
    visible?: boolean | undefined;
}

export class InspectionDto implements IInspectionDto {
    id?: number | undefined;
    code?: string | undefined;
    name?: string | undefined;
    location?: string | undefined;
    information?: string | undefined;
    tracked?: boolean;
    schedule?: Date | undefined;
    expectedDate?: Date | undefined;
    createdAt?: Date | undefined;
    lastModifiedAt?: Date | undefined;
    inspectionType?: InspectionTypeDto | undefined;
    elements?: ElementsDto | undefined;
    inspectionState?: InspectionStateDto[] | undefined;
    inspectionMember?: InspectionMemberDto[] | undefined;
    inspectionMemberUnknown?: InspectionMemberUnknownDto[] | undefined;
    inspectionWalk?: InspectionWalkDto[] | undefined;
    inspectionFile?: InspectionFileDto[] | undefined;
    inspectionRemark?: InspectionRemarkDto[] | undefined;
    items?: ElementsDto[] | undefined;
    inspectionTags?: InspectionTagsDto[] | undefined;
    organizer?: UserDetailDto | undefined;

    constructor(data?: IInspectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.location = _data["location"];
            this.information = _data["information"];
            this.tracked = _data["tracked"];
            this.schedule = _data["schedule"] ? new Date(_data["schedule"].toString()) : undefined as any;
            this.expectedDate = _data["expectedDate"] ? new Date(_data["expectedDate"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.inspectionType = _data["inspectionType"] ? InspectionTypeDto.fromJS(_data["inspectionType"]) : undefined as any;
            this.elements = _data["elements"] ? ElementsDto.fromJS(_data["elements"]) : undefined as any;
            if (Array.isArray(_data["inspectionState"])) {
                this.inspectionState = [] as any;
                for (let item of _data["inspectionState"])
                    this.inspectionState!.push(InspectionStateDto.fromJS(item));
            }
            if (Array.isArray(_data["inspectionMember"])) {
                this.inspectionMember = [] as any;
                for (let item of _data["inspectionMember"])
                    this.inspectionMember!.push(InspectionMemberDto.fromJS(item));
            }
            if (Array.isArray(_data["inspectionMemberUnknown"])) {
                this.inspectionMemberUnknown = [] as any;
                for (let item of _data["inspectionMemberUnknown"])
                    this.inspectionMemberUnknown!.push(InspectionMemberUnknownDto.fromJS(item));
            }
            if (Array.isArray(_data["inspectionWalk"])) {
                this.inspectionWalk = [] as any;
                for (let item of _data["inspectionWalk"])
                    this.inspectionWalk!.push(InspectionWalkDto.fromJS(item));
            }
            if (Array.isArray(_data["inspectionFile"])) {
                this.inspectionFile = [] as any;
                for (let item of _data["inspectionFile"])
                    this.inspectionFile!.push(InspectionFileDto.fromJS(item));
            }
            if (Array.isArray(_data["inspectionRemark"])) {
                this.inspectionRemark = [] as any;
                for (let item of _data["inspectionRemark"])
                    this.inspectionRemark!.push(InspectionRemarkDto.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ElementsDto.fromJS(item));
            }
            if (Array.isArray(_data["inspectionTags"])) {
                this.inspectionTags = [] as any;
                for (let item of _data["inspectionTags"])
                    this.inspectionTags!.push(InspectionTagsDto.fromJS(item));
            }
            this.organizer = _data["organizer"] ? UserDetailDto.fromJS(_data["organizer"]) : undefined as any;
        }
    }

    static fromJS(data: any): InspectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["location"] = this.location;
        data["information"] = this.information;
        data["tracked"] = this.tracked;
        data["schedule"] = this.schedule ? this.schedule.toISOString() : undefined as any;
        data["expectedDate"] = this.expectedDate ? this.expectedDate.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["inspectionType"] = this.inspectionType ? this.inspectionType.toJSON() : undefined as any;
        data["elements"] = this.elements ? this.elements.toJSON() : undefined as any;
        if (Array.isArray(this.inspectionState)) {
            data["inspectionState"] = [];
            for (let item of this.inspectionState)
                data["inspectionState"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionMember)) {
            data["inspectionMember"] = [];
            for (let item of this.inspectionMember)
                data["inspectionMember"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionMemberUnknown)) {
            data["inspectionMemberUnknown"] = [];
            for (let item of this.inspectionMemberUnknown)
                data["inspectionMemberUnknown"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionWalk)) {
            data["inspectionWalk"] = [];
            for (let item of this.inspectionWalk)
                data["inspectionWalk"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionFile)) {
            data["inspectionFile"] = [];
            for (let item of this.inspectionFile)
                data["inspectionFile"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionRemark)) {
            data["inspectionRemark"] = [];
            for (let item of this.inspectionRemark)
                data["inspectionRemark"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionTags)) {
            data["inspectionTags"] = [];
            for (let item of this.inspectionTags)
                data["inspectionTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["organizer"] = this.organizer ? this.organizer.toJSON() : undefined as any;
        return data;
    }
}

export interface IInspectionDto {
    id?: number | undefined;
    code?: string | undefined;
    name?: string | undefined;
    location?: string | undefined;
    information?: string | undefined;
    tracked?: boolean;
    schedule?: Date | undefined;
    expectedDate?: Date | undefined;
    createdAt?: Date | undefined;
    lastModifiedAt?: Date | undefined;
    inspectionType?: InspectionTypeDto | undefined;
    elements?: ElementsDto | undefined;
    inspectionState?: InspectionStateDto[] | undefined;
    inspectionMember?: InspectionMemberDto[] | undefined;
    inspectionMemberUnknown?: InspectionMemberUnknownDto[] | undefined;
    inspectionWalk?: InspectionWalkDto[] | undefined;
    inspectionFile?: InspectionFileDto[] | undefined;
    inspectionRemark?: InspectionRemarkDto[] | undefined;
    items?: ElementsDto[] | undefined;
    inspectionTags?: InspectionTagsDto[] | undefined;
    organizer?: UserDetailDto | undefined;
}

export class InspectionStateDto implements IInspectionStateDto {
    inspectionStatus?: InspectionStatusDto | undefined;
    createdAt?: Date;

    constructor(data?: IInspectionStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionStatus = _data["inspectionStatus"] ? InspectionStatusDto.fromJS(_data["inspectionStatus"]) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InspectionStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionStatus"] = this.inspectionStatus ? this.inspectionStatus.toJSON() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IInspectionStateDto {
    inspectionStatus?: InspectionStatusDto | undefined;
    createdAt?: Date;
}

export class InspectionMemberDto implements IInspectionMemberDto {
    id?: number;
    memberStatus?: MemberStatusDto | undefined;
    invitationStatus?: InvitationStatusDto | undefined;
    user?: UserDetailProjectTemplateDto | undefined;
    confirmed?: boolean;

    constructor(data?: IInspectionMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberStatus = _data["memberStatus"] ? MemberStatusDto.fromJS(_data["memberStatus"]) : undefined as any;
            this.invitationStatus = _data["invitationStatus"] ? InvitationStatusDto.fromJS(_data["invitationStatus"]) : undefined as any;
            this.user = _data["user"] ? UserDetailProjectTemplateDto.fromJS(_data["user"]) : undefined as any;
            this.confirmed = _data["confirmed"];
        }
    }

    static fromJS(data: any): InspectionMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberStatus"] = this.memberStatus ? this.memberStatus.toJSON() : undefined as any;
        data["invitationStatus"] = this.invitationStatus ? this.invitationStatus.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["confirmed"] = this.confirmed;
        return data;
    }
}

export interface IInspectionMemberDto {
    id?: number;
    memberStatus?: MemberStatusDto | undefined;
    invitationStatus?: InvitationStatusDto | undefined;
    user?: UserDetailProjectTemplateDto | undefined;
    confirmed?: boolean;
}

export class MemberStatusDto extends MasterDto implements IMemberStatusDto {

    constructor(data?: IMemberStatusDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MemberStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberStatusDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMemberStatusDto extends IMasterDto {
}

export class InvitationStatusDto extends MasterDto implements IInvitationStatusDto {
    color?: string | undefined;

    constructor(data?: IInvitationStatusDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.color = _data["color"];
        }
    }

    static override fromJS(data: any): InvitationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvitationStatusDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        super.toJSON(data);
        return data;
    }
}

export interface IInvitationStatusDto extends IMasterDto {
    color?: string | undefined;
}

export class InspectionMemberUnknownDto implements IInspectionMemberUnknownDto {
    id?: number;
    userName?: string | undefined;
    consolidated?: boolean;
    discarded?: boolean;

    constructor(data?: IInspectionMemberUnknownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.consolidated = _data["consolidated"];
            this.discarded = _data["discarded"];
        }
    }

    static fromJS(data: any): InspectionMemberUnknownDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionMemberUnknownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["consolidated"] = this.consolidated;
        data["discarded"] = this.discarded;
        return data;
    }
}

export interface IInspectionMemberUnknownDto {
    id?: number;
    userName?: string | undefined;
    consolidated?: boolean;
    discarded?: boolean;
}

export class InspectionFileDto implements IInspectionFileDto {
    id?: number | undefined;
    mimeType?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    imageFileServer?: string | undefined;
    file?: string | undefined;
    default?: boolean;
    defaultDownload?: boolean;
    documentType?: MasterDto | undefined;
    lastModifiedAt?: Date | undefined;
    createdAt?: Date | undefined;
    size?: number;

    constructor(data?: IInspectionFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mimeType = _data["mimeType"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.imageFileServer = _data["imageFileServer"];
            this.file = _data["file"];
            this.default = _data["default"];
            this.defaultDownload = _data["defaultDownload"];
            this.documentType = _data["documentType"] ? MasterDto.fromJS(_data["documentType"]) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): InspectionFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mimeType"] = this.mimeType;
        data["name"] = this.name;
        data["description"] = this.description;
        data["imageFileServer"] = this.imageFileServer;
        data["file"] = this.file;
        data["default"] = this.default;
        data["defaultDownload"] = this.defaultDownload;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["size"] = this.size;
        return data;
    }
}

export interface IInspectionFileDto {
    id?: number | undefined;
    mimeType?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    imageFileServer?: string | undefined;
    file?: string | undefined;
    default?: boolean;
    defaultDownload?: boolean;
    documentType?: MasterDto | undefined;
    lastModifiedAt?: Date | undefined;
    createdAt?: Date | undefined;
    size?: number;
}

export class InspectionRemarkDto implements IInspectionRemarkDto {
    remark?: string | undefined;
    userName?: string | undefined;
    remarkType?: RemarkTypesDto | undefined;
    lastModifiedAt?: Date | undefined;
    createdAt?: Date | undefined;

    constructor(data?: IInspectionRemarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remark = _data["remark"];
            this.userName = _data["userName"];
            this.remarkType = _data["remarkType"] ? RemarkTypesDto.fromJS(_data["remarkType"]) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InspectionRemarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionRemarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remark"] = this.remark;
        data["userName"] = this.userName;
        data["remarkType"] = this.remarkType ? this.remarkType.toJSON() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IInspectionRemarkDto {
    remark?: string | undefined;
    userName?: string | undefined;
    remarkType?: RemarkTypesDto | undefined;
    lastModifiedAt?: Date | undefined;
    createdAt?: Date | undefined;
}

export class InspectionTagsDto extends MasterDto implements IInspectionTagsDto {
    tagsId?: number;
    inspectionId?: number;
    tags?: TagsDto | undefined;

    constructor(data?: IInspectionTagsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tagsId = _data["tagsId"];
            this.inspectionId = _data["inspectionId"];
            this.tags = _data["tags"] ? TagsDto.fromJS(_data["tags"]) : undefined as any;
        }
    }

    static override fromJS(data: any): InspectionTagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTagsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagsId"] = this.tagsId;
        data["inspectionId"] = this.inspectionId;
        data["tags"] = this.tags ? this.tags.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionTagsDto extends IMasterDto {
    tagsId?: number;
    inspectionId?: number;
    tags?: TagsDto | undefined;
}

export class PunchStageDto implements IPunchStageDto {
    id?: number | undefined;
    punchId?: number;
    done?: boolean | undefined;
    reject?: boolean | undefined;
    rejectCount?: number;
    overridden?: boolean | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    doneById?: string | undefined;
    doneByUser?: UserDetailDto | undefined;
    doneAt?: Date | undefined;
    lastModifiedAt?: Date;
    assignedTo?: UserDetailDto | undefined;
    inspectionTypeFlowSign?: InspectionTypeFlowSignDto | undefined;
    isSignable?: boolean;
    isRejectable?: boolean;
    isDisputable?: boolean;
    isHoldable?: boolean;
    isOverridable?: boolean;
    statusStage?: PunchStageStatusDto | undefined;
    punchRemark?: PunchRemarkDto[] | undefined;
    sign?: PunchSignatureDto | undefined;
    comment?: string | undefined;

    constructor(data?: IPunchStageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.punchId = _data["punchId"];
            this.done = _data["done"];
            this.reject = _data["reject"];
            this.rejectCount = _data["rejectCount"];
            this.overridden = _data["overridden"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.doneById = _data["doneById"];
            this.doneByUser = _data["doneByUser"] ? UserDetailDto.fromJS(_data["doneByUser"]) : undefined as any;
            this.doneAt = _data["doneAt"] ? new Date(_data["doneAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.assignedTo = _data["assignedTo"] ? UserDetailDto.fromJS(_data["assignedTo"]) : undefined as any;
            this.inspectionTypeFlowSign = _data["inspectionTypeFlowSign"] ? InspectionTypeFlowSignDto.fromJS(_data["inspectionTypeFlowSign"]) : undefined as any;
            this.isSignable = _data["isSignable"];
            this.isRejectable = _data["isRejectable"];
            this.isDisputable = _data["isDisputable"];
            this.isHoldable = _data["isHoldable"];
            this.isOverridable = _data["isOverridable"];
            this.statusStage = _data["statusStage"] ? PunchStageStatusDto.fromJS(_data["statusStage"]) : undefined as any;
            if (Array.isArray(_data["punchRemark"])) {
                this.punchRemark = [] as any;
                for (let item of _data["punchRemark"])
                    this.punchRemark!.push(PunchRemarkDto.fromJS(item));
            }
            this.sign = _data["sign"] ? PunchSignatureDto.fromJS(_data["sign"]) : undefined as any;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): PunchStageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchStageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["punchId"] = this.punchId;
        data["done"] = this.done;
        data["reject"] = this.reject;
        data["rejectCount"] = this.rejectCount;
        data["overridden"] = this.overridden;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["doneById"] = this.doneById;
        data["doneByUser"] = this.doneByUser ? this.doneByUser.toJSON() : undefined as any;
        data["doneAt"] = this.doneAt ? this.doneAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["assignedTo"] = this.assignedTo ? this.assignedTo.toJSON() : undefined as any;
        data["inspectionTypeFlowSign"] = this.inspectionTypeFlowSign ? this.inspectionTypeFlowSign.toJSON() : undefined as any;
        data["isSignable"] = this.isSignable;
        data["isRejectable"] = this.isRejectable;
        data["isDisputable"] = this.isDisputable;
        data["isHoldable"] = this.isHoldable;
        data["isOverridable"] = this.isOverridable;
        data["statusStage"] = this.statusStage ? this.statusStage.toJSON() : undefined as any;
        if (Array.isArray(this.punchRemark)) {
            data["punchRemark"] = [];
            for (let item of this.punchRemark)
                data["punchRemark"].push(item ? item.toJSON() : undefined as any);
        }
        data["sign"] = this.sign ? this.sign.toJSON() : undefined as any;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IPunchStageDto {
    id?: number | undefined;
    punchId?: number;
    done?: boolean | undefined;
    reject?: boolean | undefined;
    rejectCount?: number;
    overridden?: boolean | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    doneById?: string | undefined;
    doneByUser?: UserDetailDto | undefined;
    doneAt?: Date | undefined;
    lastModifiedAt?: Date;
    assignedTo?: UserDetailDto | undefined;
    inspectionTypeFlowSign?: InspectionTypeFlowSignDto | undefined;
    isSignable?: boolean;
    isRejectable?: boolean;
    isDisputable?: boolean;
    isHoldable?: boolean;
    isOverridable?: boolean;
    statusStage?: PunchStageStatusDto | undefined;
    punchRemark?: PunchRemarkDto[] | undefined;
    sign?: PunchSignatureDto | undefined;
    comment?: string | undefined;
}

export class PunchStageStatusDto implements IPunchStageStatusDto {
    code?: string | undefined;
    color?: string | undefined;

    constructor(data?: IPunchStageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): PunchStageStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchStageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["color"] = this.color;
        return data;
    }
}

export interface IPunchStageStatusDto {
    code?: string | undefined;
    color?: string | undefined;
}

export class PunchSignatureDto implements IPunchSignatureDto {
    punchId?: number | undefined;
    sign?: string | undefined;
    information?: string | undefined;
    date?: Date;
    remark?: PunchRemarkDto | undefined;

    constructor(data?: IPunchSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchId = _data["punchId"];
            this.sign = _data["sign"];
            this.information = _data["information"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.remark = _data["remark"] ? PunchRemarkDto.fromJS(_data["remark"]) : undefined as any;
        }
    }

    static fromJS(data: any): PunchSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchId"] = this.punchId;
        data["sign"] = this.sign;
        data["information"] = this.information;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["remark"] = this.remark ? this.remark.toJSON() : undefined as any;
        return data;
    }
}

export interface IPunchSignatureDto {
    punchId?: number | undefined;
    sign?: string | undefined;
    information?: string | undefined;
    date?: Date;
    remark?: PunchRemarkDto | undefined;
}

export class LocationProjectDto implements ILocationProjectDto {
    id?: number | undefined;
    name?: string | undefined;
    locationTypeId?: number;
    locationTypeName?: string | undefined;
    projectId?: number;

    constructor(data?: ILocationProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locationTypeId = _data["locationTypeId"];
            this.locationTypeName = _data["locationTypeName"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): LocationProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationTypeId"] = this.locationTypeId;
        data["locationTypeName"] = this.locationTypeName;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ILocationProjectDto {
    id?: number | undefined;
    name?: string | undefined;
    locationTypeId?: number;
    locationTypeName?: string | undefined;
    projectId?: number;
}

export class AttachmentDto implements IAttachmentDto {
    information?: string | undefined;
    mimeType?: string | undefined;
    realNameFile?: string | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.information = _data["information"];
            this.mimeType = _data["mimeType"];
            this.realNameFile = _data["realNameFile"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["information"] = this.information;
        data["mimeType"] = this.mimeType;
        data["realNameFile"] = this.realNameFile;
        return data;
    }
}

export interface IAttachmentDto {
    information?: string | undefined;
    mimeType?: string | undefined;
    realNameFile?: string | undefined;
}

export class PunchBulkSignatureViewModel implements IPunchBulkSignatureViewModel {
    role?: string | undefined;
    punchIds?: number[] | undefined;
    sign?: string | undefined;
    information?: string | undefined;
    remark?: PunchRemarkViewModel | undefined;

    constructor(data?: IPunchBulkSignatureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            if (Array.isArray(_data["punchIds"])) {
                this.punchIds = [] as any;
                for (let item of _data["punchIds"])
                    this.punchIds!.push(item);
            }
            this.sign = _data["sign"];
            this.information = _data["information"];
            this.remark = _data["remark"] ? PunchRemarkViewModel.fromJS(_data["remark"]) : undefined as any;
        }
    }

    static fromJS(data: any): PunchBulkSignatureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBulkSignatureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        if (Array.isArray(this.punchIds)) {
            data["punchIds"] = [];
            for (let item of this.punchIds)
                data["punchIds"].push(item);
        }
        data["sign"] = this.sign;
        data["information"] = this.information;
        data["remark"] = this.remark ? this.remark.toJSON() : undefined as any;
        return data;
    }
}

export interface IPunchBulkSignatureViewModel {
    role?: string | undefined;
    punchIds?: number[] | undefined;
    sign?: string | undefined;
    information?: string | undefined;
    remark?: PunchRemarkViewModel | undefined;
}

export class PunchBulkSignatureDto implements IPunchBulkSignatureDto {
    role?: string | undefined;
    punchIds?: number[] | undefined;
    sign?: string | undefined;
    date?: Date | undefined;
    remark?: PunchRemarkDto | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IPunchBulkSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            if (Array.isArray(_data["punchIds"])) {
                this.punchIds = [] as any;
                for (let item of _data["punchIds"])
                    this.punchIds!.push(item);
            }
            this.sign = _data["sign"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.remark = _data["remark"] ? PunchRemarkDto.fromJS(_data["remark"]) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchBulkSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBulkSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        if (Array.isArray(this.punchIds)) {
            data["punchIds"] = [];
            for (let item of this.punchIds)
                data["punchIds"].push(item);
        }
        data["sign"] = this.sign;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["remark"] = this.remark ? this.remark.toJSON() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchBulkSignatureDto {
    role?: string | undefined;
    punchIds?: number[] | undefined;
    sign?: string | undefined;
    date?: Date | undefined;
    remark?: PunchRemarkDto | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export class PunchTransferViewModel implements IPunchTransferViewModel {
    inspectionId?: number;
    categories?: CategoryViewModel[] | undefined;
    topics?: TopicViewModel[] | undefined;
    punches?: PunchViewModel[] | undefined;

    constructor(data?: IPunchTransferViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoryViewModel.fromJS(item));
            }
            if (Array.isArray(_data["topics"])) {
                this.topics = [] as any;
                for (let item of _data["topics"])
                    this.topics!.push(TopicViewModel.fromJS(item));
            }
            if (Array.isArray(_data["punches"])) {
                this.punches = [] as any;
                for (let item of _data["punches"])
                    this.punches!.push(PunchViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchTransferViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchTransferViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punches)) {
            data["punches"] = [];
            for (let item of this.punches)
                data["punches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchTransferViewModel {
    inspectionId?: number;
    categories?: CategoryViewModel[] | undefined;
    topics?: TopicViewModel[] | undefined;
    punches?: PunchViewModel[] | undefined;
}

export class PunchAvailableColumnViewModel implements IPunchAvailableColumnViewModel {
    columnName?: string | undefined;
    propertyName?: string | undefined;
    dataType?: AvailableTypesEnum;
    isCustomField?: boolean;

    constructor(data?: IPunchAvailableColumnViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.propertyName = _data["propertyName"];
            this.dataType = _data["dataType"];
            this.isCustomField = _data["isCustomField"];
        }
    }

    static fromJS(data: any): PunchAvailableColumnViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchAvailableColumnViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["propertyName"] = this.propertyName;
        data["dataType"] = this.dataType;
        data["isCustomField"] = this.isCustomField;
        return data;
    }
}

export interface IPunchAvailableColumnViewModel {
    columnName?: string | undefined;
    propertyName?: string | undefined;
    dataType?: AvailableTypesEnum;
    isCustomField?: boolean;
}

export class DocumentForListViewModel implements IDocumentForListViewModel {
    processId?: number;
    fileName?: string | undefined;
    status?: MasterViewModel | undefined;
    pagesCount?: number | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    createdAt?: Date;
    mediaId?: number | undefined;

    constructor(data?: IDocumentForListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processId = _data["processId"];
            this.fileName = _data["fileName"];
            this.status = _data["status"] ? MasterViewModel.fromJS(_data["status"]) : undefined as any;
            this.pagesCount = _data["pagesCount"];
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.mediaId = _data["mediaId"];
        }
    }

    static fromJS(data: any): DocumentForListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentForListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processId"] = this.processId;
        data["fileName"] = this.fileName;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["pagesCount"] = this.pagesCount;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["mediaId"] = this.mediaId;
        return data;
    }
}

export interface IDocumentForListViewModel {
    processId?: number;
    fileName?: string | undefined;
    status?: MasterViewModel | undefined;
    pagesCount?: number | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    createdAt?: Date;
    mediaId?: number | undefined;
}

export class SignedPunchesExecuteGenerationViewModel implements ISignedPunchesExecuteGenerationViewModel {
    signedPunches?: PunchWithSignsViewModel[] | undefined;

    constructor(data?: ISignedPunchesExecuteGenerationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["signedPunches"])) {
                this.signedPunches = [] as any;
                for (let item of _data["signedPunches"])
                    this.signedPunches!.push(PunchWithSignsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignedPunchesExecuteGenerationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SignedPunchesExecuteGenerationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.signedPunches)) {
            data["signedPunches"] = [];
            for (let item of this.signedPunches)
                data["signedPunches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISignedPunchesExecuteGenerationViewModel {
    signedPunches?: PunchWithSignsViewModel[] | undefined;
}

export class PunchWithSignsViewModel implements IPunchWithSignsViewModel {
    punchId?: number;
    signs?: SignViewModel[] | undefined;
    pages?: number[] | undefined;

    constructor(data?: IPunchWithSignsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchId = _data["punchId"];
            if (Array.isArray(_data["signs"])) {
                this.signs = [] as any;
                for (let item of _data["signs"])
                    this.signs!.push(SignViewModel.fromJS(item));
            }
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(item);
            }
        }
    }

    static fromJS(data: any): PunchWithSignsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchWithSignsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchId"] = this.punchId;
        if (Array.isArray(this.signs)) {
            data["signs"] = [];
            for (let item of this.signs)
                data["signs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item);
        }
        return data;
    }
}

export interface IPunchWithSignsViewModel {
    punchId?: number;
    signs?: SignViewModel[] | undefined;
    pages?: number[] | undefined;
}

export class SignViewModel implements ISignViewModel {
    role?: string | undefined;
    sequence?: number;
    signDate?: Date;
    userId?: string | undefined;

    constructor(data?: ISignViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.sequence = _data["sequence"];
            this.signDate = _data["signDate"] ? new Date(_data["signDate"].toString()) : undefined as any;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): SignViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SignViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["sequence"] = this.sequence;
        data["signDate"] = this.signDate ? this.signDate.toISOString() : undefined as any;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ISignViewModel {
    role?: string | undefined;
    sequence?: number;
    signDate?: Date;
    userId?: string | undefined;
}

export class SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel implements ISignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel {
    processId?: number;
    mediaId?: number;
    previewResult?: SignedPunchesDetailPreviewViewModel | undefined;

    constructor(data?: ISignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processId = _data["processId"];
            this.mediaId = _data["mediaId"];
            this.previewResult = _data["previewResult"] ? SignedPunchesDetailPreviewViewModel.fromJS(_data["previewResult"]) : undefined as any;
        }
    }

    static fromJS(data: any): SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processId"] = this.processId;
        data["mediaId"] = this.mediaId;
        data["previewResult"] = this.previewResult ? this.previewResult.toJSON() : undefined as any;
        return data;
    }
}

export interface ISignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel {
    processId?: number;
    mediaId?: number;
    previewResult?: SignedPunchesDetailPreviewViewModel | undefined;
}

export class SignedPunchesDetailPreviewViewModel implements ISignedPunchesDetailPreviewViewModel {
    punchesWithPages?: PunchWithPagesViewModel[] | undefined;

    constructor(data?: ISignedPunchesDetailPreviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["punchesWithPages"])) {
                this.punchesWithPages = [] as any;
                for (let item of _data["punchesWithPages"])
                    this.punchesWithPages!.push(PunchWithPagesViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignedPunchesDetailPreviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SignedPunchesDetailPreviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.punchesWithPages)) {
            data["punchesWithPages"] = [];
            for (let item of this.punchesWithPages)
                data["punchesWithPages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISignedPunchesDetailPreviewViewModel {
    punchesWithPages?: PunchWithPagesViewModel[] | undefined;
}

export class PunchWithPagesViewModel implements IPunchWithPagesViewModel {
    punchId?: number;
    punchCode?: string | undefined;
    pages?: number[] | undefined;
    discard?: boolean;

    constructor(data?: IPunchWithPagesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchId = _data["punchId"];
            this.punchCode = _data["punchCode"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(item);
            }
            this.discard = _data["discard"];
        }
    }

    static fromJS(data: any): PunchWithPagesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchWithPagesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchId"] = this.punchId;
        data["punchCode"] = this.punchCode;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item);
        }
        data["discard"] = this.discard;
        return data;
    }
}

export interface IPunchWithPagesViewModel {
    punchId?: number;
    punchCode?: string | undefined;
    pages?: number[] | undefined;
    discard?: boolean;
}

export class GroupedPunchesByRolesViewModel implements IGroupedPunchesByRolesViewModel {
    allInspectionFlowRoles?: string[] | undefined;
    punchesByRole?: PunchesToSignViewModel[] | undefined;
    mediaId?: number;

    constructor(data?: IGroupedPunchesByRolesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allInspectionFlowRoles"])) {
                this.allInspectionFlowRoles = [] as any;
                for (let item of _data["allInspectionFlowRoles"])
                    this.allInspectionFlowRoles!.push(item);
            }
            if (Array.isArray(_data["punchesByRole"])) {
                this.punchesByRole = [] as any;
                for (let item of _data["punchesByRole"])
                    this.punchesByRole!.push(PunchesToSignViewModel.fromJS(item));
            }
            this.mediaId = _data["mediaId"];
        }
    }

    static fromJS(data: any): GroupedPunchesByRolesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedPunchesByRolesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allInspectionFlowRoles)) {
            data["allInspectionFlowRoles"] = [];
            for (let item of this.allInspectionFlowRoles)
                data["allInspectionFlowRoles"].push(item);
        }
        if (Array.isArray(this.punchesByRole)) {
            data["punchesByRole"] = [];
            for (let item of this.punchesByRole)
                data["punchesByRole"].push(item ? item.toJSON() : undefined as any);
        }
        data["mediaId"] = this.mediaId;
        return data;
    }
}

export interface IGroupedPunchesByRolesViewModel {
    allInspectionFlowRoles?: string[] | undefined;
    punchesByRole?: PunchesToSignViewModel[] | undefined;
    mediaId?: number;
}

export class PunchesToSignViewModel implements IPunchesToSignViewModel {
    inspectionFlowRoles?: MasterViewModel[] | undefined;
    punches?: PunchWithInspectionTypeViewModel[] | undefined;

    constructor(data?: IPunchesToSignViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["inspectionFlowRoles"])) {
                this.inspectionFlowRoles = [] as any;
                for (let item of _data["inspectionFlowRoles"])
                    this.inspectionFlowRoles!.push(MasterViewModel.fromJS(item));
            }
            if (Array.isArray(_data["punches"])) {
                this.punches = [] as any;
                for (let item of _data["punches"])
                    this.punches!.push(PunchWithInspectionTypeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchesToSignViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchesToSignViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.inspectionFlowRoles)) {
            data["inspectionFlowRoles"] = [];
            for (let item of this.inspectionFlowRoles)
                data["inspectionFlowRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punches)) {
            data["punches"] = [];
            for (let item of this.punches)
                data["punches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchesToSignViewModel {
    inspectionFlowRoles?: MasterViewModel[] | undefined;
    punches?: PunchWithInspectionTypeViewModel[] | undefined;
}

export class PunchWithInspectionTypeViewModel implements IPunchWithInspectionTypeViewModel {
    id?: number;
    code?: string | undefined;
    inspectionTypeId?: number;
    pages?: number[] | undefined;
    rolesAlreadySigned?: PunchSignViewModel[] | undefined;

    constructor(data?: IPunchWithInspectionTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.inspectionTypeId = _data["inspectionTypeId"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(item);
            }
            if (Array.isArray(_data["rolesAlreadySigned"])) {
                this.rolesAlreadySigned = [] as any;
                for (let item of _data["rolesAlreadySigned"])
                    this.rolesAlreadySigned!.push(PunchSignViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchWithInspectionTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchWithInspectionTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["inspectionTypeId"] = this.inspectionTypeId;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item);
        }
        if (Array.isArray(this.rolesAlreadySigned)) {
            data["rolesAlreadySigned"] = [];
            for (let item of this.rolesAlreadySigned)
                data["rolesAlreadySigned"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchWithInspectionTypeViewModel {
    id?: number;
    code?: string | undefined;
    inspectionTypeId?: number;
    pages?: number[] | undefined;
    rolesAlreadySigned?: PunchSignViewModel[] | undefined;
}

export class PunchSignViewModel implements IPunchSignViewModel {
    role?: string | undefined;
    sequence?: number;
    signDate?: Date | undefined;
    userName?: string | undefined;

    constructor(data?: IPunchSignViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.sequence = _data["sequence"];
            this.signDate = _data["signDate"] ? new Date(_data["signDate"].toString()) : undefined as any;
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): PunchSignViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchSignViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["sequence"] = this.sequence;
        data["signDate"] = this.signDate ? this.signDate.toISOString() : undefined as any;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IPunchSignViewModel {
    role?: string | undefined;
    sequence?: number;
    signDate?: Date | undefined;
    userName?: string | undefined;
}

export class FileChunkViewModel implements IFileChunkViewModel {
    total?: number;
    fileName?: string | undefined;

    constructor(data?: IFileChunkViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): FileChunkViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileChunkViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IFileChunkViewModel {
    total?: number;
    fileName?: string | undefined;
}

export class TemplateProjectDownloadViewModel implements ITemplateProjectDownloadViewModel {
    id?: number;
    requestUser?: string | undefined;
    requestDate?: Date;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    generationStatus?: MasterDto | undefined;
    type?: MasterDto | undefined;
    name?: string | undefined;
    isFiltered?: boolean;
    templateProjectId?: number;
    errorDescription?: string | undefined;

    constructor(data?: ITemplateProjectDownloadViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestUser = _data["requestUser"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.generationStatus = _data["generationStatus"] ? MasterDto.fromJS(_data["generationStatus"]) : undefined as any;
            this.type = _data["type"] ? MasterDto.fromJS(_data["type"]) : undefined as any;
            this.name = _data["name"];
            this.isFiltered = _data["isFiltered"];
            this.templateProjectId = _data["templateProjectId"];
            this.errorDescription = _data["errorDescription"];
        }
    }

    static fromJS(data: any): TemplateProjectDownloadViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateProjectDownloadViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestUser"] = this.requestUser;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["generationStatus"] = this.generationStatus ? this.generationStatus.toJSON() : undefined as any;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["name"] = this.name;
        data["isFiltered"] = this.isFiltered;
        data["templateProjectId"] = this.templateProjectId;
        data["errorDescription"] = this.errorDescription;
        return data;
    }
}

export interface ITemplateProjectDownloadViewModel {
    id?: number;
    requestUser?: string | undefined;
    requestDate?: Date;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    generationStatus?: MasterDto | undefined;
    type?: MasterDto | undefined;
    name?: string | undefined;
    isFiltered?: boolean;
    templateProjectId?: number;
    errorDescription?: string | undefined;
}

export class ProcessViewModel implements IProcessViewModel {
    id?: number;
    processType?: MasterViewModel | undefined;
    status?: MasterViewModel | undefined;
    createdBy?: string | undefined;
    createdUserName?: string | undefined;
    enqueueDate?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    projectId?: number | undefined;
    projectCode?: string | undefined;
    templateId?: number | undefined;
    templateCode?: string | undefined;
    error?: string | undefined;
    isFiltered?: boolean;

    constructor(data?: IProcessViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processType = _data["processType"] ? MasterViewModel.fromJS(_data["processType"]) : undefined as any;
            this.status = _data["status"] ? MasterViewModel.fromJS(_data["status"]) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdUserName = _data["createdUserName"];
            this.enqueueDate = _data["enqueueDate"] ? new Date(_data["enqueueDate"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.projectId = _data["projectId"];
            this.projectCode = _data["projectCode"];
            this.templateId = _data["templateId"];
            this.templateCode = _data["templateCode"];
            this.error = _data["error"];
            this.isFiltered = _data["isFiltered"];
        }
    }

    static fromJS(data: any): ProcessViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processType"] = this.processType ? this.processType.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["createdUserName"] = this.createdUserName;
        data["enqueueDate"] = this.enqueueDate ? this.enqueueDate.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["projectId"] = this.projectId;
        data["projectCode"] = this.projectCode;
        data["templateId"] = this.templateId;
        data["templateCode"] = this.templateCode;
        data["error"] = this.error;
        data["isFiltered"] = this.isFiltered;
        return data;
    }
}

export interface IProcessViewModel {
    id?: number;
    processType?: MasterViewModel | undefined;
    status?: MasterViewModel | undefined;
    createdBy?: string | undefined;
    createdUserName?: string | undefined;
    enqueueDate?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    projectId?: number | undefined;
    projectCode?: string | undefined;
    templateId?: number | undefined;
    templateCode?: string | undefined;
    error?: string | undefined;
    isFiltered?: boolean;
}

export class DataSourceRequest implements IDataSourceRequest {
    page?: number;
    pageSize?: number;
    sorts?: SortDescriptor[] | undefined;
    filters?: FilterDescriptor[] | undefined;
    advancedFilter?: AdvancedFilterDescriptor[] | undefined;

    constructor(data?: IDataSourceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["sorts"])) {
                this.sorts = [] as any;
                for (let item of _data["sorts"])
                    this.sorts!.push(SortDescriptor.fromJS(item));
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterDescriptor.fromJS(item));
            }
            if (Array.isArray(_data["advancedFilter"])) {
                this.advancedFilter = [] as any;
                for (let item of _data["advancedFilter"])
                    this.advancedFilter!.push(AdvancedFilterDescriptor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataSourceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DataSourceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.sorts)) {
            data["sorts"] = [];
            for (let item of this.sorts)
                data["sorts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.advancedFilter)) {
            data["advancedFilter"] = [];
            for (let item of this.advancedFilter)
                data["advancedFilter"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataSourceRequest {
    page?: number;
    pageSize?: number;
    sorts?: SortDescriptor[] | undefined;
    filters?: FilterDescriptor[] | undefined;
    advancedFilter?: AdvancedFilterDescriptor[] | undefined;
}

export class SortDescriptor implements ISortDescriptor {
    member?: string | undefined;
    sortDirection?: SortDirection;

    constructor(data?: ISortDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.member = _data["member"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): SortDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new SortDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["member"] = this.member;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface ISortDescriptor {
    member?: string | undefined;
    sortDirection?: SortDirection;
}

export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}

export class FilterDescriptor implements IFilterDescriptor {
    member?: string | undefined;
    value?: any | undefined;
    filterType?: FilterType;
    condition?: ConditionType;

    constructor(data?: IFilterDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.member = _data["member"];
            this.value = _data["value"];
            this.filterType = _data["filterType"];
            this.condition = _data["condition"];
        }
    }

    static fromJS(data: any): FilterDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["member"] = this.member;
        data["value"] = this.value;
        data["filterType"] = this.filterType;
        data["condition"] = this.condition;
        return data;
    }
}

export interface IFilterDescriptor {
    member?: string | undefined;
    value?: any | undefined;
    filterType?: FilterType;
    condition?: ConditionType;
}

export enum FilterType {
    Contains = 1,
    Equals = 2,
    NotEquals = 3,
    NotContains = 4,
    StartWith = 5,
    EndWith = 6,
    IsNull = 7,
    IsNotNull = 8,
    IsEmpty = 9,
    IsNotEmpty = 10,
    Greater = 11,
    Less = 12,
    GreaterOrEqual = 13,
    LessOrEqual = 14,
}

export enum ConditionType {
    And = 0,
    Or = 1,
    None = 2,
}

export class AdvancedFilterDescriptor implements IAdvancedFilterDescriptor {
    filters?: FilterDescriptor[] | undefined;
    condition?: ConditionType;

    constructor(data?: IAdvancedFilterDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterDescriptor.fromJS(item));
            }
            this.condition = _data["condition"];
        }
    }

    static fromJS(data: any): AdvancedFilterDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedFilterDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        data["condition"] = this.condition;
        return data;
    }
}

export interface IAdvancedFilterDescriptor {
    filters?: FilterDescriptor[] | undefined;
    condition?: ConditionType;
}

export class ProcessDto implements IProcessDto {
    id?: number;
    priority?: number;
    inputData?: string | undefined;
    outputData?: string | undefined;
    processType?: ProcessType;
    status?: ProcessStatus;
    createdBy?: string | undefined;
    createdUserName?: string | undefined;
    enqueueDate?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    projectId?: number | undefined;
    projectCode?: string | undefined;
    templateId?: number | undefined;
    templateCode?: string | undefined;
    error?: string | undefined;
    hangfireQueueName?: HanfireQueuesName | undefined;
    hangfireId?: string | undefined;
    isFiltered?: boolean;

    constructor(data?: IProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.priority = _data["priority"];
            this.inputData = _data["inputData"];
            this.outputData = _data["outputData"];
            this.processType = _data["processType"];
            this.status = _data["status"];
            this.createdBy = _data["createdBy"];
            this.createdUserName = _data["createdUserName"];
            this.enqueueDate = _data["enqueueDate"] ? new Date(_data["enqueueDate"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.projectId = _data["projectId"];
            this.projectCode = _data["projectCode"];
            this.templateId = _data["templateId"];
            this.templateCode = _data["templateCode"];
            this.error = _data["error"];
            this.hangfireQueueName = _data["hangfireQueueName"];
            this.hangfireId = _data["hangfireId"];
            this.isFiltered = _data["isFiltered"];
        }
    }

    static fromJS(data: any): ProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["priority"] = this.priority;
        data["inputData"] = this.inputData;
        data["outputData"] = this.outputData;
        data["processType"] = this.processType;
        data["status"] = this.status;
        data["createdBy"] = this.createdBy;
        data["createdUserName"] = this.createdUserName;
        data["enqueueDate"] = this.enqueueDate ? this.enqueueDate.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["projectId"] = this.projectId;
        data["projectCode"] = this.projectCode;
        data["templateId"] = this.templateId;
        data["templateCode"] = this.templateCode;
        data["error"] = this.error;
        data["hangfireQueueName"] = this.hangfireQueueName;
        data["hangfireId"] = this.hangfireId;
        data["isFiltered"] = this.isFiltered;
        return data;
    }
}

export interface IProcessDto {
    id?: number;
    priority?: number;
    inputData?: string | undefined;
    outputData?: string | undefined;
    processType?: ProcessType;
    status?: ProcessStatus;
    createdBy?: string | undefined;
    createdUserName?: string | undefined;
    enqueueDate?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    projectId?: number | undefined;
    projectCode?: string | undefined;
    templateId?: number | undefined;
    templateCode?: string | undefined;
    error?: string | undefined;
    hangfireQueueName?: HanfireQueuesName | undefined;
    hangfireId?: string | undefined;
    isFiltered?: boolean;
}

export enum ProcessType {
    ExportAllPunches = 1,
    Custom = 2,
    CustomTemplate = 4,
    BulkUpdate = 8,
    DownloadPunchAttachments = 16,
    PunchAttachmentsActions = 32,
    DocumentProcessor = 64,
    SyncProjectElements = 128,
}

export enum ProcessStatus {
    Pending = 1,
    Executing = 2,
    ReadyForPreview = 4,
    Success = 8,
    Error = 16,
    Cancelled = 32,
}

export enum HanfireQueuesName {
    Update_queue = 1,
    Export_queue = 2,
}

export class PunchDetailMobilityViewModel extends PunchViewModel implements IPunchDetailMobilityViewModel {
    signature?: PunchStageViewModel[] | undefined;
    logs?: PunchLogViewModel[] | undefined;
    remark?: PunchRemarkViewModel[] | undefined;
    inspection?: InspectionViewModel | undefined;
    inspectionWalk?: InspectionWalkInfoViewModel | undefined;
    customsFields?: PunchCustomFieldViewModel[] | undefined;
    fields?: PunchCustomFieldViewModel[] | undefined;

    constructor(data?: IPunchDetailMobilityViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["signature"])) {
                this.signature = [] as any;
                for (let item of _data["signature"])
                    this.signature!.push(PunchStageViewModel.fromJS(item));
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(PunchLogViewModel.fromJS(item));
            }
            if (Array.isArray(_data["remark"])) {
                this.remark = [] as any;
                for (let item of _data["remark"])
                    this.remark!.push(PunchRemarkViewModel.fromJS(item));
            }
            this.inspection = _data["inspection"] ? InspectionViewModel.fromJS(_data["inspection"]) : undefined as any;
            this.inspectionWalk = _data["inspectionWalk"] ? InspectionWalkInfoViewModel.fromJS(_data["inspectionWalk"]) : undefined as any;
            if (Array.isArray(_data["customsFields"])) {
                this.customsFields = [] as any;
                for (let item of _data["customsFields"])
                    this.customsFields!.push(PunchCustomFieldViewModel.fromJS(item));
            }
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(PunchCustomFieldViewModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PunchDetailMobilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchDetailMobilityViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.signature)) {
            data["signature"] = [];
            for (let item of this.signature)
                data["signature"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.remark)) {
            data["remark"] = [];
            for (let item of this.remark)
                data["remark"].push(item ? item.toJSON() : undefined as any);
        }
        data["inspection"] = this.inspection ? this.inspection.toJSON() : undefined as any;
        data["inspectionWalk"] = this.inspectionWalk ? this.inspectionWalk.toJSON() : undefined as any;
        if (Array.isArray(this.customsFields)) {
            data["customsFields"] = [];
            for (let item of this.customsFields)
                data["customsFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPunchDetailMobilityViewModel extends IPunchViewModel {
    signature?: PunchStageViewModel[] | undefined;
    logs?: PunchLogViewModel[] | undefined;
    remark?: PunchRemarkViewModel[] | undefined;
    inspection?: InspectionViewModel | undefined;
    inspectionWalk?: InspectionWalkInfoViewModel | undefined;
    customsFields?: PunchCustomFieldViewModel[] | undefined;
    fields?: PunchCustomFieldViewModel[] | undefined;
}

export class PunchMobilityViewModelDataSourceResult implements IPunchMobilityViewModelDataSourceResult {
    data?: PunchMobilityViewModel[] | undefined;
    total?: number;
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;

    constructor(data?: IPunchMobilityViewModelDataSourceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PunchMobilityViewModel.fromJS(item));
            }
            this.total = _data["total"];
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PunchMobilityViewModelDataSourceResult {
        data = typeof data === 'object' ? data : {};
        let result = new PunchMobilityViewModelDataSourceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPunchMobilityViewModelDataSourceResult {
    data?: PunchMobilityViewModel[] | undefined;
    total?: number;
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
}

export class PunchMobilityViewModel implements IPunchMobilityViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    altitude?: number | undefined;
    location?: string | undefined;
    pdfPositionX?: number | undefined;
    pdfPositionY?: number | undefined;
    pdfPage?: number | undefined;
    pdfFile?: number | undefined;
    punchCoordinator?: string | undefined;
    rejectCount?: number | undefined;
    dateEntry?: Date;
    createdAt?: Date;
    lastModifiedAt?: Date;
    expectedClosingDate?: Date | undefined;
    discipline?: MasterViewModel | undefined;
    category?: CategoryViewModel | undefined;
    departmentAction?: MasterViewModel | undefined;
    itemsAffected?: ElementsViewModel[] | undefined;
    attachments?: PunchMediaViewModel[] | undefined;
    punchCustomFields?: PunchCustomFieldViewModel[] | undefined;
    priority?: MasterViewModel | undefined;
    status?: StatusViewModel | undefined;
    topic?: MasterViewModel | undefined;
    entryType?: MasterViewModel | undefined;
    originator?: OriginatorDto | undefined;
    userOriginator?: UserInfoViewModel | undefined;
    subContractor?: SubcontractorDto | undefined;
    cover?: PunchMediaViewModel | undefined;
    userValid?: boolean;
    commentary?: string | undefined;
    user?: UserInfoViewModel | undefined;
    tags?: TagsViewModel[] | undefined;
    inspection?: InspectionViewModel | undefined;
    inspectionCode?: string | undefined;
    inspectionType?: InspectionTypeViewModel | undefined;
    unit?: MasterViewModel | undefined;
    subSystem?: MasterViewModel | undefined;
    isMyPunch?: boolean;
    isRejected?: boolean;
    isSignable?: boolean;
    isRejectable?: boolean;
    reasonNotSignable?: string | undefined;
    onDispute?: boolean | undefined;
    closed?: boolean | undefined;
    isLocked?: boolean;
    createdBy?: string | undefined;
    notes?: string | undefined;
    tag?: string | undefined;
    contractorResponsibleName?: string | undefined;
    locationProject?: LocationProjectViewModel | undefined;

    constructor(data?: IPunchMobilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.altitude = _data["altitude"];
            this.location = _data["location"];
            this.pdfPositionX = _data["pdfPositionX"];
            this.pdfPositionY = _data["pdfPositionY"];
            this.pdfPage = _data["pdfPage"];
            this.pdfFile = _data["pdfFile"];
            this.punchCoordinator = _data["punchCoordinator"];
            this.rejectCount = _data["rejectCount"];
            this.dateEntry = _data["dateEntry"] ? new Date(_data["dateEntry"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.expectedClosingDate = _data["expectedClosingDate"] ? new Date(_data["expectedClosingDate"].toString()) : undefined as any;
            this.discipline = _data["discipline"] ? MasterViewModel.fromJS(_data["discipline"]) : undefined as any;
            this.category = _data["category"] ? CategoryViewModel.fromJS(_data["category"]) : undefined as any;
            this.departmentAction = _data["departmentAction"] ? MasterViewModel.fromJS(_data["departmentAction"]) : undefined as any;
            if (Array.isArray(_data["itemsAffected"])) {
                this.itemsAffected = [] as any;
                for (let item of _data["itemsAffected"])
                    this.itemsAffected!.push(ElementsViewModel.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(PunchMediaViewModel.fromJS(item));
            }
            if (Array.isArray(_data["punchCustomFields"])) {
                this.punchCustomFields = [] as any;
                for (let item of _data["punchCustomFields"])
                    this.punchCustomFields!.push(PunchCustomFieldViewModel.fromJS(item));
            }
            this.priority = _data["priority"] ? MasterViewModel.fromJS(_data["priority"]) : undefined as any;
            this.status = _data["status"] ? StatusViewModel.fromJS(_data["status"]) : undefined as any;
            this.topic = _data["topic"] ? MasterViewModel.fromJS(_data["topic"]) : undefined as any;
            this.entryType = _data["entryType"] ? MasterViewModel.fromJS(_data["entryType"]) : undefined as any;
            this.originator = _data["originator"] ? OriginatorDto.fromJS(_data["originator"]) : undefined as any;
            this.userOriginator = _data["userOriginator"] ? UserInfoViewModel.fromJS(_data["userOriginator"]) : undefined as any;
            this.subContractor = _data["subContractor"] ? SubcontractorDto.fromJS(_data["subContractor"]) : undefined as any;
            this.cover = _data["cover"] ? PunchMediaViewModel.fromJS(_data["cover"]) : undefined as any;
            this.userValid = _data["userValid"];
            this.commentary = _data["commentary"];
            this.user = _data["user"] ? UserInfoViewModel.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagsViewModel.fromJS(item));
            }
            this.inspection = _data["inspection"] ? InspectionViewModel.fromJS(_data["inspection"]) : undefined as any;
            this.inspectionCode = _data["inspectionCode"];
            this.inspectionType = _data["inspectionType"] ? InspectionTypeViewModel.fromJS(_data["inspectionType"]) : undefined as any;
            this.unit = _data["unit"] ? MasterViewModel.fromJS(_data["unit"]) : undefined as any;
            this.subSystem = _data["subSystem"] ? MasterViewModel.fromJS(_data["subSystem"]) : undefined as any;
            this.isMyPunch = _data["isMyPunch"];
            this.isRejected = _data["isRejected"];
            this.isSignable = _data["isSignable"];
            this.isRejectable = _data["isRejectable"];
            this.reasonNotSignable = _data["reasonNotSignable"];
            this.onDispute = _data["onDispute"];
            this.closed = _data["closed"];
            this.isLocked = _data["isLocked"];
            this.createdBy = _data["createdBy"];
            this.notes = _data["notes"];
            this.tag = _data["tag"];
            this.contractorResponsibleName = _data["contractorResponsibleName"];
            this.locationProject = _data["locationProject"] ? LocationProjectViewModel.fromJS(_data["locationProject"]) : undefined as any;
        }
    }

    static fromJS(data: any): PunchMobilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchMobilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["altitude"] = this.altitude;
        data["location"] = this.location;
        data["pdfPositionX"] = this.pdfPositionX;
        data["pdfPositionY"] = this.pdfPositionY;
        data["pdfPage"] = this.pdfPage;
        data["pdfFile"] = this.pdfFile;
        data["punchCoordinator"] = this.punchCoordinator;
        data["rejectCount"] = this.rejectCount;
        data["dateEntry"] = this.dateEntry ? this.dateEntry.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["expectedClosingDate"] = this.expectedClosingDate ? this.expectedClosingDate.toISOString() : undefined as any;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["departmentAction"] = this.departmentAction ? this.departmentAction.toJSON() : undefined as any;
        if (Array.isArray(this.itemsAffected)) {
            data["itemsAffected"] = [];
            for (let item of this.itemsAffected)
                data["itemsAffected"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchCustomFields)) {
            data["punchCustomFields"] = [];
            for (let item of this.punchCustomFields)
                data["punchCustomFields"].push(item ? item.toJSON() : undefined as any);
        }
        data["priority"] = this.priority ? this.priority.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["topic"] = this.topic ? this.topic.toJSON() : undefined as any;
        data["entryType"] = this.entryType ? this.entryType.toJSON() : undefined as any;
        data["originator"] = this.originator ? this.originator.toJSON() : undefined as any;
        data["userOriginator"] = this.userOriginator ? this.userOriginator.toJSON() : undefined as any;
        data["subContractor"] = this.subContractor ? this.subContractor.toJSON() : undefined as any;
        data["cover"] = this.cover ? this.cover.toJSON() : undefined as any;
        data["userValid"] = this.userValid;
        data["commentary"] = this.commentary;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["inspection"] = this.inspection ? this.inspection.toJSON() : undefined as any;
        data["inspectionCode"] = this.inspectionCode;
        data["inspectionType"] = this.inspectionType ? this.inspectionType.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["subSystem"] = this.subSystem ? this.subSystem.toJSON() : undefined as any;
        data["isMyPunch"] = this.isMyPunch;
        data["isRejected"] = this.isRejected;
        data["isSignable"] = this.isSignable;
        data["isRejectable"] = this.isRejectable;
        data["reasonNotSignable"] = this.reasonNotSignable;
        data["onDispute"] = this.onDispute;
        data["closed"] = this.closed;
        data["isLocked"] = this.isLocked;
        data["createdBy"] = this.createdBy;
        data["notes"] = this.notes;
        data["tag"] = this.tag;
        data["contractorResponsibleName"] = this.contractorResponsibleName;
        data["locationProject"] = this.locationProject ? this.locationProject.toJSON() : undefined as any;
        return data;
    }
}

export interface IPunchMobilityViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    altitude?: number | undefined;
    location?: string | undefined;
    pdfPositionX?: number | undefined;
    pdfPositionY?: number | undefined;
    pdfPage?: number | undefined;
    pdfFile?: number | undefined;
    punchCoordinator?: string | undefined;
    rejectCount?: number | undefined;
    dateEntry?: Date;
    createdAt?: Date;
    lastModifiedAt?: Date;
    expectedClosingDate?: Date | undefined;
    discipline?: MasterViewModel | undefined;
    category?: CategoryViewModel | undefined;
    departmentAction?: MasterViewModel | undefined;
    itemsAffected?: ElementsViewModel[] | undefined;
    attachments?: PunchMediaViewModel[] | undefined;
    punchCustomFields?: PunchCustomFieldViewModel[] | undefined;
    priority?: MasterViewModel | undefined;
    status?: StatusViewModel | undefined;
    topic?: MasterViewModel | undefined;
    entryType?: MasterViewModel | undefined;
    originator?: OriginatorDto | undefined;
    userOriginator?: UserInfoViewModel | undefined;
    subContractor?: SubcontractorDto | undefined;
    cover?: PunchMediaViewModel | undefined;
    userValid?: boolean;
    commentary?: string | undefined;
    user?: UserInfoViewModel | undefined;
    tags?: TagsViewModel[] | undefined;
    inspection?: InspectionViewModel | undefined;
    inspectionCode?: string | undefined;
    inspectionType?: InspectionTypeViewModel | undefined;
    unit?: MasterViewModel | undefined;
    subSystem?: MasterViewModel | undefined;
    isMyPunch?: boolean;
    isRejected?: boolean;
    isSignable?: boolean;
    isRejectable?: boolean;
    reasonNotSignable?: string | undefined;
    onDispute?: boolean | undefined;
    closed?: boolean | undefined;
    isLocked?: boolean;
    createdBy?: string | undefined;
    notes?: string | undefined;
    tag?: string | undefined;
    contractorResponsibleName?: string | undefined;
    locationProject?: LocationProjectViewModel | undefined;
}

export class PunchBagMobilityViewModelQueryResult implements IPunchBagMobilityViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: PunchBagMobilityViewModel[] | undefined;

    constructor(data?: IPunchBagMobilityViewModelQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.orderBy = _data["orderBy"];
            this.ascending = _data["ascending"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PunchBagMobilityViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchBagMobilityViewModelQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBagMobilityViewModelQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["orderBy"] = this.orderBy;
        data["ascending"] = this.ascending;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchBagMobilityViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: PunchBagMobilityViewModel[] | undefined;
}

export class PunchBagMobilityViewModel implements IPunchBagMobilityViewModel {
    id?: number;
    name?: string | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    assignedUserId?: string | undefined;
    assignedUserName?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
    expiresAt?: Date;
    maxSignatureRole?: string | undefined;
    punchCount?: number;

    constructor(data?: IPunchBagMobilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.assignedUserId = _data["assignedUserId"];
            this.assignedUserName = _data["assignedUserName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.maxSignatureRole = _data["maxSignatureRole"];
            this.punchCount = _data["punchCount"];
        }
    }

    static fromJS(data: any): PunchBagMobilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBagMobilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["assignedUserId"] = this.assignedUserId;
        data["assignedUserName"] = this.assignedUserName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["maxSignatureRole"] = this.maxSignatureRole;
        data["punchCount"] = this.punchCount;
        return data;
    }
}

export interface IPunchBagMobilityViewModel {
    id?: number;
    name?: string | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    assignedUserId?: string | undefined;
    assignedUserName?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
    expiresAt?: Date;
    maxSignatureRole?: string | undefined;
    punchCount?: number;
}

export class MediaFileViewModel implements IMediaFileViewModel {
    fileContent?: string | undefined;
    filename?: string | undefined;
    mimeType?: string | undefined;

    constructor(data?: IMediaFileViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileContent = _data["fileContent"];
            this.filename = _data["filename"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): MediaFileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MediaFileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileContent"] = this.fileContent;
        data["filename"] = this.filename;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface IMediaFileViewModel {
    fileContent?: string | undefined;
    filename?: string | undefined;
    mimeType?: string | undefined;
}

export class CheckVersionResultAppDto implements ICheckVersionResultAppDto {
    result?: string | undefined;
    updateURL?: string | undefined;
    newVersion?: string | undefined;

    constructor(data?: ICheckVersionResultAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.updateURL = _data["updateURL"];
            this.newVersion = _data["newVersion"];
        }
    }

    static fromJS(data: any): CheckVersionResultAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckVersionResultAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["updateURL"] = this.updateURL;
        data["newVersion"] = this.newVersion;
        return data;
    }
}

export interface ICheckVersionResultAppDto {
    result?: string | undefined;
    updateURL?: string | undefined;
    newVersion?: string | undefined;
}

export class CategoryProjectViewModel extends MasterViewModel implements ICategoryProjectViewModel {
    contractualInterpretation?: string | undefined;
    projectTemplates?: string[] | undefined;

    constructor(data?: ICategoryProjectViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contractualInterpretation = _data["contractualInterpretation"];
            if (Array.isArray(_data["projectTemplates"])) {
                this.projectTemplates = [] as any;
                for (let item of _data["projectTemplates"])
                    this.projectTemplates!.push(item);
            }
        }
    }

    static override fromJS(data: any): CategoryProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryProjectViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractualInterpretation"] = this.contractualInterpretation;
        if (Array.isArray(this.projectTemplates)) {
            data["projectTemplates"] = [];
            for (let item of this.projectTemplates)
                data["projectTemplates"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICategoryProjectViewModel extends IMasterViewModel {
    contractualInterpretation?: string | undefined;
    projectTemplates?: string[] | undefined;
}

export class MapResumeViewModel implements IMapResumeViewModel {
    id?: string | undefined;
    description?: string | undefined;
    name?: string | undefined;
    version?: number;
    location?: string | undefined;
    zoomLevel?: number;
    default?: boolean;
    lastUpdate?: Date;

    constructor(data?: IMapResumeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.version = _data["version"];
            this.location = _data["location"];
            this.zoomLevel = _data["zoomLevel"];
            this.default = _data["default"];
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MapResumeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MapResumeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["name"] = this.name;
        data["version"] = this.version;
        data["location"] = this.location;
        data["zoomLevel"] = this.zoomLevel;
        data["default"] = this.default;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : undefined as any;
        return data;
    }
}

export interface IMapResumeViewModel {
    id?: string | undefined;
    description?: string | undefined;
    name?: string | undefined;
    version?: number;
    location?: string | undefined;
    zoomLevel?: number;
    default?: boolean;
    lastUpdate?: Date;
}

export class MapInViewModel implements IMapInViewModel {
    description?: string | undefined;
    name?: string | undefined;
    mimeType?: string | undefined;
    location?: string | undefined;
    zoomLevel?: string | undefined;
    default?: boolean;
    file?: string | undefined;

    constructor(data?: IMapInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.name = _data["name"];
            this.mimeType = _data["mimeType"];
            this.location = _data["location"];
            this.zoomLevel = _data["zoomLevel"];
            this.default = _data["default"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): MapInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MapInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        data["mimeType"] = this.mimeType;
        data["location"] = this.location;
        data["zoomLevel"] = this.zoomLevel;
        data["default"] = this.default;
        data["file"] = this.file;
        return data;
    }
}

export interface IMapInViewModel {
    description?: string | undefined;
    name?: string | undefined;
    mimeType?: string | undefined;
    location?: string | undefined;
    zoomLevel?: string | undefined;
    default?: boolean;
    file?: string | undefined;
}

export class ExportTopicViewModel implements IExportTopicViewModel {
    templateId?: number;
    topicsIds?: (number | undefined)[] | undefined;

    constructor(data?: IExportTopicViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            if (Array.isArray(_data["topicsIds"])) {
                this.topicsIds = [] as any;
                for (let item of _data["topicsIds"])
                    this.topicsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExportTopicViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTopicViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        if (Array.isArray(this.topicsIds)) {
            data["topicsIds"] = [];
            for (let item of this.topicsIds)
                data["topicsIds"].push(item);
        }
        return data;
    }
}

export interface IExportTopicViewModel {
    templateId?: number;
    topicsIds?: (number | undefined)[] | undefined;
}

export class TopicProjectViewModel extends MasterViewModel implements ITopicProjectViewModel {
    disciplineCode?: string | undefined;
    projectTemplates?: string[] | undefined;

    constructor(data?: ITopicProjectViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.disciplineCode = _data["disciplineCode"];
            if (Array.isArray(_data["projectTemplates"])) {
                this.projectTemplates = [] as any;
                for (let item of _data["projectTemplates"])
                    this.projectTemplates!.push(item);
            }
        }
    }

    static override fromJS(data: any): TopicProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TopicProjectViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disciplineCode"] = this.disciplineCode;
        if (Array.isArray(this.projectTemplates)) {
            data["projectTemplates"] = [];
            for (let item of this.projectTemplates)
                data["projectTemplates"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITopicProjectViewModel extends IMasterViewModel {
    disciplineCode?: string | undefined;
    projectTemplates?: string[] | undefined;
}

export class MaintenanceModeNotificationViewModel implements IMaintenanceModeNotificationViewModel {
    activeFrom?: Date;
    activeUntil?: Date;

    constructor(data?: IMaintenanceModeNotificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : undefined as any;
            this.activeUntil = _data["activeUntil"] ? new Date(_data["activeUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MaintenanceModeNotificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceModeNotificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : undefined as any;
        data["activeUntil"] = this.activeUntil ? this.activeUntil.toISOString() : undefined as any;
        return data;
    }
}

export interface IMaintenanceModeNotificationViewModel {
    activeFrom?: Date;
    activeUntil?: Date;
}

export class MaintenanceModeViewModel implements IMaintenanceModeViewModel {
    id?: number;
    activeFrom?: Date;
    activeUntil?: Date;
    notifyFrom?: Date;
    enabled?: boolean;

    constructor(data?: IMaintenanceModeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : undefined as any;
            this.activeUntil = _data["activeUntil"] ? new Date(_data["activeUntil"].toString()) : undefined as any;
            this.notifyFrom = _data["notifyFrom"] ? new Date(_data["notifyFrom"].toString()) : undefined as any;
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): MaintenanceModeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceModeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : undefined as any;
        data["activeUntil"] = this.activeUntil ? this.activeUntil.toISOString() : undefined as any;
        data["notifyFrom"] = this.notifyFrom ? this.notifyFrom.toISOString() : undefined as any;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IMaintenanceModeViewModel {
    id?: number;
    activeFrom?: Date;
    activeUntil?: Date;
    notifyFrom?: Date;
    enabled?: boolean;
}

export class MaintenanceModeIn implements IMaintenanceModeIn {
    id?: number;
    activeFrom?: Date;
    activeUntil?: Date;
    notifyFrom?: Date;
    enabled?: boolean;

    constructor(data?: IMaintenanceModeIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : undefined as any;
            this.activeUntil = _data["activeUntil"] ? new Date(_data["activeUntil"].toString()) : undefined as any;
            this.notifyFrom = _data["notifyFrom"] ? new Date(_data["notifyFrom"].toString()) : undefined as any;
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): MaintenanceModeIn {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceModeIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : undefined as any;
        data["activeUntil"] = this.activeUntil ? this.activeUntil.toISOString() : undefined as any;
        data["notifyFrom"] = this.notifyFrom ? this.notifyFrom.toISOString() : undefined as any;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IMaintenanceModeIn {
    id?: number;
    activeFrom?: Date;
    activeUntil?: Date;
    notifyFrom?: Date;
    enabled?: boolean;
}

export class InspectionViewModelDataSourceResult implements IInspectionViewModelDataSourceResult {
    data?: InspectionViewModel[] | undefined;
    total?: number;
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;

    constructor(data?: IInspectionViewModelDataSourceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InspectionViewModel.fromJS(item));
            }
            this.total = _data["total"];
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): InspectionViewModelDataSourceResult {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionViewModelDataSourceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IInspectionViewModelDataSourceResult {
    data?: InspectionViewModel[] | undefined;
    total?: number;
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
}

export class FilterViewModelDataSourceViewModel extends DataSourceViewModel implements IFilterViewModelDataSourceViewModel {
    filters?: FilterViewModel[] | undefined;

    constructor(data?: IFilterViewModelDataSourceViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterViewModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FilterViewModelDataSourceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterViewModelDataSourceViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilterViewModelDataSourceViewModel extends IDataSourceViewModel {
    filters?: FilterViewModel[] | undefined;
}

export class InspectionDataSourceViewModel extends FilterViewModelDataSourceViewModel implements IInspectionDataSourceViewModel {

    constructor(data?: IInspectionDataSourceViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): InspectionDataSourceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDataSourceViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionDataSourceViewModel extends IFilterViewModelDataSourceViewModel {
}

export class InspectionDetailDto extends MasterDto implements IInspectionDetailDto {
    inspectionType?: MasterDto | undefined;
    organizer?: UserDto | undefined;
    items?: ElementOutDto[] | undefined;
    name?: string | undefined;
    information?: string | undefined;
    location?: string | undefined;
    tracked?: boolean;
    date?: Date | undefined;
    lastModifiedAt?: Date | undefined;
    inspectionState?: InspectionStatusDto | undefined;
    wbs?: WbsDtoOut | undefined;
    attendes?: UserInspectionDto[] | undefined;
    userWalks?: UserWalkOutDto[] | undefined;
    files?: InspectionFileDto[] | undefined;
    attendeesUnknown?: InspectionMemberUnknownDto[] | undefined;
    remarks?: InspectionRemarkOutDto[] | undefined;

    constructor(data?: IInspectionDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.inspectionType = _data["inspectionType"] ? MasterDto.fromJS(_data["inspectionType"]) : undefined as any;
            this.organizer = _data["organizer"] ? UserDto.fromJS(_data["organizer"]) : undefined as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ElementOutDto.fromJS(item));
            }
            this.name = _data["name"];
            this.information = _data["information"];
            this.location = _data["location"];
            this.tracked = _data["tracked"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.inspectionState = _data["inspectionState"] ? InspectionStatusDto.fromJS(_data["inspectionState"]) : undefined as any;
            this.wbs = _data["wbs"] ? WbsDtoOut.fromJS(_data["wbs"]) : undefined as any;
            if (Array.isArray(_data["attendes"])) {
                this.attendes = [] as any;
                for (let item of _data["attendes"])
                    this.attendes!.push(UserInspectionDto.fromJS(item));
            }
            if (Array.isArray(_data["userWalks"])) {
                this.userWalks = [] as any;
                for (let item of _data["userWalks"])
                    this.userWalks!.push(UserWalkOutDto.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(InspectionFileDto.fromJS(item));
            }
            if (Array.isArray(_data["attendeesUnknown"])) {
                this.attendeesUnknown = [] as any;
                for (let item of _data["attendeesUnknown"])
                    this.attendeesUnknown!.push(InspectionMemberUnknownDto.fromJS(item));
            }
            if (Array.isArray(_data["remarks"])) {
                this.remarks = [] as any;
                for (let item of _data["remarks"])
                    this.remarks!.push(InspectionRemarkOutDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): InspectionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionType"] = this.inspectionType ? this.inspectionType.toJSON() : undefined as any;
        data["organizer"] = this.organizer ? this.organizer.toJSON() : undefined as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name;
        data["information"] = this.information;
        data["location"] = this.location;
        data["tracked"] = this.tracked;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["inspectionState"] = this.inspectionState ? this.inspectionState.toJSON() : undefined as any;
        data["wbs"] = this.wbs ? this.wbs.toJSON() : undefined as any;
        if (Array.isArray(this.attendes)) {
            data["attendes"] = [];
            for (let item of this.attendes)
                data["attendes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userWalks)) {
            data["userWalks"] = [];
            for (let item of this.userWalks)
                data["userWalks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attendeesUnknown)) {
            data["attendeesUnknown"] = [];
            for (let item of this.attendeesUnknown)
                data["attendeesUnknown"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.remarks)) {
            data["remarks"] = [];
            for (let item of this.remarks)
                data["remarks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionDetailDto extends IMasterDto {
    inspectionType?: MasterDto | undefined;
    organizer?: UserDto | undefined;
    items?: ElementOutDto[] | undefined;
    name?: string | undefined;
    information?: string | undefined;
    location?: string | undefined;
    tracked?: boolean;
    date?: Date | undefined;
    lastModifiedAt?: Date | undefined;
    inspectionState?: InspectionStatusDto | undefined;
    wbs?: WbsDtoOut | undefined;
    attendes?: UserInspectionDto[] | undefined;
    userWalks?: UserWalkOutDto[] | undefined;
    files?: InspectionFileDto[] | undefined;
    attendeesUnknown?: InspectionMemberUnknownDto[] | undefined;
    remarks?: InspectionRemarkOutDto[] | undefined;
}

export class ElementOutDto extends MasterDto implements IElementOutDto {
    nodeLevel?: NodeLevelsDto | undefined;
    elementType?: ElementTypesDto | undefined;
    discipline?: DisciplineDto | undefined;
    subElement?: ElementsDto[] | undefined;
    selected?: boolean;
    elementMatchId?: number | undefined;

    constructor(data?: IElementOutDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nodeLevel = _data["nodeLevel"] ? NodeLevelsDto.fromJS(_data["nodeLevel"]) : undefined as any;
            this.elementType = _data["elementType"] ? ElementTypesDto.fromJS(_data["elementType"]) : undefined as any;
            this.discipline = _data["discipline"] ? DisciplineDto.fromJS(_data["discipline"]) : undefined as any;
            if (Array.isArray(_data["subElement"])) {
                this.subElement = [] as any;
                for (let item of _data["subElement"])
                    this.subElement!.push(ElementsDto.fromJS(item));
            }
            this.selected = _data["selected"];
            this.elementMatchId = _data["elementMatchId"];
        }
    }

    static override fromJS(data: any): ElementOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementOutDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeLevel"] = this.nodeLevel ? this.nodeLevel.toJSON() : undefined as any;
        data["elementType"] = this.elementType ? this.elementType.toJSON() : undefined as any;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        if (Array.isArray(this.subElement)) {
            data["subElement"] = [];
            for (let item of this.subElement)
                data["subElement"].push(item ? item.toJSON() : undefined as any);
        }
        data["selected"] = this.selected;
        data["elementMatchId"] = this.elementMatchId;
        super.toJSON(data);
        return data;
    }
}

export interface IElementOutDto extends IMasterDto {
    nodeLevel?: NodeLevelsDto | undefined;
    elementType?: ElementTypesDto | undefined;
    discipline?: DisciplineDto | undefined;
    subElement?: ElementsDto[] | undefined;
    selected?: boolean;
    elementMatchId?: number | undefined;
}

export class WbsDtoOut extends MasterDto implements IWbsDtoOut {
    node?: string | undefined;

    constructor(data?: IWbsDtoOut) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.node = _data["node"];
        }
    }

    static override fromJS(data: any): WbsDtoOut {
        data = typeof data === 'object' ? data : {};
        let result = new WbsDtoOut();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["node"] = this.node;
        super.toJSON(data);
        return data;
    }
}

export interface IWbsDtoOut extends IMasterDto {
    node?: string | undefined;
}

export class UserInspectionDto implements IUserInspectionDto {
    invitationStatus?: MemberStatusDto | undefined;
    memberStatus?: MasterDto | undefined;
    user?: UserViewDtoOut | undefined;
    confirmed?: boolean;

    constructor(data?: IUserInspectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationStatus = _data["invitationStatus"] ? MemberStatusDto.fromJS(_data["invitationStatus"]) : undefined as any;
            this.memberStatus = _data["memberStatus"] ? MasterDto.fromJS(_data["memberStatus"]) : undefined as any;
            this.user = _data["user"] ? UserViewDtoOut.fromJS(_data["user"]) : undefined as any;
            this.confirmed = _data["confirmed"];
        }
    }

    static fromJS(data: any): UserInspectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInspectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationStatus"] = this.invitationStatus ? this.invitationStatus.toJSON() : undefined as any;
        data["memberStatus"] = this.memberStatus ? this.memberStatus.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["confirmed"] = this.confirmed;
        return data;
    }
}

export interface IUserInspectionDto {
    invitationStatus?: MemberStatusDto | undefined;
    memberStatus?: MasterDto | undefined;
    user?: UserViewDtoOut | undefined;
    confirmed?: boolean;
}

export class UserViewDtoOut extends UserDto implements IUserViewDtoOut {
    disciplines?: MasterDto[] | undefined;
    role?: string | undefined;
    projectsTemplates?: TemplateProjectDto[] | undefined;
    units?: MasterDto[] | undefined;
    isOrganizer?: boolean;

    constructor(data?: IUserViewDtoOut) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["disciplines"])) {
                this.disciplines = [] as any;
                for (let item of _data["disciplines"])
                    this.disciplines!.push(MasterDto.fromJS(item));
            }
            this.role = _data["role"];
            if (Array.isArray(_data["projectsTemplates"])) {
                this.projectsTemplates = [] as any;
                for (let item of _data["projectsTemplates"])
                    this.projectsTemplates!.push(TemplateProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(MasterDto.fromJS(item));
            }
            this.isOrganizer = _data["isOrganizer"];
        }
    }

    static override fromJS(data: any): UserViewDtoOut {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewDtoOut();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.disciplines)) {
            data["disciplines"] = [];
            for (let item of this.disciplines)
                data["disciplines"].push(item ? item.toJSON() : undefined as any);
        }
        data["role"] = this.role;
        if (Array.isArray(this.projectsTemplates)) {
            data["projectsTemplates"] = [];
            for (let item of this.projectsTemplates)
                data["projectsTemplates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        data["isOrganizer"] = this.isOrganizer;
        super.toJSON(data);
        return data;
    }
}

export interface IUserViewDtoOut extends IUserDto {
    disciplines?: MasterDto[] | undefined;
    role?: string | undefined;
    projectsTemplates?: TemplateProjectDto[] | undefined;
    units?: MasterDto[] | undefined;
    isOrganizer?: boolean;
}

export class UserWalkOutDto implements IUserWalkOutDto {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
    walks?: InspectionWalkOutDto[] | undefined;

    constructor(data?: IUserWalkOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.company = _data["company"];
            if (Array.isArray(_data["walks"])) {
                this.walks = [] as any;
                for (let item of _data["walks"])
                    this.walks!.push(InspectionWalkOutDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserWalkOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWalkOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["company"] = this.company;
        if (Array.isArray(this.walks)) {
            data["walks"] = [];
            for (let item of this.walks)
                data["walks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserWalkOutDto {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
    walks?: InspectionWalkOutDto[] | undefined;
}

export class InspectionWalkOutDto implements IInspectionWalkOutDto {
    track?: string | undefined;
    startDate?: Date;
    closeDate?: Date | undefined;
    punch?: PunchInspectionOutDto[] | undefined;
    inspectionStatus?: InspectionStatusDto | undefined;
    fromImport?: boolean;

    constructor(data?: IInspectionWalkOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.track = _data["track"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : undefined as any;
            if (Array.isArray(_data["punch"])) {
                this.punch = [] as any;
                for (let item of _data["punch"])
                    this.punch!.push(PunchInspectionOutDto.fromJS(item));
            }
            this.inspectionStatus = _data["inspectionStatus"] ? InspectionStatusDto.fromJS(_data["inspectionStatus"]) : undefined as any;
            this.fromImport = _data["fromImport"];
        }
    }

    static fromJS(data: any): InspectionWalkOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionWalkOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["track"] = this.track;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : undefined as any;
        if (Array.isArray(this.punch)) {
            data["punch"] = [];
            for (let item of this.punch)
                data["punch"].push(item ? item.toJSON() : undefined as any);
        }
        data["inspectionStatus"] = this.inspectionStatus ? this.inspectionStatus.toJSON() : undefined as any;
        data["fromImport"] = this.fromImport;
        return data;
    }
}

export interface IInspectionWalkOutDto {
    track?: string | undefined;
    startDate?: Date;
    closeDate?: Date | undefined;
    punch?: PunchInspectionOutDto[] | undefined;
    inspectionStatus?: InspectionStatusDto | undefined;
    fromImport?: boolean;
}

export class PunchInspectionOutDto implements IPunchInspectionOutDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    altitude?: number | undefined;
    location?: string | undefined;
    pdfPositionX?: number | undefined;
    pdfPositionY?: number | undefined;
    pdfPage?: number | undefined;
    pdfFile?: number | undefined;
    punchCoordinator?: string | undefined;
    rejectCount?: number | undefined;
    dateEntry?: Date;
    createdAt?: Date;
    lastModifiedAt?: Date;
    expectedClosingDate?: Date | undefined;
    discipline?: DisciplineDto | undefined;
    category?: CategoryDto | undefined;
    departmentAction?: MasterDto | undefined;
    punchCustomFields?: PunchCustomFieldDto[] | undefined;
    punchRemarks?: PunchRemarkDto[] | undefined;
    itemsAffected?: ElementOutDto[] | undefined;
    attachments?: PunchMediaOutDto[] | undefined;
    priority?: MasterDto | undefined;
    status?: StatusDto | undefined;
    topic?: MasterDto | undefined;
    entryType?: MasterDto | undefined;
    originator?: OriginatorDto | undefined;
    userOriginator?: UserDto | undefined;
    subContractor?: SubcontractorDto | undefined;
    cover?: PunchMediaOutDto | undefined;
    userValid?: boolean;
    user?: UserDto | undefined;
    tags?: TagsDto[] | undefined;
    inspection?: InspectionDetailDto | undefined;
    inspectionCode?: string | undefined;
    inspectionType?: InspectionTypeDto | undefined;
    unit?: MasterDto | undefined;
    subSystem?: MasterDto | undefined;
    isMyPunch?: boolean;
    isRejected?: boolean;
    isSignable?: boolean;
    isRejectable?: boolean;
    reasonNotSignable?: string | undefined;
    onDispute?: boolean | undefined;
    closed?: boolean | undefined;
    commentary?: string | undefined;
    contractorResponsibleName?: string | undefined;

    constructor(data?: IPunchInspectionOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.altitude = _data["altitude"];
            this.location = _data["location"];
            this.pdfPositionX = _data["pdfPositionX"];
            this.pdfPositionY = _data["pdfPositionY"];
            this.pdfPage = _data["pdfPage"];
            this.pdfFile = _data["pdfFile"];
            this.punchCoordinator = _data["punchCoordinator"];
            this.rejectCount = _data["rejectCount"];
            this.dateEntry = _data["dateEntry"] ? new Date(_data["dateEntry"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.expectedClosingDate = _data["expectedClosingDate"] ? new Date(_data["expectedClosingDate"].toString()) : undefined as any;
            this.discipline = _data["discipline"] ? DisciplineDto.fromJS(_data["discipline"]) : undefined as any;
            this.category = _data["category"] ? CategoryDto.fromJS(_data["category"]) : undefined as any;
            this.departmentAction = _data["departmentAction"] ? MasterDto.fromJS(_data["departmentAction"]) : undefined as any;
            if (Array.isArray(_data["punchCustomFields"])) {
                this.punchCustomFields = [] as any;
                for (let item of _data["punchCustomFields"])
                    this.punchCustomFields!.push(PunchCustomFieldDto.fromJS(item));
            }
            if (Array.isArray(_data["punchRemarks"])) {
                this.punchRemarks = [] as any;
                for (let item of _data["punchRemarks"])
                    this.punchRemarks!.push(PunchRemarkDto.fromJS(item));
            }
            if (Array.isArray(_data["itemsAffected"])) {
                this.itemsAffected = [] as any;
                for (let item of _data["itemsAffected"])
                    this.itemsAffected!.push(ElementOutDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(PunchMediaOutDto.fromJS(item));
            }
            this.priority = _data["priority"] ? MasterDto.fromJS(_data["priority"]) : undefined as any;
            this.status = _data["status"] ? StatusDto.fromJS(_data["status"]) : undefined as any;
            this.topic = _data["topic"] ? MasterDto.fromJS(_data["topic"]) : undefined as any;
            this.entryType = _data["entryType"] ? MasterDto.fromJS(_data["entryType"]) : undefined as any;
            this.originator = _data["originator"] ? OriginatorDto.fromJS(_data["originator"]) : undefined as any;
            this.userOriginator = _data["userOriginator"] ? UserDto.fromJS(_data["userOriginator"]) : undefined as any;
            this.subContractor = _data["subContractor"] ? SubcontractorDto.fromJS(_data["subContractor"]) : undefined as any;
            this.cover = _data["cover"] ? PunchMediaOutDto.fromJS(_data["cover"]) : undefined as any;
            this.userValid = _data["userValid"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagsDto.fromJS(item));
            }
            this.inspection = _data["inspection"] ? InspectionDetailDto.fromJS(_data["inspection"]) : undefined as any;
            this.inspectionCode = _data["inspectionCode"];
            this.inspectionType = _data["inspectionType"] ? InspectionTypeDto.fromJS(_data["inspectionType"]) : undefined as any;
            this.unit = _data["unit"] ? MasterDto.fromJS(_data["unit"]) : undefined as any;
            this.subSystem = _data["subSystem"] ? MasterDto.fromJS(_data["subSystem"]) : undefined as any;
            this.isMyPunch = _data["isMyPunch"];
            this.isRejected = _data["isRejected"];
            this.isSignable = _data["isSignable"];
            this.isRejectable = _data["isRejectable"];
            this.reasonNotSignable = _data["reasonNotSignable"];
            this.onDispute = _data["onDispute"];
            this.closed = _data["closed"];
            this.commentary = _data["commentary"];
            this.contractorResponsibleName = _data["contractorResponsibleName"];
        }
    }

    static fromJS(data: any): PunchInspectionOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchInspectionOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["altitude"] = this.altitude;
        data["location"] = this.location;
        data["pdfPositionX"] = this.pdfPositionX;
        data["pdfPositionY"] = this.pdfPositionY;
        data["pdfPage"] = this.pdfPage;
        data["pdfFile"] = this.pdfFile;
        data["punchCoordinator"] = this.punchCoordinator;
        data["rejectCount"] = this.rejectCount;
        data["dateEntry"] = this.dateEntry ? this.dateEntry.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["expectedClosingDate"] = this.expectedClosingDate ? this.expectedClosingDate.toISOString() : undefined as any;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["departmentAction"] = this.departmentAction ? this.departmentAction.toJSON() : undefined as any;
        if (Array.isArray(this.punchCustomFields)) {
            data["punchCustomFields"] = [];
            for (let item of this.punchCustomFields)
                data["punchCustomFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchRemarks)) {
            data["punchRemarks"] = [];
            for (let item of this.punchRemarks)
                data["punchRemarks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.itemsAffected)) {
            data["itemsAffected"] = [];
            for (let item of this.itemsAffected)
                data["itemsAffected"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["priority"] = this.priority ? this.priority.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["topic"] = this.topic ? this.topic.toJSON() : undefined as any;
        data["entryType"] = this.entryType ? this.entryType.toJSON() : undefined as any;
        data["originator"] = this.originator ? this.originator.toJSON() : undefined as any;
        data["userOriginator"] = this.userOriginator ? this.userOriginator.toJSON() : undefined as any;
        data["subContractor"] = this.subContractor ? this.subContractor.toJSON() : undefined as any;
        data["cover"] = this.cover ? this.cover.toJSON() : undefined as any;
        data["userValid"] = this.userValid;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["inspection"] = this.inspection ? this.inspection.toJSON() : undefined as any;
        data["inspectionCode"] = this.inspectionCode;
        data["inspectionType"] = this.inspectionType ? this.inspectionType.toJSON() : undefined as any;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["subSystem"] = this.subSystem ? this.subSystem.toJSON() : undefined as any;
        data["isMyPunch"] = this.isMyPunch;
        data["isRejected"] = this.isRejected;
        data["isSignable"] = this.isSignable;
        data["isRejectable"] = this.isRejectable;
        data["reasonNotSignable"] = this.reasonNotSignable;
        data["onDispute"] = this.onDispute;
        data["closed"] = this.closed;
        data["commentary"] = this.commentary;
        data["contractorResponsibleName"] = this.contractorResponsibleName;
        return data;
    }
}

export interface IPunchInspectionOutDto {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    altitude?: number | undefined;
    location?: string | undefined;
    pdfPositionX?: number | undefined;
    pdfPositionY?: number | undefined;
    pdfPage?: number | undefined;
    pdfFile?: number | undefined;
    punchCoordinator?: string | undefined;
    rejectCount?: number | undefined;
    dateEntry?: Date;
    createdAt?: Date;
    lastModifiedAt?: Date;
    expectedClosingDate?: Date | undefined;
    discipline?: DisciplineDto | undefined;
    category?: CategoryDto | undefined;
    departmentAction?: MasterDto | undefined;
    punchCustomFields?: PunchCustomFieldDto[] | undefined;
    punchRemarks?: PunchRemarkDto[] | undefined;
    itemsAffected?: ElementOutDto[] | undefined;
    attachments?: PunchMediaOutDto[] | undefined;
    priority?: MasterDto | undefined;
    status?: StatusDto | undefined;
    topic?: MasterDto | undefined;
    entryType?: MasterDto | undefined;
    originator?: OriginatorDto | undefined;
    userOriginator?: UserDto | undefined;
    subContractor?: SubcontractorDto | undefined;
    cover?: PunchMediaOutDto | undefined;
    userValid?: boolean;
    user?: UserDto | undefined;
    tags?: TagsDto[] | undefined;
    inspection?: InspectionDetailDto | undefined;
    inspectionCode?: string | undefined;
    inspectionType?: InspectionTypeDto | undefined;
    unit?: MasterDto | undefined;
    subSystem?: MasterDto | undefined;
    isMyPunch?: boolean;
    isRejected?: boolean;
    isSignable?: boolean;
    isRejectable?: boolean;
    reasonNotSignable?: string | undefined;
    onDispute?: boolean | undefined;
    closed?: boolean | undefined;
    commentary?: string | undefined;
    contractorResponsibleName?: string | undefined;
}

export class PunchMediaOutDto implements IPunchMediaOutDto {
    id?: number | undefined;
    punchId?: number | undefined;
    mimeType?: string | undefined;
    mediaTypeId?: number | undefined;
    file?: string | undefined;
    cover?: boolean;
    realNameFile?: string | undefined;
    lastModifiedAt?: Date;

    constructor(data?: IPunchMediaOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.punchId = _data["punchId"];
            this.mimeType = _data["mimeType"];
            this.mediaTypeId = _data["mediaTypeId"];
            this.file = _data["file"];
            this.cover = _data["cover"];
            this.realNameFile = _data["realNameFile"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PunchMediaOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchMediaOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["punchId"] = this.punchId;
        data["mimeType"] = this.mimeType;
        data["mediaTypeId"] = this.mediaTypeId;
        data["file"] = this.file;
        data["cover"] = this.cover;
        data["realNameFile"] = this.realNameFile;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IPunchMediaOutDto {
    id?: number | undefined;
    punchId?: number | undefined;
    mimeType?: string | undefined;
    mediaTypeId?: number | undefined;
    file?: string | undefined;
    cover?: boolean;
    realNameFile?: string | undefined;
    lastModifiedAt?: Date;
}

export class InspectionRemarkOutDto implements IInspectionRemarkOutDto {
    remark?: string | undefined;
    userName?: string | undefined;
    lastModifiedAt?: Date | undefined;

    constructor(data?: IInspectionRemarkOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remark = _data["remark"];
            this.userName = _data["userName"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InspectionRemarkOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionRemarkOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remark"] = this.remark;
        data["userName"] = this.userName;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IInspectionRemarkOutDto {
    remark?: string | undefined;
    userName?: string | undefined;
    lastModifiedAt?: Date | undefined;
}

export class InspectionDetailViewModel extends InspectionViewModel implements IInspectionDetailViewModel {
    attendeesUnknown?: InspectionMemberUnknownViewModel[] | undefined;
    remarks?: InspectionRemarkViewModel[] | undefined;

    constructor(data?: IInspectionDetailViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["attendeesUnknown"])) {
                this.attendeesUnknown = [] as any;
                for (let item of _data["attendeesUnknown"])
                    this.attendeesUnknown!.push(InspectionMemberUnknownViewModel.fromJS(item));
            }
            if (Array.isArray(_data["remarks"])) {
                this.remarks = [] as any;
                for (let item of _data["remarks"])
                    this.remarks!.push(InspectionRemarkViewModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): InspectionDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDetailViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attendeesUnknown)) {
            data["attendeesUnknown"] = [];
            for (let item of this.attendeesUnknown)
                data["attendeesUnknown"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.remarks)) {
            data["remarks"] = [];
            for (let item of this.remarks)
                data["remarks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionDetailViewModel extends IInspectionViewModel {
    attendeesUnknown?: InspectionMemberUnknownViewModel[] | undefined;
    remarks?: InspectionRemarkViewModel[] | undefined;
}

export class InspectionMemberUnknownViewModel implements IInspectionMemberUnknownViewModel {
    id?: number;
    userName?: string | undefined;
    consolidated?: boolean;
    discarded?: boolean;

    constructor(data?: IInspectionMemberUnknownViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.consolidated = _data["consolidated"];
            this.discarded = _data["discarded"];
        }
    }

    static fromJS(data: any): InspectionMemberUnknownViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionMemberUnknownViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["consolidated"] = this.consolidated;
        data["discarded"] = this.discarded;
        return data;
    }
}

export interface IInspectionMemberUnknownViewModel {
    id?: number;
    userName?: string | undefined;
    consolidated?: boolean;
    discarded?: boolean;
}

export class InspectionRemarkViewModel extends RemarkViewModel implements IInspectionRemarkViewModel {
    inspectionId?: number | undefined;

    constructor(data?: IInspectionRemarkViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.inspectionId = _data["inspectionId"];
        }
    }

    static override fromJS(data: any): InspectionRemarkViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionRemarkViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionRemarkViewModel extends IRemarkViewModel {
    inspectionId?: number | undefined;
}

export class InspectionOptionsViewModel implements IInspectionOptionsViewModel {
    id?: number;
    userId?: string | undefined;
    walkId?: number;
    tracked?: boolean | undefined;
    reschedule?: Date | undefined;
    remark?: string | undefined;
    track?: string | undefined;

    constructor(data?: IInspectionOptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.walkId = _data["walkId"];
            this.tracked = _data["tracked"];
            this.reschedule = _data["reschedule"] ? new Date(_data["reschedule"].toString()) : undefined as any;
            this.remark = _data["remark"];
            this.track = _data["track"];
        }
    }

    static fromJS(data: any): InspectionOptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionOptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["walkId"] = this.walkId;
        data["tracked"] = this.tracked;
        data["reschedule"] = this.reschedule ? this.reschedule.toISOString() : undefined as any;
        data["remark"] = this.remark;
        data["track"] = this.track;
        return data;
    }
}

export interface IInspectionOptionsViewModel {
    id?: number;
    userId?: string | undefined;
    walkId?: number;
    tracked?: boolean | undefined;
    reschedule?: Date | undefined;
    remark?: string | undefined;
    track?: string | undefined;
}

export class AttendeeViewModel implements IAttendeeViewModel {
    inspectionId?: number;
    userId?: string | undefined;
    memberStatusId?: number;
    username?: string | undefined;
    attendeeUnknownId?: number | undefined;

    constructor(data?: IAttendeeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            this.userId = _data["userId"];
            this.memberStatusId = _data["memberStatusId"];
            this.username = _data["username"];
            this.attendeeUnknownId = _data["attendeeUnknownId"];
        }
    }

    static fromJS(data: any): AttendeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttendeeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["userId"] = this.userId;
        data["memberStatusId"] = this.memberStatusId;
        data["username"] = this.username;
        data["attendeeUnknownId"] = this.attendeeUnknownId;
        return data;
    }
}

export interface IAttendeeViewModel {
    inspectionId?: number;
    userId?: string | undefined;
    memberStatusId?: number;
    username?: string | undefined;
    attendeeUnknownId?: number | undefined;
}

export class PunchBulkModifyViewModel implements IPunchBulkModifyViewModel {
    punchesId?: number[] | undefined;
    description?: string | undefined;
    categoryId?: number | undefined;
    disciplineId?: number | undefined;
    topicId?: number | undefined;
    originatorId?: number | undefined;
    subcontractor?: number | undefined;
    departmentActionId?: number | undefined;
    commentary?: string | undefined;
    items?: number[] | undefined;
    labels?: number[] | undefined;
    expectedClosingDate?: Date | undefined;
    contractorResponsibleName?: string | undefined;
    locationProjectId?: number | undefined;

    constructor(data?: IPunchBulkModifyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["punchesId"])) {
                this.punchesId = [] as any;
                for (let item of _data["punchesId"])
                    this.punchesId!.push(item);
            }
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.disciplineId = _data["disciplineId"];
            this.topicId = _data["topicId"];
            this.originatorId = _data["originatorId"];
            this.subcontractor = _data["subcontractor"];
            this.departmentActionId = _data["departmentActionId"];
            this.commentary = _data["commentary"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            this.expectedClosingDate = _data["expectedClosingDate"] ? new Date(_data["expectedClosingDate"].toString()) : undefined as any;
            this.contractorResponsibleName = _data["contractorResponsibleName"];
            this.locationProjectId = _data["locationProjectId"];
        }
    }

    static fromJS(data: any): PunchBulkModifyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBulkModifyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.punchesId)) {
            data["punchesId"] = [];
            for (let item of this.punchesId)
                data["punchesId"].push(item);
        }
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["disciplineId"] = this.disciplineId;
        data["topicId"] = this.topicId;
        data["originatorId"] = this.originatorId;
        data["subcontractor"] = this.subcontractor;
        data["departmentActionId"] = this.departmentActionId;
        data["commentary"] = this.commentary;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["expectedClosingDate"] = this.expectedClosingDate ? this.expectedClosingDate.toISOString() : undefined as any;
        data["contractorResponsibleName"] = this.contractorResponsibleName;
        data["locationProjectId"] = this.locationProjectId;
        return data;
    }
}

export interface IPunchBulkModifyViewModel {
    punchesId?: number[] | undefined;
    description?: string | undefined;
    categoryId?: number | undefined;
    disciplineId?: number | undefined;
    topicId?: number | undefined;
    originatorId?: number | undefined;
    subcontractor?: number | undefined;
    departmentActionId?: number | undefined;
    commentary?: string | undefined;
    items?: number[] | undefined;
    labels?: number[] | undefined;
    expectedClosingDate?: Date | undefined;
    contractorResponsibleName?: string | undefined;
    locationProjectId?: number | undefined;
}

export class InspectionSelectedItemViewModel implements IInspectionSelectedItemViewModel {
    elemetsId?: (number | undefined)[] | undefined;
    areWapIds?: boolean | undefined;

    constructor(data?: IInspectionSelectedItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elemetsId"])) {
                this.elemetsId = [] as any;
                for (let item of _data["elemetsId"])
                    this.elemetsId!.push(item);
            }
            this.areWapIds = _data["areWapIds"];
        }
    }

    static fromJS(data: any): InspectionSelectedItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionSelectedItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elemetsId)) {
            data["elemetsId"] = [];
            for (let item of this.elemetsId)
                data["elemetsId"].push(item);
        }
        data["areWapIds"] = this.areWapIds;
        return data;
    }
}

export interface IInspectionSelectedItemViewModel {
    elemetsId?: (number | undefined)[] | undefined;
    areWapIds?: boolean | undefined;
}

export class PunchImportViewModel implements IPunchImportViewModel {
    inspectionId?: number;
    inspection?: InspectionViewModel | undefined;
    template?: string | undefined;

    constructor(data?: IPunchImportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            this.inspection = _data["inspection"] ? InspectionViewModel.fromJS(_data["inspection"]) : undefined as any;
            this.template = _data["template"];
        }
    }

    static fromJS(data: any): PunchImportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchImportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["inspection"] = this.inspection ? this.inspection.toJSON() : undefined as any;
        data["template"] = this.template;
        return data;
    }
}

export interface IPunchImportViewModel {
    inspectionId?: number;
    inspection?: InspectionViewModel | undefined;
    template?: string | undefined;
}

export class PunchImportPreviewViewModel extends PunchImportViewModel implements IPunchImportPreviewViewModel {
    templateNamePreview?: string | undefined;
    summary?: { [key: string]: number; } | undefined;
    error?: string | undefined;

    constructor(data?: IPunchImportPreviewViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.templateNamePreview = _data["templateNamePreview"];
            if (_data["summary"]) {
                this.summary = {} as any;
                for (let key in _data["summary"]) {
                    if (_data["summary"].hasOwnProperty(key))
                        (this.summary as any)![key] = _data["summary"][key];
                }
            }
            this.error = _data["error"];
        }
    }

    static override fromJS(data: any): PunchImportPreviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchImportPreviewViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateNamePreview"] = this.templateNamePreview;
        if (this.summary) {
            data["summary"] = {};
            for (let key in this.summary) {
                if (this.summary.hasOwnProperty(key))
                    (data["summary"] as any)[key] = (this.summary as any)[key];
            }
        }
        data["error"] = this.error;
        super.toJSON(data);
        return data;
    }
}

export interface IPunchImportPreviewViewModel extends IPunchImportViewModel {
    templateNamePreview?: string | undefined;
    summary?: { [key: string]: number; } | undefined;
    error?: string | undefined;
}

export class PunchImportMultipleInspectionsViewModel implements IPunchImportMultipleInspectionsViewModel {
    template?: string | undefined;
    timezone?: string | undefined;

    constructor(data?: IPunchImportMultipleInspectionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): PunchImportMultipleInspectionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchImportMultipleInspectionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IPunchImportMultipleInspectionsViewModel {
    template?: string | undefined;
    timezone?: string | undefined;
}

export class PunchImportMultipleInspectionsPreviewViewModel extends PunchImportMultipleInspectionsViewModel implements IPunchImportMultipleInspectionsPreviewViewModel {
    templateNamePreview?: string | undefined;
    inspections?: MasterViewModel[] | undefined;
    summary?: { [key: string]: string; } | undefined;
    error?: string | undefined;
    isCorrect?: boolean;

    constructor(data?: IPunchImportMultipleInspectionsPreviewViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.templateNamePreview = _data["templateNamePreview"];
            if (Array.isArray(_data["inspections"])) {
                this.inspections = [] as any;
                for (let item of _data["inspections"])
                    this.inspections!.push(MasterViewModel.fromJS(item));
            }
            if (_data["summary"]) {
                this.summary = {} as any;
                for (let key in _data["summary"]) {
                    if (_data["summary"].hasOwnProperty(key))
                        (this.summary as any)![key] = _data["summary"][key];
                }
            }
            this.error = _data["error"];
            this.isCorrect = _data["isCorrect"];
        }
    }

    static override fromJS(data: any): PunchImportMultipleInspectionsPreviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchImportMultipleInspectionsPreviewViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateNamePreview"] = this.templateNamePreview;
        if (Array.isArray(this.inspections)) {
            data["inspections"] = [];
            for (let item of this.inspections)
                data["inspections"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.summary) {
            data["summary"] = {};
            for (let key in this.summary) {
                if (this.summary.hasOwnProperty(key))
                    (data["summary"] as any)[key] = (this.summary as any)[key];
            }
        }
        data["error"] = this.error;
        data["isCorrect"] = this.isCorrect;
        super.toJSON(data);
        return data;
    }
}

export interface IPunchImportMultipleInspectionsPreviewViewModel extends IPunchImportMultipleInspectionsViewModel {
    templateNamePreview?: string | undefined;
    inspections?: MasterViewModel[] | undefined;
    summary?: { [key: string]: string; } | undefined;
    error?: string | undefined;
    isCorrect?: boolean;
}

export class TemplateSetUpDto implements ITemplateSetUpDto {
    id?: number;
    template?: string | undefined;
    templateName?: string | undefined;
    summary?: { [key: string]: number; } | undefined;
    error?: string | undefined;

    constructor(data?: ITemplateSetUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.template = _data["template"];
            this.templateName = _data["templateName"];
            if (_data["summary"]) {
                this.summary = {} as any;
                for (let key in _data["summary"]) {
                    if (_data["summary"].hasOwnProperty(key))
                        (this.summary as any)![key] = _data["summary"][key];
                }
            }
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): TemplateSetUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSetUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["template"] = this.template;
        data["templateName"] = this.templateName;
        if (this.summary) {
            data["summary"] = {};
            for (let key in this.summary) {
                if (this.summary.hasOwnProperty(key))
                    (data["summary"] as any)[key] = (this.summary as any)[key];
            }
        }
        data["error"] = this.error;
        return data;
    }
}

export interface ITemplateSetUpDto {
    id?: number;
    template?: string | undefined;
    templateName?: string | undefined;
    summary?: { [key: string]: number; } | undefined;
    error?: string | undefined;
}

export class InspectionTypeSelectedCategoriesViewModel implements IInspectionTypeSelectedCategoriesViewModel {
    inspectionId?: number;
    categoriesIds?: (number | undefined)[] | undefined;

    constructor(data?: IInspectionTypeSelectedCategoriesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            if (Array.isArray(_data["categoriesIds"])) {
                this.categoriesIds = [] as any;
                for (let item of _data["categoriesIds"])
                    this.categoriesIds!.push(item);
            }
        }
    }

    static fromJS(data: any): InspectionTypeSelectedCategoriesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeSelectedCategoriesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        if (Array.isArray(this.categoriesIds)) {
            data["categoriesIds"] = [];
            for (let item of this.categoriesIds)
                data["categoriesIds"].push(item);
        }
        return data;
    }
}

export interface IInspectionTypeSelectedCategoriesViewModel {
    inspectionId?: number;
    categoriesIds?: (number | undefined)[] | undefined;
}

export class InspectionTypeSelectedTopicsViewModel implements IInspectionTypeSelectedTopicsViewModel {
    inspectionId?: number;
    topicsIds?: (number | undefined)[] | undefined;

    constructor(data?: IInspectionTypeSelectedTopicsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            if (Array.isArray(_data["topicsIds"])) {
                this.topicsIds = [] as any;
                for (let item of _data["topicsIds"])
                    this.topicsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): InspectionTypeSelectedTopicsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeSelectedTopicsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        if (Array.isArray(this.topicsIds)) {
            data["topicsIds"] = [];
            for (let item of this.topicsIds)
                data["topicsIds"].push(item);
        }
        return data;
    }
}

export interface IInspectionTypeSelectedTopicsViewModel {
    inspectionId?: number;
    topicsIds?: (number | undefined)[] | undefined;
}

export class PunchBookmarksViewModel implements IPunchBookmarksViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    originator?: string | undefined;
    raisedBy?: string | undefined;
    inspection?: string | undefined;
    templateId?: number;
    commentary?: string | undefined;
    createdAt?: string | undefined;
    punchItems?: string | undefined;
    subContractorId?: number | undefined;
    subContractor?: string | undefined;
    subContractorCode?: string | undefined;
    subContractorShortDescription?: string | undefined;
    disciplineId?: number | undefined;
    discipline?: string | undefined;
    categoryId?: number | undefined;
    category?: string | undefined;
    statusId?: number | undefined;
    status?: string | undefined;
    actionById?: number | undefined;
    actionBy?: string | undefined;
    topicId?: number | undefined;
    topic?: string | undefined;
    expectedClosingDate?: Date | undefined;
    elementMatchIds?: number[] | undefined;
    customFields?: CustomFieldBookmarks[] | undefined;
    signs?: SignatureBookmarks[] | undefined;

    constructor(data?: IPunchBookmarksViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.originator = _data["originator"];
            this.raisedBy = _data["raisedBy"];
            this.inspection = _data["inspection"];
            this.templateId = _data["templateId"];
            this.commentary = _data["commentary"];
            this.createdAt = _data["createdAt"];
            this.punchItems = _data["punchItems"];
            this.subContractorId = _data["subContractorId"];
            this.subContractor = _data["subContractor"];
            this.subContractorCode = _data["subContractorCode"];
            this.subContractorShortDescription = _data["subContractorShortDescription"];
            this.disciplineId = _data["disciplineId"];
            this.discipline = _data["discipline"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
            this.statusId = _data["statusId"];
            this.status = _data["status"];
            this.actionById = _data["actionById"];
            this.actionBy = _data["actionBy"];
            this.topicId = _data["topicId"];
            this.topic = _data["topic"];
            this.expectedClosingDate = _data["expectedClosingDate"] ? new Date(_data["expectedClosingDate"].toString()) : undefined as any;
            if (Array.isArray(_data["elementMatchIds"])) {
                this.elementMatchIds = [] as any;
                for (let item of _data["elementMatchIds"])
                    this.elementMatchIds!.push(item);
            }
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomFieldBookmarks.fromJS(item));
            }
            if (Array.isArray(_data["signs"])) {
                this.signs = [] as any;
                for (let item of _data["signs"])
                    this.signs!.push(SignatureBookmarks.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchBookmarksViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchBookmarksViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["originator"] = this.originator;
        data["raisedBy"] = this.raisedBy;
        data["inspection"] = this.inspection;
        data["templateId"] = this.templateId;
        data["commentary"] = this.commentary;
        data["createdAt"] = this.createdAt;
        data["punchItems"] = this.punchItems;
        data["subContractorId"] = this.subContractorId;
        data["subContractor"] = this.subContractor;
        data["subContractorCode"] = this.subContractorCode;
        data["subContractorShortDescription"] = this.subContractorShortDescription;
        data["disciplineId"] = this.disciplineId;
        data["discipline"] = this.discipline;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        data["actionById"] = this.actionById;
        data["actionBy"] = this.actionBy;
        data["topicId"] = this.topicId;
        data["topic"] = this.topic;
        data["expectedClosingDate"] = this.expectedClosingDate ? this.expectedClosingDate.toISOString() : undefined as any;
        if (Array.isArray(this.elementMatchIds)) {
            data["elementMatchIds"] = [];
            for (let item of this.elementMatchIds)
                data["elementMatchIds"].push(item);
        }
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.signs)) {
            data["signs"] = [];
            for (let item of this.signs)
                data["signs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchBookmarksViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    originator?: string | undefined;
    raisedBy?: string | undefined;
    inspection?: string | undefined;
    templateId?: number;
    commentary?: string | undefined;
    createdAt?: string | undefined;
    punchItems?: string | undefined;
    subContractorId?: number | undefined;
    subContractor?: string | undefined;
    subContractorCode?: string | undefined;
    subContractorShortDescription?: string | undefined;
    disciplineId?: number | undefined;
    discipline?: string | undefined;
    categoryId?: number | undefined;
    category?: string | undefined;
    statusId?: number | undefined;
    status?: string | undefined;
    actionById?: number | undefined;
    actionBy?: string | undefined;
    topicId?: number | undefined;
    topic?: string | undefined;
    expectedClosingDate?: Date | undefined;
    elementMatchIds?: number[] | undefined;
    customFields?: CustomFieldBookmarks[] | undefined;
    signs?: SignatureBookmarks[] | undefined;
}

export class CustomFieldBookmarks implements ICustomFieldBookmarks {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: ICustomFieldBookmarks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomFieldBookmarks {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldBookmarks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomFieldBookmarks {
    name?: string | undefined;
    value?: string | undefined;
}

export class SignatureBookmarks implements ISignatureBookmarks {
    name?: string | undefined;
    sign?: string | undefined;
    role?: string | undefined;
    date?: string | undefined;

    constructor(data?: ISignatureBookmarks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sign = _data["sign"];
            this.role = _data["role"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): SignatureBookmarks {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureBookmarks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sign"] = this.sign;
        data["role"] = this.role;
        data["date"] = this.date;
        return data;
    }
}

export interface ISignatureBookmarks {
    name?: string | undefined;
    sign?: string | undefined;
    role?: string | undefined;
    date?: string | undefined;
}

export class PunchesFilterInDto extends FilterData implements IPunchesFilterInDto {
    elementIds?: number[] | undefined;
    allowSeeInactive?: boolean;

    constructor(data?: IPunchesFilterInDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["elementIds"])) {
                this.elementIds = [] as any;
                for (let item of _data["elementIds"])
                    this.elementIds!.push(item);
            }
            this.allowSeeInactive = _data["allowSeeInactive"];
        }
    }

    static override fromJS(data: any): PunchesFilterInDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchesFilterInDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elementIds)) {
            data["elementIds"] = [];
            for (let item of this.elementIds)
                data["elementIds"].push(item);
        }
        data["allowSeeInactive"] = this.allowSeeInactive;
        super.toJSON(data);
        return data;
    }
}

export interface IPunchesFilterInDto extends IFilterData {
    elementIds?: number[] | undefined;
    allowSeeInactive?: boolean;
}

export class PunchesQueryInDto extends PunchesFilterInDto implements IPunchesQueryInDto {
    pageSize?: number;
    pageIndex?: number;

    constructor(data?: IPunchesQueryInDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
        }
    }

    static override fromJS(data: any): PunchesQueryInDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchesQueryInDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        super.toJSON(data);
        return data;
    }
}

export interface IPunchesQueryInDto extends IPunchesFilterInDto {
    pageSize?: number;
    pageIndex?: number;
}

export class PunchesWithInspectionQueryInDto extends PunchesQueryInDto implements IPunchesWithInspectionQueryInDto {
    inspectionIds?: number[] | undefined;
    punchesCreatedOnRfi?: boolean;
    loadCover?: boolean;

    constructor(data?: IPunchesWithInspectionQueryInDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["inspectionIds"])) {
                this.inspectionIds = [] as any;
                for (let item of _data["inspectionIds"])
                    this.inspectionIds!.push(item);
            }
            this.punchesCreatedOnRfi = _data["punchesCreatedOnRfi"];
            this.loadCover = _data["loadCover"];
        }
    }

    static override fromJS(data: any): PunchesWithInspectionQueryInDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchesWithInspectionQueryInDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.inspectionIds)) {
            data["inspectionIds"] = [];
            for (let item of this.inspectionIds)
                data["inspectionIds"].push(item);
        }
        data["punchesCreatedOnRfi"] = this.punchesCreatedOnRfi;
        data["loadCover"] = this.loadCover;
        super.toJSON(data);
        return data;
    }
}

export interface IPunchesWithInspectionQueryInDto extends IPunchesQueryInDto {
    inspectionIds?: number[] | undefined;
    punchesCreatedOnRfi?: boolean;
    loadCover?: boolean;
}

export class PunchMilestoneExportViewModel implements IPunchMilestoneExportViewModel {
    code?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    punchItems?: string | undefined;
    category?: string | undefined;
    discipline?: string | undefined;
    actionBy?: string | undefined;
    originator?: string | undefined;
    subContractor?: string | undefined;
    commentary?: string | undefined;

    constructor(data?: IPunchMilestoneExportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.punchItems = _data["punchItems"];
            this.category = _data["category"];
            this.discipline = _data["discipline"];
            this.actionBy = _data["actionBy"];
            this.originator = _data["originator"];
            this.subContractor = _data["subContractor"];
            this.commentary = _data["commentary"];
        }
    }

    static fromJS(data: any): PunchMilestoneExportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchMilestoneExportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["status"] = this.status;
        data["punchItems"] = this.punchItems;
        data["category"] = this.category;
        data["discipline"] = this.discipline;
        data["actionBy"] = this.actionBy;
        data["originator"] = this.originator;
        data["subContractor"] = this.subContractor;
        data["commentary"] = this.commentary;
        return data;
    }
}

export interface IPunchMilestoneExportViewModel {
    code?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    punchItems?: string | undefined;
    category?: string | undefined;
    discipline?: string | undefined;
    actionBy?: string | undefined;
    originator?: string | undefined;
    subContractor?: string | undefined;
    commentary?: string | undefined;
}

export class PropertyFilterViewModel implements IPropertyFilterViewModel {
    propertyName?: string | undefined;
    propertyDescription?: string | undefined;
    possibleComparator?: string[] | undefined;
    responses?: CodeDescriptorViewModel[] | undefined;
    filtrable?: boolean | undefined;
    elementCode?: boolean | undefined;
    isDate?: boolean | undefined;
    type?: number | undefined;
    id?: number | undefined;

    constructor(data?: IPropertyFilterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.propertyDescription = _data["propertyDescription"];
            if (Array.isArray(_data["possibleComparator"])) {
                this.possibleComparator = [] as any;
                for (let item of _data["possibleComparator"])
                    this.possibleComparator!.push(item);
            }
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(CodeDescriptorViewModel.fromJS(item));
            }
            this.filtrable = _data["filtrable"];
            this.elementCode = _data["elementCode"];
            this.isDate = _data["isDate"];
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PropertyFilterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyFilterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["propertyDescription"] = this.propertyDescription;
        if (Array.isArray(this.possibleComparator)) {
            data["possibleComparator"] = [];
            for (let item of this.possibleComparator)
                data["possibleComparator"].push(item);
        }
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item ? item.toJSON() : undefined as any);
        }
        data["filtrable"] = this.filtrable;
        data["elementCode"] = this.elementCode;
        data["isDate"] = this.isDate;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface IPropertyFilterViewModel {
    propertyName?: string | undefined;
    propertyDescription?: string | undefined;
    possibleComparator?: string[] | undefined;
    responses?: CodeDescriptorViewModel[] | undefined;
    filtrable?: boolean | undefined;
    elementCode?: boolean | undefined;
    isDate?: boolean | undefined;
    type?: number | undefined;
    id?: number | undefined;
}

export class CodeDescriptorViewModel implements ICodeDescriptorViewModel {
    code?: any | undefined;
    description?: string | undefined;

    constructor(data?: ICodeDescriptorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CodeDescriptorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CodeDescriptorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface ICodeDescriptorViewModel {
    code?: any | undefined;
    description?: string | undefined;
}

export class BookmarkDataWapPunchReflectionViewModel implements IBookmarkDataWapPunchReflectionViewModel {
    bookmark?: string | undefined;
    entity?: string | undefined;
    source?: number;
    description?: string | undefined;
    field?: string | undefined;
    sized?: boolean;
    base64Image?: boolean;

    constructor(data?: IBookmarkDataWapPunchReflectionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookmark = _data["bookmark"];
            this.entity = _data["entity"];
            this.source = _data["source"];
            this.description = _data["description"];
            this.field = _data["field"];
            this.sized = _data["sized"];
            this.base64Image = _data["base64Image"];
        }
    }

    static fromJS(data: any): BookmarkDataWapPunchReflectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BookmarkDataWapPunchReflectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookmark"] = this.bookmark;
        data["entity"] = this.entity;
        data["source"] = this.source;
        data["description"] = this.description;
        data["field"] = this.field;
        data["sized"] = this.sized;
        data["base64Image"] = this.base64Image;
        return data;
    }
}

export interface IBookmarkDataWapPunchReflectionViewModel {
    bookmark?: string | undefined;
    entity?: string | undefined;
    source?: number;
    description?: string | undefined;
    field?: string | undefined;
    sized?: boolean;
    base64Image?: boolean;
}

export class PunchSimpleViewModelQueryResult implements IPunchSimpleViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: PunchSimpleViewModel[] | undefined;

    constructor(data?: IPunchSimpleViewModelQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.orderBy = _data["orderBy"];
            this.ascending = _data["ascending"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PunchSimpleViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchSimpleViewModelQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new PunchSimpleViewModelQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["orderBy"] = this.orderBy;
        data["ascending"] = this.ascending;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchSimpleViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: PunchSimpleViewModel[] | undefined;
}

export class PunchSimpleViewModel implements IPunchSimpleViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    topic?: TopicViewModel | undefined;
    discipline?: DisciplineViewModel | undefined;
    status?: StatusViewModel | undefined;
    category?: CategoryViewModel | undefined;
    originator?: MasterViewModel | undefined;
    userOriginator?: UserInfoViewModel | undefined;
    inspectionId?: number;
    closed?: boolean;
    createdBy?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date;
    notes?: string | undefined;
    cover?: PunchMediaViewModel | undefined;
    elements?: MasterViewModel[] | undefined;
    attachmentsCount?: number;

    constructor(data?: IPunchSimpleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.topic = _data["topic"] ? TopicViewModel.fromJS(_data["topic"]) : undefined as any;
            this.discipline = _data["discipline"] ? DisciplineViewModel.fromJS(_data["discipline"]) : undefined as any;
            this.status = _data["status"] ? StatusViewModel.fromJS(_data["status"]) : undefined as any;
            this.category = _data["category"] ? CategoryViewModel.fromJS(_data["category"]) : undefined as any;
            this.originator = _data["originator"] ? MasterViewModel.fromJS(_data["originator"]) : undefined as any;
            this.userOriginator = _data["userOriginator"] ? UserInfoViewModel.fromJS(_data["userOriginator"]) : undefined as any;
            this.inspectionId = _data["inspectionId"];
            this.closed = _data["closed"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.cover = _data["cover"] ? PunchMediaViewModel.fromJS(_data["cover"]) : undefined as any;
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(MasterViewModel.fromJS(item));
            }
            this.attachmentsCount = _data["attachmentsCount"];
        }
    }

    static fromJS(data: any): PunchSimpleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchSimpleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["topic"] = this.topic ? this.topic.toJSON() : undefined as any;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["originator"] = this.originator ? this.originator.toJSON() : undefined as any;
        data["userOriginator"] = this.userOriginator ? this.userOriginator.toJSON() : undefined as any;
        data["inspectionId"] = this.inspectionId;
        data["closed"] = this.closed;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["cover"] = this.cover ? this.cover.toJSON() : undefined as any;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        data["attachmentsCount"] = this.attachmentsCount;
        return data;
    }
}

export interface IPunchSimpleViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    topic?: TopicViewModel | undefined;
    discipline?: DisciplineViewModel | undefined;
    status?: StatusViewModel | undefined;
    category?: CategoryViewModel | undefined;
    originator?: MasterViewModel | undefined;
    userOriginator?: UserInfoViewModel | undefined;
    inspectionId?: number;
    closed?: boolean;
    createdBy?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date;
    notes?: string | undefined;
    cover?: PunchMediaViewModel | undefined;
    elements?: MasterViewModel[] | undefined;
    attachmentsCount?: number;
}

export class PunchDetailSimpleViewModel implements IPunchDetailSimpleViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    originatorCompany?: MasterViewModel | undefined;
    originator?: UserInfoViewModel | undefined;
    topic?: TopicViewModel | undefined;
    discipline?: DisciplineViewModel | undefined;
    status?: StatusViewModel | undefined;
    category?: CategoryViewModel | undefined;
    departmentAction?: MasterViewModel | undefined;
    inspection?: InspectionViewModel | undefined;
    subContractor?: SubcontractorDto | undefined;
    punchMedia?: PunchMediaViewModel[] | undefined;
    itemsAffected?: ElementsViewModel[] | undefined;
    punchTags?: PunchTagsDto[] | undefined;
    cover?: PunchMediaViewModel | undefined;
    closed?: boolean | undefined;
    createdAt?: Date;
    commentary?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IPunchDetailSimpleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.originatorCompany = _data["originatorCompany"] ? MasterViewModel.fromJS(_data["originatorCompany"]) : undefined as any;
            this.originator = _data["originator"] ? UserInfoViewModel.fromJS(_data["originator"]) : undefined as any;
            this.topic = _data["topic"] ? TopicViewModel.fromJS(_data["topic"]) : undefined as any;
            this.discipline = _data["discipline"] ? DisciplineViewModel.fromJS(_data["discipline"]) : undefined as any;
            this.status = _data["status"] ? StatusViewModel.fromJS(_data["status"]) : undefined as any;
            this.category = _data["category"] ? CategoryViewModel.fromJS(_data["category"]) : undefined as any;
            this.departmentAction = _data["departmentAction"] ? MasterViewModel.fromJS(_data["departmentAction"]) : undefined as any;
            this.inspection = _data["inspection"] ? InspectionViewModel.fromJS(_data["inspection"]) : undefined as any;
            this.subContractor = _data["subContractor"] ? SubcontractorDto.fromJS(_data["subContractor"]) : undefined as any;
            if (Array.isArray(_data["punchMedia"])) {
                this.punchMedia = [] as any;
                for (let item of _data["punchMedia"])
                    this.punchMedia!.push(PunchMediaViewModel.fromJS(item));
            }
            if (Array.isArray(_data["itemsAffected"])) {
                this.itemsAffected = [] as any;
                for (let item of _data["itemsAffected"])
                    this.itemsAffected!.push(ElementsViewModel.fromJS(item));
            }
            if (Array.isArray(_data["punchTags"])) {
                this.punchTags = [] as any;
                for (let item of _data["punchTags"])
                    this.punchTags!.push(PunchTagsDto.fromJS(item));
            }
            this.cover = _data["cover"] ? PunchMediaViewModel.fromJS(_data["cover"]) : undefined as any;
            this.closed = _data["closed"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.commentary = _data["commentary"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): PunchDetailSimpleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchDetailSimpleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["originatorCompany"] = this.originatorCompany ? this.originatorCompany.toJSON() : undefined as any;
        data["originator"] = this.originator ? this.originator.toJSON() : undefined as any;
        data["topic"] = this.topic ? this.topic.toJSON() : undefined as any;
        data["discipline"] = this.discipline ? this.discipline.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["departmentAction"] = this.departmentAction ? this.departmentAction.toJSON() : undefined as any;
        data["inspection"] = this.inspection ? this.inspection.toJSON() : undefined as any;
        data["subContractor"] = this.subContractor ? this.subContractor.toJSON() : undefined as any;
        if (Array.isArray(this.punchMedia)) {
            data["punchMedia"] = [];
            for (let item of this.punchMedia)
                data["punchMedia"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.itemsAffected)) {
            data["itemsAffected"] = [];
            for (let item of this.itemsAffected)
                data["itemsAffected"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.punchTags)) {
            data["punchTags"] = [];
            for (let item of this.punchTags)
                data["punchTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["cover"] = this.cover ? this.cover.toJSON() : undefined as any;
        data["closed"] = this.closed;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["commentary"] = this.commentary;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IPunchDetailSimpleViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    originatorCompany?: MasterViewModel | undefined;
    originator?: UserInfoViewModel | undefined;
    topic?: TopicViewModel | undefined;
    discipline?: DisciplineViewModel | undefined;
    status?: StatusViewModel | undefined;
    category?: CategoryViewModel | undefined;
    departmentAction?: MasterViewModel | undefined;
    inspection?: InspectionViewModel | undefined;
    subContractor?: SubcontractorDto | undefined;
    punchMedia?: PunchMediaViewModel[] | undefined;
    itemsAffected?: ElementsViewModel[] | undefined;
    punchTags?: PunchTagsDto[] | undefined;
    cover?: PunchMediaViewModel | undefined;
    closed?: boolean | undefined;
    createdAt?: Date;
    commentary?: string | undefined;
    notes?: string | undefined;
}

export class PunchDetailSimpleInViewModel implements IPunchDetailSimpleInViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    originatorCompanyId?: number;
    originator?: UserInfoViewModel | undefined;
    topicId?: number | undefined;
    disciplineId?: number | undefined;
    categoryId?: number | undefined;
    itemsAffected?: ElementsViewModel[] | undefined;
    inspectionId?: number;
    notes?: string | undefined;

    constructor(data?: IPunchDetailSimpleInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.originatorCompanyId = _data["originatorCompanyId"];
            this.originator = _data["originator"] ? UserInfoViewModel.fromJS(_data["originator"]) : undefined as any;
            this.topicId = _data["topicId"];
            this.disciplineId = _data["disciplineId"];
            this.categoryId = _data["categoryId"];
            if (Array.isArray(_data["itemsAffected"])) {
                this.itemsAffected = [] as any;
                for (let item of _data["itemsAffected"])
                    this.itemsAffected!.push(ElementsViewModel.fromJS(item));
            }
            this.inspectionId = _data["inspectionId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): PunchDetailSimpleInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchDetailSimpleInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["originatorCompanyId"] = this.originatorCompanyId;
        data["originator"] = this.originator ? this.originator.toJSON() : undefined as any;
        data["topicId"] = this.topicId;
        data["disciplineId"] = this.disciplineId;
        data["categoryId"] = this.categoryId;
        if (Array.isArray(this.itemsAffected)) {
            data["itemsAffected"] = [];
            for (let item of this.itemsAffected)
                data["itemsAffected"].push(item ? item.toJSON() : undefined as any);
        }
        data["inspectionId"] = this.inspectionId;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IPunchDetailSimpleInViewModel {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    originatorCompanyId?: number;
    originator?: UserInfoViewModel | undefined;
    topicId?: number | undefined;
    disciplineId?: number | undefined;
    categoryId?: number | undefined;
    itemsAffected?: ElementsViewModel[] | undefined;
    inspectionId?: number;
    notes?: string | undefined;
}

export class PunchMasterDataViewModel implements IPunchMasterDataViewModel {
    categories?: CategoryViewModel[] | undefined;
    disciplines?: MasterViewModel[] | undefined;
    originators?: MasterViewModel[] | undefined;
    topics?: MasterViewModel[] | undefined;
    statuses?: MasterViewModel[] | undefined;
    users?: UserInfoViewModel[] | undefined;

    constructor(data?: IPunchMasterDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoryViewModel.fromJS(item));
            }
            if (Array.isArray(_data["disciplines"])) {
                this.disciplines = [] as any;
                for (let item of _data["disciplines"])
                    this.disciplines!.push(MasterViewModel.fromJS(item));
            }
            if (Array.isArray(_data["originators"])) {
                this.originators = [] as any;
                for (let item of _data["originators"])
                    this.originators!.push(MasterViewModel.fromJS(item));
            }
            if (Array.isArray(_data["topics"])) {
                this.topics = [] as any;
                for (let item of _data["topics"])
                    this.topics!.push(MasterViewModel.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(MasterViewModel.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserInfoViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchMasterDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchMasterDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.disciplines)) {
            data["disciplines"] = [];
            for (let item of this.disciplines)
                data["disciplines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.originators)) {
            data["originators"] = [];
            for (let item of this.originators)
                data["originators"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchMasterDataViewModel {
    categories?: CategoryViewModel[] | undefined;
    disciplines?: MasterViewModel[] | undefined;
    originators?: MasterViewModel[] | undefined;
    topics?: MasterViewModel[] | undefined;
    statuses?: MasterViewModel[] | undefined;
    users?: UserInfoViewModel[] | undefined;
}

export class ProjectSyncViewModel extends MasterViewModel implements IProjectSyncViewModel {
    name?: string | undefined;
    client?: string | undefined;
    location?: string | undefined;

    constructor(data?: IProjectSyncViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.client = _data["client"];
            this.location = _data["location"];
        }
    }

    static override fromJS(data: any): ProjectSyncViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSyncViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["client"] = this.client;
        data["location"] = this.location;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectSyncViewModel extends IMasterViewModel {
    name?: string | undefined;
    client?: string | undefined;
    location?: string | undefined;
}

export class PunchSignatureSignViewModel implements IPunchSignatureSignViewModel {
    punchId?: number | undefined;
    sign?: string | undefined;
    date?: Date | undefined;
    remark?: PunchRemarkViewModel | undefined;
    templateId?: number;
    projectId?: number;
    signConfigId?: number | undefined;
    requiredRole?: string | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IPunchSignatureSignViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchId = _data["punchId"];
            this.sign = _data["sign"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.remark = _data["remark"] ? PunchRemarkViewModel.fromJS(_data["remark"]) : undefined as any;
            this.templateId = _data["templateId"];
            this.projectId = _data["projectId"];
            this.signConfigId = _data["signConfigId"];
            this.requiredRole = _data["requiredRole"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchSignatureSignViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchSignatureSignViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchId"] = this.punchId;
        data["sign"] = this.sign;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["remark"] = this.remark ? this.remark.toJSON() : undefined as any;
        data["templateId"] = this.templateId;
        data["projectId"] = this.projectId;
        data["signConfigId"] = this.signConfigId;
        data["requiredRole"] = this.requiredRole;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchSignatureSignViewModel {
    punchId?: number | undefined;
    sign?: string | undefined;
    date?: Date | undefined;
    remark?: PunchRemarkViewModel | undefined;
    templateId?: number;
    projectId?: number;
    signConfigId?: number | undefined;
    requiredRole?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export class ConfiguredReportViewModelDataSourceResult implements IConfiguredReportViewModelDataSourceResult {
    data?: ConfiguredReportViewModel[] | undefined;
    total?: number;
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;

    constructor(data?: IConfiguredReportViewModelDataSourceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConfiguredReportViewModel.fromJS(item));
            }
            this.total = _data["total"];
            this.currentPage = _data["currentPage"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): ConfiguredReportViewModelDataSourceResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConfiguredReportViewModelDataSourceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IConfiguredReportViewModelDataSourceResult {
    data?: ConfiguredReportViewModel[] | undefined;
    total?: number;
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
}

export class ConfiguredReportViewModel implements IConfiguredReportViewModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    tags?: ConfiguredReportTagViewModel[] | undefined;
    lastUpdate?: Date | undefined;
    media?: ConfiguredReportMediaViewModel | undefined;
    reportSource?: PbiReportViewModel | undefined;

    constructor(data?: IConfiguredReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ConfiguredReportTagViewModel.fromJS(item));
            }
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : undefined as any;
            this.media = _data["media"] ? ConfiguredReportMediaViewModel.fromJS(_data["media"]) : undefined as any;
            this.reportSource = _data["reportSource"] ? PbiReportViewModel.fromJS(_data["reportSource"]) : undefined as any;
        }
    }

    static fromJS(data: any): ConfiguredReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfiguredReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : undefined as any;
        data["media"] = this.media ? this.media.toJSON() : undefined as any;
        data["reportSource"] = this.reportSource ? this.reportSource.toJSON() : undefined as any;
        return data;
    }
}

export interface IConfiguredReportViewModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    tags?: ConfiguredReportTagViewModel[] | undefined;
    lastUpdate?: Date | undefined;
    media?: ConfiguredReportMediaViewModel | undefined;
    reportSource?: PbiReportViewModel | undefined;
}

export class ConfiguredReportTagViewModel implements IConfiguredReportTagViewModel {
    code?: string | undefined;

    constructor(data?: IConfiguredReportTagViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ConfiguredReportTagViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfiguredReportTagViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IConfiguredReportTagViewModel {
    code?: string | undefined;
}

export class ConfiguredReportMediaViewModel implements IConfiguredReportMediaViewModel {
    mimeType?: string | undefined;
    fileName?: string | undefined;
    thumbnail?: string | undefined;

    constructor(data?: IConfiguredReportMediaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mimeType = _data["mimeType"];
            this.fileName = _data["fileName"];
            this.thumbnail = _data["thumbnail"];
        }
    }

    static fromJS(data: any): ConfiguredReportMediaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfiguredReportMediaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mimeType"] = this.mimeType;
        data["fileName"] = this.fileName;
        data["thumbnail"] = this.thumbnail;
        return data;
    }
}

export interface IConfiguredReportMediaViewModel {
    mimeType?: string | undefined;
    fileName?: string | undefined;
    thumbnail?: string | undefined;
}

export class PbiReportViewModel implements IPbiReportViewModel {
    id?: number;
    modifiedBy?: string | undefined;
    createdBy?: string | undefined;
    pbiId?: string | undefined;
    pbiName?: string | undefined;
    pbiDescription?: string | undefined;
    pbiModified?: Date | undefined;
    pbiCreated?: Date | undefined;
    pbiModifiedBy?: string | undefined;
    pbiCreatedBy?: string | undefined;
    datasetId?: string | undefined;
    version?: string | undefined;
    embedUrl?: string | undefined;
    webUrl?: string | undefined;
    embedToken?: EmbedToken | undefined;

    constructor(data?: IPbiReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modifiedBy = _data["modifiedBy"];
            this.createdBy = _data["createdBy"];
            this.pbiId = _data["pbiId"];
            this.pbiName = _data["pbiName"];
            this.pbiDescription = _data["pbiDescription"];
            this.pbiModified = _data["pbiModified"] ? new Date(_data["pbiModified"].toString()) : undefined as any;
            this.pbiCreated = _data["pbiCreated"] ? new Date(_data["pbiCreated"].toString()) : undefined as any;
            this.pbiModifiedBy = _data["pbiModifiedBy"];
            this.pbiCreatedBy = _data["pbiCreatedBy"];
            this.datasetId = _data["datasetId"];
            this.version = _data["version"];
            this.embedUrl = _data["embedUrl"];
            this.webUrl = _data["webUrl"];
            this.embedToken = _data["embedToken"] ? EmbedToken.fromJS(_data["embedToken"]) : undefined as any;
        }
    }

    static fromJS(data: any): PbiReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PbiReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedBy"] = this.modifiedBy;
        data["createdBy"] = this.createdBy;
        data["pbiId"] = this.pbiId;
        data["pbiName"] = this.pbiName;
        data["pbiDescription"] = this.pbiDescription;
        data["pbiModified"] = this.pbiModified ? this.pbiModified.toISOString() : undefined as any;
        data["pbiCreated"] = this.pbiCreated ? this.pbiCreated.toISOString() : undefined as any;
        data["pbiModifiedBy"] = this.pbiModifiedBy;
        data["pbiCreatedBy"] = this.pbiCreatedBy;
        data["datasetId"] = this.datasetId;
        data["version"] = this.version;
        data["embedUrl"] = this.embedUrl;
        data["webUrl"] = this.webUrl;
        data["embedToken"] = this.embedToken ? this.embedToken.toJSON() : undefined as any;
        return data;
    }
}

export interface IPbiReportViewModel {
    id?: number;
    modifiedBy?: string | undefined;
    createdBy?: string | undefined;
    pbiId?: string | undefined;
    pbiName?: string | undefined;
    pbiDescription?: string | undefined;
    pbiModified?: Date | undefined;
    pbiCreated?: Date | undefined;
    pbiModifiedBy?: string | undefined;
    pbiCreatedBy?: string | undefined;
    datasetId?: string | undefined;
    version?: string | undefined;
    embedUrl?: string | undefined;
    webUrl?: string | undefined;
    embedToken?: EmbedToken | undefined;
}

export class EmbedToken implements IEmbedToken {
    token?: string | undefined;
    tokenId?: string;
    expiration?: Date;

    constructor(data?: IEmbedToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenId = _data["tokenId"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EmbedToken {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenId"] = this.tokenId;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : undefined as any;
        return data;
    }
}

export interface IEmbedToken {
    token?: string | undefined;
    tokenId?: string;
    expiration?: Date;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export class MatchWbsViewModel implements IMatchWbsViewModel {
    elements?: ElementsViewModel[] | undefined;
    projectId?: number | undefined;
    templateId?: number | undefined;

    constructor(data?: IMatchWbsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ElementsViewModel.fromJS(item));
            }
            this.projectId = _data["projectId"];
            this.templateId = _data["templateId"];
        }
    }

    static fromJS(data: any): MatchWbsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MatchWbsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectId"] = this.projectId;
        data["templateId"] = this.templateId;
        return data;
    }
}

export interface IMatchWbsViewModel {
    elements?: ElementsViewModel[] | undefined;
    projectId?: number | undefined;
    templateId?: number | undefined;
}

export class ElementsWithPunchesIdsViewModel implements IElementsWithPunchesIdsViewModel {
    elementMatchId?: number;
    punchesIds?: number[] | undefined;

    constructor(data?: IElementsWithPunchesIdsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementMatchId = _data["elementMatchId"];
            if (Array.isArray(_data["punchesIds"])) {
                this.punchesIds = [] as any;
                for (let item of _data["punchesIds"])
                    this.punchesIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ElementsWithPunchesIdsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ElementsWithPunchesIdsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementMatchId"] = this.elementMatchId;
        if (Array.isArray(this.punchesIds)) {
            data["punchesIds"] = [];
            for (let item of this.punchesIds)
                data["punchesIds"].push(item);
        }
        return data;
    }
}

export interface IElementsWithPunchesIdsViewModel {
    elementMatchId?: number;
    punchesIds?: number[] | undefined;
}

export class ElementTreeViewModel implements IElementTreeViewModel {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    nodeLevelId?: number;
    haveChildren?: boolean;

    constructor(data?: IElementTreeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.nodeLevelId = _data["nodeLevelId"];
            this.haveChildren = _data["haveChildren"];
        }
    }

    static fromJS(data: any): ElementTreeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ElementTreeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["nodeLevelId"] = this.nodeLevelId;
        data["haveChildren"] = this.haveChildren;
        return data;
    }
}

export interface IElementTreeViewModel {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    nodeLevelId?: number;
    haveChildren?: boolean;
}

export class ElementTreeListViewModelQueryResult implements IElementTreeListViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: ElementTreeListViewModel[] | undefined;

    constructor(data?: IElementTreeListViewModelQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.orderBy = _data["orderBy"];
            this.ascending = _data["ascending"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ElementTreeListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElementTreeListViewModelQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new ElementTreeListViewModelQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["orderBy"] = this.orderBy;
        data["ascending"] = this.ascending;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IElementTreeListViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: ElementTreeListViewModel[] | undefined;
}

export class ElementTreeListViewModel extends MasterViewModel implements IElementTreeListViewModel {
    nodeLevel?: string | undefined;
    punchCount?: number;

    constructor(data?: IElementTreeListViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nodeLevel = _data["nodeLevel"];
            this.punchCount = _data["punchCount"];
        }
    }

    static override fromJS(data: any): ElementTreeListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ElementTreeListViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeLevel"] = this.nodeLevel;
        data["punchCount"] = this.punchCount;
        super.toJSON(data);
        return data;
    }
}

export interface IElementTreeListViewModel extends IMasterViewModel {
    nodeLevel?: string | undefined;
    punchCount?: number;
}

export class TreeElementQueryData extends FilterData implements ITreeElementQueryData {
    pageSize?: number;
    pageIndex?: number;
    elementId?: number;
    nodeLevelHierarchyId?: number;

    constructor(data?: ITreeElementQueryData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.elementId = _data["elementId"];
            this.nodeLevelHierarchyId = _data["nodeLevelHierarchyId"];
        }
    }

    static override fromJS(data: any): TreeElementQueryData {
        data = typeof data === 'object' ? data : {};
        let result = new TreeElementQueryData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["elementId"] = this.elementId;
        data["nodeLevelHierarchyId"] = this.nodeLevelHierarchyId;
        super.toJSON(data);
        return data;
    }
}

export interface ITreeElementQueryData extends IFilterData {
    pageSize?: number;
    pageIndex?: number;
    elementId?: number;
    nodeLevelHierarchyId?: number;
}

export class TemplateSetUpModelView implements ITemplateSetUpModelView {
    template?: string | undefined;

    constructor(data?: ITemplateSetUpModelView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"];
        }
    }

    static fromJS(data: any): TemplateSetUpModelView {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSetUpModelView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template;
        return data;
    }
}

export interface ITemplateSetUpModelView {
    template?: string | undefined;
}

export class TemplateSetUpInModelView extends TemplateSetUpModelView implements ITemplateSetUpInModelView {
    templateName?: string | undefined;
    summary?: { [key: string]: number; } | undefined;
    error?: string | undefined;

    constructor(data?: ITemplateSetUpInModelView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.templateName = _data["templateName"];
            if (_data["summary"]) {
                this.summary = {} as any;
                for (let key in _data["summary"]) {
                    if (_data["summary"].hasOwnProperty(key))
                        (this.summary as any)![key] = _data["summary"][key];
                }
            }
            this.error = _data["error"];
        }
    }

    static override fromJS(data: any): TemplateSetUpInModelView {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSetUpInModelView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        if (this.summary) {
            data["summary"] = {};
            for (let key in this.summary) {
                if (this.summary.hasOwnProperty(key))
                    (data["summary"] as any)[key] = (this.summary as any)[key];
            }
        }
        data["error"] = this.error;
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateSetUpInModelView extends ITemplateSetUpModelView {
    templateName?: string | undefined;
    summary?: { [key: string]: number; } | undefined;
    error?: string | undefined;
}

export class RoleViewModel implements IRoleViewModel {
    id?: number;
    code?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    rolePermissions?: string[] | undefined;

    constructor(data?: IRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            if (Array.isArray(_data["rolePermissions"])) {
                this.rolePermissions = [] as any;
                for (let item of _data["rolePermissions"])
                    this.rolePermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        if (Array.isArray(this.rolePermissions)) {
            data["rolePermissions"] = [];
            for (let item of this.rolePermissions)
                data["rolePermissions"].push(item);
        }
        return data;
    }
}

export interface IRoleViewModel {
    id?: number;
    code?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    rolePermissions?: string[] | undefined;
}

export class PolicyViewModel implements IPolicyViewModel {
    id?: number;
    name?: string | undefined;
    claimType?: string | undefined;
    requiredClaimValues?: string[] | undefined;

    constructor(data?: IPolicyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.claimType = _data["claimType"];
            if (Array.isArray(_data["requiredClaimValues"])) {
                this.requiredClaimValues = [] as any;
                for (let item of _data["requiredClaimValues"])
                    this.requiredClaimValues!.push(item);
            }
        }
    }

    static fromJS(data: any): PolicyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["claimType"] = this.claimType;
        if (Array.isArray(this.requiredClaimValues)) {
            data["requiredClaimValues"] = [];
            for (let item of this.requiredClaimValues)
                data["requiredClaimValues"].push(item);
        }
        return data;
    }
}

export interface IPolicyViewModel {
    id?: number;
    name?: string | undefined;
    claimType?: string | undefined;
    requiredClaimValues?: string[] | undefined;
}

export class PermissionRoleViewModel implements IPermissionRoleViewModel {
    id?: number;
    policyName?: string | undefined;
    groupDescription?: string | undefined;
    permissionDescription?: string | undefined;
    roles?: RoleSimpleViewModel[] | undefined;

    constructor(data?: IPermissionRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policyName = _data["policyName"];
            this.groupDescription = _data["groupDescription"];
            this.permissionDescription = _data["permissionDescription"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleSimpleViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionRoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionRoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policyName"] = this.policyName;
        data["groupDescription"] = this.groupDescription;
        data["permissionDescription"] = this.permissionDescription;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPermissionRoleViewModel {
    id?: number;
    policyName?: string | undefined;
    groupDescription?: string | undefined;
    permissionDescription?: string | undefined;
    roles?: RoleSimpleViewModel[] | undefined;
}

export class RoleSimpleViewModel implements IRoleSimpleViewModel {
    id?: number;
    displayName?: string | undefined;

    constructor(data?: IRoleSimpleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RoleSimpleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleSimpleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRoleSimpleViewModel {
    id?: number;
    displayName?: string | undefined;
}

export class UserAuthorizationViewModel implements IUserAuthorizationViewModel {
    id?: string;
    email?: string | undefined;
    fullName?: string | undefined;
    userType?: string | undefined;
    userTypeId?: number;
    applicationUserAuthId?: number;
    authorizations?: AuthorizationViewModel[] | undefined;

    constructor(data?: IUserAuthorizationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.userType = _data["userType"];
            this.userTypeId = _data["userTypeId"];
            this.applicationUserAuthId = _data["applicationUserAuthId"];
            if (Array.isArray(_data["authorizations"])) {
                this.authorizations = [] as any;
                for (let item of _data["authorizations"])
                    this.authorizations!.push(AuthorizationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserAuthorizationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuthorizationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["userType"] = this.userType;
        data["userTypeId"] = this.userTypeId;
        data["applicationUserAuthId"] = this.applicationUserAuthId;
        if (Array.isArray(this.authorizations)) {
            data["authorizations"] = [];
            for (let item of this.authorizations)
                data["authorizations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserAuthorizationViewModel {
    id?: string;
    email?: string | undefined;
    fullName?: string | undefined;
    userType?: string | undefined;
    userTypeId?: number;
    applicationUserAuthId?: number;
    authorizations?: AuthorizationViewModel[] | undefined;
}

export class AuthorizationViewModel implements IAuthorizationViewModel {
    id?: number;
    projectId?: number | undefined;
    projectCode?: string | undefined;
    isGlobal?: boolean;
    authorizationProperties?: { [key: string]: string; } | undefined;
    authProperties?: AuthPropertyViewModel[] | undefined;
    roles?: string[] | undefined;

    constructor(data?: IAuthorizationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectCode = _data["projectCode"];
            this.isGlobal = _data["isGlobal"];
            if (_data["authorizationProperties"]) {
                this.authorizationProperties = {} as any;
                for (let key in _data["authorizationProperties"]) {
                    if (_data["authorizationProperties"].hasOwnProperty(key))
                        (this.authorizationProperties as any)![key] = _data["authorizationProperties"][key];
                }
            }
            if (Array.isArray(_data["authProperties"])) {
                this.authProperties = [] as any;
                for (let item of _data["authProperties"])
                    this.authProperties!.push(AuthPropertyViewModel.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): AuthorizationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectCode"] = this.projectCode;
        data["isGlobal"] = this.isGlobal;
        if (this.authorizationProperties) {
            data["authorizationProperties"] = {};
            for (let key in this.authorizationProperties) {
                if (this.authorizationProperties.hasOwnProperty(key))
                    (data["authorizationProperties"] as any)[key] = (this.authorizationProperties as any)[key];
            }
        }
        if (Array.isArray(this.authProperties)) {
            data["authProperties"] = [];
            for (let item of this.authProperties)
                data["authProperties"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IAuthorizationViewModel {
    id?: number;
    projectId?: number | undefined;
    projectCode?: string | undefined;
    isGlobal?: boolean;
    authorizationProperties?: { [key: string]: string; } | undefined;
    authProperties?: AuthPropertyViewModel[] | undefined;
    roles?: string[] | undefined;
}

export class AuthPropertyViewModel implements IAuthPropertyViewModel {
    key?: string | undefined;
    values?: string[] | undefined;

    constructor(data?: IAuthPropertyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): AuthPropertyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthPropertyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IAuthPropertyViewModel {
    key?: string | undefined;
    values?: string[] | undefined;
}

export class RegisterAndAuthorizeUserInViewModel implements IRegisterAndAuthorizeUserInViewModel {
    userId?: string;
    applicationId?: number;
    email?: string | undefined;
    fullName?: string | undefined;
    userType?: number;
    roles?: string[] | undefined;
    authorizationProperties?: { [key: string]: AuthorizationPropertyValueInViewModel; } | undefined;

    constructor(data?: IRegisterAndAuthorizeUserInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.applicationId = _data["applicationId"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.userType = _data["userType"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (_data["authorizationProperties"]) {
                this.authorizationProperties = {} as any;
                for (let key in _data["authorizationProperties"]) {
                    if (_data["authorizationProperties"].hasOwnProperty(key))
                        (this.authorizationProperties as any)![key] = _data["authorizationProperties"][key] ? AuthorizationPropertyValueInViewModel.fromJS(_data["authorizationProperties"][key]) : new AuthorizationPropertyValueInViewModel();
                }
            }
        }
    }

    static fromJS(data: any): RegisterAndAuthorizeUserInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterAndAuthorizeUserInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["applicationId"] = this.applicationId;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["userType"] = this.userType;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (this.authorizationProperties) {
            data["authorizationProperties"] = {};
            for (let key in this.authorizationProperties) {
                if (this.authorizationProperties.hasOwnProperty(key))
                    (data["authorizationProperties"] as any)[key] = this.authorizationProperties[key] ? this.authorizationProperties[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IRegisterAndAuthorizeUserInViewModel {
    userId?: string;
    applicationId?: number;
    email?: string | undefined;
    fullName?: string | undefined;
    userType?: number;
    roles?: string[] | undefined;
    authorizationProperties?: { [key: string]: AuthorizationPropertyValueInViewModel; } | undefined;
}

export class AuthorizationPropertyValueInViewModel implements IAuthorizationPropertyValueInViewModel {
    value?: string | undefined;
    includeAsClaim?: boolean;

    constructor(data?: IAuthorizationPropertyValueInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.includeAsClaim = _data["includeAsClaim"];
        }
    }

    static fromJS(data: any): AuthorizationPropertyValueInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationPropertyValueInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["includeAsClaim"] = this.includeAsClaim;
        return data;
    }
}

export interface IAuthorizationPropertyValueInViewModel {
    value?: string | undefined;
    includeAsClaim?: boolean;
}

export class AuthorizeUserInViewModel implements IAuthorizeUserInViewModel {
    userId?: string;
    applicationUserAuthId?: number;
    roles?: string[] | undefined;
    authorizationProperties?: { [key: string]: AuthorizationPropertyValueInViewModel; } | undefined;

    constructor(data?: IAuthorizeUserInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.applicationUserAuthId = _data["applicationUserAuthId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (_data["authorizationProperties"]) {
                this.authorizationProperties = {} as any;
                for (let key in _data["authorizationProperties"]) {
                    if (_data["authorizationProperties"].hasOwnProperty(key))
                        (this.authorizationProperties as any)![key] = _data["authorizationProperties"][key] ? AuthorizationPropertyValueInViewModel.fromJS(_data["authorizationProperties"][key]) : new AuthorizationPropertyValueInViewModel();
                }
            }
        }
    }

    static fromJS(data: any): AuthorizeUserInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeUserInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["applicationUserAuthId"] = this.applicationUserAuthId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (this.authorizationProperties) {
            data["authorizationProperties"] = {};
            for (let key in this.authorizationProperties) {
                if (this.authorizationProperties.hasOwnProperty(key))
                    (data["authorizationProperties"] as any)[key] = this.authorizationProperties[key] ? this.authorizationProperties[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IAuthorizeUserInViewModel {
    userId?: string;
    applicationUserAuthId?: number;
    roles?: string[] | undefined;
    authorizationProperties?: { [key: string]: AuthorizationPropertyValueInViewModel; } | undefined;
}

export class EditAuthorizationInViewModel implements IEditAuthorizationInViewModel {
    id?: number;
    applicationUserAuthId?: number;
    roles?: string[] | undefined;

    constructor(data?: IEditAuthorizationInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationUserAuthId = _data["applicationUserAuthId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): EditAuthorizationInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditAuthorizationInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationUserAuthId"] = this.applicationUserAuthId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IEditAuthorizationInViewModel {
    id?: number;
    applicationUserAuthId?: number;
    roles?: string[] | undefined;
}

export class EditAuthPropertiesInViewModel implements IEditAuthPropertiesInViewModel {
    id?: number;
    applicationUserAuthId?: number;
    authorizationProperties?: { [key: string]: AuthorizationPropertyValueInViewModel; } | undefined;
    authProperties?: AuthorizationPropertyInViewModel[] | undefined;
    roles?: string[] | undefined;

    constructor(data?: IEditAuthPropertiesInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationUserAuthId = _data["applicationUserAuthId"];
            if (_data["authorizationProperties"]) {
                this.authorizationProperties = {} as any;
                for (let key in _data["authorizationProperties"]) {
                    if (_data["authorizationProperties"].hasOwnProperty(key))
                        (this.authorizationProperties as any)![key] = _data["authorizationProperties"][key] ? AuthorizationPropertyValueInViewModel.fromJS(_data["authorizationProperties"][key]) : new AuthorizationPropertyValueInViewModel();
                }
            }
            if (Array.isArray(_data["authProperties"])) {
                this.authProperties = [] as any;
                for (let item of _data["authProperties"])
                    this.authProperties!.push(AuthorizationPropertyInViewModel.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): EditAuthPropertiesInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditAuthPropertiesInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationUserAuthId"] = this.applicationUserAuthId;
        if (this.authorizationProperties) {
            data["authorizationProperties"] = {};
            for (let key in this.authorizationProperties) {
                if (this.authorizationProperties.hasOwnProperty(key))
                    (data["authorizationProperties"] as any)[key] = this.authorizationProperties[key] ? this.authorizationProperties[key].toJSON() : undefined as any;
            }
        }
        if (Array.isArray(this.authProperties)) {
            data["authProperties"] = [];
            for (let item of this.authProperties)
                data["authProperties"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IEditAuthPropertiesInViewModel {
    id?: number;
    applicationUserAuthId?: number;
    authorizationProperties?: { [key: string]: AuthorizationPropertyValueInViewModel; } | undefined;
    authProperties?: AuthorizationPropertyInViewModel[] | undefined;
    roles?: string[] | undefined;
}

export class AuthorizationPropertyInViewModel implements IAuthorizationPropertyInViewModel {
    key?: string | undefined;
    values?: AuthorizationPropertyValueInViewModel[] | undefined;

    constructor(data?: IAuthorizationPropertyInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(AuthorizationPropertyValueInViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthorizationPropertyInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationPropertyInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAuthorizationPropertyInViewModel {
    key?: string | undefined;
    values?: AuthorizationPropertyValueInViewModel[] | undefined;
}

export class UserApplicationViewModel implements IUserApplicationViewModel {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    typeId?: number;
    typeName?: string | undefined;

    constructor(data?: IUserApplicationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
        }
    }

    static fromJS(data: any): UserApplicationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserApplicationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        return data;
    }
}

export interface IUserApplicationViewModel {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    typeId?: number;
    typeName?: string | undefined;
}

export class AuthLevelAppDto implements IAuthLevelAppDto {
    id?: number;
    roles?: string[] | undefined;
    projectId?: number | undefined;
    authorizationProperties?: { [key: string]: string; } | undefined;

    constructor(data?: IAuthLevelAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.projectId = _data["projectId"];
            if (_data["authorizationProperties"]) {
                this.authorizationProperties = {} as any;
                for (let key in _data["authorizationProperties"]) {
                    if (_data["authorizationProperties"].hasOwnProperty(key))
                        (this.authorizationProperties as any)![key] = _data["authorizationProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): AuthLevelAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLevelAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["projectId"] = this.projectId;
        if (this.authorizationProperties) {
            data["authorizationProperties"] = {};
            for (let key in this.authorizationProperties) {
                if (this.authorizationProperties.hasOwnProperty(key))
                    (data["authorizationProperties"] as any)[key] = (this.authorizationProperties as any)[key];
            }
        }
        return data;
    }
}

export interface IAuthLevelAppDto {
    id?: number;
    roles?: string[] | undefined;
    projectId?: number | undefined;
    authorizationProperties?: { [key: string]: string; } | undefined;
}

export class UserTridentityWithPhonesViewModel implements IUserTridentityWithPhonesViewModel {
    email?: string | undefined;
    userName?: string | undefined;
    displayName?: string | undefined;
    id?: string | undefined;
    department?: string | undefined;
    phoneNumbers?: string[] | undefined;

    constructor(data?: IUserTridentityWithPhonesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.displayName = _data["displayName"];
            this.id = _data["id"];
            this.department = _data["department"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): UserTridentityWithPhonesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserTridentityWithPhonesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        data["department"] = this.department;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        return data;
    }
}

export interface IUserTridentityWithPhonesViewModel {
    email?: string | undefined;
    userName?: string | undefined;
    displayName?: string | undefined;
    id?: string | undefined;
    department?: string | undefined;
    phoneNumbers?: string[] | undefined;
}

export class CreateTridentityUserInViewModel implements ICreateTridentityUserInViewModel {
    email?: string | undefined;
    fullName?: string | undefined;
    returnUrl?: string | undefined;

    constructor(data?: ICreateTridentityUserInViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.returnUrl = _data["returnUrl"];
        }
    }

    static fromJS(data: any): CreateTridentityUserInViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTridentityUserInViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["returnUrl"] = this.returnUrl;
        return data;
    }
}

export interface ICreateTridentityUserInViewModel {
    email?: string | undefined;
    fullName?: string | undefined;
    returnUrl?: string | undefined;
}

export class InspectionAuditViewModelQueryResult implements IInspectionAuditViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: InspectionAuditViewModel[] | undefined;

    constructor(data?: IInspectionAuditViewModelQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.orderBy = _data["orderBy"];
            this.ascending = _data["ascending"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InspectionAuditViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InspectionAuditViewModelQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionAuditViewModelQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["orderBy"] = this.orderBy;
        data["ascending"] = this.ascending;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInspectionAuditViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: InspectionAuditViewModel[] | undefined;
}

export abstract class BaseAuditViewModel implements IBaseAuditViewModel {
    projectId?: number;
    templateId?: number;
    date?: Date;
    userEmail?: string | undefined;
    userFullName?: string | undefined;
    action?: string | undefined;
    remarks?: string | undefined;

    constructor(data?: IBaseAuditViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.templateId = _data["templateId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.userEmail = _data["userEmail"];
            this.userFullName = _data["userFullName"];
            this.action = _data["action"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): BaseAuditViewModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseAuditViewModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["templateId"] = this.templateId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["userEmail"] = this.userEmail;
        data["userFullName"] = this.userFullName;
        data["action"] = this.action;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IBaseAuditViewModel {
    projectId?: number;
    templateId?: number;
    date?: Date;
    userEmail?: string | undefined;
    userFullName?: string | undefined;
    action?: string | undefined;
    remarks?: string | undefined;
}

export class InspectionAuditViewModel extends BaseAuditViewModel implements IInspectionAuditViewModel {
    inspectionName?: string | undefined;

    constructor(data?: IInspectionAuditViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.inspectionName = _data["inspectionName"];
        }
    }

    static override fromJS(data: any): InspectionAuditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionAuditViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionName"] = this.inspectionName;
        super.toJSON(data);
        return data;
    }
}

export interface IInspectionAuditViewModel extends IBaseAuditViewModel {
    inspectionName?: string | undefined;
}

export class PunchAuditViewModelQueryResult implements IPunchAuditViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: PunchAuditViewModel[] | undefined;

    constructor(data?: IPunchAuditViewModelQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.orderBy = _data["orderBy"];
            this.ascending = _data["ascending"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PunchAuditViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PunchAuditViewModelQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new PunchAuditViewModelQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["orderBy"] = this.orderBy;
        data["ascending"] = this.ascending;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPunchAuditViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: PunchAuditViewModel[] | undefined;
}

export class PunchAuditViewModel extends BaseAuditViewModel implements IPunchAuditViewModel {
    punchCode?: string | undefined;

    constructor(data?: IPunchAuditViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.punchCode = _data["punchCode"];
        }
    }

    static override fromJS(data: any): PunchAuditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PunchAuditViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchCode"] = this.punchCode;
        super.toJSON(data);
        return data;
    }
}

export interface IPunchAuditViewModel extends IBaseAuditViewModel {
    punchCode?: string | undefined;
}

export class UserAuditViewModelQueryResult implements IUserAuditViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: UserAuditViewModel[] | undefined;

    constructor(data?: IUserAuditViewModelQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.orderBy = _data["orderBy"];
            this.ascending = _data["ascending"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserAuditViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserAuditViewModelQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuditViewModelQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["orderBy"] = this.orderBy;
        data["ascending"] = this.ascending;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserAuditViewModelQueryResult {
    total?: number;
    orderBy?: string | undefined;
    ascending?: boolean;
    data?: UserAuditViewModel[] | undefined;
}

export class UserAuditViewModel extends BaseAuditViewModel implements IUserAuditViewModel {

    constructor(data?: IUserAuditViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UserAuditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuditViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUserAuditViewModel extends IBaseAuditViewModel {
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
